import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetchData } from '../graphql/fetchData';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ISO8601Date: string;
  ISO8601DateTime: string;
};

export type AccessibilityModeEnum =
  | 'INACCESSIBLE'
  | 'WHEELCHAIR_ACCESSIBLE';

export type AdminDonationToNfpInput = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};

export type AdminDonationToNfpMarkPaidInput = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};

/** Autogenerated return type of AdminDonationToNfpMarkPaid. */
export type AdminDonationToNfpMarkPaidPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type AdminLevelEnum =
  | 'MANAGE'
  | 'NONE'
  | 'READ_ONLY';

export type AdminMoveTicketsInput = {
  performanceId: Scalars['ID'];
  ticketId: Scalars['ID'];
};

/** Autogenerated return type of AdminMoveTicketsToDifferentPerformance. */
export type AdminMoveTicketsToDifferentPerformancePayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AdminNewsItemCreate. */
export type AdminNewsItemCreatePayload = {
  errors: Array<UserError>;
  newsItem: Maybe<NewsItem>;
};

/** Autogenerated return type of AdminNewsItemDestroy. */
export type AdminNewsItemDestroyPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AdminNewsItemUpdate. */
export type AdminNewsItemUpdatePayload = {
  errors: Array<UserError>;
  newsItem: Maybe<NewsItem>;
};

export type AdminPerformanceAddCommentInput = {
  comment: Scalars['String'];
  performanceId: Scalars['ID'];
};

/** Autogenerated return type of AdminPerformanceAddComment. */
export type AdminPerformanceAddCommentPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AdminPersonCreate. */
export type AdminPersonCreatePayload = {
  errors: Array<UserError>;
  person: Maybe<Person>;
};

/** Autogenerated return type of AdminPersonDestroy. */
export type AdminPersonDestroyPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AdminPersonUpdate. */
export type AdminPersonUpdatePayload = {
  errors: Array<UserError>;
  person: Maybe<Person>;
};

/** Autogenerated return type of AdminSendCourseResults. */
export type AdminSendCourseResultsPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AdminSendCourseSurveys. */
export type AdminSendCourseSurveysPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AdminSingleUseVoucherCreate. */
export type AdminSingleUseVoucherCreatePayload = {
  errors: Array<UserError>;
  singleUseVoucher: Maybe<SingleUseVoucher>;
};

/** Autogenerated return type of AdminSingleUseVoucherDestroy. */
export type AdminSingleUseVoucherDestroyPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AdminSingleUseVoucherUpdate. */
export type AdminSingleUseVoucherUpdatePayload = {
  errors: Array<UserError>;
  singleUseVoucher: Maybe<SingleUseVoucher>;
};

/** Autogenerated return type of AdminTheatreMembershipCreate. */
export type AdminTheatreMembershipCreatePayload = {
  errors: Array<UserError>;
  theatreMembership: Maybe<TheatreMembership>;
};

/** Autogenerated return type of AdminTheatreMembershipDestroy. */
export type AdminTheatreMembershipDestroyPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AdminTheatreMembershipUpdate. */
export type AdminTheatreMembershipUpdatePayload = {
  errors: Array<UserError>;
  theatreMembership: Maybe<TheatreMembership>;
};

/** Autogenerated return type of AdminTicketPricingGroupCreate. */
export type AdminTicketPricingGroupCreatePayload = {
  errors: Array<UserError>;
  ticketPricingGroup: Maybe<TicketPricingGroup>;
};

/** Autogenerated return type of AdminTicketPricingGroupDestroy. */
export type AdminTicketPricingGroupDestroyPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of AdminTicketPricingGroupUpdate. */
export type AdminTicketPricingGroupUpdatePayload = {
  errors: Array<UserError>;
  ticketPricingGroup: Maybe<TicketPricingGroup>;
};

export type AdminWorkshopAddCommentInput = {
  comment: Scalars['String'];
  workshopId: Scalars['ID'];
};

/** Autogenerated return type of AdminWorkshopAddComment. */
export type AdminWorkshopAddCommentPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type AllowDiscountsModeEnum =
  | 'DISABLED'
  | 'STANDARD_DISCOUNTS_ALLOWED';

/** Autogenerated return type of BatchCreatePerformances. */
export type BatchCreatePerformancesPayload = {
  errors: Array<UserError>;
  performances: Maybe<Array<Performance>>;
};

/** Autogenerated return type of BatchCreateWorkshops. */
export type BatchCreateWorkshopsPayload = {
  errors: Array<UserError>;
  workshops: Maybe<Array<Workshop>>;
};

export type BlackoutSession = {
  endDatetime: Scalars['ISO8601DateTime'];
  startDatetime: Scalars['ISO8601DateTime'];
};

export type Blog = {
  author: Maybe<Person>;
  authorId: Maybe<Scalars['ID']>;
  authorString: Maybe<Scalars['String']>;
  beforeTheFold: Maybe<Scalars['String']>;
  body: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageUrls: Array<Scalars['String']>;
  nextBlog: Maybe<Blog>;
  permalinkPath: Scalars['String'];
  previousBlog: Maybe<Blog>;
  publishedAt: Maybe<Scalars['ISO8601DateTime']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type BlogPage = {
  nodes: Array<Blog>;
  pageInfo: SimplePageInfo;
};

export type BookingStatusEnum =
  | 'CONFIRMED'
  | 'PENDING_CONFIRMATION'
  | 'PENDING_PAYMENT'
  | 'REFUNDED'
  | 'VOUCHER_ISSUED';

export type CalendarBlockingModeEnum =
  | 'ALL'
  | 'DISABLED'
  | 'PERFORMANCES'
  | 'WORKSHOPS';

export type CalendarSession = {
  calendarSessionable: CalendarSessionable;
  calendarSessionableId: Scalars['ID'];
  calendarSessionableType: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  endDatetime: Scalars['ISO8601DateTime'];
  googleCalendarEventId: Maybe<Scalars['String']>;
  googleCalendarId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isUnusualDay: Scalars['Boolean'];
  isUnusualTime: Scalars['Boolean'];
  isUnusualVenue: Scalars['Boolean'];
  scope: VenueAvailabilityScope;
  startDatetime: Scalars['ISO8601DateTime'];
  studentWorkshopAttendances: Array<StudentWorkshopAttendance>;
  updatedAt: Scalars['ISO8601DateTime'];
  venue: Maybe<Venue>;
  venueId: Maybe<Scalars['ID']>;
};

export type CalendarSessionable = Performance | Workshop;

/** Autogenerated return type of CaptureReferralCode. */
export type CaptureReferralCodePayload = {
  success: Scalars['Boolean'];
};

/** Autogenerated return type of CaptureUtm. */
export type CaptureUtmPayload = {
  success: Scalars['Boolean'];
};

/** Arguments */
export type CheckVenueAvailabilityInput = {
  proposedCalendarSessions: Array<SingleCalendarSessionAttributes>;
  stagedCalendarSessions: InputMaybe<Array<SingleCalendarSessionAttributes>>;
};

export type CodeEnabledTicketPricePoint = {
  category: CodeEnabledTicketPricePointCategoryEnum;
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  expiry: Maybe<Scalars['ISO8601DateTime']>;
  hasCodeEnabledTicketPricePointId: Scalars['Int'];
  hasCodeEnabledTicketPricePointType: Scalars['String'];
  id: Scalars['ID'];
  maximumRedemptionsPerPerformance: Maybe<Scalars['Int']>;
  price: Scalars['Float'];
  restrictToMultiplesOf: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type CodeEnabledTicketPricePointCategoryEnum =
  | 'OTHER'
  | 'PRODUCER25_PERCENT'
  | 'PRODUCER75_PERCENT'
  | 'PRODUCER_TWO_FOR_ONE';

export type ComedyDisciplineEnum =
  | 'CLOWNING'
  | 'IMPROV'
  | 'OTHER'
  | 'SKETCH'
  | 'STAND_UP';

export type CourseContinuationFields = {
  planToContinue: Scalars['Boolean'];
  programContinuationReasons: Scalars['String'];
  subscribeToAlerts: Scalars['Boolean'];
};

export type CourseEvaluationFields = {
  bestPartOfExperience: Scalars['String'];
  couldBeImproved: Scalars['String'];
  instructor1: Scalars['Int'];
  instructor2: Scalars['Int'];
  instructor3: Scalars['Int'];
  instructor4: Scalars['Int'];
  instructor5: Scalars['Int'];
  instructorPraiseCriticism: Scalars['String'];
  misc1: Scalars['Int'];
  misc2: Scalars['Int'];
  misc3: Scalars['Int'];
  oneCoolThingYouLearned: Scalars['String'];
  testimonial: Scalars['String'];
  workshop1: Scalars['Int'];
  workshop2: Scalars['Int'];
  workshop3: Scalars['Int'];
  workshop4: Scalars['Int'];
};

export type CourseEvaluationInput = {
  courseContinuation: CourseContinuationFields;
  courseEvaluation: CourseEvaluationFields;
  workshopRegistrationId: Scalars['ID'];
};

/** Autogenerated return type of CourseEvaluation. */
export type CourseEvaluationPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type CourseEvaluationQueryResponse = {
  canEvaluate: Scalars['Boolean'];
};

/** Autogenerated return type of CreatePerformance. */
export type CreatePerformancePayload = {
  errors: Array<UserError>;
  performance: Maybe<Performance>;
};

/** Autogenerated return type of CreateWorkshop. */
export type CreateWorkshopPayload = {
  errors: Array<UserError>;
  workshop: Maybe<Workshop>;
};

export type CustomerReplyToEnum =
  | 'COMPANY'
  | 'SENDER'
  | 'SENDER_ALIAS'
  | 'THEATRE'
  | 'WORKSHOPS';

export type DiscountOffer = {
  anytime: Scalars['Int'];
  inPersonAny: Scalars['Int'];
  inPersonNextTerm: Scalars['Int'];
  sameOrNextDay: Scalars['Int'];
  thirtyDays: Scalars['Int'];
};

export type DonationToNfp = {
  amount: Scalars['Float'];
  createdAt: Scalars['ISO8601DateTime'];
  donateableId: Scalars['ID'];
  donateableType: Scalars['String'];
  id: Scalars['ID'];
  transferStatus: DonationToNfpTransferStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  userId: Maybe<Scalars['ID']>;
};

export type DonationToNfpTransferStatusEnum =
  | 'INTERNAL_TO_NFP'
  | 'PENDING'
  | 'PTY_LTD_OWES_NFP'
  | 'PTY_LTD_PAID_NFP';

export type EditNewsItemInput = {
  authorId: InputMaybe<Scalars['ID']>;
  body: Scalars['String'];
  category: NewsItemCategoryEnum;
  featured: Scalars['Boolean'];
  heroImageBlobId: InputMaybe<Scalars['String']>;
  preview: Scalars['String'];
  title: Scalars['String'];
};

/** Attributes for creating or updating a performance */
export type EditPerformanceAttributes = {
  /** Offer student comps? (OVERRIDE) */
  acceptStudentComps: ShowTypeSettingsOverrideEnum;
  /** Special callout text for website calendar */
  calendarHeadline: Scalars['String'];
  /** Simple description for website calendar */
  description: Scalars['String'];
  /** Producer expenses to log against a potential payout */
  expenses: Scalars['Float'];
  /** ID of the session (when editing nested attributes) */
  id: InputMaybe<Scalars['ID']>;
  /** Name of the performance */
  name: Scalars['String'];
  /** Offer early bird discount? (OVERRIDE) */
  offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum;
  /** Date and time the performance should go on sale */
  onSaleDatetime: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Seating capacity (OVERRIDE) */
  seatingCapacityOverride: InputMaybe<Scalars['Int']>;
  /** ID of the show type we belong to */
  showTypeId: Scalars['ID'];
  /** Date and time of the performance */
  startDatetime: Scalars['ISO8601DateTime'];
  /** Status */
  status: PerformanceStatusEnum;
  /** Number of available student comps (OVERRIDE) */
  studentQuotaCompAllotment: InputMaybe<Scalars['Int']>;
  /** ID of the ticket pricing group (OVERRIDE) */
  ticketPricingGroupId: InputMaybe<Scalars['ID']>;
  /** ID of the venue (OVERRIDE) */
  venueId: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of EditPerformance. */
export type EditPerformancePayload = {
  errors: Array<UserError>;
  performance: Maybe<Performance>;
};

export type EditPersonInput = {
  bio: InputMaybe<Scalars['String']>;
  blogBio: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  hidden: InputMaybe<Scalars['Boolean']>;
  imageBlobId: InputMaybe<Scalars['String']>;
  imageCroppedToFaceBlobId: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  userId: InputMaybe<Scalars['ID']>;
  workshopBio: InputMaybe<Scalars['String']>;
};

export type EditSingleUseVoucherInput = {
  expiryDate: Scalars['ISO8601Date'];
  hasVoucherId: InputMaybe<Scalars['ID']>;
  hasVoucherType: InputMaybe<Scalars['String']>;
  maximumDollarValue: Scalars['Float'];
  memo: Scalars['String'];
  redeemed: Scalars['Boolean'];
  restrictedToPurchasableId: InputMaybe<Scalars['ID']>;
  restrictedToPurchasableType: InputMaybe<Scalars['String']>;
  voucherType: Scalars['String'];
};

export type EditStudentAvailabilityInput = {
  fridayDaytime: StudentAvailabilityEnum;
  fridayEvening: StudentAvailabilityEnum;
  mondayDaytime: StudentAvailabilityEnum;
  mondayEvening: StudentAvailabilityEnum;
  saturdayDaytime: StudentAvailabilityEnum;
  saturdayEvening: StudentAvailabilityEnum;
  startingFrom: InputMaybe<Scalars['ISO8601Date']>;
  sundayDaytime: StudentAvailabilityEnum;
  sundayEvening: StudentAvailabilityEnum;
  thursdayDaytime: StudentAvailabilityEnum;
  thursdayEvening: StudentAvailabilityEnum;
  tuesdayDaytime: StudentAvailabilityEnum;
  tuesdayEvening: StudentAvailabilityEnum;
  wednesdayDaytime: StudentAvailabilityEnum;
  wednesdayEvening: StudentAvailabilityEnum;
};

/** Autogenerated return type of EditStudentAvailability. */
export type EditStudentAvailabilityPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type EditStudentProfileInput = {
  pronounsEnum: PronounsEnum;
  pronounsOther: Scalars['String'];
  referralDetail: Scalars['String'];
  referralSource: Scalars['String'];
  specialNeeds: Scalars['String'];
};

/** Autogenerated return type of EditStudentProfile. */
export type EditStudentProfilePayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Attributes for creating or updating a TheatreMembership */
export type EditTheatreMembershipInput = {
  expirationDate: InputMaybe<Scalars['ISO8601Date']>;
  /** Payment status */
  paymentStatus: Scalars['String'];
  /** Membership tier */
  tier: Scalars['String'];
  /** User associated with membership */
  userId: Scalars['ID'];
};

export type EditTicketPricingGroupInput = {
  archived: InputMaybe<Scalars['Boolean']>;
  communityMemberPrice: InputMaybe<Scalars['Float']>;
  communityMemberPriceDoorOnly: InputMaybe<Scalars['Boolean']>;
  concessionPrice: InputMaybe<Scalars['Float']>;
  createdAt: InputMaybe<Scalars['ISO8601DateTime']>;
  freeOnDoor: InputMaybe<Scalars['Boolean']>;
  fullPrice: InputMaybe<Scalars['Float']>;
  groupMinimumSize: InputMaybe<Scalars['Int']>;
  groupPrice: InputMaybe<Scalars['Float']>;
  id: InputMaybe<Scalars['ID']>;
  name: InputMaybe<Scalars['String']>;
  paidMemberPrice: InputMaybe<Scalars['Float']>;
  perUnitServiceFee: InputMaybe<Scalars['Float']>;
  totalServiceFee: InputMaybe<Scalars['Float']>;
  updatedAt: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Attributes for creating or updating a workshop */
export type EditWorkshopAttributes = {
  /** Internal capacity */
  absoluteMaximumCapacity: Scalars['Int'];
  /** IDs of any teaching assistants */
  assistants: Array<Scalars['ID']>;
  /** Advertised capacity */
  capacity: Scalars['Int'];
  /** Confirmed and bookable? */
  confirmed: Scalars['Boolean'];
  /** HTML-rich course description */
  description: Scalars['String'];
  /** In Person or Online? */
  meetingType: WorkshopMeetingTypeEnum;
  /** Name of the workshop */
  name: Scalars['String'];
  /** Prerequisite Mode */
  prerequisiteMode: WorkshopPrerequisiteModeEnum;
  /** ID of any custom per-workshop prerequisite workshop level */
  prerequisiteWorkshopLevelId: InputMaybe<Scalars['ID']>;
  /** If set, locks the workshop */
  simplePassword: InputMaybe<Scalars['String']>;
  /** Explicitly enable student comps for this workshop? */
  studentCompsOfferedOverride: Scalars['Boolean'];
  /** How many student comps should be offered for this workshop */
  studentCompsQuantityOverride: InputMaybe<Scalars['Int']>;
  /** How many student jams should be offered for this workshop */
  studentJamsQuantityOverride: InputMaybe<Scalars['Int']>;
  /** Attributes for student showcases */
  studentShowcasesAttributes: Array<EditPerformanceAttributes>;
  /** Explicitly enable student showcases for this workshop? */
  studentShowcasesOfferedOverride: Scalars['Boolean'];
  /** How many student showcases should be offered for this workshop */
  studentShowcasesQuantityOverride: InputMaybe<Scalars['Int']>;
  /** IDs of any substitute teachers */
  substituteTeachers: Array<Scalars['ID']>;
  /** IDs of any teachers */
  teachers: Array<Scalars['ID']>;
  /** Visible on public-facing site? */
  visible: Scalars['Boolean'];
  /** ID of the workshop level we belong to */
  workshopLevelId: Scalars['ID'];
  /** ID of any custom per-workshop pricing group */
  workshopPricingGroupId: InputMaybe<Scalars['ID']>;
  /** Workshop session info */
  workshopSessionsAttributes: Array<WorkshopSessionAttributes>;
  /** ID of the workshop term */
  workshopTermId: InputMaybe<Scalars['ID']>;
  /** If online, paste in the Zoom meeting invitation */
  zoomMeetingInvitation: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of EditWorkshop. */
export type EditWorkshopPayload = {
  errors: Array<UserError>;
  workshop: Maybe<Workshop>;
};

export type EvaluationByStudent = {
  bestPartOfExperience: Maybe<Scalars['String']>;
  couldBeImproved: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  instructor1: Scalars['Int'];
  instructor2: Scalars['Int'];
  instructor3: Scalars['Int'];
  instructor4: Scalars['Int'];
  instructor5: Scalars['Int'];
  instructorPraiseCriticism: Maybe<Scalars['String']>;
  misc1: Scalars['Int'];
  misc2: Scalars['Int'];
  misc3: Scalars['Int'];
  oneCoolThingYouLearned: Maybe<Scalars['String']>;
  programContinuationPlans: Maybe<Scalars['String']>;
  programContinuationPlansEnum: ProgramContinuationPlansEnum;
  programContinuationReasons: Maybe<Scalars['String']>;
  testimonial: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  workshop1: Scalars['Int'];
  workshop2: Scalars['Int'];
  workshop3: Scalars['Int'];
  workshop4: Scalars['Int'];
  workshopRegistrationId: Scalars['ID'];
};

export type EvaluationByTeacher = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  instructorCommentsForStudent: Maybe<Scalars['String']>;
  instructorCommentsInternalUse: Maybe<Scalars['String']>;
  passRepeatStatusForUser: Maybe<PassRepeatStatusForUser>;
  passRepeatStatusInternal: Maybe<PassRepeatStatusInternalEnum>;
  releaseStatus: EvaluationByTeacherStatus;
  releasedByEducationDirector: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['ISO8601DateTime'];
  workshopRegistrationId: Scalars['ID'];
  workshopTrackInvitations: Array<WorkshopTrackInvitation>;
};

export type EvaluationByTeacherStatus =
  /** Course results will be released once student submits their course evaluation */
  | 'AWAITING_COURSE_EVALUATION'
  /** Course results may be shared with the student */
  | 'RELEASED'
  /** Course results have not been released by education director */
  | 'UNRELEASED';

export type EvaluationModeEnum =
  | 'EVALUATED_FEEDBACK_ONLY'
  | 'EVALUATED_PASS_REPEAT'
  | 'NOT_EVALUATED';

export type FreeTrialOffers = {
  discountOffers: DiscountOffer;
  nextTermWorkshops: Array<Workshop>;
  otherUpcomingWorkshops: Array<Workshop>;
};

export type HasTicketPricePointTypeEnum =
  | 'PERFORMANCE'
  | 'SHOW_TYPE';

export type IndividualStudentEvaluationInput = {
  instructorCommentsForStudent: InputMaybe<Scalars['String']>;
  instructorCommentsInternalUse: InputMaybe<Scalars['String']>;
  inviteToWorkshopTrackIds: Array<Scalars['ID']>;
  passRepeatStatusInternal: PassRepeatStatusInternalEnum;
  workshopRegistrationId: Scalars['ID'];
};

export type IndividualStudentWorkshopAttendanceInput = {
  notes: Scalars['String'];
  state: StudentWorkshopAttendanceStateEnum;
  workshopRegistrationId: Scalars['ID'];
};

/** Attributes for instructor search */
export type InstructorSearchAttributes = {
  ids: InputMaybe<Array<Scalars['ID']>>;
  query: InputMaybe<Scalars['String']>;
  restrictToPreviousTeachers: InputMaybe<Scalars['Boolean']>;
};

export type InternalComment = {
  comment: Scalars['String'];
  commentableId: Scalars['Int'];
  commentableType: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  userId: Scalars['Int'];
};

export type JoinWorkshopWaitingListInput = {
  action: WaitingListActionEnum;
  workshopId: Scalars['ID'];
};

/** Autogenerated return type of JoinWorkshopWaitingList. */
export type JoinWorkshopWaitingListPayload = {
  errors: Array<UserError>;
  success: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of LogWorkshopCheckoutImpression. */
export type LogWorkshopCheckoutImpressionPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type ManageWorkshopLevelAlertInput = {
  subscribed: Scalars['Boolean'];
  workshopLevelId: Scalars['ID'];
};

/** Autogenerated return type of ManageWorkshopLevelAlert. */
export type ManageWorkshopLevelAlertPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ManageWorkshopLevelAlertsSmartSubscribe. */
export type ManageWorkshopLevelAlertsSmartSubscribePayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ManageWorkshopLevelAlertsUnsubscribeAll. */
export type ManageWorkshopLevelAlertsUnsubscribeAllPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type MembershipPaymentStatusEnum =
  | 'COMPLIMENTARY'
  | 'PAYMENT_CONFIRMED'
  | 'PENDING_PAYMENT';

export type MembershipTierEnum =
  | 'COMMUNITY'
  | 'PAID';

export type Mutation = {
  adminDonationToNfpMarkPaid: AdminDonationToNfpMarkPaidPayload;
  adminMoveTicketsToDifferentPerformance: AdminMoveTicketsToDifferentPerformancePayload;
  adminNewsItemCreate: AdminNewsItemCreatePayload;
  adminNewsItemDestroy: AdminNewsItemDestroyPayload;
  adminNewsItemUpdate: AdminNewsItemUpdatePayload;
  adminPerformanceAddComment: AdminPerformanceAddCommentPayload;
  adminPersonCreate: AdminPersonCreatePayload;
  adminPersonDestroy: AdminPersonDestroyPayload;
  adminPersonUpdate: AdminPersonUpdatePayload;
  adminSendCourseResults: AdminSendCourseResultsPayload;
  adminSendCourseSurveys: AdminSendCourseSurveysPayload;
  adminSingleUseVoucherCreate: AdminSingleUseVoucherCreatePayload;
  adminSingleUseVoucherDestroy: AdminSingleUseVoucherDestroyPayload;
  adminSingleUseVoucherUpdate: AdminSingleUseVoucherUpdatePayload;
  adminTheatreMembershipCreate: AdminTheatreMembershipCreatePayload;
  adminTheatreMembershipDestroy: AdminTheatreMembershipDestroyPayload;
  adminTheatreMembershipUpdate: AdminTheatreMembershipUpdatePayload;
  adminTicketPricingGroupCreate: AdminTicketPricingGroupCreatePayload;
  adminTicketPricingGroupDestroy: AdminTicketPricingGroupDestroyPayload;
  adminTicketPricingGroupUpdate: AdminTicketPricingGroupUpdatePayload;
  adminWorkshopAddComment: AdminWorkshopAddCommentPayload;
  batchCreatePerformances: BatchCreatePerformancesPayload;
  batchCreateWorkshops: BatchCreateWorkshopsPayload;
  captureReferralCode: CaptureReferralCodePayload;
  captureUtm: CaptureUtmPayload;
  courseEvaluation: CourseEvaluationPayload;
  createPerformance: CreatePerformancePayload;
  createWorkshop: CreateWorkshopPayload;
  editPerformance: EditPerformancePayload;
  editStudentAvailability: EditStudentAvailabilityPayload;
  editStudentProfile: EditStudentProfilePayload;
  editWorkshop: EditWorkshopPayload;
  joinWorkshopWaitingList: JoinWorkshopWaitingListPayload;
  logWorkshopCheckoutImpression: LogWorkshopCheckoutImpressionPayload;
  manageWorkshopLevelAlert: ManageWorkshopLevelAlertPayload;
  manageWorkshopLevelAlertsSmartSubscribe: ManageWorkshopLevelAlertsSmartSubscribePayload;
  manageWorkshopLevelAlertsUnsubscribeAll: ManageWorkshopLevelAlertsUnsubscribeAllPayload;
  paymentPlanMakePayment: PaymentPlanMakePaymentPayload;
  paymentPlanMakePaymentPaymentIntent: PaymentPlanMakePaymentPaymentIntentPayload;
  performanceAddComps: PerformanceAddCompsPayload;
  performanceAddStandby: PerformanceAddStandbyPayload;
  performanceLogStudentAttendance: PerformanceLogStudentAttendancePayload;
  performanceSetDoorSales: PerformanceSetDoorSalesPayload;
  postponeWorkshops: PostponeWorkshopsPayload;
  preregistrationCheckout: PreregistrationCheckoutPayload;
  preregistrationCheckoutConfirmPending: PreregistrationCheckoutConfirmPendingPayload;
  preregistrationRerankPreferences: PreregistrationRerankPreferencesPayload;
  referralBonusAward: ReferralBonusAwardPayload;
  referralBonusReject: ReferralBonusRejectPayload;
  selfServeIssueTicketVoucher: SelfServeIssueTicketVoucherPayload;
  selfServeTicketTransferConfirm: SelfServeTicketTransferConfirmPayload;
  selfServeWorkshopDeferral: SelfServeWorkshopDeferralPayload;
  selfServeWorkshopTransferConfirm: SelfServeWorkshopTransferConfirmPayload;
  sendMailMergeForCustomers: SendMailMergeForCustomersPayload;
  sendMailMergeForWorkshops: SendMailMergeForWorkshopsPayload;
  teacherEvaluateStudent: TeacherEvaluateStudentPayload;
  teacherLockAttendance: TeacherLockAttendancePayload;
  teacherLockEvaluations: TeacherLockEvaluationsPayload;
  teacherTakeAttendance: TeacherTakeAttendancePayload;
  theatreMembershipEnterDetails: TheatreMembershipEnterDetailsPayload;
  ticketCheckoutConfirmPendingConfirmation: TicketCheckoutConfirmPendingConfirmationPayload;
  ticketDeleteComp: TicketDeleteCompPayload;
  ticketMarkCollected: TicketMarkCollectedPayload;
  ticketPricePointCreate: TicketPricePointCreatePayload;
  ticketPricePointDestroy: TicketPricePointDestroyPayload;
  ticketRefundStripe: TicketRefundStripePayload;
  ticketResendConfirmationEmail: TicketResendConfirmationEmailPayload;
  updateEmailSettings: UpdateEmailSettingsPayload;
  workshopAddStudentManual: WorkshopAddStudentManualPayload;
  workshopAddStudentStripe: WorkshopAddStudentStripePayload;
  workshopCheckoutConfirmPending: WorkshopCheckoutConfirmPendingPayload;
  workshopRegistrationDefer: WorkshopRegistrationDeferPayload;
  workshopRegistrationDrop: WorkshopRegistrationDropPayload;
  workshopRegistrationMoveToDifferentUser: WorkshopRegistrationMoveToDifferentUserPayload;
  workshopRegistrationMoveToDifferentWorkshop: WorkshopRegistrationMoveToDifferentWorkshopPayload;
  workshopRegistrationResendConfirmationEmail: WorkshopRegistrationResendConfirmationEmailPayload;
  workshopSendManualCourseReminders: WorkshopSendManualCourseRemindersPayload;
  workshopVoucherSellManual: WorkshopVoucherSellManualPayload;
  workshopVoucherSellStripe: WorkshopVoucherSellStripePayload;
};


export type MutationAdminDonationToNfpMarkPaidArgs = {
  params: AdminDonationToNfpMarkPaidInput;
};


export type MutationAdminMoveTicketsToDifferentPerformanceArgs = {
  params: AdminMoveTicketsInput;
};


export type MutationAdminNewsItemCreateArgs = {
  attributes: EditNewsItemInput;
};


export type MutationAdminNewsItemDestroyArgs = {
  id: Scalars['ID'];
};


export type MutationAdminNewsItemUpdateArgs = {
  attributes: EditNewsItemInput;
  id: Scalars['ID'];
};


export type MutationAdminPerformanceAddCommentArgs = {
  input: AdminPerformanceAddCommentInput;
};


export type MutationAdminPersonCreateArgs = {
  attributes: EditPersonInput;
};


export type MutationAdminPersonDestroyArgs = {
  id: Scalars['ID'];
};


export type MutationAdminPersonUpdateArgs = {
  attributes: EditPersonInput;
  id: Scalars['ID'];
};


export type MutationAdminSendCourseResultsArgs = {
  workshopRegistrationIds: Array<Scalars['ID']>;
};


export type MutationAdminSendCourseSurveysArgs = {
  workshopRegistrationIds: Array<Scalars['ID']>;
};


export type MutationAdminSingleUseVoucherCreateArgs = {
  attributes: EditSingleUseVoucherInput;
};


export type MutationAdminSingleUseVoucherDestroyArgs = {
  id: Scalars['ID'];
};


export type MutationAdminSingleUseVoucherUpdateArgs = {
  attributes: EditSingleUseVoucherInput;
  id: Scalars['ID'];
};


export type MutationAdminTheatreMembershipCreateArgs = {
  attributes: EditTheatreMembershipInput;
};


export type MutationAdminTheatreMembershipDestroyArgs = {
  id: Scalars['ID'];
};


export type MutationAdminTheatreMembershipUpdateArgs = {
  attributes: EditTheatreMembershipInput;
  id: Scalars['ID'];
};


export type MutationAdminTicketPricingGroupCreateArgs = {
  attributes: EditTicketPricingGroupInput;
};


export type MutationAdminTicketPricingGroupDestroyArgs = {
  id: Scalars['ID'];
};


export type MutationAdminTicketPricingGroupUpdateArgs = {
  attributes: EditTicketPricingGroupInput;
  id: Scalars['ID'];
};


export type MutationAdminWorkshopAddCommentArgs = {
  input: AdminWorkshopAddCommentInput;
};


export type MutationBatchCreatePerformancesArgs = {
  attributes: Array<EditPerformanceAttributes>;
};


export type MutationBatchCreateWorkshopsArgs = {
  attributes: Array<EditWorkshopAttributes>;
};


export type MutationCaptureReferralCodeArgs = {
  refcode: Scalars['String'];
};


export type MutationCaptureUtmArgs = {
  params: UtmParams;
};


export type MutationCourseEvaluationArgs = {
  params: CourseEvaluationInput;
};


export type MutationCreatePerformanceArgs = {
  attributes: EditPerformanceAttributes;
};


export type MutationCreateWorkshopArgs = {
  attributes: EditWorkshopAttributes;
};


export type MutationEditPerformanceArgs = {
  attributes: EditPerformanceAttributes;
  id: Scalars['ID'];
};


export type MutationEditStudentAvailabilityArgs = {
  params: EditStudentAvailabilityInput;
};


export type MutationEditStudentProfileArgs = {
  params: EditStudentProfileInput;
};


export type MutationEditWorkshopArgs = {
  attributes: EditWorkshopAttributes;
  id: Scalars['ID'];
};


export type MutationJoinWorkshopWaitingListArgs = {
  params: JoinWorkshopWaitingListInput;
};


export type MutationLogWorkshopCheckoutImpressionArgs = {
  id: Scalars['ID'];
};


export type MutationManageWorkshopLevelAlertArgs = {
  params: ManageWorkshopLevelAlertInput;
};


export type MutationPaymentPlanMakePaymentArgs = {
  params: PaymentPlanMakePaymentInput;
};


export type MutationPaymentPlanMakePaymentPaymentIntentArgs = {
  params: PaymentPlanMakePaymentPaymentIntentInput;
};


export type MutationPerformanceAddCompsArgs = {
  params: PerformanceAddCompsParams;
};


export type MutationPerformanceAddStandbyArgs = {
  bracket: Scalars['String'];
  name: Scalars['String'];
  performanceId: Scalars['ID'];
};


export type MutationPerformanceLogStudentAttendanceArgs = {
  performanceId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationPerformanceSetDoorSalesArgs = {
  bracket: TicketBracketEnum;
  performanceId: Scalars['ID'];
  quantity: Scalars['Int'];
};


export type MutationPostponeWorkshopsArgs = {
  attributes: PostponeWorkshopsAttributes;
};


export type MutationPreregistrationCheckoutArgs = {
  params: PreregistrationCheckoutInput;
};


export type MutationPreregistrationCheckoutConfirmPendingArgs = {
  preregistrationId: Scalars['ID'];
};


export type MutationPreregistrationRerankPreferencesArgs = {
  params: PreregistrationRerankPreferencesInput;
};


export type MutationReferralBonusAwardArgs = {
  userId: Scalars['ID'];
  workshopRegistrationId: Scalars['ID'];
};


export type MutationReferralBonusRejectArgs = {
  workshopRegistrationId: Scalars['ID'];
};


export type MutationSelfServeIssueTicketVoucherArgs = {
  ticketId: Scalars['ID'];
};


export type MutationSelfServeTicketTransferConfirmArgs = {
  transferId: Scalars['ID'];
};


export type MutationSelfServeWorkshopDeferralArgs = {
  workshopRegistrationId: Scalars['ID'];
};


export type MutationSelfServeWorkshopTransferConfirmArgs = {
  transferId: Scalars['ID'];
};


export type MutationSendMailMergeForCustomersArgs = {
  params: SendMailMergeForCustomersInput;
};


export type MutationSendMailMergeForWorkshopsArgs = {
  params: SendMailMergeForWorkshopsInput;
};


export type MutationTeacherEvaluateStudentArgs = {
  params: TeacherEvaluateStudentInput;
};


export type MutationTeacherLockAttendanceArgs = {
  workshopSessionId: Scalars['ID'];
};


export type MutationTeacherLockEvaluationsArgs = {
  workshopId: Scalars['ID'];
};


export type MutationTeacherTakeAttendanceArgs = {
  params: TeacherTakeAttendanceInput;
};


export type MutationTheatreMembershipEnterDetailsArgs = {
  params: TheatreMembershipEnterDetailsInput;
};


export type MutationTicketCheckoutConfirmPendingConfirmationArgs = {
  orderUuid: Scalars['String'];
};


export type MutationTicketDeleteCompArgs = {
  ticketId: Scalars['ID'];
};


export type MutationTicketMarkCollectedArgs = {
  collected: Scalars['Boolean'];
  ticketId: Scalars['ID'];
};


export type MutationTicketPricePointCreateArgs = {
  params: TicketPricePointCreateParams;
};


export type MutationTicketPricePointDestroyArgs = {
  id: Scalars['ID'];
};


export type MutationTicketRefundStripeArgs = {
  ticketId: Scalars['ID'];
};


export type MutationTicketResendConfirmationEmailArgs = {
  ticketId: Scalars['ID'];
};


export type MutationUpdateEmailSettingsArgs = {
  params: UpdateEmailSettingsInput;
};


export type MutationWorkshopAddStudentManualArgs = {
  params: WorkshopAddStudentManualInput;
};


export type MutationWorkshopAddStudentStripeArgs = {
  params: WorkshopAddStudentStripe;
};


export type MutationWorkshopCheckoutConfirmPendingArgs = {
  workshopRegistrationId: Scalars['ID'];
};


export type MutationWorkshopRegistrationDeferArgs = {
  params: WorkshopRegistrationDeferInput;
};


export type MutationWorkshopRegistrationDropArgs = {
  emailStudent: Scalars['Boolean'];
  issueRefund: Scalars['Boolean'];
  messageForStudent?: InputMaybe<Scalars['String']>;
  workshopRegistrationId: Scalars['ID'];
};


export type MutationWorkshopRegistrationMoveToDifferentUserArgs = {
  userId: Scalars['ID'];
  workshopRegistrationId: Scalars['ID'];
};


export type MutationWorkshopRegistrationMoveToDifferentWorkshopArgs = {
  workshopId: Scalars['ID'];
  workshopRegistrationId: Scalars['ID'];
};


export type MutationWorkshopRegistrationResendConfirmationEmailArgs = {
  workshopRegistrationId: Scalars['ID'];
};


export type MutationWorkshopSendManualCourseRemindersArgs = {
  workshopId: Scalars['ID'];
};


export type MutationWorkshopVoucherSellManualArgs = {
  params: WorkshopVoucherSellManualInput;
};


export type MutationWorkshopVoucherSellStripeArgs = {
  params: WorkshopVoucherSellStripeInput;
};

export type MySitePermissionsReturn = {
  cms: Scalars['Boolean'];
  teachingStaff: Scalars['Boolean'];
  ticketing: Scalars['Boolean'];
};

export type NewsItem = {
  author: Maybe<Person>;
  authorId: Maybe<Scalars['ID']>;
  body: Scalars['String'];
  category: NewsItemCategoryEnum;
  createdAt: Scalars['ISO8601DateTime'];
  featured: Scalars['Boolean'];
  heroImageUrl: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  nextNewsItem: Maybe<NewsItem>;
  preview: Scalars['String'];
  previousNewsItem: Maybe<NewsItem>;
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type NewsItemCategoryEnum =
  | 'CORPORATE'
  | 'DIVERSITY'
  | 'GENERAL'
  | 'PODCAST'
  | 'THEATRE'
  | 'WORKSHOPS';

export type NewsItemPage = {
  nodes: Array<NewsItem>;
  pageInfo: SimplePageInfo;
};

export type OptimisticPreregistrationCurrentWorkshopRegistration = {
  weekOfTerm: Scalars['Int'];
  workshopRegistration: WorkshopRegistration;
};

export type OptimisticPreregistrationDiscounts = {
  week5: Scalars['Int'];
  week6: Scalars['Int'];
  week7: Scalars['Int'];
  week8: Scalars['Int'];
  weeks1Through4: Scalars['Int'];
};

export type OptimisticPreregistrationUserStatus = {
  currentWorkshopRegistrations: Array<OptimisticPreregistrationCurrentWorkshopRegistration>;
  discounts: OptimisticPreregistrationDiscounts;
};

export type OtherVenuesAtSameTime = {
  available: Scalars['Boolean'];
  venue: Venue;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

export type PassRepeatStatusForUser =
  | 'PASS'
  | 'REPEAT';

export type PassRepeatStatusInternalEnum =
  | 'PASS'
  | 'PASS_WITH_HIGH_DISTINCTION'
  | 'REPEAT'
  | 'UNDECIDED';

export type Payment = {
  createdAt: Scalars['ISO8601DateTime'];
  hasPaymentId: Scalars['ID'];
  hasPaymentType: Scalars['String'];
  id: Scalars['ID'];
  paymentAmount: Scalars['Float'];
  paymentAmountDonation: Scalars['Float'];
  paymentDescription: Scalars['String'];
  paymentIntentId: Maybe<Scalars['String']>;
  paymentRefunds: Array<PaymentRefund>;
  paymentType: PaymentTypeEnum;
  paymentUid: Maybe<Scalars['String']>;
  status: PaymentStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PaymentIntent = {
  amount: Scalars['Int'];
  id: Scalars['String'];
  secret: Scalars['String'];
};

export type PaymentIntentDonation = {
  donation: StandaloneDonationToNfp;
  paymentIntent: PaymentIntent;
};

/** Custom attributes for this query */
export type PaymentIntentDonationInput = {
  amount: Scalars['Float'];
  email: Scalars['String'];
  name: Scalars['String'];
  telephone: Scalars['String'];
  uuid: Scalars['String'];
};

export type PaymentIntentMembership = {
  paymentIntent: PaymentIntent;
  theatreMembership: TheatreMembership;
};

/** Custom attributes for this query */
export type PaymentIntentMembershipInput = {
  birthdayMonth: Scalars['String'];
  expectedPrice: Scalars['Float'];
  referredByMember: Scalars['String'];
};

export type PaymentIntentResponse = {
  errorMessage: Maybe<Scalars['String']>;
  isFree: Maybe<Scalars['Boolean']>;
  paymentIntent: Maybe<PaymentIntent>;
};

export type PaymentIntentWorkshopVoucherParams = {
  apiSource: InputMaybe<Scalars['String']>;
  donationAmount: Scalars['Float'];
  expectedVoucherPrice: Scalars['Float'];
  priceType: WorkshopPriceTypeEnum;
  workshopLevelId: Scalars['ID'];
  workshopPreregistrationPeriodId: InputMaybe<Scalars['ID']>;
  workshopRegistrationDuringPreregistrationId: InputMaybe<Scalars['ID']>;
};

export type PaymentIntentWorkshopVoucherResponse = {
  errorMessage: Maybe<Scalars['String']>;
  paymentIntent: Maybe<PaymentIntent>;
  stagedVoucher: Maybe<SingleUseVoucher>;
};

export type PaymentLedgerTypeEnum =
  | 'PAID_IN_FULL'
  | 'PAYMENT_PLAN'
  | 'PAYMENT_PLAN_ABANDONED';

export type PaymentPlanCheckInitialPayments = {
  apiSource: InputMaybe<Scalars['String']>;
  bookingType: WorkshopBookingTypeEnum;
  discountCode: InputMaybe<Scalars['String']>;
  paymentMode: WorkshopPaymentModeEnum;
  preregistration: InputMaybe<Scalars['Boolean']>;
  priceType: WorkshopPriceTypeEnum;
  workshopId: InputMaybe<Scalars['ID']>;
};

export type PaymentPlanCheckStatus = {
  paymentOptions: Array<PaymentPlanPaymentOption>;
  workshopPaymentLedger: WorkshopPaymentLedger;
};

export type PaymentPlanMakePaymentInput = {
  expectedPaymentAmountCents: Scalars['Int'];
  paymentPercentage: PaymentPlanPaymentPercentageEnum;
  stripeToken: Scalars['String'];
  workshopPaymentLedgerId: Scalars['ID'];
};

/** Autogenerated return type of PaymentPlanMakePayment. */
export type PaymentPlanMakePaymentPayload = {
  errors: Array<UserError>;
  workshopPaymentLedger: Maybe<WorkshopPaymentLedger>;
};

export type PaymentPlanMakePaymentPaymentIntentInput = {
  expectedPaymentAmountCents: Scalars['Int'];
  paymentPercentage: PaymentPlanPaymentPercentageEnum;
  workshopPaymentLedgerId: Scalars['ID'];
};

/** Autogenerated return type of PaymentPlanMakePaymentPaymentIntent. */
export type PaymentPlanMakePaymentPaymentIntentPayload = {
  errors: Array<UserError>;
  paymentIntent: Maybe<PaymentIntent>;
  pendingPayment: Maybe<Payment>;
};

export type PaymentPlanOption = {
  name: PaymentPlanPaymentPercentageEnum;
  schedule: Array<PaymentPlanSchedule>;
};

export type PaymentPlanPaymentOption = {
  label: Scalars['String'];
  paymentAmountCents: Scalars['Int'];
  paymentPercentage: PaymentPlanPaymentPercentageEnum;
};

export type PaymentPlanPaymentPercentageEnum =
  | 'PERCENT25'
  | 'PERCENT50'
  | 'PERCENT75'
  | 'PERCENT100';

export type PaymentPlanSchedule = {
  description: Scalars['String'];
  headline: Scalars['String'];
  paymentAmountCents: Scalars['Int'];
  paymentDate: Scalars['ISO8601Date'];
};

export type PaymentPlanStatusEnum =
  | 'BEHIND_SCHEDULE'
  | 'ON_SCHEDULE'
  | 'PAID_OFF';

export type PaymentRefund = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  paymentId: Maybe<Scalars['ID']>;
  refundAmount: Maybe<Scalars['Float']>;
  refundUid: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PaymentStatusEnum =
  | 'PAID'
  | 'PENDING';

export type PaymentTypeEnum =
  | 'BANK_TRANSFER'
  | 'CASH'
  | 'SQUARE'
  | 'STRIPE';

export type Performance = {
  acceptStudentComps: ShowTypeSettingsOverrideEnum;
  bookingWindowBufferMinutes: Maybe<Scalars['Int']>;
  bookingWindowClosed: Scalars['Boolean'];
  bookingWindowOpen: Scalars['Boolean'];
  bracket2DoorSaleQuantity: Scalars['Int'];
  bracket2DoorSaleValue: Scalars['Float'];
  bracket2FreeEntryQuantity: Scalars['Int'];
  cachePast: Scalars['Boolean'];
  calendarHeadline: Scalars['String'];
  calendarSessions: Array<CalendarSession>;
  cancelled: Scalars['Boolean'];
  cancelledReason: Maybe<Scalars['String']>;
  codeEnabledTicketPricePoints: Array<CodeEnabledTicketPricePoint>;
  createdAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  determinedAcceptStudentComps: Scalars['Boolean'];
  determinedHasSecondBracket: Scalars['Boolean'];
  determinedSeatingCapacity: Scalars['Int'];
  determinedTicketPricingGroup: Maybe<TicketPricingGroup>;
  determinedVenue: Venue;
  doorSaleCreditCardProcessingFees: Scalars['Float'];
  doorSaleQuantity: Scalars['Int'];
  doorSaleValue: Scalars['Float'];
  doorSaleValueAfterCreditCardFees: Scalars['Float'];
  doorSalesLogged: Maybe<Scalars['Boolean']>;
  drinkSaleQuantity: Scalars['Int'];
  drinkSaleValue: Scalars['Float'];
  durationInMinutes: Scalars['Int'];
  expenses: Scalars['Float'];
  extendedDescription: Maybe<Scalars['String']>;
  freeEntryQuantity: Scalars['Int'];
  hasPromoPricePoints: Scalars['Boolean'];
  hasSecondBracket: ShowTypeSettingsOverrideEnum;
  id: Scalars['ID'];
  internalComments: Array<InternalComment>;
  name: Scalars['String'];
  offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum;
  onSaleDatetime: Maybe<Scalars['ISO8601DateTime']>;
  onlineCompedSeatQuantity: Scalars['Int'];
  onlineCreditCardProcessingFees: Scalars['Float'];
  onlineFreeRegistrationSeatQuantity: Scalars['Int'];
  onlinePaidSeatQuantity: Scalars['Int'];
  onlineReservedSeatQuantity: Scalars['Int'];
  onlineStudentSeatQuantity: Scalars['Int'];
  onlineTicketSalesValue: Scalars['Float'];
  onlineTicketSalesValueAfterCreditCardFees: Scalars['Float'];
  paidStandbyQuantity: Scalars['Int'];
  paidStandbyValue: Scalars['Float'];
  performanceTicketRegistrations: Array<PerformanceTicketRegistration>;
  performanceTicketRegistrationsCount: Scalars['Int'];
  picture: Maybe<Scalars['String']>;
  prices: Maybe<Scalars['String']>;
  producerPayoutPercentage: Scalars['Float'];
  producerShareIncome: Scalars['Float'];
  seatingCapacity: Scalars['Int'];
  seatingCapacityOverride: Maybe<Scalars['Int']>;
  seatsRemainingReport: SeatsRemainingReport;
  showType: ShowType;
  showTypeId: Scalars['ID'];
  slug: Maybe<Scalars['String']>;
  slugifiedId: Scalars['String'];
  soldOut: Scalars['Boolean'];
  standbys: Array<PerformanceStandbyQueue>;
  startDatetime: Scalars['ISO8601DateTime'];
  status: PerformanceStatusEnum;
  studentCompsRemaining: Scalars['Int'];
  studentCompsRemainingReport: SeatsRemainingReport;
  studentPerformanceAttendances: Array<StudentPerformanceAttendance>;
  studentQuotaCompAllotment: Maybe<Scalars['Int']>;
  ticShareIncome: Scalars['Float'];
  ticketBookings: Array<PerformanceTicketRegistration>;
  ticketPricingGroup: Maybe<TicketPricingGroup>;
  ticketPricingGroupId: Maybe<Scalars['ID']>;
  ticketingLink: Maybe<Scalars['String']>;
  totalAttendance: Scalars['Int'];
  totalCreditCardProcessingFees: Scalars['Float'];
  totalDonations: Scalars['Float'];
  totalFreeAttendance: Scalars['Int'];
  totalIncome: Scalars['Float'];
  totalPaidAttendance: Scalars['Int'];
  totalPaidTicketValue: Scalars['Float'];
  totalPaidTicketValueAfterCreditCardFees: Scalars['Float'];
  totalTicketingFees: Scalars['Float'];
  totalTips: Scalars['Float'];
  updatedAt: Scalars['ISO8601DateTime'];
  venue: Maybe<Venue>;
  venueCreditCardProcessingFees: Scalars['Float'];
  venueDrinkSaleQuantity: Scalars['Int'];
  venueDrinkSaleValue: Scalars['Float'];
  venueFreeEntryQuantity: Scalars['Int'];
  venueId: Maybe<Scalars['ID']>;
  venueNonPresaleAttendance: Scalars['Int'];
  venuePaidSeatQuantity: Scalars['Int'];
  venuePaidSeatQuantitySecondBracket: Scalars['Int'];
  venueTicketSalesValue: Scalars['Float'];
  venueTicketSalesValueAfterCreditCardFees: Scalars['Float'];
  workshop: Maybe<Workshop>;
};

export type PerformanceAddCompsParams = {
  bracket: TicketBracketEnum;
  name: Scalars['String'];
  paymentType: TicketPaymentTypeEnum;
  performanceId: Scalars['ID'];
  quantity: Scalars['Int'];
};

/** Autogenerated return type of PerformanceAddComps. */
export type PerformanceAddCompsPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of PerformanceAddStandby. */
export type PerformanceAddStandbyPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type PerformanceChangeFeesResponse = {
  paidTickets: Array<WorkshopChangeFeesSchedule>;
  studentTickets: Array<WorkshopChangeFeesSchedule>;
};

export type PerformanceChangeFeesScheduleParams = {
  performanceId: Scalars['ID'];
  ticketOrder: TicketOrderAttributes;
};

/** The connection type for Performance. */
export type PerformanceConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PerformanceEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Performance>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PerformanceDiscount = {
  discountAmount: Scalars['Float'];
  discountName: Scalars['String'];
  viaCode: Scalars['Boolean'];
};

/** Attributes to determine a performance discount */
export type PerformanceDiscountAttributes = {
  bracket: TicketBracketEnum;
  performanceId: Scalars['ID'];
  promoCode: InputMaybe<Scalars['String']>;
  ticketOrder: TicketOrderAttributes;
  voucherCode: Scalars['String'];
};

export type PerformanceDiscountResponse = {
  discount: Maybe<PerformanceDiscount>;
  errorMessage: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type PerformanceEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Performance>;
};

/** Attributes for performance list */
export type PerformanceListAttributes = {
  endDate: InputMaybe<Scalars['ISO8601Date']>;
  scope: PerformanceSearchScopeEnum;
  showTagIds: InputMaybe<Array<Scalars['ID']>>;
  showTypeIds: InputMaybe<Array<Scalars['ID']>>;
  startDate: InputMaybe<Scalars['ISO8601Date']>;
  statusEnum: InputMaybe<PerformanceStatusEnum>;
  venueIds: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of PerformanceLogStudentAttendance. */
export type PerformanceLogStudentAttendancePayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type PerformanceSearchScopeEnum =
  | 'ALL'
  | 'BY_DATE_RANGE'
  | 'PAST'
  | 'UPCOMING';

/** Autogenerated return type of PerformanceSetDoorSales. */
export type PerformanceSetDoorSalesPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type PerformanceStandbyQueue = {
  admitted: Maybe<Scalars['Boolean']>;
  bracket: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  performanceId: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PerformanceStatusEnum =
  | 'CANCELLED'
  | 'CONFIRMED'
  | 'PENDING';

export type PerformanceTicketRegistration = {
  bookingStatus: BookingStatusEnum;
  bracket: TicketBracketEnum;
  confirmed: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  email: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  newsletterOptIn: Maybe<Scalars['Boolean']>;
  paymentAmount: Scalars['Float'];
  paymentAmountDonation: Scalars['Float'];
  paymentAmountFees: Scalars['Float'];
  paymentAmountTickets: Scalars['Float'];
  paymentAmountTip: Scalars['Float'];
  paymentDescription: Maybe<Scalars['String']>;
  paymentType: TicketPaymentTypeEnum;
  paymentUid: Maybe<Scalars['String']>;
  pendingPurchase: Maybe<Scalars['Boolean']>;
  performance: Performance;
  performanceId: Scalars['ID'];
  redeemed: Scalars['Boolean'];
  refundAmount: Maybe<Scalars['Float']>;
  refundUid: Maybe<Scalars['String']>;
  refunded: Maybe<Scalars['Boolean']>;
  refundedAt: Maybe<Scalars['ISO8601DateTime']>;
  sendConfirmationEmails: Maybe<Scalars['Boolean']>;
  sentConfirmationEmails: Maybe<Scalars['ISO8601DateTime']>;
  telephone: Maybe<Scalars['String']>;
  ticketOrder: Maybe<TicketOrder>;
  ticketQuantityCommunityMember: Scalars['Int'];
  ticketQuantityConcession: Scalars['Int'];
  ticketQuantityFull: Scalars['Int'];
  ticketQuantityGroup: Scalars['Int'];
  ticketQuantityPaidMember: Scalars['Int'];
  ticketQuantityPatron: Scalars['Int'];
  ticketQuantityPromoCode: Scalars['Int'];
  ticketQuantityTotal: Scalars['Int'];
  token: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  user: Maybe<User>;
  userId: Maybe<Scalars['ID']>;
  utmCampaign: Maybe<Scalars['String']>;
  utmSource: Maybe<Scalars['String']>;
  workshopRegistration: Maybe<WorkshopRegistration>;
  workshopRegistrationId: Maybe<Scalars['ID']>;
};

export type Person = {
  assistedWorkshopsCount: Maybe<Scalars['Int']>;
  bio: Maybe<Scalars['String']>;
  blogBio: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  picture: Maybe<Scalars['String']>;
  pictureUrlCroppedToFace: Maybe<Scalars['String']>;
  pictureUrlWeb: Maybe<Scalars['String']>;
  playsWithTeams: Array<Team>;
  slug: Scalars['String'];
  twitterHandle: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  user: Maybe<User>;
  userId: Maybe<Scalars['ID']>;
  workshopBio: Maybe<Scalars['String']>;
  workshopsCount: Maybe<Scalars['Int']>;
};

/** Attributes for postponing some number of workshops */
export type PostponeWorkshopsAttributes = {
  /** Advanced – postpone by additional units if a session would land in this date range */
  blackoutDatesStart: InputMaybe<Scalars['ISO8601Date']>;
  /** Advanced – postpone any sessions landing in a blackout duration by the length of the blackout */
  blackoutDurationQuantity: InputMaybe<Scalars['Int']>;
  /** Advanced – postpone any sessions landing in a blackout duration by the length of the blackout */
  blackoutDurationUnit: InputMaybe<Scalars['String']>;
  /** Message to pass on to students impacted */
  messageForStudents: InputMaybe<Scalars['String']>;
  /** Postpone by this many units */
  postponeByQuantity: Scalars['Int'];
  /** Unit of time to postpone by (day/week/etc.) */
  postponeByUnit: Scalars['String'];
  /** Only postpone sessions taking place on or after this date */
  sessionsOnOrAfter: Scalars['ISO8601Date'];
  /** IDs of workshops to postpone */
  workshopIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of PostponeWorkshops. */
export type PostponeWorkshopsPayload = {
  errors: Array<UserError>;
  workshops: Maybe<Array<Workshop>>;
};

export type PostponeWorkshopsValidityReport = {
  conflictingWorkshopId: Maybe<Scalars['ID']>;
  invalidReason: Maybe<Scalars['String']>;
  newEndDatetime: Scalars['ISO8601DateTime'];
  newStartDatetime: Scalars['ISO8601DateTime'];
  valid: Scalars['Boolean'];
  workshopSessionId: Scalars['ID'];
};

/** Autogenerated return type of PreregistrationCheckoutConfirmPending. */
export type PreregistrationCheckoutConfirmPendingPayload = {
  errors: Array<UserError>;
  preregistration: Maybe<WorkshopPreregistration>;
};

export type PreregistrationCheckoutInput = {
  apiSource: InputMaybe<Scalars['String']>;
  discountCode: InputMaybe<Scalars['String']>;
  donationAmount: Scalars['Float'];
  passPreferences: Scalars['String'];
  paymentDueTodayCents: Scalars['Int'];
  paymentMode: WorkshopPaymentModeEnum;
  paymentPlanInitialPercentage: InputMaybe<PaymentPlanPaymentPercentageEnum>;
  priceType: WorkshopPriceTypeEnum;
  repeatPreferences: Scalars['String'];
  stripeToken: InputMaybe<Scalars['String']>;
};

/** Custom attributes for this query */
export type PreregistrationCheckoutParams = {
  apiSource: InputMaybe<Scalars['String']>;
  discountCode: InputMaybe<Scalars['String']>;
  donationAmount: Scalars['Float'];
  passPreferences: Scalars['String'];
  paymentDueTodayCents: Scalars['Int'];
  paymentMode: WorkshopPaymentModeEnum;
  paymentPlanInitialPercentage: InputMaybe<PaymentPlanPaymentPercentageEnum>;
  priceType: WorkshopPriceTypeEnum;
  repeatPreferences: Scalars['String'];
};

export type PreregistrationCheckoutParamsResponse = {
  errorMessage: Maybe<Scalars['String']>;
  isFree: Maybe<Scalars['Boolean']>;
  paymentIntent: Maybe<PaymentIntent>;
  preregistration: Maybe<WorkshopPreregistration>;
};

/** Autogenerated return type of PreregistrationCheckout. */
export type PreregistrationCheckoutPayload = {
  errors: Array<UserError>;
  preregistration: Maybe<WorkshopPreregistration>;
};

export type PreregistrationDiscounts = {
  anytimeDiscountInDollars: Scalars['Int'];
  dayOneDiscountInDollars: Scalars['Int'];
  weekOneDiscountInDollars: Scalars['Int'];
  weekTwoDiscountInDollars: Scalars['Int'];
};

export type PreregistrationFulfillmentStatusEnum =
  | 'ADVANCING'
  | 'CONVERTED_TO_OPTIMISTIC'
  | 'PENDING'
  | 'REPEATING'
  | 'UNFULFILLED'
  | 'WAITING_FOR_PAYMENT';

export type PreregistrationRerankPreferencesInput = {
  currentLevelPreferences: Scalars['String'];
  nextLevelPreferences: Scalars['String'];
  preregistrationId: Scalars['ID'];
};

/** Autogenerated return type of PreregistrationRerankPreferences. */
export type PreregistrationRerankPreferencesPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type PreregistrationUserStatus = {
  activeWorkshopPreregistrationPeriod: Maybe<WorkshopPreregistrationPeriod>;
  currentWorkshopRegistrations: Array<WorkshopRegistration>;
  discountedVoucher: Maybe<SingleUseVoucher>;
  discounts: PreregistrationDiscounts;
  paymentPlanAvailable: Scalars['Boolean'];
  upcomingWorkshopPreregistrationPeriod: Maybe<WorkshopPreregistrationPeriod>;
  workshopPreregistration: Maybe<WorkshopPreregistration>;
};

export type ProductionCompanyEnum =
  | 'NFP'
  | 'PTY_LTD';

export type ProductionTypeEnum =
  | 'MANUAL_DOOR_SPLIT'
  | 'STANDARD_DOOR_SPLIT';

export type ProgramContinuationPlansEnum =
  | 'ALREADY_BOOKED_VIA_PREREGISTRATION'
  | 'DO_NOT_PLAN_TO_CONTINUE'
  | 'OTHER'
  | 'PLAN_TO_CONTINUE_BASED_ON_AVAILABILITY'
  | 'PLAN_TO_CONTINUE_OTHER'
  | 'UNKNOWN';

export type PronounsEnum =
  | 'HE_HIM'
  | 'OTHER'
  | 'SHE_HER'
  | 'THEY_THEM'
  | 'UNKNOWN';

export type PublicStatistics = {
  allWorkshopCount: Scalars['Int'];
  coreWorkshopCount: Scalars['Int'];
  performanceCount: Scalars['Int'];
  personCount: Scalars['Int'];
};

export type Query = {
  /** Active site announcements for today */
  activeSiteAnnouncements: Array<SiteAnnouncement>;
  adminDonationToNfpReport: Array<DonationToNfp>;
  /** Read a NewsItem */
  adminNewsItem: NewsItem;
  /** List all NewsItem */
  adminNewsItemList: Array<NewsItem>;
  /** Read a Person */
  adminPerson: Person;
  /** List all Person */
  adminPersonList: Array<Person>;
  /** Read a SingleUseVoucher */
  adminSingleUseVoucher: SingleUseVoucher;
  /** List all SingleUseVoucher */
  adminSingleUseVoucherList: Array<SingleUseVoucher>;
  /** Read a TheatreMembership */
  adminTheatreMembership: TheatreMembership;
  /** List all TheatreMembership */
  adminTheatreMembershipList: Array<TheatreMembership>;
  /** Read a TicketPricingGroup */
  adminTicketPricingGroup: TicketPricingGroup;
  /** List all TicketPricingGroup */
  adminTicketPricingGroupList: Array<TicketPricingGroup>;
  adminWorkshopPreregistrationPeriod: WorkshopPreregistrationPeriod;
  adminWorkshopPreregistrationPeriodList: Array<WorkshopPreregistrationPeriod>;
  /** Get workshop templates */
  adminWorkshopTemplates: Array<WorkshopTemplate>;
  /** Look up multiple users */
  batchUserInfoAdmin: Array<User>;
  blogBySlug: Maybe<Blog>;
  /** Get all blogs, paginated */
  blogs: BlogPage;
  /** Determine whether it's possible to postpone workshops before taking action */
  checkPostponeWorkshopsValidity: Array<PostponeWorkshopsValidityReport>;
  /** Determine whether it's possible to schedule some calendar sessions */
  checkVenueAvailability: Array<VenueAvailabilityReport>;
  /** My new query */
  courseEvaluationQuery: CourseEvaluationQueryResponse;
  /** Current user */
  currentUser: Maybe<User>;
  /** When asking a customer how they heard about us, what are the options? */
  customerReferralOptions: Array<Scalars['String']>;
  featuredNewsItem: Maybe<NewsItem>;
  /** My new query */
  freeTrialOffers: FreeTrialOffers;
  /** Search instructors */
  instructorSearchAdmin: Array<Person>;
  myPreregistration: WorkshopPreregistration;
  mySitePermissions: MySitePermissionsReturn;
  /** My new query */
  myTheatreMembership: TheatreMembership;
  /** My new query */
  myTheatreMemberships: Array<TheatreMembership>;
  /** My new query */
  myTicketDetails: Maybe<PerformanceTicketRegistration>;
  myVoucher: SingleUseVoucher;
  /** My new query */
  myWorkshopsProgress: Maybe<Array<WorkshopLevelProgress>>;
  /** Get news item by slug */
  newsItemBySlug: Maybe<NewsItem>;
  /** All news items, paginated */
  newsItems: NewsItemPage;
  /** Get news items by category, paginated */
  newsItemsByCategory: NewsItemPage;
  /** What's the user's optimistic preregistration status? */
  optimisticPreregistrationUserStatus: Maybe<OptimisticPreregistrationUserStatus>;
  /** Generate a Stripe PaymentIntent for a new Donation */
  paymentIntentDonation: PaymentIntentDonation;
  /** Generate a Stripe PaymentIntent for a new Membership */
  paymentIntentMembership: PaymentIntentMembership;
  /** My new query */
  paymentIntentPreregistration: PreregistrationCheckoutParamsResponse;
  /** Generate Stripe PaymentIntent for ticket checkout */
  paymentIntentTickets: PaymentIntentResponse;
  /** Payment intent for a workshop voucher purchase */
  paymentIntentWorkshopVoucher: PaymentIntentWorkshopVoucherResponse;
  /** My new query */
  paymentIntentWorkshops: WorkshopCheckoutParamsResponse;
  /** My new query */
  paymentPlanCheckInitialPayments: Array<PaymentPlanOption>;
  /** My new query */
  paymentPlanCheckStatus: PaymentPlanCheckStatus;
  peopleBySlug: Array<Person>;
  performanceChangeFeesSchedule: PerformanceChangeFeesResponse;
  /** Find multiple performances by IDs */
  performanceDetailsAdmin: Array<Performance>;
  /** Lookup performance discount by code */
  performanceDiscount: PerformanceDiscountResponse;
  /** My new query */
  performanceInfo: Performance;
  /** Advanced performances list */
  performancesListAdmin: PerformanceConnection;
  /** List of all confirmed, upcoming performances at the theatre */
  performancesUpcoming: Array<Performance>;
  personBySlug: Maybe<Person>;
  personList: Array<Person>;
  personLookup: Array<Person>;
  /** What's the user's preregistration status? */
  preregistrationUserStatus: Maybe<PreregistrationUserStatus>;
  /** True user via Pretender gem */
  pretenderTrueUser: Maybe<User>;
  publicStatistics: PublicStatistics;
  /** Confirmed workshop registrations with pending community referrals */
  referralBonusPendingWorkshopRegistrations: Array<WorkshopRegistration>;
  /** My new query */
  selfServeTicketTransferFee: SelfServeTicketTransferFeeResponse;
  /** My new query */
  selfServeTicketTransferPermission: SelfServeTicketTransferPermissionReturn;
  /** Check the status of a user-initiated ticket transfer */
  selfServeTicketTransferStatus: SelfServeTicketTransfer;
  /** My new query */
  selfServeTicketVoucherValue: SelfServeTicketVoucherValueResponse;
  /** My new query */
  selfServeWorkshopDeferralValue: SelfServeWorkshopDeferralValueResponse;
  /** My new query */
  selfServeWorkshopTransferFee: SelfServeWorkshopTransferFeeResponse;
  /** Check the status of a user-initiated workshop transfer */
  selfServeWorkshopTransferStatus: SelfServeWorkshopTransfer;
  /** Referral code from session */
  sessionReferralCode: Scalars['String'];
  /** My new query */
  showTagInfo: Maybe<ShowTag>;
  /** My new query */
  showTagPerformanceList: Array<Performance>;
  /** List all show tags */
  showTagsListAdmin: Array<ShowTag>;
  /** My new query */
  showTypeBySlug: Maybe<ShowType>;
  /** My new query */
  showTypeStudentShowcase: ShowType;
  /** Retrieve a ShowTypes upcoming performances by ID */
  showTypeUpcomingPerformances: Array<Performance>;
  /** List all show types */
  showTypesListAdmin: Array<ShowType>;
  /** Get public site constants */
  siteConstants: SiteConstants;
  /** My new query */
  siteFeatures: SiteFeaturesReturn;
  standaloneDonation: StandaloneDonationToNfp;
  teamBySlug: Maybe<Team>;
  teamCategoryList: Array<TeamCategory>;
  teamList: Array<Team>;
  /** Pricing information for theatre memberships */
  theatreMembershipPricing: Scalars['Int'];
  /** My new query */
  throwError: Scalars['String'];
  /** Find a ticket by ID */
  ticketInfo: PerformanceTicketRegistration;
  /** Find a TicketOrder by uuid */
  ticketOrder: TicketOrder;
  /** My new query */
  ticketPricePointForCode: TicketPricePointForCodeReturn;
  /** List of all ticket pricing groups */
  ticketPricingGroupsListAdmin: Array<TicketPricingGroup>;
  /** Look up a user */
  userInfoAdmin: User;
  /** Information about a user's tie to a performance */
  userPerformanceInfo: Maybe<UserPerformanceInfo>;
  /** Search for a user by name, email or ID */
  userSearchAdmin: Array<User>;
  /** My new query */
  venueBlackoutsPublic: Array<VenueListPublicReturn>;
  /** List all venues */
  venuesListAdmin: Array<Venue>;
  /** List all publicly listed venues */
  venuesListPublic: Array<Venue>;
  workshopAttendanceQuery: CalendarSession;
  /** List all workshop categories */
  workshopCategoriesListAdmin: Array<WorkshopCategory>;
  /** Get a workshop category */
  workshopCategory: WorkshopCategory;
  /** My new query */
  workshopChangeFeesSchedule: Array<WorkshopChangeFeesSchedule>;
  /** My new query */
  workshopChangeFeesScheduleFreeTrialPurchase: Maybe<Array<WorkshopChangeFeesSchedule>>;
  /** Find multiple workshops by IDs */
  workshopDetailsAdmin: Array<Workshop>;
  /** My new query */
  workshopDiscount: WorkshopDiscountResponse;
  /** Find a workshop by ID */
  workshopInfo: Workshop;
  /** My new query */
  workshopInstructorPermissions: WorkshopInstructorPermissionsReturn;
  /** Find a workshop level by Slug */
  workshopLevelBySlug: WorkshopLevel;
  /** Find a workshop level by ID */
  workshopLevelInfo: WorkshopLevel;
  /** List all workshop levels */
  workshopLevelsList: Array<WorkshopLevel>;
  /** List all workshop levels for public */
  workshopLevelsListPublic: Array<WorkshopLevel>;
  workshopPaymentPlanAvailable: WorkshopPaymentPlanAvailableResponse;
  /** Determine if currentUser has permission to book a workshop */
  workshopPermissionCheck: WorkshopPermissionResult;
  /** List all workshop pricing groups */
  workshopPricingGroupsListAdmin: Array<WorkshopPricingGroup>;
  /** My new query */
  workshopRegistrationDetails: Maybe<WorkshopRegistration>;
  /** Find multiple workshop registrations by IDs */
  workshopRegistrationDetailsAdmin: Array<WorkshopRegistration>;
  /** Search for a workshop by name or ID */
  workshopSearchAdmin: Array<Workshop>;
  /** Return all in-term workshop registrations */
  workshopStudentsInTerm: Array<WorkshopRegistration>;
  /** My new query */
  workshopTagInfo: Array<Workshop>;
  workshopTermBySlug: Maybe<WorkshopTerm>;
  /** My new query */
  workshopTermsList: Array<WorkshopTerm>;
  /** List all workshop terms */
  workshopTermsListAdmin: Array<Scalars['String']>;
  /** Check pricing for workshop vouchers */
  workshopVoucherCheckPrice: WorkshopVoucherCheckPrice;
  workshopWaitingListStatus: Maybe<WorkshopWaitingListStatus>;
  /** Upcoming intro courses and discount for user */
  workshopsFreeTrialSellClassOptions: Array<SellClassOption>;
  /** Advanced workshops list */
  workshopsListAdmin: WorkshopConnection;
  /** List of all confirmed, upcoming workshops at the theatre */
  workshopsUpcoming: Array<Workshop>;
};


export type QueryAdminDonationToNfpReportArgs = {
  params: AdminDonationToNfpInput;
};


export type QueryAdminNewsItemArgs = {
  id: Scalars['ID'];
};


export type QueryAdminPersonArgs = {
  id: Scalars['ID'];
};


export type QueryAdminSingleUseVoucherArgs = {
  id: Scalars['ID'];
};


export type QueryAdminTheatreMembershipArgs = {
  id: Scalars['ID'];
};


export type QueryAdminTicketPricingGroupArgs = {
  id: Scalars['ID'];
};


export type QueryAdminWorkshopPreregistrationPeriodArgs = {
  id: Scalars['ID'];
};


export type QueryBatchUserInfoAdminArgs = {
  userIds: Array<Scalars['ID']>;
};


export type QueryBlogBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryBlogsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryCheckPostponeWorkshopsValidityArgs = {
  attributes: PostponeWorkshopsAttributes;
};


export type QueryCheckVenueAvailabilityArgs = {
  params: CheckVenueAvailabilityInput;
};


export type QueryCourseEvaluationQueryArgs = {
  workshopRegistrationId: Scalars['ID'];
};


export type QueryFreeTrialOffersArgs = {
  workshopCategoryId: Scalars['ID'];
};


export type QueryInstructorSearchAdminArgs = {
  searchAttributes: InstructorSearchAttributes;
};


export type QueryMyPreregistrationArgs = {
  id: Scalars['ID'];
};


export type QueryMyTheatreMembershipArgs = {
  id: Scalars['ID'];
};


export type QueryMyTicketDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryMyVoucherArgs = {
  id: Scalars['ID'];
};


export type QueryNewsItemBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryNewsItemsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryNewsItemsByCategoryArgs = {
  category: NewsItemCategoryEnum;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryPaymentIntentDonationArgs = {
  params: PaymentIntentDonationInput;
};


export type QueryPaymentIntentMembershipArgs = {
  params: PaymentIntentMembershipInput;
};


export type QueryPaymentIntentPreregistrationArgs = {
  params: PreregistrationCheckoutParams;
};


export type QueryPaymentIntentTicketsArgs = {
  params: TicketCheckoutParams;
};


export type QueryPaymentIntentWorkshopVoucherArgs = {
  params: PaymentIntentWorkshopVoucherParams;
};


export type QueryPaymentIntentWorkshopsArgs = {
  params: WorkshopCheckoutParams;
};


export type QueryPaymentPlanCheckInitialPaymentsArgs = {
  params: PaymentPlanCheckInitialPayments;
};


export type QueryPaymentPlanCheckStatusArgs = {
  workshopPaymentLedgerId: Scalars['ID'];
};


export type QueryPeopleBySlugArgs = {
  slugs: Array<Scalars['String']>;
};


export type QueryPerformanceChangeFeesScheduleArgs = {
  params: PerformanceChangeFeesScheduleParams;
};


export type QueryPerformanceDetailsAdminArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryPerformanceDiscountArgs = {
  params: PerformanceDiscountAttributes;
};


export type QueryPerformanceInfoArgs = {
  id: Scalars['ID'];
};


export type QueryPerformancesListAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  params: PerformanceListAttributes;
};


export type QueryPersonBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryPersonLookupArgs = {
  ids: Array<Scalars['ID']>;
};


export type QuerySelfServeTicketTransferFeeArgs = {
  params: SelfServeTicketTransferFeeParams;
};


export type QuerySelfServeTicketTransferPermissionArgs = {
  params: SelfServeTicketTransferPermissionParams;
};


export type QuerySelfServeTicketTransferStatusArgs = {
  transferId: Scalars['ID'];
};


export type QuerySelfServeTicketVoucherValueArgs = {
  ticketId: Scalars['ID'];
};


export type QuerySelfServeWorkshopDeferralValueArgs = {
  workshopRegistrationId: Scalars['ID'];
};


export type QuerySelfServeWorkshopTransferFeeArgs = {
  params: SelfServeWorkshopTransferFeeParams;
};


export type QuerySelfServeWorkshopTransferStatusArgs = {
  transferId: Scalars['ID'];
};


export type QueryShowTagInfoArgs = {
  slug: Scalars['String'];
};


export type QueryShowTagPerformanceListArgs = {
  params: ShowTagPerformanceListAttributes;
};


export type QueryShowTypeBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryShowTypeUpcomingPerformancesArgs = {
  id: Scalars['ID'];
};


export type QueryStandaloneDonationArgs = {
  uuid: Scalars['String'];
};


export type QueryTeamBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryTicketInfoArgs = {
  ticketId: Scalars['ID'];
};


export type QueryTicketOrderArgs = {
  uuid: Scalars['String'];
};


export type QueryTicketPricePointForCodeArgs = {
  params: TicketPricePointForCodeInput;
};


export type QueryUserInfoAdminArgs = {
  userId: Scalars['ID'];
};


export type QueryUserPerformanceInfoArgs = {
  performanceId: Scalars['ID'];
};


export type QueryUserSearchAdminArgs = {
  searchAttributes: UserSearchAttributes;
};


export type QueryVenueBlackoutsPublicArgs = {
  blackoutSessionsBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QueryWorkshopAttendanceQueryArgs = {
  workshopSessionId: Scalars['ID'];
};


export type QueryWorkshopCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryWorkshopChangeFeesScheduleArgs = {
  id: Scalars['ID'];
};


export type QueryWorkshopChangeFeesScheduleFreeTrialPurchaseArgs = {
  id: Scalars['ID'];
};


export type QueryWorkshopDetailsAdminArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryWorkshopDiscountArgs = {
  params: WorkshopDiscountQueryAttributes;
};


export type QueryWorkshopInfoArgs = {
  id: Scalars['ID'];
};


export type QueryWorkshopInstructorPermissionsArgs = {
  workshopId: Scalars['ID'];
};


export type QueryWorkshopLevelBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryWorkshopLevelInfoArgs = {
  id: Scalars['ID'];
};


export type QueryWorkshopPaymentPlanAvailableArgs = {
  workshopId: Scalars['ID'];
};


export type QueryWorkshopPermissionCheckArgs = {
  params: WorkshopPermissionCheckParams;
};


export type QueryWorkshopRegistrationDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryWorkshopRegistrationDetailsAdminArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryWorkshopSearchAdminArgs = {
  searchAttributes: WorkshopSearchAttributes;
};


export type QueryWorkshopTagInfoArgs = {
  tag: Scalars['String'];
};


export type QueryWorkshopTermBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryWorkshopTermsListArgs = {
  params: WorkshopTermsListInput;
};


export type QueryWorkshopVoucherCheckPriceArgs = {
  params: WorkshopVoucherCheckPriceInput;
};


export type QueryWorkshopWaitingListStatusArgs = {
  workshopId: Scalars['ID'];
};


export type QueryWorkshopsFreeTrialSellClassOptionsArgs = {
  userId: Scalars['ID'];
  workshopCategoryId: Scalars['ID'];
};


export type QueryWorkshopsListAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  params: WorkshopsListAttributes;
};

export type ReconciliationModeEnum =
  | 'NFP_SUPPORT_MODEL'
  | 'NONE'
  | 'ONCE_OFF_VENUE_HIRE'
  | 'SEASONAL_VENUE_HIRE';

/** Autogenerated return type of ReferralBonusAward. */
export type ReferralBonusAwardPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of ReferralBonusReject. */
export type ReferralBonusRejectPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type RestrictedToPurchasable = Workshop | WorkshopCategory | WorkshopLevel;

export type SalesEmailCategory = {
  displayDescription: Scalars['String'];
  displayName: Scalars['String'];
  internalName: Scalars['String'];
  subscribed: Scalars['Boolean'];
};

export type SeatsRemainingReport = {
  bothBrackets: Maybe<Scalars['Int']>;
  firstBracket: Scalars['Int'];
  secondBracket: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of SelfServeIssueTicketVoucher. */
export type SelfServeIssueTicketVoucherPayload = {
  errors: Array<UserError>;
  success: Maybe<SelfServeIssueTicketVoucherSuccess>;
};

export type SelfServeIssueTicketVoucherSuccess = {
  ticket: PerformanceTicketRegistration;
  voucher: Maybe<SingleUseVoucher>;
};

export type SelfServeTicketTransfer = {
  bookingStatus: SelfServeTicketTransferStatusEnum;
  createdAt: Scalars['ISO8601DateTime'];
  existingTicket: PerformanceTicketRegistration;
  existingTicketId: Scalars['Int'];
  id: Scalars['ID'];
  newPerformance: Performance;
  newPerformanceId: Scalars['Int'];
  payment: Maybe<Payment>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of SelfServeTicketTransferConfirm. */
export type SelfServeTicketTransferConfirmPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type SelfServeTicketTransferFeeInfo = {
  costsBreakdown: Array<WorkshopCreditFee>;
  isFree: Scalars['Boolean'];
  paymentIntent: Maybe<PaymentIntent>;
  transferId: Scalars['ID'];
};

/** Custom attributes for this query */
export type SelfServeTicketTransferFeeParams = {
  existingTicketId: Scalars['ID'];
  newPerformanceId: Scalars['ID'];
};

export type SelfServeTicketTransferFeeResponse = {
  errorMessage: Maybe<Scalars['String']>;
  transferFeeInfo: Maybe<SelfServeTicketTransferFeeInfo>;
};

export type SelfServeTicketTransferPermissionError = {
  errorMessage: Scalars['String'];
};

/** Custom attributes for this query */
export type SelfServeTicketTransferPermissionParams = {
  existingTicketId: Scalars['ID'];
  newPerformanceId: Scalars['ID'];
};

export type SelfServeTicketTransferPermissionReturn = SelfServeTicketTransferPermissionError | SelfServeTicketTransferPermissionSuccess;

export type SelfServeTicketTransferPermissionSuccess = {
  success: Maybe<Scalars['Boolean']>;
};

export type SelfServeTicketTransferStatusEnum =
  | 'CONFIRMED'
  | 'PENDING_CONFIRMATION'
  | 'PENDING_PAYMENT';

export type SelfServeTicketVoucherValueResponse = {
  costsBreakdown: Array<WorkshopCreditFee>;
  totalCosts: Scalars['Float'];
  voucherValue: Scalars['Float'];
};

/** Autogenerated return type of SelfServeWorkshopDeferral. */
export type SelfServeWorkshopDeferralPayload = {
  errors: Array<UserError>;
  success: Maybe<SelfServeWorkshopDeferralSuccess>;
};

export type SelfServeWorkshopDeferralSuccess = {
  voucher: Maybe<SingleUseVoucher>;
  workshopRegistration: WorkshopRegistration;
};

export type SelfServeWorkshopDeferralValueResponse = {
  costsBreakdown: Array<WorkshopCreditFee>;
  totalCosts: Scalars['Float'];
  voucherValue: Scalars['Float'];
};

export type SelfServeWorkshopTransfer = {
  bookingStatus: SelfServeWorkshopTransferStatusEnum;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  payment: Maybe<Payment>;
  updatedAt: Scalars['ISO8601DateTime'];
  workshop: Workshop;
  workshopId: Scalars['ID'];
  workshopRegistration: WorkshopRegistration;
  workshopRegistrationId: Scalars['ID'];
};

/** Autogenerated return type of SelfServeWorkshopTransferConfirm. */
export type SelfServeWorkshopTransferConfirmPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type SelfServeWorkshopTransferFeeInfo = {
  costsBreakdown: Array<WorkshopCreditFee>;
  isFree: Scalars['Boolean'];
  paymentIntent: Maybe<PaymentIntent>;
  transferId: Scalars['ID'];
};

/** Custom attributes for this query */
export type SelfServeWorkshopTransferFeeParams = {
  password: Scalars['String'];
  workshopId: Scalars['ID'];
  workshopRegistrationId: Scalars['ID'];
};

export type SelfServeWorkshopTransferFeeResponse = {
  errorMessage: Maybe<Scalars['String']>;
  transferFeeInfo: Maybe<SelfServeWorkshopTransferFeeInfo>;
};

export type SelfServeWorkshopTransferStatusEnum =
  | 'CONFIRMED'
  | 'PENDING_CONFIRMATION'
  | 'PENDING_PAYMENT';

export type SellClassOption = {
  discounts: Array<WorkshopDiscount>;
  workshop: Workshop;
};

export type SendMailMergeForCustomersInput = {
  bodyWithVariables: Scalars['String'];
  ccSender: Scalars['Boolean'];
  customerIds: Array<Scalars['ID']>;
  replyTo: CustomerReplyToEnum;
  subjectWithVariables: Scalars['String'];
};

/** Autogenerated return type of SendMailMergeForCustomers. */
export type SendMailMergeForCustomersPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type SendMailMergeForWorkshopsInput = {
  bodyWithVariables: Scalars['String'];
  ccInstructors: Scalars['Boolean'];
  ccSender: Scalars['Boolean'];
  replyTo: WorkshopsReplyToEnum;
  skipWorkshopRegistrationIds: Array<Scalars['ID']>;
  subjectWithVariables: Scalars['String'];
  workshopIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of SendMailMergeForWorkshops. */
export type SendMailMergeForWorkshopsPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type SessionModeEnum =
  | 'EIGHT_SESSION'
  | 'FOUR_SESSION'
  | 'SINGLE_SESSION'
  | 'VARIABLE_SESSION';

export type ShowTag = {
  createdAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  pictureUrl: Maybe<Scalars['String']>;
  pictureVariant500pxUrl: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  upcomingPerformancesForPublic: Array<Performance>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Custom attributes for this query */
export type ShowTagPerformanceListAttributes = {
  includePrevious: Scalars['Boolean'];
  showTagSlug: Scalars['String'];
};

export type ShowType = {
  acceptPasses: Maybe<Scalars['Boolean']>;
  acceptStudentComps: Scalars['Boolean'];
  calendarPreview: Scalars['String'];
  calendarThumbnailUrlWeb: Maybe<Scalars['String']>;
  castMembers: Array<Person>;
  category: ShowTypeCategoryEnum;
  codeEnabledTicketPricePoints: Array<CodeEnabledTicketPricePoint>;
  createdAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  discountCodePrefix: Scalars['String'];
  extendedDescription: Scalars['String'];
  externalTicketingLink: Maybe<Scalars['String']>;
  externalTicketingPrice: Maybe<Scalars['String']>;
  frequencyText: Maybe<Scalars['String']>;
  hasSecondBracket: Scalars['Boolean'];
  headliner: Scalars['Boolean'];
  id: Scalars['ID'];
  mailchimpTicketPurchaseGrouping: Maybe<Scalars['String']>;
  multipleBracketPricingGroup: Maybe<TicketPricingGroup>;
  multipleBracketPricingGroupId: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  offerEarlyBirdDiscount: Maybe<Scalars['Boolean']>;
  performanceDurationMinutesOverride: Maybe<Scalars['Int']>;
  picture: Maybe<Scalars['String']>;
  pictureUrlWeb: Maybe<Scalars['String']>;
  position: Maybe<Scalars['Int']>;
  presentedByNfp: Scalars['Boolean'];
  productionCompany: ProductionCompanyEnum;
  productionType: ProductionTypeEnum;
  reconciliationMode: ReconciliationModeEnum;
  showListCategoryId: Maybe<Scalars['ID']>;
  showTags: Array<ShowTag>;
  slug: Scalars['String'];
  standardDescription: Scalars['String'];
  standardExpenses: Scalars['Float'];
  studentCompWorkshopCategories: Array<WorkshopCategory>;
  studentQuotaCompAllotment: Scalars['Int'];
  studentViewingQuotaCreditGiven: Scalars['Boolean'];
  teamCategory: Maybe<TeamCategory>;
  teamCategoryId: Maybe<Scalars['ID']>;
  ticketPricingGroup: Maybe<TicketPricingGroup>;
  ticketPricingGroupId: Maybe<Scalars['ID']>;
  ticketingMode: TicketingModeEnum;
  ticketingType: Maybe<Scalars['String']>;
  upcomingPerformancesForPublic: Array<Performance>;
  updatedAt: Scalars['ISO8601DateTime'];
  venue: Venue;
  venueId: Scalars['ID'];
  visible: Scalars['Boolean'];
  websiteUrl: Scalars['String'];
};

export type ShowTypeCategoryEnum =
  | 'JAM'
  | 'SHOW'
  | 'STUDENT_SHOWCASE';

export type ShowTypeSettingsOverrideEnum =
  | 'DEFAULT'
  | 'OVERRIDE_NO'
  | 'OVERRIDE_YES';

export type SimplePageInfo = {
  currentPage: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nodesCount: Scalars['Int'];
  pagesCount: Scalars['Int'];
  perPage: Scalars['Int'];
};

/** Attributes for a single calendar session availability query */
export type SingleCalendarSessionAttributes = {
  description: InputMaybe<Scalars['String']>;
  endDatetime: Scalars['ISO8601DateTime'];
  id: InputMaybe<Scalars['ID']>;
  scope: VenueAvailabilityScope;
  startDatetime: Scalars['ISO8601DateTime'];
  venueId: InputMaybe<Scalars['ID']>;
};

export type SingleUseVoucher = {
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  expiryDate: Scalars['ISO8601Date'];
  hasVoucherId: Maybe<Scalars['ID']>;
  hasVoucherType: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  maximumDollarValue: Scalars['Float'];
  memo: Scalars['String'];
  payment: Maybe<Payment>;
  paymentStatus: VoucherPaymentStatus;
  redeemed: Scalars['Boolean'];
  restrictedToPurchasable: Maybe<RestrictedToPurchasable>;
  restrictedToPurchasableId: Maybe<Scalars['ID']>;
  restrictedToPurchasableType: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  voucherType: VoucherTypeEnum;
};

export type SiteAnnouncement = {
  actionLink: Maybe<Scalars['String']>;
  actionText: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  browseLink: Maybe<Scalars['String']>;
  browseText: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  endDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  message: Scalars['String'];
  name: Scalars['String'];
  scope: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SiteConstants = {
  coreWorkshopRequiredRepeatDiscountPercentage: Scalars['Int'];
  coreWorkshopVoluntaryRepeatDiscountPercentage: Scalars['Int'];
  freeTrialComplimentaryChangeWindowInHours: Scalars['Int'];
  minimumSessionsToProvideAbsenceCompensation: Scalars['Int'];
  paymentPlanFeeMultiplierMiddleOfTerm: Scalars['Int'];
  paymentPlanFeeMultiplierStartOfTerm: Scalars['Int'];
  ticketingCommunityPriceWindowDays: Scalars['Int'];
  ticketingStudentCompWindowDays: Scalars['Int'];
};

export type SiteFeaturesReturn = {
  optimisticWorkshopBookingsEnabled: Scalars['Boolean'];
};

export type StandaloneDonationToNfp = {
  amount: Scalars['Float'];
  createdAt: Scalars['ISO8601DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  paymentStatus: Scalars['String'];
  telephone: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  uuid: Scalars['String'];
};

export type StudentAvailability = {
  createdAt: Scalars['ISO8601DateTime'];
  fridayDaytime: StudentAvailabilityEnum;
  fridayEvening: StudentAvailabilityEnum;
  id: Scalars['ID'];
  mondayDaytime: StudentAvailabilityEnum;
  mondayEvening: StudentAvailabilityEnum;
  saturdayDaytime: StudentAvailabilityEnum;
  saturdayEvening: StudentAvailabilityEnum;
  startingFrom: Maybe<Scalars['ISO8601Date']>;
  sundayDaytime: StudentAvailabilityEnum;
  sundayEvening: StudentAvailabilityEnum;
  thursdayDaytime: StudentAvailabilityEnum;
  thursdayEvening: StudentAvailabilityEnum;
  tuesdayDaytime: StudentAvailabilityEnum;
  tuesdayEvening: StudentAvailabilityEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  userId: Maybe<Scalars['ID']>;
  wednesdayDaytime: StudentAvailabilityEnum;
  wednesdayEvening: StudentAvailabilityEnum;
};

export type StudentAvailabilityEnum =
  | 'FULL_AVAILABILITY'
  | 'POTENTIAL_AVAILABILITY'
  | 'UNAVAILABLE';

export type StudentCompReport = {
  jamsTotal: Scalars['Int'];
  jamsUsed: Scalars['Int'];
  showsTotal: Scalars['Int'];
  showsUsed: Scalars['Int'];
  studentDisciplines: Array<ComedyDisciplineEnum>;
  usedPerformanceIds: Array<Scalars['ID']>;
};

export type StudentPerformanceAttendance = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  performance: Performance;
  performanceId: Maybe<Scalars['ID']>;
  updatedAt: Scalars['ISO8601DateTime'];
  workshopRegistration: WorkshopRegistration;
  workshopRegistrationId: Maybe<Scalars['ID']>;
};

export type StudentPerksModeEnum =
  | 'CONFIGURABLE_PER_WORKSHOP'
  | 'DISABLED'
  | 'ENABLED_FOR_WORKSHOP_LEVEL';

export type StudentProfile = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  pronounsEnum: Maybe<PronounsEnum>;
  pronounsOther: Maybe<Scalars['String']>;
  referralDetail: Maybe<Scalars['String']>;
  referralProcessed: Maybe<Scalars['Boolean']>;
  referralSource: Maybe<Scalars['String']>;
  specialNeeds: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  usedPronouns: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['ID']>;
};

export type StudentWorkshopAttendance = {
  calendarSession: CalendarSession;
  calendarSessionId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  locked: Scalars['Boolean'];
  notes: Scalars['String'];
  state: StudentWorkshopAttendanceStateEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  workshopRegistration: WorkshopRegistration;
  workshopRegistrationId: Scalars['ID'];
};

export type StudentWorkshopAttendanceStateEnum =
  | 'ABSENT'
  | 'PARTIAL'
  | 'PRESENT';

export type Subscription = {
  performanceUpdated: Performance;
};


export type SubscriptionPerformanceUpdatedArgs = {
  performanceId: Scalars['ID'];
};

export type SubscriptionInput = {
  subscribed: Scalars['Boolean'];
  subscriptionName: Scalars['String'];
};

export type TeacherEvaluateStudentInput = {
  evaluation: IndividualStudentEvaluationInput;
  workshopId: Scalars['ID'];
};

/** Autogenerated return type of TeacherEvaluateStudent. */
export type TeacherEvaluateStudentPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of TeacherLockAttendance. */
export type TeacherLockAttendancePayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of TeacherLockEvaluations. */
export type TeacherLockEvaluationsPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type TeacherTakeAttendanceInput = {
  attendanceRecords: Array<IndividualStudentWorkshopAttendanceInput>;
  workshopSessionId: Scalars['ID'];
};

/** Autogenerated return type of TeacherTakeAttendance. */
export type TeacherTakeAttendancePayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type Team = {
  bio: Maybe<Scalars['String']>;
  coaches: Array<Person>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  members: Array<Person>;
  name: Scalars['String'];
  performances: Array<Performance>;
  picture: Maybe<Scalars['String']>;
  pictureUrlWeb: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  teamCategoryId: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  visible: Scalars['Boolean'];
};

export type TeamCategory = {
  createdAt: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  position: Maybe<Scalars['Int']>;
  tagline: Scalars['String'];
  teams: Array<Team>;
  updatedAt: Maybe<Scalars['ISO8601DateTime']>;
  visible: Scalars['Boolean'];
  visibleTeams: Array<Team>;
};

export type TheatreMembership = {
  birthdayMonth: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  expirationDate: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  paymentStatus: MembershipPaymentStatusEnum;
  referredByMember: Scalars['String'];
  tier: MembershipTierEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  userId: Scalars['ID'];
};

export type TheatreMembershipEnterDetailsInput = {
  birthdayMonth: Scalars['String'];
  membershipId: Scalars['ID'];
  referredByMember: Scalars['String'];
};

/** Autogenerated return type of TheatreMembershipEnterDetails. */
export type TheatreMembershipEnterDetailsPayload = {
  membership: TheatreMembership;
};

export type TheatreMembershipReport = {
  activeMembership: Maybe<TheatreMembershipReportActiveMembership>;
};

export type TheatreMembershipReportActiveMembership = {
  expirationDate: Maybe<Scalars['ISO8601Date']>;
  maximumCommunityRateTicketsPerPerformance: Scalars['Int'];
};

export type TicketBracketEnum =
  | 'BOTH'
  | 'FIRST'
  | 'SECOND';

/** Autogenerated return type of TicketCheckoutConfirmPendingConfirmation. */
export type TicketCheckoutConfirmPendingConfirmationPayload = {
  errors: Array<UserError>;
  tickets: Array<PerformanceTicketRegistration>;
};

export type TicketCheckoutParams = {
  bracket: TicketBracketEnum;
  customerInfo: TicketCustomerInfo;
  donationAmount: Scalars['Float'];
  expectedTicketPriceCents: Scalars['Int'];
  orderUuid: Scalars['String'];
  performanceId: Scalars['ID'];
  /** Widely shared promo codes, e.g. 'FRIENDS', 'FAMILY', 'STUDENT' */
  promoCode: InputMaybe<Scalars['String']>;
  ticketOrder: TicketOrderAttributes;
  /** Personal voucher codes, e.g. 'billowing-winds-1234' */
  voucherCode: InputMaybe<Scalars['String']>;
};

export type TicketCustomerInfo = {
  acceptLatecomerPolicy: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  joinNewsletter: Scalars['Boolean'];
  lastName: Scalars['String'];
  telephone: Scalars['String'];
};

/** Autogenerated return type of TicketDeleteComp. */
export type TicketDeleteCompPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of TicketMarkCollected. */
export type TicketMarkCollectedPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type TicketOrder = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  paymentIntentId: Maybe<Scalars['String']>;
  tickets: Array<PerformanceTicketRegistration>;
  updatedAt: Scalars['ISO8601DateTime'];
  uuid: Scalars['String'];
};

/** Ticket quantities associated with an order */
export type TicketOrderAttributes = {
  /** Community-tier member tickets */
  ticketQuantityCommunityMember: Scalars['Int'];
  /** Concession price tickets */
  ticketQuantityConcession: Scalars['Int'];
  /** Full price tickets */
  ticketQuantityFull: Scalars['Int'];
  /** Group price tickets */
  ticketQuantityGroup: Scalars['Int'];
  /** Paid-tier member tickets */
  ticketQuantityPaidMember: Scalars['Int'];
  /** Patron price tickets */
  ticketQuantityPatron: Scalars['Int'];
  /** Promo code tickets */
  ticketQuantityPromoCode: Scalars['Int'];
  /** Student Comp tickets */
  ticketQuantityStudentComp: Scalars['Int'];
};

export type TicketPaymentTypeEnum =
  | 'FREE_REGISTRATION'
  | 'GIFT_TICKET'
  | 'MANUAL'
  | 'PRODUCER_ISSUED_COMP'
  | 'STRIPE'
  | 'STUDENT_JAM'
  | 'STUDENT_RESERVATION'
  | 'VENUE_ISSUED_COMP'
  | 'VIP_MEMBERSHIP';

export type TicketPricePointCreateParams = {
  category: CodeEnabledTicketPricePointCategoryEnum;
  code: Scalars['String'];
  hasTicketPricePointId: Scalars['ID'];
  hasTicketPricePointType: HasTicketPricePointTypeEnum;
};

/** Autogenerated return type of TicketPricePointCreate. */
export type TicketPricePointCreatePayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of TicketPricePointDestroy. */
export type TicketPricePointDestroyPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Custom attributes for this query */
export type TicketPricePointForCodeInput = {
  code: Scalars['String'];
  performanceId: Scalars['ID'];
};

export type TicketPricePointForCodeReturn = TicketPricePointNoLimit | TicketPricePointNotFound | TicketPricePointWithLimit;

export type TicketPricePointNoLimit = {
  ticketPricePoint: CodeEnabledTicketPricePoint;
};

export type TicketPricePointNotFound = {
  notFound: Maybe<Scalars['Boolean']>;
};

export type TicketPricePointWithLimit = {
  ticketPricePoint: CodeEnabledTicketPricePoint;
  ticketsRemainingForPerformance: Scalars['Int'];
};

export type TicketPricingGroup = {
  archived: Scalars['Boolean'];
  communityMemberPrice: Maybe<Scalars['Float']>;
  communityMemberPriceDoorOnly: Scalars['Boolean'];
  concessionPrice: Scalars['Float'];
  createdAt: Scalars['ISO8601DateTime'];
  freeOnDoor: Scalars['Boolean'];
  fullPrice: Scalars['Float'];
  groupMinimumSize: Maybe<Scalars['Int']>;
  groupPrice: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  paidMemberPrice: Maybe<Scalars['Float']>;
  patronMarkupPercentage: Scalars['Int'];
  perUnitServiceFee: Scalars['Float'];
  totalServiceFee: Scalars['Float'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of TicketRefundStripe. */
export type TicketRefundStripePayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated return type of TicketResendConfirmationEmail. */
export type TicketResendConfirmationEmailPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type TicketingModeEnum =
  | 'EXTERNAL'
  | 'EXTERNAL_WITH_INTERNAL_STUDENT_COMPS'
  | 'INTERNAL';

export type TimeOfDayWithDuration = {
  durationSeconds: Scalars['Int'];
  secondsIntoDay: Scalars['Int'];
};

export type UpdateEmailSettingsInput = {
  subscriptions: Array<SubscriptionInput>;
  workshopLevelAlerts: Array<WorkshopLevelAlertInput>;
};

/** Autogenerated return type of UpdateEmailSettings. */
export type UpdateEmailSettingsPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type User = {
  activeCommunityMembership: Maybe<TheatreMembership>;
  activePaidMembership: Maybe<TheatreMembership>;
  behindOnAPaymentPlan: Scalars['Boolean'];
  canPreregister: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  currentlyInCoreWorkshop: Scalars['Boolean'];
  currentlyInWorkshopOfferingComps: Scalars['Boolean'];
  eligibleForPaymentPlans: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  hasTakenCoreWorkshops: Scalars['Boolean'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  outgoingEmailAlias: Maybe<Scalars['String']>;
  owesOnAPaymentPlan: Scalars['Boolean'];
  producedShows: Array<ShowType>;
  referralCode: Scalars['String'];
  referralLink: Scalars['String'];
  referredUserNames: Array<Scalars['String']>;
  referredUsers: Maybe<Array<User>>;
  studentAvailability: Maybe<StudentAvailability>;
  studentCompReport: StudentCompReport;
  studentProfile: Maybe<StudentProfile>;
  subscribedSalesEmailCategories: Array<SalesEmailCategory>;
  superAdmin: Scalars['Boolean'];
  telephone: Scalars['String'];
  theatreMembershipReport: TheatreMembershipReport;
  theatreMemberships: Array<TheatreMembership>;
  ticketPurchaseValue: Scalars['Float'];
  ticketingAdminLevelEnum: AdminLevelEnum;
  tickets: Array<PerformanceTicketRegistration>;
  totalPurchaseValue: Scalars['Float'];
  updatedAt: Scalars['ISO8601DateTime'];
  vouchers: Array<SingleUseVoucher>;
  workshopAdminLevelEnum: AdminLevelEnum;
  workshopAlertSubscriptions: Array<WorkshopAlertSubscription>;
  workshopPreregistrations: Array<WorkshopPreregistration>;
  workshopPurchaseValue: Scalars['Float'];
  workshopRegistrations: Array<WorkshopRegistration>;
  workshopRegistrationsInSession: Array<WorkshopRegistration>;
};

/** A user-readable error */
export type UserError = {
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path: Maybe<Array<Scalars['String']>>;
};

export type UserPerformanceInfo = {
  existingCommunityRateTickets: Scalars['Int'];
  hasStudentComp: Scalars['Boolean'];
  isOwnStudentShowcase: Scalars['Boolean'];
  maximumCommunityRateTicketsPerPerformance: Scalars['Int'];
  withinCommunityRateWindow: Scalars['Boolean'];
  withinStudentCompWindow: Scalars['Boolean'];
};

/** Attributes for user search */
export type UserSearchAttributes = {
  ids: InputMaybe<Array<Scalars['ID']>>;
  query: InputMaybe<Scalars['String']>;
};

export type UserWorkshopLevelMaximumProgress = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  userId: Maybe<Scalars['ID']>;
  workshopCategory: WorkshopCategory;
  workshopCategoryId: Maybe<Scalars['ID']>;
  workshopLevel: WorkshopLevel;
  workshopLevelId: Maybe<Scalars['ID']>;
  workshopRegistration: WorkshopRegistration;
  workshopRegistrationId: Maybe<Scalars['ID']>;
};

export type UtmParams = {
  utmCampaign: InputMaybe<Scalars['String']>;
  utmSource: InputMaybe<Scalars['String']>;
};

export type Venue = {
  accessibilityMode: AccessibilityModeEnum;
  address: Maybe<Scalars['String']>;
  blockOutOtherCalendarMode: CalendarBlockingModeEnum;
  blockOutOtherCalendarVenue: Maybe<Venue>;
  blockOutOtherCalendarVenueId: Maybe<Scalars['ID']>;
  createdAt: Scalars['ISO8601DateTime'];
  description: Maybe<Scalars['String']>;
  directions: Maybe<Scalars['String']>;
  googleCalendarId: Scalars['String'];
  id: Scalars['ID'];
  inHouse: Maybe<Scalars['Boolean']>;
  lat: Maybe<Scalars['Float']>;
  link: Maybe<Scalars['String']>;
  lng: Maybe<Scalars['Float']>;
  mapLink: Maybe<Scalars['String']>;
  name: Scalars['String'];
  payoutSeatingCapacity: Scalars['Int'];
  recommendedWorkshopParticipantCapacity: Scalars['Int'];
  seatingCapacity: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  venueAvailabilities: Array<VenueAvailability>;
  venueGroup: Maybe<VenueGroup>;
};

export type VenueAvailability = {
  createdAt: Scalars['ISO8601DateTime'];
  fridayAvailability: Maybe<TimeOfDayWithDuration>;
  id: Scalars['ID'];
  mondayAvailability: Maybe<TimeOfDayWithDuration>;
  saturdayAvailability: Maybe<TimeOfDayWithDuration>;
  scope: VenueAvailabilityScope;
  sundayAvailability: Maybe<TimeOfDayWithDuration>;
  thursdayAvailability: Maybe<TimeOfDayWithDuration>;
  tuesdayAvailability: Maybe<TimeOfDayWithDuration>;
  updatedAt: Scalars['ISO8601DateTime'];
  venueId: Scalars['Int'];
  wednesdayAvailability: Maybe<TimeOfDayWithDuration>;
};

export type VenueAvailabilityReport = {
  available: Scalars['Boolean'];
  otherVenuesAtSameTime: Array<OtherVenuesAtSameTime>;
  queryEndDatetime: Scalars['ISO8601DateTime'];
  queryStartDatetime: Scalars['ISO8601DateTime'];
  queryVenue: Maybe<Venue>;
  unavailableReason: Maybe<Scalars['String']>;
};

export type VenueAvailabilityScope =
  | 'PERFORMANCES'
  | 'ROOM_HIRE'
  | 'WORKSHOPS';

export type VenueGroup = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type VenueListPublicReturn = {
  upcomingBlackoutSessions: Array<BlackoutSession>;
  venue: Venue;
};

export type VoucherPaymentStatus =
  | 'CONFIRMED'
  | 'PENDING_PAYMENT';

export type VoucherTypeEnum =
  | 'TICKET'
  | 'WORKSHOP';

export type WaitingListActionEnum =
  | 'JOIN'
  | 'LEAVE';

export type Workshop = {
  absoluteMaximumCapacity: Scalars['Int'];
  assistants: Array<Person>;
  availableForBooking: Scalars['Boolean'];
  cancelled: Scalars['Boolean'];
  capacity: Scalars['Int'];
  confirmed: Scalars['Boolean'];
  confirmedWorkshopRegistrations: Array<WorkshopRegistration>;
  createdAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  determinedPrerequisiteMode: WorkshopPrerequisiteModeEnum;
  determinedPrerequisiteWorkshopLevel: Maybe<WorkshopLevel>;
  determinedStudentCompsDuringTerm: Scalars['Int'];
  determinedStudentCompsOffered: Scalars['Boolean'];
  determinedStudentJamsDuringTerm: Scalars['Int'];
  determinedStudentShowcasesDuringTerm: Scalars['Int'];
  determinedStudentShowcasesOffered: Scalars['Boolean'];
  earlyBirdEligibleUntil: Maybe<Scalars['ISO8601Date']>;
  endDate: Scalars['ISO8601Date'];
  endOfTermDate: Scalars['ISO8601Date'];
  evaluationsLocked: Scalars['Boolean'];
  grossIncome: Scalars['Float'];
  id: Scalars['ID'];
  internalComments: Array<InternalComment>;
  isPast: Scalars['Boolean'];
  meetingType: WorkshopMeetingTypeEnum;
  name: Scalars['String'];
  numSpacesRemaining: Scalars['Int'];
  numStudentsEnrolled: Scalars['Int'];
  picture: Maybe<Scalars['String']>;
  preferredWorkshopPricingGroup: WorkshopPricingGroup;
  prerequisiteMode: WorkshopPrerequisiteModeEnum;
  prerequisiteWorkshopLevel: Maybe<WorkshopLevel>;
  reservedWorkshopRegistrations: Array<WorkshopRegistration>;
  sentInstructorReminder: Maybe<Scalars['ISO8601DateTime']>;
  simplePassword: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  soldOut: Scalars['Boolean'];
  startDate: Scalars['ISO8601Date'];
  startOfTermDate: Scalars['ISO8601Date'];
  studentCompsOfferedOverride: Scalars['Boolean'];
  studentCompsQuantityOverride: Maybe<Scalars['Int']>;
  studentJamsQuantityOverride: Maybe<Scalars['Int']>;
  studentShowcases: Array<Performance>;
  studentShowcasesOfferedOverride: Scalars['Boolean'];
  studentShowcasesQuantityOverride: Maybe<Scalars['Int']>;
  substituteTeachers: Array<Person>;
  teachers: Array<Person>;
  terms: Array<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  visible: Scalars['Boolean'];
  workshopLevel: WorkshopLevel;
  workshopLevelId: Scalars['ID'];
  workshopPricingGroup: Maybe<WorkshopPricingGroup>;
  workshopRegistrations: Array<WorkshopRegistration>;
  workshopSessions: Array<CalendarSession>;
  workshopTerm: Maybe<WorkshopTerm>;
  workshopWaitingLists: Array<WorkshopWaitingList>;
  zoomMeetingInvitation: Maybe<Scalars['String']>;
};

export type WorkshopAddStudentManualInput = {
  changeOfRegistrationCreditOverride: InputMaybe<Scalars['Float']>;
  paymentAmount: Scalars['Float'];
  paymentDescription: Scalars['String'];
  userId: Scalars['ID'];
  workshopId: Scalars['ID'];
};

/** Autogenerated return type of WorkshopAddStudentManual. */
export type WorkshopAddStudentManualPayload = {
  errors: Array<UserError>;
  workshopRegistration: Maybe<WorkshopRegistration>;
};

export type WorkshopAddStudentStripe = {
  apiSource: InputMaybe<Scalars['String']>;
  discountCode: InputMaybe<Scalars['String']>;
  priceType: WorkshopPriceTypeEnum;
  stripeToken: Scalars['String'];
  userId: Scalars['ID'];
  workshopId: Scalars['ID'];
};

/** Autogenerated return type of WorkshopAddStudentStripe. */
export type WorkshopAddStudentStripePayload = {
  errors: Array<UserError>;
  workshopRegistration: Maybe<WorkshopRegistration>;
};

export type WorkshopAlertSubscription = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  messageToConspiracy: Maybe<Scalars['String']>;
  previouslyAlertedRecords: Maybe<Scalars['String']>;
  subscribed: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
  userId: Scalars['ID'];
  workshopAlertable: WorkshopAlertable;
  workshopAlertableId: Scalars['ID'];
  workshopAlertableType: Scalars['String'];
};

export type WorkshopAlertable = Workshop | WorkshopLevel;

export type WorkshopBookingTypeEnum =
  | 'OPTIMISTIC'
  | 'TRADITIONAL';

export type WorkshopCategory = {
  categoryType: ComedyDisciplineEnum;
  createdAt: Scalars['ISO8601DateTime'];
  discipline: ComedyDisciplineEnum;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  workshopLevels: Array<WorkshopLevel>;
  workshopLevelsForCustomers: Array<WorkshopLevel>;
  workshopTracks: Array<WorkshopTrack>;
  workshopTracksPublic: Array<WorkshopTrack>;
};

export type WorkshopChangeFeesSchedule = {
  beforeDatetime: Scalars['ISO8601DateTime'];
  centsDeducted: Scalars['Int'];
  description: Scalars['String'];
  percentageDeducted: Scalars['Float'];
  reasonForFee: Scalars['String'];
};

/** Autogenerated return type of WorkshopCheckoutConfirmPending. */
export type WorkshopCheckoutConfirmPendingPayload = {
  errors: Array<UserError>;
  workshopRegistration: Maybe<WorkshopRegistration>;
};

/** Custom attributes for this query */
export type WorkshopCheckoutParams = {
  apiSource: InputMaybe<Scalars['String']>;
  bookingPassword: InputMaybe<Scalars['String']>;
  bookingType: WorkshopBookingTypeEnum;
  discountCode: InputMaybe<Scalars['String']>;
  donationAmount: Scalars['Float'];
  paymentMode: WorkshopPaymentModeEnum;
  paymentPlanInitialPercentage: InputMaybe<PaymentPlanPaymentPercentageEnum>;
  priceType: WorkshopPriceTypeEnum;
  workshopId: Scalars['ID'];
  workshopPaymentDueTodayCents: Scalars['Int'];
};

export type WorkshopCheckoutParamsResponse = {
  errorMessage: Maybe<Scalars['String']>;
  isFree: Maybe<Scalars['Boolean']>;
  paymentIntent: Maybe<PaymentIntent>;
  workshopRegistration: Maybe<WorkshopRegistration>;
};

/** The connection type for Workshop. */
export type WorkshopConnection = {
  /** A list of edges. */
  edges: Maybe<Array<Maybe<WorkshopEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Workshop>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type WorkshopCreditFee = {
  cost: Scalars['Float'];
  reason: Scalars['String'];
};

export type WorkshopDiscount = {
  discountAmount: Scalars['Float'];
  discountName: Scalars['String'];
  discountType: WorkshopDiscountTypeEnum;
};

/** Custom attributes for this query */
export type WorkshopDiscountQueryAttributes = {
  apiSource: InputMaybe<Scalars['String']>;
  bookingType: WorkshopBookingTypeEnum;
  discountCode: InputMaybe<Scalars['String']>;
  priceType: WorkshopPriceTypeEnum;
  workshopId: Scalars['ID'];
};

export type WorkshopDiscountResponse = {
  discounts: Array<WorkshopDiscount>;
  errorMessage: Maybe<Scalars['String']>;
};

export type WorkshopDiscountTypeEnum =
  | 'AUTOMATIC'
  | 'CODE';

/** An edge in a connection. */
export type WorkshopEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Maybe<Workshop>;
};

export type WorkshopInstructorPermissionsEnum =
  | 'ASSISTANT'
  | 'INSTRUCTOR'
  | 'NONE'
  | 'SUBSTITUTE_TEACHER';

export type WorkshopInstructorPermissionsReturn = {
  permissions: WorkshopInstructorPermissionsEnum;
};

export type WorkshopLevel = {
  advancingWorkshopLevels: Array<WorkshopLevel>;
  allowDiscountsMode: AllowDiscountsModeEnum;
  automaticallyApplyRepeatDiscount: Maybe<Scalars['Boolean']>;
  byApplicationOnly: Maybe<Scalars['Boolean']>;
  collectReferralInformation: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  curriculumLink: Maybe<Scalars['String']>;
  description: Scalars['String'];
  evaluationMode: EvaluationModeEnum;
  hubspotName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  levelType: WorkshopLevelTypeEnum;
  mailchimpWorkshopLevelEnrolledGrouping: Maybe<Scalars['String']>;
  mailchimpWorkshopLevelPassGrouping: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nextWorkshopLevel: Maybe<WorkshopLevel>;
  nextWorkshopLevelId: Maybe<Scalars['ID']>;
  onlineClassesAvailable: Maybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  prerequisiteMode: WorkshopPrerequisiteModeEnum;
  prerequisiteWorkshopLevel: Maybe<WorkshopLevel>;
  repeatCode: Maybe<Scalars['String']>;
  sessionMode: SessionModeEnum;
  showWorkshopTitles: Maybe<Scalars['Boolean']>;
  simplePassword: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  studentCompsMode: StudentPerksModeEnum;
  studentCompsQuantity: Maybe<Scalars['Int']>;
  studentJamsQuantity: Maybe<Scalars['Int']>;
  studentShowcaseMode: StudentPerksModeEnum;
  studentShowcaseQuantity: Maybe<Scalars['Int']>;
  summary: Scalars['String'];
  teacherEvaluationsRequired: Scalars['Boolean'];
  upcomingBookableWorkshops: Array<Workshop>;
  upcomingWorkshops: Array<Workshop>;
  updatedAt: Scalars['ISO8601DateTime'];
  userWorkshopLevelMaximumProgresses: Array<UserWorkshopLevelMaximumProgress>;
  visible: Scalars['Boolean'];
  visibleWorkshopLevelAnnouncements: Array<WorkshopLevelAnnouncement>;
  workshopCategory: WorkshopCategory;
  workshopCategoryId: Scalars['String'];
  workshopLevelAnnouncements: Array<WorkshopLevelAnnouncement>;
  workshopPricingGroup: Maybe<WorkshopPricingGroup>;
  workshopPricingGroupId: Maybe<Scalars['ID']>;
  workshopTestimonials: Array<WorkshopTestimonial>;
  workshopTrack: WorkshopTrack;
  workshops: Array<Workshop>;
};

export type WorkshopLevelAlertInput = {
  subscribed: Scalars['Boolean'];
  workshopLevelId: Scalars['ID'];
};

export type WorkshopLevelAnnouncement = {
  announcement: Scalars['String'];
  announcementType: WorkshopLevelAnnouncementTypeEnum;
  createdAt: Scalars['ISO8601DateTime'];
  endDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
  updatedAt: Scalars['ISO8601DateTime'];
  visible: Scalars['Boolean'];
  workshopLevelId: Scalars['Int'];
};

export type WorkshopLevelAnnouncementTypeEnum =
  | 'ANNOUNCEMENT'
  | 'SALE';

export type WorkshopLevelProgress = {
  progress: WorkshopLevelProgressEnum;
  workshopLevel: WorkshopLevel;
};

export type WorkshopLevelProgressEnum =
  | 'BOOKED'
  | 'COMPLETED'
  | 'EVALUATION_LOCKED'
  | 'IN_PROGRESS'
  | 'NOT_TAKEN'
  | 'PASS'
  | 'REPEAT_WITHOUT_PASS';

export type WorkshopLevelTypeEnum =
  | 'FREE_INFO_SESSION'
  | 'FREE_TRIAL'
  | 'INTRO_CORE_LEVEL'
  | 'STANDALONE'
  | 'UPPER_CORE_LEVEL';

export type WorkshopMeetingTypeEnum =
  | 'IN_PERSON'
  | 'ONLINE';

export type WorkshopNameSuffixEnum =
  | 'date';

export type WorkshopPaymentLedger = {
  amountOutstanding: Scalars['Float'];
  amountOutstandingCents: Scalars['Int'];
  amountPaidToDate: Scalars['Float'];
  amountPaidToDateCents: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  exclusivelyStripePayments: Scalars['Boolean'];
  hasLedgerId: Maybe<Scalars['ID']>;
  hasLedgerType: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  netPaymentAmount: Scalars['Float'];
  paymentLedgerType: PaymentLedgerTypeEnum;
  paymentPlanStatus: Maybe<PaymentPlanStatusEnum>;
  payments: Array<Payment>;
  refundedAmount: Scalars['Float'];
  registrationFee: Scalars['Float'];
  registrationFeeCents: Scalars['Int'];
  sentOverdueReminderDatetime: Maybe<Scalars['ISO8601DateTime']>;
  sentUpcomingPaymentDueReminderDatetime: Maybe<Scalars['ISO8601DateTime']>;
  targetPaymentDateFull: Maybe<Scalars['ISO8601Date']>;
  targetPaymentDateHalf: Maybe<Scalars['ISO8601Date']>;
  updatedAt: Scalars['ISO8601DateTime'];
  userId: Scalars['ID'];
};

export type WorkshopPaymentModeEnum =
  | 'PAYMENT_PLAN_DUE_MIDDLE_OF_TERM'
  | 'PAYMENT_PLAN_DUE_START_OF_TERM'
  | 'UPFRONT';

export type WorkshopPaymentPlanAvailableResponse = {
  availableForUser: Scalars['Boolean'];
  availableForWorkshop: Scalars['Boolean'];
};

export type WorkshopPermission =
  | 'AVAILABLE_BY_PASSING_PREREQUISITE'
  | 'AVAILABLE_VIA_PASSWORD'
  | 'DENIED'
  | 'GRANTED';

export type WorkshopPermissionCheckContext =
  | 'MOVE_WORKSHOP';

/** Custom attributes for this query */
export type WorkshopPermissionCheckParams = {
  context: InputMaybe<WorkshopPermissionCheckContext>;
  password: InputMaybe<Scalars['String']>;
  workshopId: Scalars['ID'];
};

export type WorkshopPermissionResult = {
  errorMessage: Maybe<Scalars['String']>;
  permission: WorkshopPermission;
};

export type WorkshopPreregistration = {
  createdAt: Scalars['ISO8601DateTime'];
  currentLevelPreferences: Scalars['String'];
  currentWorkshopRegistration: WorkshopRegistration;
  currentWorkshopRegistrationId: Maybe<Scalars['ID']>;
  fulfillmentStatus: PreregistrationFulfillmentStatusEnum;
  id: Scalars['ID'];
  nextLevelPreferences: Scalars['String'];
  nextWorkshopRegistration: Maybe<WorkshopRegistration>;
  nextWorkshopRegistrationId: Maybe<Scalars['Int']>;
  queuePosition: Scalars['Int'];
  registrationDescription: Maybe<Scalars['String']>;
  registrationType: Maybe<Scalars['String']>;
  sendConfirmationEmails: Maybe<Scalars['Boolean']>;
  sentConfirmationEmailsAt: Maybe<Scalars['ISO8601DateTime']>;
  sentRefundEmailsAt: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  userId: Maybe<Scalars['ID']>;
  workshopPaymentLedger: Maybe<WorkshopPaymentLedger>;
  workshopPreregistrationPeriod: WorkshopPreregistrationPeriod;
  workshopPreregistrationPeriodId: Maybe<Scalars['ID']>;
};

export type WorkshopPreregistrationPeriod = {
  createdAt: Scalars['ISO8601DateTime'];
  currentTermTag: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  nextTermTag: Scalars['String'];
  periodEnds: Scalars['ISO8601DateTime'];
  periodStarts: Scalars['ISO8601DateTime'];
  preferencesDueAt: Scalars['ISO8601DateTime'];
  preregistrations: Array<WorkshopPreregistration>;
  preregistrationsCount: Scalars['Int'];
  startedProcessingJob: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
  viewableUntil: Scalars['ISO8601DateTime'];
};

export type WorkshopPrerequisiteModeEnum =
  | 'DISABLED'
  | 'PASSWORD'
  | 'WORKSHOP_LEVEL_COMPLETION'
  | 'WORKSHOP_LEVEL_PARTICIPATION'
  | 'WORKSHOP_LEVEL_PASSING_GRADE';

export type WorkshopPriceTypeEnum =
  | 'CONCESSION'
  | 'FULL';

export type WorkshopPricingGroup = {
  concessionPrice: Scalars['Float'];
  concessionPriceCents: Scalars['Int'];
  createdAt: Maybe<Scalars['ISO8601DateTime']>;
  earlyBirdDiscountAmount: Maybe<Scalars['Float']>;
  earlyBirdDiscountAmountCents: Maybe<Scalars['Int']>;
  flexibleFee: Maybe<Scalars['Float']>;
  flexibleFeeCents: Maybe<Scalars['Int']>;
  flexibleFeeName: Maybe<Scalars['String']>;
  fullPrice: Scalars['Float'];
  fullPriceCents: Scalars['Int'];
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  perUnitServiceFee: Scalars['Float'];
  perUnitServiceFeeCents: Scalars['Int'];
  totalServiceFee: Scalars['Float'];
  totalServiceFeeCents: Scalars['Int'];
  updatedAt: Maybe<Scalars['ISO8601DateTime']>;
};

export type WorkshopRegistration = {
  aasmState: Maybe<Scalars['String']>;
  changeFeesSchedule: Array<WorkshopChangeFeesSchedule>;
  createdAt: Scalars['ISO8601DateTime'];
  dependantOptimisticWorkshopRegistrations: Array<WorkshopRegistration>;
  donationPayment: Maybe<Payment>;
  evaluationByStudent: Maybe<EvaluationByStudent>;
  evaluationByTeacher: Maybe<EvaluationByTeacher>;
  id: Scalars['ID'];
  newsletterOptIn: Maybe<Scalars['Boolean']>;
  pendingReferral: Maybe<Scalars['Boolean']>;
  performanceTicketRegistrationsCount: Scalars['Int'];
  prerequisiteWorkshopRegistration: Maybe<WorkshopRegistration>;
  referralDetail: Maybe<Scalars['String']>;
  referralSource: Maybe<Scalars['String']>;
  registrationDescription: Maybe<Scalars['String']>;
  registrationType: WorkshopRegistrationTypeEnum;
  sendConfirmationEmails: Maybe<Scalars['Boolean']>;
  sentConfirmationEmails: Maybe<Scalars['ISO8601DateTime']>;
  sentConfirmationRequestEmails: Maybe<Scalars['ISO8601DateTime']>;
  sentCourseEvaluationEmails: Maybe<Scalars['ISO8601DateTime']>;
  sentCourseResultEmails: Maybe<Scalars['ISO8601DateTime']>;
  sentFollowupEmails: Maybe<Scalars['ISO8601DateTime']>;
  sentReminderEmails: Maybe<Scalars['ISO8601DateTime']>;
  state: WorkshopRegistrationState;
  studentPerformanceAttendances: Array<StudentPerformanceAttendance>;
  studentReservations: Array<PerformanceTicketRegistration>;
  studentWorkshopAttendances: Array<StudentWorkshopAttendance>;
  upcomingPreregistration: Maybe<WorkshopPreregistration>;
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  userId: Scalars['ID'];
  utmCampaign: Maybe<Scalars['String']>;
  utmSource: Maybe<Scalars['String']>;
  workshop: Workshop;
  workshopId: Scalars['ID'];
  workshopPaymentLedger: Maybe<WorkshopPaymentLedger>;
};

export type WorkshopRegistrationDeferInput = {
  deductAutomatedFee: InputMaybe<Scalars['Boolean']>;
  deductChangeOfRegistrationFee: InputMaybe<Scalars['Boolean']>;
  deductCreditForNSessions: InputMaybe<Scalars['Int']>;
  messageForStudent: InputMaybe<Scalars['String']>;
  workshopRegistrationId: Scalars['ID'];
};

/** Autogenerated return type of WorkshopRegistrationDefer. */
export type WorkshopRegistrationDeferPayload = {
  errors: Array<UserError>;
  workshopRegistration: Maybe<WorkshopRegistration>;
};

/** Autogenerated return type of WorkshopRegistrationDrop. */
export type WorkshopRegistrationDropPayload = {
  errors: Array<UserError>;
  workshopRegistration: Maybe<WorkshopRegistration>;
};

/** Autogenerated return type of WorkshopRegistrationMoveToDifferentUser. */
export type WorkshopRegistrationMoveToDifferentUserPayload = {
  errors: Array<UserError>;
  workshopRegistration: WorkshopRegistration;
};

/** Autogenerated return type of WorkshopRegistrationMoveToDifferentWorkshop. */
export type WorkshopRegistrationMoveToDifferentWorkshopPayload = {
  errors: Array<UserError>;
  workshopRegistration: WorkshopRegistration;
};

/** Autogenerated return type of WorkshopRegistrationResendConfirmationEmail. */
export type WorkshopRegistrationResendConfirmationEmailPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

export type WorkshopRegistrationState =
  | 'CONFIRMED'
  | 'DEFERRED'
  | 'DROPPED'
  | 'OPTIMISTIC'
  | 'PENDING';

export type WorkshopRegistrationTypeEnum =
  | 'FREE'
  | 'FREE_VIA_DISCOUNT'
  | 'PAID';

/** Attributes for workshop search */
export type WorkshopSearchAttributes = {
  ids: InputMaybe<Array<Scalars['ID']>>;
  query: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of WorkshopSendManualCourseReminders. */
export type WorkshopSendManualCourseRemindersPayload = {
  errors: Array<UserError>;
  success: Scalars['Boolean'];
};

/** Attributes for creating or updating a calendar session */
export type WorkshopSessionAttributes = {
  /** End time of the session */
  endDatetime: Scalars['ISO8601DateTime'];
  /** ID of the session (when editing) */
  id: InputMaybe<Scalars['ID']>;
  /** Start time of the session */
  startDatetime: Scalars['ISO8601DateTime'];
  /** ID of the venue */
  venueId: InputMaybe<Scalars['ID']>;
};

export type WorkshopTemplate = {
  capacity: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  meetingType: WorkshopMeetingTypeEnum;
  name: Scalars['String'];
  numberOfSessions: Scalars['Int'];
  sessionDurationMinutes: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  venue: Maybe<Venue>;
  venueId: Maybe<Scalars['ID']>;
  workshopLevel: WorkshopLevel;
  workshopLevelId: Scalars['ID'];
  workshopNamePrefix: Scalars['String'];
  workshopNameSuffix: WorkshopNameSuffixEnum;
  workshopPricingGroup: Maybe<WorkshopPricingGroup>;
  workshopPricingGroupId: Maybe<Scalars['ID']>;
  zoomMeetingInvitation: Maybe<Scalars['String']>;
};

export type WorkshopTerm = {
  createdAt: Scalars['ISO8601DateTime'];
  description: Maybe<Scalars['String']>;
  durationInWeeks: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  startingMonday: Scalars['ISO8601Date'];
  upcomingWorkshops: Array<Workshop>;
  updatedAt: Scalars['ISO8601DateTime'];
  workshops: Array<Workshop>;
};

/** Custom attributes for this query */
export type WorkshopTermsListInput = {
  scope: WorkshopsTermsListScopeEnum;
};

export type WorkshopTestimonial = {
  author: Scalars['String'];
  createdAt: Maybe<Scalars['ISO8601DateTime']>;
  hasWorkshopTestimonialId: Maybe<Scalars['Int']>;
  hasWorkshopTestimonialType: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  link: Maybe<Scalars['String']>;
  testimonial: Scalars['String'];
  updatedAt: Maybe<Scalars['ISO8601DateTime']>;
};

export type WorkshopTrack = {
  allAdvancingStudentsReceiveInvitation: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  headline: Scalars['String'];
  id: Scalars['ID'];
  imageUrlWeb: Maybe<Scalars['String']>;
  name: Scalars['String'];
  position: Scalars['Int'];
  requiresExplicitInvitation: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
  workshopCategory: WorkshopCategory;
  workshopCategoryId: Scalars['Int'];
  workshopLevels: Array<WorkshopLevel>;
  workshopLevelsPublic: Array<WorkshopLevel>;
};

export type WorkshopTrackInvitation = {
  createdAt: Scalars['ISO8601DateTime'];
  evaluationByTeacher: Maybe<EvaluationByTeacher>;
  evaluationByTeacherId: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  status: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  userId: Scalars['Int'];
  workshopTrack: WorkshopTrack;
  workshopTrackId: Scalars['Int'];
};

export type WorkshopVoucherCheckPrice = {
  discounts: Array<WorkshopDiscount>;
  workshopPricingGroup: WorkshopPricingGroup;
};

export type WorkshopVoucherCheckPriceInput = {
  apiSource: InputMaybe<Scalars['String']>;
  userId: InputMaybe<Scalars['ID']>;
  workshopCategoryId: Scalars['ID'];
};

export type WorkshopVoucherSellManualInput = {
  pricePaid: Scalars['Float'];
  priceType: WorkshopPriceTypeEnum;
  userId: Scalars['ID'];
  workshopCategoryId: Scalars['ID'];
};

/** Autogenerated return type of WorkshopVoucherSellManual. */
export type WorkshopVoucherSellManualPayload = {
  errors: Array<UserError>;
  workshopVoucher: Maybe<SingleUseVoucher>;
};

export type WorkshopVoucherSellStripeInput = {
  apiSource: InputMaybe<Scalars['String']>;
  priceType: WorkshopPriceTypeEnum;
  stripeToken: Scalars['String'];
  userId: InputMaybe<Scalars['ID']>;
  workshopCategoryId: Scalars['ID'];
};

/** Autogenerated return type of WorkshopVoucherSellStripe. */
export type WorkshopVoucherSellStripePayload = {
  errors: Array<UserError>;
  workshopVoucher: Maybe<SingleUseVoucher>;
};

export type WorkshopWaitingList = {
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  userId: Scalars['ID'];
  workshop: Workshop;
  workshopId: Scalars['ID'];
};

export type WorkshopWaitingListStatus = {
  canJoinWaitingList: Scalars['Boolean'];
  numOtherStudentsOnList: Scalars['Int'];
  onWaitingList: Scalars['Boolean'];
};

/** Attributes for workshop search */
export type WorkshopsListAttributes = {
  endDate: InputMaybe<Scalars['ISO8601Date']>;
  inSessionOnDate: InputMaybe<Scalars['ISO8601Date']>;
  scope: Scalars['String'];
  startDate: InputMaybe<Scalars['ISO8601Date']>;
  teacher: InputMaybe<Array<Scalars['ID']>>;
  unstaffed: InputMaybe<Scalars['Boolean']>;
  workshopCategory: InputMaybe<Array<Scalars['ID']>>;
  workshopLevel: InputMaybe<Array<Scalars['ID']>>;
  workshopTerm: InputMaybe<Array<Scalars['ID']>>;
};

export type WorkshopsReplyToEnum =
  | 'COMPANY'
  | 'SENDER'
  | 'SENDER_ALIAS'
  | 'WORKSHOPS';

export type WorkshopsTermsListScopeEnum =
  | 'ALL'
  | 'POTENTIALLY_BOOKABLE';

export type WorkshopCategoriesAndLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkshopCategoriesAndLevelsQuery = { workshopCategoriesListAdmin: Array<{ id: string, name: string, workshopLevelsForCustomers: Array<{ id: string, name: string, summary: string }> }> };

export type MyStudentAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type MyStudentAvailabilityQuery = { currentUser: { studentAvailability: { updatedAt: string, mondayDaytime: StudentAvailabilityEnum, mondayEvening: StudentAvailabilityEnum, tuesdayDaytime: StudentAvailabilityEnum, tuesdayEvening: StudentAvailabilityEnum, wednesdayDaytime: StudentAvailabilityEnum, wednesdayEvening: StudentAvailabilityEnum, thursdayDaytime: StudentAvailabilityEnum, thursdayEvening: StudentAvailabilityEnum, fridayDaytime: StudentAvailabilityEnum, fridayEvening: StudentAvailabilityEnum, saturdayDaytime: StudentAvailabilityEnum, saturdayEvening: StudentAvailabilityEnum, sundayDaytime: StudentAvailabilityEnum, sundayEvening: StudentAvailabilityEnum, startingFrom: string | null } | null } | null };

export type EditStudentAvailabilityMutationVariables = Exact<{
  params: EditStudentAvailabilityInput;
}>;


export type EditStudentAvailabilityMutation = { editStudentAvailability: { success: boolean, errors: Array<{ message: string }> } };

export type CourseEvaluationQueryVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
}>;


export type CourseEvaluationQuery = { currentUser: { studentAvailability: { updatedAt: string, mondayDaytime: StudentAvailabilityEnum, mondayEvening: StudentAvailabilityEnum, tuesdayDaytime: StudentAvailabilityEnum, tuesdayEvening: StudentAvailabilityEnum, wednesdayDaytime: StudentAvailabilityEnum, wednesdayEvening: StudentAvailabilityEnum, thursdayDaytime: StudentAvailabilityEnum, thursdayEvening: StudentAvailabilityEnum, fridayDaytime: StudentAvailabilityEnum, fridayEvening: StudentAvailabilityEnum, saturdayDaytime: StudentAvailabilityEnum, saturdayEvening: StudentAvailabilityEnum, sundayDaytime: StudentAvailabilityEnum, sundayEvening: StudentAvailabilityEnum, startingFrom: string | null } | null } | null, workshopRegistrationDetails: { id: string, upcomingPreregistration: { nextWorkshopRegistration: { workshop: { name: string } } | null } | null, workshop: { name: string, workshopLevel: { name: string, teacherEvaluationsRequired: boolean, levelType: WorkshopLevelTypeEnum, nextWorkshopLevel: { name: string } | null } } } | null, courseEvaluationQuery: { canEvaluate: boolean } };

export type EvaluateCourseMutationVariables = Exact<{
  params: CourseEvaluationInput;
}>;


export type EvaluateCourseMutation = { courseEvaluation: { success: boolean, errors: Array<{ message: string }> } };

export type StudentAvailabilityEssentialsFragment = { updatedAt: string, mondayDaytime: StudentAvailabilityEnum, mondayEvening: StudentAvailabilityEnum, tuesdayDaytime: StudentAvailabilityEnum, tuesdayEvening: StudentAvailabilityEnum, wednesdayDaytime: StudentAvailabilityEnum, wednesdayEvening: StudentAvailabilityEnum, thursdayDaytime: StudentAvailabilityEnum, thursdayEvening: StudentAvailabilityEnum, fridayDaytime: StudentAvailabilityEnum, fridayEvening: StudentAvailabilityEnum, saturdayDaytime: StudentAvailabilityEnum, saturdayEvening: StudentAvailabilityEnum, sundayDaytime: StudentAvailabilityEnum, sundayEvening: StudentAvailabilityEnum, startingFrom: string | null };

export type AccountDetailsTicketFragment = { id: string, email: string | null, refunded: boolean | null, bookingStatus: BookingStatusEnum, ticketQuantityFull: number, ticketQuantityConcession: number, ticketQuantityGroup: number, ticketQuantityCommunityMember: number, ticketQuantityPaidMember: number, ticketQuantityPatron: number, ticketQuantityTotal: number, paymentAmount: number, paymentAmountTickets: number, paymentAmountTip: number, paymentAmountDonation: number, paymentAmountFees: number, createdAt: string, paymentType: TicketPaymentTypeEnum, paymentDescription: string | null, paymentUid: string | null, redeemed: boolean, performance: { id: string, name: string, startDatetime: string, bookingWindowBufferMinutes: number | null, durationInMinutes: number, showType: { calendarThumbnailUrlWeb: string | null } }, ticketOrder: { paymentIntentId: string | null } | null };

export type AccountDetailsWorkshopPaymentLedgerFragment = { id: string, paymentLedgerType: PaymentLedgerTypeEnum, registrationFee: number, amountPaidToDate: number, amountOutstanding: number, targetPaymentDateHalf: string | null, targetPaymentDateFull: string | null, paymentPlanStatus: PaymentPlanStatusEnum | null, payments: Array<{ paymentAmount: number, paymentDescription: string, paymentType: PaymentTypeEnum, paymentUid: string | null, paymentIntentId: string | null, createdAt: string, paymentRefunds: Array<{ refundUid: string | null, refundAmount: number | null, createdAt: string }> }> };

export type AccountDetailsWorkshopRegistrationFragment = { __typename: 'WorkshopRegistration', id: string, state: WorkshopRegistrationState, createdAt: string, registrationType: WorkshopRegistrationTypeEnum, workshopPaymentLedger: { id: string, paymentLedgerType: PaymentLedgerTypeEnum, registrationFee: number, amountPaidToDate: number, amountOutstanding: number, targetPaymentDateHalf: string | null, targetPaymentDateFull: string | null, paymentPlanStatus: PaymentPlanStatusEnum | null, payments: Array<{ paymentAmount: number, paymentDescription: string, paymentType: PaymentTypeEnum, paymentUid: string | null, paymentIntentId: string | null, createdAt: string, paymentRefunds: Array<{ refundUid: string | null, refundAmount: number | null, createdAt: string }> }> } | null, evaluationByStudent: { id: string } | null, evaluationByTeacher: { passRepeatStatusForUser: PassRepeatStatusForUser | null, instructorCommentsForStudent: string | null, releasedByEducationDirector: boolean | null, releaseStatus: EvaluationByTeacherStatus } | null, studentReservations: Array<{ id: string, redeemed: boolean, paymentType: TicketPaymentTypeEnum, performance: { name: string, startDatetime: string } }>, workshop: { id: string, name: string, startDate: string, endDate: string, determinedStudentCompsOffered: boolean, determinedStudentJamsDuringTerm: number, determinedStudentCompsDuringTerm: number, workshopLevel: { levelType: WorkshopLevelTypeEnum, teacherEvaluationsRequired: boolean, name: string, nextWorkshopLevel: { name: string } | null }, preferredWorkshopPricingGroup: { fullPrice: number, concessionPrice: number, flexibleFee: number | null, totalServiceFee: number }, workshopSessions: Array<{ startDatetime: string, endDatetime: string, venue: { name: string } | null }>, teachers: Array<{ fullName: string }> } };

export type AccountDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountDetailsQuery = { customerReferralOptions: Array<string>, siteConstants: { coreWorkshopRequiredRepeatDiscountPercentage: number, coreWorkshopVoluntaryRepeatDiscountPercentage: number, freeTrialComplimentaryChangeWindowInHours: number }, currentUser: { id: string, name: string, firstName: string, lastName: string, fullName: string, telephone: string, email: string, canPreregister: boolean, referralCode: string, referralLink: string, referredUserNames: Array<string>, studentProfile: { pronounsEnum: PronounsEnum | null, pronounsOther: string | null, specialNeeds: string | null, referralDetail: string | null, referralSource: string | null } | null, activePaidMembership: { tier: MembershipTierEnum } | null, studentCompReport: { showsUsed: number, showsTotal: number, jamsUsed: number, jamsTotal: number }, tickets: Array<{ id: string, email: string | null, refunded: boolean | null, bookingStatus: BookingStatusEnum, ticketQuantityFull: number, ticketQuantityConcession: number, ticketQuantityGroup: number, ticketQuantityCommunityMember: number, ticketQuantityPaidMember: number, ticketQuantityPatron: number, ticketQuantityTotal: number, paymentAmount: number, paymentAmountTickets: number, paymentAmountTip: number, paymentAmountDonation: number, paymentAmountFees: number, createdAt: string, paymentType: TicketPaymentTypeEnum, paymentDescription: string | null, paymentUid: string | null, redeemed: boolean, performance: { id: string, name: string, startDatetime: string, bookingWindowBufferMinutes: number | null, durationInMinutes: number, showType: { calendarThumbnailUrlWeb: string | null } }, ticketOrder: { paymentIntentId: string | null } | null }>, workshopRegistrations: Array<{ __typename: 'WorkshopRegistration', id: string, state: WorkshopRegistrationState, createdAt: string, registrationType: WorkshopRegistrationTypeEnum, workshopPaymentLedger: { id: string, paymentLedgerType: PaymentLedgerTypeEnum, registrationFee: number, amountPaidToDate: number, amountOutstanding: number, targetPaymentDateHalf: string | null, targetPaymentDateFull: string | null, paymentPlanStatus: PaymentPlanStatusEnum | null, payments: Array<{ paymentAmount: number, paymentDescription: string, paymentType: PaymentTypeEnum, paymentUid: string | null, paymentIntentId: string | null, createdAt: string, paymentRefunds: Array<{ refundUid: string | null, refundAmount: number | null, createdAt: string }> }> } | null, evaluationByStudent: { id: string } | null, evaluationByTeacher: { passRepeatStatusForUser: PassRepeatStatusForUser | null, instructorCommentsForStudent: string | null, releasedByEducationDirector: boolean | null, releaseStatus: EvaluationByTeacherStatus } | null, studentReservations: Array<{ id: string, redeemed: boolean, paymentType: TicketPaymentTypeEnum, performance: { name: string, startDatetime: string } }>, workshop: { id: string, name: string, startDate: string, endDate: string, determinedStudentCompsOffered: boolean, determinedStudentJamsDuringTerm: number, determinedStudentCompsDuringTerm: number, workshopLevel: { levelType: WorkshopLevelTypeEnum, teacherEvaluationsRequired: boolean, name: string, nextWorkshopLevel: { name: string } | null }, preferredWorkshopPricingGroup: { fullPrice: number, concessionPrice: number, flexibleFee: number | null, totalServiceFee: number }, workshopSessions: Array<{ startDatetime: string, endDatetime: string, venue: { name: string } | null }>, teachers: Array<{ fullName: string }> } }>, workshopPreregistrations: Array<{ __typename: 'WorkshopPreregistration', id: string, fulfillmentStatus: PreregistrationFulfillmentStatusEnum, workshopPreregistrationPeriod: { currentTermTag: string, preferencesDueAt: string }, workshopPaymentLedger: { id: string, paymentLedgerType: PaymentLedgerTypeEnum, registrationFee: number, amountPaidToDate: number, amountOutstanding: number, targetPaymentDateHalf: string | null, targetPaymentDateFull: string | null, paymentPlanStatus: PaymentPlanStatusEnum | null, payments: Array<{ paymentAmount: number, paymentDescription: string, paymentType: PaymentTypeEnum, paymentUid: string | null, paymentIntentId: string | null, createdAt: string, paymentRefunds: Array<{ refundUid: string | null, refundAmount: number | null, createdAt: string }> }> } | null }>, studentAvailability: { updatedAt: string, mondayDaytime: StudentAvailabilityEnum, mondayEvening: StudentAvailabilityEnum, tuesdayDaytime: StudentAvailabilityEnum, tuesdayEvening: StudentAvailabilityEnum, wednesdayDaytime: StudentAvailabilityEnum, wednesdayEvening: StudentAvailabilityEnum, thursdayDaytime: StudentAvailabilityEnum, thursdayEvening: StudentAvailabilityEnum, fridayDaytime: StudentAvailabilityEnum, fridayEvening: StudentAvailabilityEnum, saturdayDaytime: StudentAvailabilityEnum, saturdayEvening: StudentAvailabilityEnum, sundayDaytime: StudentAvailabilityEnum, sundayEvening: StudentAvailabilityEnum, startingFrom: string | null } | null, workshopAlertSubscriptions: Array<{ subscribed: boolean, workshopAlertable: { __typename: 'Workshop' } | { __typename: 'WorkshopLevel', id: string } }>, subscribedSalesEmailCategories: Array<{ internalName: string, displayName: string, displayDescription: string, subscribed: boolean }>, vouchers: Array<{ redeemed: boolean, code: string, memo: string, maximumDollarValue: number }> } | null };

export type FindStudentTicketQueryVariables = Exact<{ [key: string]: never; }>;


export type FindStudentTicketQuery = { performancesUpcoming: Array<{ id: string, slugifiedId: string, startDatetime: string, soldOut: boolean, acceptStudentComps: ShowTypeSettingsOverrideEnum, studentCompsRemaining: number, name: string, showType: { calendarThumbnailUrlWeb: string | null, category: ShowTypeCategoryEnum } }> };

export type PaymentPlanCheckStatusQueryVariables = Exact<{
  workshopPaymentLedgerId: Scalars['ID'];
}>;


export type PaymentPlanCheckStatusQuery = { paymentPlanCheckStatus: { workshopPaymentLedger: { registrationFeeCents: number, amountPaidToDateCents: number, amountOutstandingCents: number, targetPaymentDateHalf: string | null, targetPaymentDateFull: string | null }, paymentOptions: Array<{ paymentPercentage: PaymentPlanPaymentPercentageEnum, label: string, paymentAmountCents: number }> } };

export type PaymentPlanMakePaymentMutationVariables = Exact<{
  params: PaymentPlanMakePaymentInput;
}>;


export type PaymentPlanMakePaymentMutation = { paymentPlanMakePayment: { workshopPaymentLedger: { amountOutstandingCents: number } | null, errors: Array<{ message: string, path: Array<string> | null }> } };

export type UpdateEmailSettingsMutationVariables = Exact<{
  params: UpdateEmailSettingsInput;
}>;


export type UpdateEmailSettingsMutation = { updateEmailSettings: { success: boolean, errors: Array<{ message: string }> } };

export type WorkshopCheckoutInfoQueryVariables = Exact<{
  workshopId: Scalars['ID'];
  permissionCheckParams: WorkshopPermissionCheckParams;
}>;


export type WorkshopCheckoutInfoQuery = { customerReferralOptions: Array<string>, currentUser: { id: string, name: string, email: string } | null, workshopPaymentPlanAvailable: { availableForWorkshop: boolean, availableForUser: boolean }, workshopPermissionCheck: { permission: WorkshopPermission, errorMessage: string | null }, workshopInfo: { id: string, name: string, meetingType: WorkshopMeetingTypeEnum, workshopLevel: { collectReferralInformation: boolean | null, allowDiscountsMode: AllowDiscountsModeEnum, levelType: WorkshopLevelTypeEnum, name: string, workshopCategory: { categoryType: ComedyDisciplineEnum } }, preferredWorkshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null }, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, venue: { id: string, name: string, address: string | null, directions: string | null } | null }>, teachers: Array<{ id: string, name: string }> } };

export type CheckWorkshopPaymentsInfoQueryVariables = Exact<{
  params: PaymentPlanCheckInitialPayments;
}>;


export type CheckWorkshopPaymentsInfoQuery = { paymentPlanCheckInitialPayments: Array<{ name: PaymentPlanPaymentPercentageEnum, schedule: Array<{ paymentAmountCents: number, paymentDate: string, headline: string, description: string }> }> };

export type WorkshopCheckoutConfirmPendingMutationVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
}>;


export type WorkshopCheckoutConfirmPendingMutation = { workshopCheckoutConfirmPending: { workshopRegistration: { id: string, aasmState: string | null } | null, errors: Array<{ message: string, path: Array<string> | null }> } };

export type WorkshopDiscountInfoQueryVariables = Exact<{
  params: WorkshopDiscountQueryAttributes;
}>;


export type WorkshopDiscountInfoQuery = { workshopDiscount: { errorMessage: string | null, discounts: Array<{ discountName: string, discountType: WorkshopDiscountTypeEnum, discountAmount: number }> } };

export type WorkshopPaymentIntentQueryVariables = Exact<{
  params: WorkshopCheckoutParams;
}>;


export type WorkshopPaymentIntentQuery = { paymentIntentWorkshops: { isFree: boolean | null, errorMessage: string | null, paymentIntent: { id: string, secret: string, amount: number } | null, workshopRegistration: { id: string, state: WorkshopRegistrationState } | null } };

export type StudentProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentProfileQuery = { currentUser: { studentProfile: { referralSource: string | null, referralDetail: string | null, pronounsEnum: PronounsEnum | null, pronounsOther: string | null, specialNeeds: string | null } | null } | null };

export type WorkshopOrderStatusInfoQueryVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
}>;


export type WorkshopOrderStatusInfoQuery = { workshopRegistrationDetails: { id: string, state: WorkshopRegistrationState, donationPayment: { paymentType: PaymentTypeEnum, paymentAmount: number, paymentAmountDonation: number, paymentIntentId: string | null, status: PaymentStatusEnum } | null, workshopPaymentLedger: { id: string, paymentLedgerType: PaymentLedgerTypeEnum, registrationFee: number, amountPaidToDate: number, amountOutstanding: number, payments: Array<{ paymentType: PaymentTypeEnum, paymentAmount: number, paymentAmountDonation: number, paymentIntentId: string | null, status: PaymentStatusEnum }> } | null } | null };

export type EditStudentProfileMutationVariables = Exact<{
  params: EditStudentProfileInput;
}>;


export type EditStudentProfileMutation = { editStudentProfile: { success: boolean, errors: Array<{ message: string }> } };

export type WorkshopFeesLookupQueryVariables = Exact<{
  workshopId: Scalars['ID'];
}>;


export type WorkshopFeesLookupQuery = { workshopInfo: { id: string, workshopSessions: Array<{ startDatetime: string, endDatetime: string }>, workshopLevel: { levelType: WorkshopLevelTypeEnum }, preferredWorkshopPricingGroup: { fullPrice: number, concessionPrice: number, flexibleFee: number | null, flexibleFeeName: string | null, totalServiceFee: number } }, workshopChangeFeesSchedule: Array<{ beforeDatetime: string, percentageDeducted: number, centsDeducted: number, description: string, reasonForFee: string }>, workshopChangeFeesScheduleFreeTrialPurchase: Array<{ beforeDatetime: string, percentageDeducted: number, centsDeducted: number, description: string, reasonForFee: string }> | null };

export type DonationStatusQueryVariables = Exact<{
  orderUuid: Scalars['String'];
}>;


export type DonationStatusQuery = { standaloneDonation: { id: string, uuid: string, paymentStatus: string } };

export type DonationPaymentIntentQueryVariables = Exact<{
  params: PaymentIntentDonationInput;
}>;


export type DonationPaymentIntentQuery = { paymentIntentDonation: { paymentIntent: { id: string, secret: string, amount: number }, donation: { id: string } } };

export type PlainDonationQueryVariables = Exact<{ [key: string]: never; }>;


export type PlainDonationQuery = { currentUser: { name: string, firstName: string, lastName: string, email: string, telephone: string } | null };

export type BecomeMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type BecomeMemberQuery = { theatreMembershipPricing: number, currentUser: { name: string, firstName: string, lastName: string, email: string, telephone: string, activePaidMembership: { tier: MembershipTierEnum, paymentStatus: MembershipPaymentStatusEnum, expirationDate: string | null } | null } | null };

export type BecomeMemberAwaitConfirmationQueryVariables = Exact<{ [key: string]: never; }>;


export type BecomeMemberAwaitConfirmationQuery = { myTheatreMemberships: Array<{ id: string, tier: MembershipTierEnum, paymentStatus: MembershipPaymentStatusEnum }> };

export type BecomeMemberPaymentIntentQueryVariables = Exact<{
  params: PaymentIntentMembershipInput;
}>;


export type BecomeMemberPaymentIntentQuery = { paymentIntentMembership: { paymentIntent: { id: string, secret: string, amount: number }, theatreMembership: { id: string } } };

export type NewsItemFragment = { id: string, title: string, preview: string, body: string, slug: string, category: NewsItemCategoryEnum, createdAt: string, updatedAt: string, authorId: string | null };

export type NewsItemIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsItemIndexQuery = { adminNewsItemList: Array<{ id: string, title: string, preview: string, body: string, slug: string, category: NewsItemCategoryEnum, createdAt: string, updatedAt: string, authorId: string | null }> };

export type NewsItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NewsItemQuery = { adminNewsItem: { id: string, title: string, preview: string, body: string, slug: string, category: NewsItemCategoryEnum, createdAt: string, updatedAt: string, authorId: string | null } };

export type NewsItemCreateMutationVariables = Exact<{
  attributes: EditNewsItemInput;
}>;


export type NewsItemCreateMutation = { adminNewsItemCreate: { newsItem: { id: string, title: string, preview: string, body: string, slug: string, category: NewsItemCategoryEnum, createdAt: string, updatedAt: string, authorId: string | null } | null, errors: Array<{ message: string }> } };

export type NewsItemEditMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: EditNewsItemInput;
}>;


export type NewsItemEditMutation = { adminNewsItemUpdate: { newsItem: { id: string, title: string, preview: string, body: string, slug: string, category: NewsItemCategoryEnum, createdAt: string, updatedAt: string, authorId: string | null } | null, errors: Array<{ message: string }> } };

export type NewsItemDestroyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NewsItemDestroyMutation = { adminNewsItemDestroy: { success: boolean, errors: Array<{ message: string }> } };

export type PersonFragment = { id: string, firstName: string, lastName: string, bio: string | null, twitterHandle: string | null, picture: string | null, createdAt: string, updatedAt: string, slug: string, blogBio: string | null, hidden: boolean, workshopBio: string | null, workshopsCount: number | null, assistedWorkshopsCount: number | null, userId: string | null };

export type PersonIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonIndexQuery = { adminPersonList: Array<{ id: string, firstName: string, lastName: string, bio: string | null, twitterHandle: string | null, picture: string | null, createdAt: string, updatedAt: string, slug: string, blogBio: string | null, hidden: boolean, workshopBio: string | null, workshopsCount: number | null, assistedWorkshopsCount: number | null, userId: string | null }> };

export type PersonQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PersonQuery = { adminPerson: { id: string, firstName: string, lastName: string, bio: string | null, twitterHandle: string | null, picture: string | null, createdAt: string, updatedAt: string, slug: string, blogBio: string | null, hidden: boolean, workshopBio: string | null, workshopsCount: number | null, assistedWorkshopsCount: number | null, userId: string | null } };

export type PersonCreateMutationVariables = Exact<{
  attributes: EditPersonInput;
}>;


export type PersonCreateMutation = { adminPersonCreate: { person: { id: string, firstName: string, lastName: string, bio: string | null, twitterHandle: string | null, picture: string | null, createdAt: string, updatedAt: string, slug: string, blogBio: string | null, hidden: boolean, workshopBio: string | null, workshopsCount: number | null, assistedWorkshopsCount: number | null, userId: string | null } | null, errors: Array<{ message: string }> } };

export type PersonEditMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: EditPersonInput;
}>;


export type PersonEditMutation = { adminPersonUpdate: { person: { id: string, firstName: string, lastName: string, bio: string | null, twitterHandle: string | null, picture: string | null, createdAt: string, updatedAt: string, slug: string, blogBio: string | null, hidden: boolean, workshopBio: string | null, workshopsCount: number | null, assistedWorkshopsCount: number | null, userId: string | null } | null, errors: Array<{ message: string }> } };

export type PersonDestroyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PersonDestroyMutation = { adminPersonDestroy: { success: boolean, errors: Array<{ message: string }> } };

export type SingleUseVoucherFragment = { id: string, code: string, createdAt: string, updatedAt: string, expiryDate: string, redeemed: boolean, memo: string, maximumDollarValue: number, hasVoucherId: string | null, hasVoucherType: string | null, restrictedToPurchasableId: string | null, restrictedToPurchasableType: string | null, voucherType: VoucherTypeEnum };

export type SingleUseVoucherIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type SingleUseVoucherIndexQuery = { adminSingleUseVoucherList: Array<{ id: string, code: string, createdAt: string, updatedAt: string, expiryDate: string, redeemed: boolean, memo: string, maximumDollarValue: number, hasVoucherId: string | null, hasVoucherType: string | null, restrictedToPurchasableId: string | null, restrictedToPurchasableType: string | null, voucherType: VoucherTypeEnum }> };

export type SingleUseVoucherQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SingleUseVoucherQuery = { adminSingleUseVoucher: { id: string, code: string, createdAt: string, updatedAt: string, expiryDate: string, redeemed: boolean, memo: string, maximumDollarValue: number, hasVoucherId: string | null, hasVoucherType: string | null, restrictedToPurchasableId: string | null, restrictedToPurchasableType: string | null, voucherType: VoucherTypeEnum } };

export type SingleUseVoucherCreateMutationVariables = Exact<{
  attributes: EditSingleUseVoucherInput;
}>;


export type SingleUseVoucherCreateMutation = { adminSingleUseVoucherCreate: { singleUseVoucher: { id: string, code: string, createdAt: string, updatedAt: string, expiryDate: string, redeemed: boolean, memo: string, maximumDollarValue: number, hasVoucherId: string | null, hasVoucherType: string | null, restrictedToPurchasableId: string | null, restrictedToPurchasableType: string | null, voucherType: VoucherTypeEnum } | null, errors: Array<{ message: string }> } };

export type SingleUseVoucherEditMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: EditSingleUseVoucherInput;
}>;


export type SingleUseVoucherEditMutation = { adminSingleUseVoucherUpdate: { singleUseVoucher: { id: string, code: string, createdAt: string, updatedAt: string, expiryDate: string, redeemed: boolean, memo: string, maximumDollarValue: number, hasVoucherId: string | null, hasVoucherType: string | null, restrictedToPurchasableId: string | null, restrictedToPurchasableType: string | null, voucherType: VoucherTypeEnum } | null, errors: Array<{ message: string }> } };

export type SingleUseVoucherDestroyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SingleUseVoucherDestroyMutation = { adminSingleUseVoucherDestroy: { success: boolean, errors: Array<{ message: string }> } };

export type TicketPricingGroupFragment = { id: string, name: string, fullPrice: number, concessionPrice: number, groupPrice: number | null, groupMinimumSize: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, archived: boolean, paidMemberPrice: number | null, perUnitServiceFee: number, createdAt: string, updatedAt: string };

export type TicketPricingGroupIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type TicketPricingGroupIndexQuery = { adminTicketPricingGroupList: Array<{ id: string, name: string, fullPrice: number, concessionPrice: number, groupPrice: number | null, groupMinimumSize: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, archived: boolean, paidMemberPrice: number | null, perUnitServiceFee: number, createdAt: string, updatedAt: string }> };

export type TicketPricingGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TicketPricingGroupQuery = { adminTicketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, groupPrice: number | null, groupMinimumSize: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, archived: boolean, paidMemberPrice: number | null, perUnitServiceFee: number, createdAt: string, updatedAt: string } };

export type TicketPricingGroupCreateMutationVariables = Exact<{
  attributes: EditTicketPricingGroupInput;
}>;


export type TicketPricingGroupCreateMutation = { adminTicketPricingGroupCreate: { ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, groupPrice: number | null, groupMinimumSize: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, archived: boolean, paidMemberPrice: number | null, perUnitServiceFee: number, createdAt: string, updatedAt: string } | null, errors: Array<{ message: string }> } };

export type TicketPricingGroupEditMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: EditTicketPricingGroupInput;
}>;


export type TicketPricingGroupEditMutation = { adminTicketPricingGroupUpdate: { ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, groupPrice: number | null, groupMinimumSize: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, archived: boolean, paidMemberPrice: number | null, perUnitServiceFee: number, createdAt: string, updatedAt: string } | null, errors: Array<{ message: string }> } };

export type TicketPricingGroupDestroyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TicketPricingGroupDestroyMutation = { adminTicketPricingGroupDestroy: { success: boolean, errors: Array<{ message: string }> } };

export type TicketBookingCustomerFieldsFragment = { name: string, email: string | null, telephone: string | null, userId: string | null, user: { id: string, fullName: string, email: string, telephone: string } | null };

export type TicketBookingPaymentFieldsFragment = { paymentType: TicketPaymentTypeEnum, paymentAmount: number, paymentAmountTickets: number, paymentAmountFees: number, paymentAmountDonation: number, paymentAmountTip: number, paymentUid: string | null, paymentDescription: string | null, refunded: boolean | null, refundedAt: string | null, refundUid: string | null, refundAmount: number | null };

export type TicketBookingQuantityFieldsFragment = { ticketQuantityFull: number, ticketQuantityConcession: number, ticketQuantityGroup: number, ticketQuantityPatron: number, ticketQuantityTotal: number };

export type TheatreMembershipListQueryVariables = Exact<{ [key: string]: never; }>;


export type TheatreMembershipListQuery = { adminTheatreMembershipList: Array<{ id: string, tier: MembershipTierEnum, paymentStatus: MembershipPaymentStatusEnum, expirationDate: string | null, user: { id: string, name: string, email: string } }> };

export type TheatreMembershipReadQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TheatreMembershipReadQuery = { adminTheatreMembership: { id: string, tier: MembershipTierEnum, paymentStatus: MembershipPaymentStatusEnum, expirationDate: string | null, user: { id: string, fullName: string, telephone: string, email: string } } };

export type TheatreMembershipCreateMutationVariables = Exact<{
  attributes: EditTheatreMembershipInput;
}>;


export type TheatreMembershipCreateMutation = { adminTheatreMembershipCreate: { theatreMembership: { id: string } | null, errors: Array<{ message: string, path: Array<string> | null }> } };

export type TheatreMembershipUpdateMutationMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: EditTheatreMembershipInput;
}>;


export type TheatreMembershipUpdateMutationMutation = { adminTheatreMembershipUpdate: { theatreMembership: { id: string } | null, errors: Array<{ message: string, path: Array<string> | null }> } };

export type TheatreMembershipDestroyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TheatreMembershipDestroyMutation = { adminTheatreMembershipDestroy: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type WorkshopLevelsListFragment = { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } };

export type WorkshopLevelsListAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkshopLevelsListAdminQuery = { workshopLevelsList: Array<{ id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }> };

export type ShowTypeBasicsFragment = { id: string, name: string, standardDescription: string, standardExpenses: number, studentQuotaCompAllotment: number, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number }, showTags: Array<{ id: string, name: string, slug: string }> };

export type ShowTypesListAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type ShowTypesListAdminQuery = { showTypesListAdmin: Array<{ id: string, name: string, standardDescription: string, standardExpenses: number, studentQuotaCompAllotment: number, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number }, showTags: Array<{ id: string, name: string, slug: string }> }> };

export type WorkshopPricingGroupsListAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkshopPricingGroupsListAdminQuery = { workshopPricingGroupsListAdmin: Array<{ id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null }> };

export type WorkshopCategoriesListAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkshopCategoriesListAdminQuery = { workshopCategoriesListAdmin: Array<{ id: string, name: string }> };

export type ShowTagsListAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type ShowTagsListAdminQuery = { showTagsListAdmin: Array<{ id: string, name: string, slug: string }> };

export type TicketPricingGroupsListAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type TicketPricingGroupsListAdminQuery = { ticketPricingGroupsListAdmin: Array<{ id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean }> };

export type VenueAvailabilityBasicsFragment = { scope: VenueAvailabilityScope, mondayAvailability: { secondsIntoDay: number, durationSeconds: number } | null, tuesdayAvailability: { secondsIntoDay: number, durationSeconds: number } | null, wednesdayAvailability: { secondsIntoDay: number, durationSeconds: number } | null, thursdayAvailability: { secondsIntoDay: number, durationSeconds: number } | null, fridayAvailability: { secondsIntoDay: number, durationSeconds: number } | null, saturdayAvailability: { secondsIntoDay: number, durationSeconds: number } | null, sundayAvailability: { secondsIntoDay: number, durationSeconds: number } | null };

export type VenuesListAdminFragment = { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number };

export type VenuesListAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type VenuesListAdminQuery = { venuesListAdmin: Array<{ id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number }> };

export type DefaultUserInfoFragment = { id: string, fullName: string, email: string, telephone: string };

export type UserSearchAdminQueryVariables = Exact<{
  searchAttributes: UserSearchAttributes;
}>;


export type UserSearchAdminQuery = { userSearchAdmin: Array<{ id: string, fullName: string, email: string, telephone: string }> };

export type InstructorSearchAdminQueryVariables = Exact<{
  searchAttributes: InstructorSearchAttributes;
}>;


export type InstructorSearchAdminQuery = { instructorSearchAdmin: Array<{ id: string, name: string, workshopBio: string | null }> };

export type WorkshopDetailsAdminQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type WorkshopDetailsAdminQuery = { workshopDetailsAdmin: Array<{ id: string, name: string, confirmed: boolean, visible: boolean, description: string, simplePassword: string | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, meetingType: WorkshopMeetingTypeEnum, zoomMeetingInvitation: string | null, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, grossIncome: number, confirmedWorkshopRegistrations: Array<{ id: string, user: { id: string, fullName: string, email: string, telephone: string } }>, workshopTerm: { id: string, name: string, startingMonday: string } | null, internalComments: Array<{ comment: string, user: { id: string, name: string } }>, workshopWaitingLists: Array<{ user: { id: string, name: string, email: string, telephone: string } }>, prerequisiteWorkshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } } | null, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, preferredWorkshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null }, studentShowcases: Array<{ id: string, name: string, status: PerformanceStatusEnum, startDatetime: string, onSaleDatetime: string | null, seatingCapacityOverride: number | null, description: string, calendarHeadline: string, offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum, acceptStudentComps: ShowTypeSettingsOverrideEnum, studentQuotaCompAllotment: number | null, expenses: number, showType: { id: string, name: string, standardExpenses: number, standardDescription: string, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, studentQuotaCompAllotment: number, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum }, showTags: Array<{ id: string, name: string, slug: string }> }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum } | null, workshop: { id: string, name: string } | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, calendarSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null }> }>, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, address: string | null, directions: string | null, recommendedWorkshopParticipantCapacity: number, seatingCapacity: number } | null }>, teachers: Array<{ id: string, name: string, workshopBio: string | null }>, assistants: Array<{ id: string, name: string, workshopBio: string | null }>, substituteTeachers: Array<{ id: string, name: string, workshopBio: string | null }> }> };

export type WorkshopSearchAdminQueryVariables = Exact<{
  searchAttributes: WorkshopSearchAttributes;
}>;


export type WorkshopSearchAdminQuery = { workshopSearchAdmin: Array<{ id: string, name: string, meetingType: WorkshopMeetingTypeEnum, zoomMeetingInvitation: string | null, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, address: string | null, directions: string | null, recommendedWorkshopParticipantCapacity: number, seatingCapacity: number } | null }>, teachers: Array<{ id: string, name: string, workshopBio: string | null }>, assistants: Array<{ id: string, name: string, workshopBio: string | null }>, substituteTeachers: Array<{ id: string, name: string, workshopBio: string | null }> }> };

export type WorkshopTermsListAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkshopTermsListAdminQuery = { workshopTermsList: Array<{ id: string, name: string, startingMonday: string }> };

export type AddStudentToIntroCourseQueryVariables = Exact<{
  userId: Scalars['ID'];
  workshopCategoryId: Scalars['ID'];
}>;


export type AddStudentToIntroCourseQuery = { userInfoAdmin: { id: string, fullName: string, email: string, telephone: string }, workshopsFreeTrialSellClassOptions: Array<{ discounts: Array<{ discountAmount: number, discountName: string }>, workshop: { id: string, name: string, meetingType: WorkshopMeetingTypeEnum, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, venue: { id: string, name: string, address: string | null, directions: string | null } | null }>, teachers: Array<{ name: string }>, assistants: Array<{ name: string }>, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, description: string, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null } | null, workshopCategory: { id: string, name: string } }, preferredWorkshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null } } }> };

export type AddStudentToIntroCourseStripeMutationVariables = Exact<{
  params: WorkshopAddStudentStripe;
}>;


export type AddStudentToIntroCourseStripeMutation = { workshopAddStudentStripe: { workshopRegistration: { id: string, workshopPaymentLedger: { amountPaidToDate: number } | null } | null, errors: Array<{ message: string, path: Array<string> | null }> } };

export type AddStudentToIntroCourseManualMutationVariables = Exact<{
  params: WorkshopAddStudentManualInput;
}>;


export type AddStudentToIntroCourseManualMutation = { workshopAddStudentManual: { errors: Array<{ message: string, path: Array<string> | null }>, workshopRegistration: { id: string } | null } };

export type ReferralBonusAwardMutationMutationVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type ReferralBonusAwardMutationMutation = { referralBonusAward: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type DeleteCompInfoQueryVariables = Exact<{
  ticketId: Scalars['ID'];
}>;


export type DeleteCompInfoQuery = { ticketInfo: { id: string, name: string, ticketQuantityTotal: number, paymentType: TicketPaymentTypeEnum } };

export type DeleteCompMutationVariables = Exact<{
  ticketId: Scalars['ID'];
}>;


export type DeleteCompMutation = { ticketDeleteComp: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type WorkshopStudentsInTermQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkshopStudentsInTermQuery = { workshopStudentsInTerm: Array<{ user: { id: string, fullName: string, email: string, telephone: string } }> };

export type LogStudentAttendanceMutationVariables = Exact<{
  userId: Scalars['ID'];
  performanceId: Scalars['ID'];
}>;


export type LogStudentAttendanceMutation = { performanceLogStudentAttendance: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type MoveTicketsOptionsQueryVariables = Exact<{
  ticketId: Scalars['ID'];
}>;


export type MoveTicketsOptionsQuery = { ticketInfo: { id: string, name: string, bracket: TicketBracketEnum, ticketQuantityTotal: number, performance: { name: string, startDatetime: string, showType: { id: string, name: string } } }, performancesUpcoming: Array<{ id: string, startDatetime: string, name: string, determinedHasSecondBracket: boolean, showType: { id: string, name: string, calendarThumbnailUrlWeb: string | null }, seatsRemainingReport: { firstBracket: number, secondBracket: number | null, bothBrackets: number | null } }> };

export type MoveTicketsAdminMutationVariables = Exact<{
  params: AdminMoveTicketsInput;
}>;


export type MoveTicketsAdminMutation = { adminMoveTicketsToDifferentPerformance: { success: boolean, errors: Array<{ message: string }> } };

export type PerformanceAddCompsMutationVariables = Exact<{
  params: PerformanceAddCompsParams;
}>;


export type PerformanceAddCompsMutation = { performanceAddComps: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type TicketRefundStripeInfoQueryVariables = Exact<{
  ticketId: Scalars['ID'];
}>;


export type TicketRefundStripeInfoQuery = { ticketInfo: { id: string, name: string, paymentAmount: number, paymentAmountTickets: number, paymentAmountFees: number, paymentAmountTip: number, paymentAmountDonation: number, paymentType: TicketPaymentTypeEnum } };

export type TicketRefundStripeMutationVariables = Exact<{
  ticketId: Scalars['ID'];
}>;


export type TicketRefundStripeMutation = { ticketRefundStripe: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type WorkshopVoucherPriceQueryVariables = Exact<{
  checkPriceParams: WorkshopVoucherCheckPriceInput;
  userId: Scalars['ID'];
}>;


export type WorkshopVoucherPriceQuery = { userInfoAdmin: { id: string, fullName: string, email: string, telephone: string }, workshopVoucherCheckPrice: { discounts: Array<{ discountAmount: number, discountName: string }>, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null } } };

export type WorkshopVoucherSellStripeMutationVariables = Exact<{
  params: WorkshopVoucherSellStripeInput;
}>;


export type WorkshopVoucherSellStripeMutation = { workshopVoucherSellStripe: { workshopVoucher: { id: string, code: string, maximumDollarValue: number, expiryDate: string, payment: { id: string, paymentType: PaymentTypeEnum, paymentAmount: number, paymentDescription: string, paymentUid: string | null } | null } | null, errors: Array<{ message: string, path: Array<string> | null }> } };

export type WorkshopVoucherSellManualMutationVariables = Exact<{
  params: WorkshopVoucherSellManualInput;
}>;


export type WorkshopVoucherSellManualMutation = { workshopVoucherSellManual: { workshopVoucher: { id: string, code: string, maximumDollarValue: number, expiryDate: string } | null, errors: Array<{ message: string, path: Array<string> | null }> } };

export type WorkshopAddStudentManualMutationVariables = Exact<{
  params: WorkshopAddStudentManualInput;
}>;


export type WorkshopAddStudentManualMutation = { workshopAddStudentManual: { errors: Array<{ message: string, path: Array<string> | null }>, workshopRegistration: { id: string } | null } };

export type PerformanceAddStandbyMutationVariables = Exact<{
  performanceId: Scalars['ID'];
  bracket: Scalars['String'];
  name: Scalars['String'];
}>;


export type PerformanceAddStandbyMutation = { performanceAddStandby: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type WorkshopRegistrationCommonFragment = { id: string, registrationType: WorkshopRegistrationTypeEnum, registrationDescription: string | null, user: { id: string, fullName: string, email: string }, workshopPaymentLedger: { registrationFee: number, amountPaidToDate: number, amountOutstanding: number } | null, workshop: { id: string, name: string, capacity: number, numStudentsEnrolled: number, soldOut: boolean, workshopSessions: Array<{ startDatetime: string, endDatetime: string, venue: { name: string } | null }>, teachers: Array<{ name: string }>, assistants: Array<{ name: string }> } };

export type WorkshopRegistrationDeferInfoQueryVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
}>;


export type WorkshopRegistrationDeferInfoQuery = { workshopRegistrationDetailsAdmin: Array<{ id: string, registrationType: WorkshopRegistrationTypeEnum, registrationDescription: string | null, workshopPaymentLedger: { netPaymentAmount: number, registrationFee: number, amountPaidToDate: number, amountOutstanding: number } | null, changeFeesSchedule: Array<{ beforeDatetime: string, reasonForFee: string, centsDeducted: number, percentageDeducted: number, description: string }>, user: { id: string, fullName: string, email: string }, workshop: { id: string, name: string, capacity: number, numStudentsEnrolled: number, soldOut: boolean, workshopSessions: Array<{ startDatetime: string, endDatetime: string, venue: { name: string } | null }>, teachers: Array<{ name: string }>, assistants: Array<{ name: string }> } }> };

export type WorkshopRegistrationDeferMutationVariables = Exact<{
  params: WorkshopRegistrationDeferInput;
}>;


export type WorkshopRegistrationDeferMutation = { workshopRegistrationDefer: { errors: Array<{ message: string, path: Array<string> | null }>, workshopRegistration: { id: string } | null } };

export type WorkshopRegistrationDropInfoQueryVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
}>;


export type WorkshopRegistrationDropInfoQuery = { workshopRegistrationDetailsAdmin: Array<{ id: string, registrationType: WorkshopRegistrationTypeEnum, registrationDescription: string | null, workshopPaymentLedger: { netPaymentAmount: number, exclusivelyStripePayments: boolean, registrationFee: number, amountPaidToDate: number, amountOutstanding: number } | null, user: { id: string, fullName: string, email: string }, workshop: { id: string, name: string, capacity: number, numStudentsEnrolled: number, soldOut: boolean, workshopSessions: Array<{ startDatetime: string, endDatetime: string, venue: { name: string } | null }>, teachers: Array<{ name: string }>, assistants: Array<{ name: string }> } }> };

export type WorkshopRegistrationDropMutationVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
  issueRefund: Scalars['Boolean'];
  emailStudent: Scalars['Boolean'];
  messageForStudent?: InputMaybe<Scalars['String']>;
}>;


export type WorkshopRegistrationDropMutation = { workshopRegistrationDrop: { errors: Array<{ message: string, path: Array<string> | null }>, workshopRegistration: { id: string } | null } };

export type WorkshopRegistrationMoveToDifferentUserInfoQueryVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
}>;


export type WorkshopRegistrationMoveToDifferentUserInfoQuery = { workshopRegistrationDetailsAdmin: Array<{ id: string, registrationType: WorkshopRegistrationTypeEnum, registrationDescription: string | null, user: { id: string, fullName: string, email: string }, workshopPaymentLedger: { registrationFee: number, amountPaidToDate: number, amountOutstanding: number } | null, workshop: { id: string, name: string, capacity: number, numStudentsEnrolled: number, soldOut: boolean, workshopSessions: Array<{ startDatetime: string, endDatetime: string, venue: { name: string } | null }>, teachers: Array<{ name: string }>, assistants: Array<{ name: string }> } }> };

export type WorkshopRegistrationMoveToDifferentUserMutationVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type WorkshopRegistrationMoveToDifferentUserMutation = { workshopRegistrationMoveToDifferentUser: { errors: Array<{ message: string, path: Array<string> | null }>, workshopRegistration: { id: string } } };

export type WorkshopRegistrationMoveToDifferentWorkshopInfoQueryVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
}>;


export type WorkshopRegistrationMoveToDifferentWorkshopInfoQuery = { workshopRegistrationDetailsAdmin: Array<{ id: string, registrationType: WorkshopRegistrationTypeEnum, registrationDescription: string | null, workshop: { id: string, name: string, capacity: number, numStudentsEnrolled: number, soldOut: boolean, workshopLevel: { id: string }, workshopSessions: Array<{ startDatetime: string, endDatetime: string, venue: { name: string } | null }>, teachers: Array<{ name: string }>, assistants: Array<{ name: string }> }, user: { id: string, fullName: string, email: string }, workshopPaymentLedger: { registrationFee: number, amountPaidToDate: number, amountOutstanding: number } | null }> };

export type WorkshopRegistrationMoveToDifferentWorkshopMutationVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
  workshopId: Scalars['ID'];
}>;


export type WorkshopRegistrationMoveToDifferentWorkshopMutation = { workshopRegistrationMoveToDifferentWorkshop: { errors: Array<{ message: string, path: Array<string> | null }>, workshopRegistration: { id: string } } };

export type SessionReferralCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionReferralCodeQuery = { sessionReferralCode: string };

export type ClassFinancesInfoQueryVariables = Exact<{
  workshopId: Scalars['ID'];
}>;


export type ClassFinancesInfoQuery = { workshopInfo: { id: string, workshopRegistrations: Array<{ id: string, state: WorkshopRegistrationState, registrationType: WorkshopRegistrationTypeEnum, registrationDescription: string | null, user: { fullName: string }, workshopPaymentLedger: { paymentLedgerType: PaymentLedgerTypeEnum, paymentPlanStatus: PaymentPlanStatusEnum | null, amountOutstanding: number, amountPaidToDate: number, registrationFee: number, targetPaymentDateHalf: string | null, targetPaymentDateFull: string | null, refundedAmount: number, payments: Array<{ paymentAmount: number, paymentType: PaymentTypeEnum, paymentIntentId: string | null, paymentUid: string | null, paymentDescription: string, createdAt: string, paymentRefunds: Array<{ refundAmount: number | null, refundUid: string | null, createdAt: string }> }> } | null }> } };

export type EvaluateStudentsInfoQueryVariables = Exact<{
  workshopId: Scalars['ID'];
}>;


export type EvaluateStudentsInfoQuery = { workshopInfo: { evaluationsLocked: boolean, determinedStudentCompsOffered: boolean, determinedStudentCompsDuringTerm: number, workshopLevel: { evaluationMode: EvaluationModeEnum, advancingWorkshopLevels: Array<{ workshopTrack: { id: string, name: string, requiresExplicitInvitation: boolean, allAdvancingStudentsReceiveInvitation: boolean } }> }, workshopRegistrations: Array<{ workshopId: string, id: string, state: WorkshopRegistrationState, user: { fullName: string }, evaluationByTeacher: { instructorCommentsForStudent: string | null, instructorCommentsInternalUse: string | null, passRepeatStatusInternal: PassRepeatStatusInternalEnum | null, workshopRegistrationId: string, workshopTrackInvitations: Array<{ status: string, workshopTrack: { id: string, name: string } }> } | null, studentPerformanceAttendances: Array<{ performance: { name: string, startDatetime: string } }>, studentReservations: Array<{ redeemed: boolean, paymentType: TicketPaymentTypeEnum, performance: { name: string, startDatetime: string } }>, studentWorkshopAttendances: Array<{ calendarSessionId: string, notes: string, state: StudentWorkshopAttendanceStateEnum, calendarSession: { startDatetime: string } }> }> } };

export type TeacherEvaluateStudentMutationVariables = Exact<{
  params: TeacherEvaluateStudentInput;
}>;


export type TeacherEvaluateStudentMutation = { teacherEvaluateStudent: { success: boolean, errors: Array<{ message: string }> } };

export type TeacherLockEvaluationsMutationVariables = Exact<{
  workshopId: Scalars['ID'];
}>;


export type TeacherLockEvaluationsMutation = { teacherLockEvaluations: { success: boolean, errors: Array<{ message: string }> } };

export type SellClassesAndVouchersInfoQueryVariables = Exact<{
  workshopId: Scalars['ID'];
}>;


export type SellClassesAndVouchersInfoQuery = { workshopInfo: { workshopLevel: { workshopCategoryId: string, levelType: WorkshopLevelTypeEnum }, workshopRegistrations: Array<{ state: WorkshopRegistrationState, id: string, user: { id: string, fullName: string, vouchers: Array<{ restrictedToPurchasable: { __typename: 'Workshop' } | { __typename: 'WorkshopCategory' } | { __typename: 'WorkshopLevel', workshopCategoryId: string } | null }>, workshopRegistrations: Array<{ state: WorkshopRegistrationState, workshop: { workshopLevel: { workshopCategoryId: string, id: string, levelType: WorkshopLevelTypeEnum } } }> } }> } };

export type ReferredUserFragment = { id: string, fullName: string, email: string, workshopPurchaseValue: number, ticketPurchaseValue: number, totalPurchaseValue: number };

export type UserVoucherFragment = { id: string, code: string, voucherType: VoucherTypeEnum, expiryDate: string, memo: string, redeemed: boolean, maximumDollarValue: number, createdAt: string, restrictedToPurchasable: { __typename: 'Workshop' } | { __typename: 'WorkshopCategory', id: string, name: string } | { __typename: 'WorkshopLevel', id: string, name: string } | null };

export type StudentProfileForInstructorInfoQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type StudentProfileForInstructorInfoQuery = { currentUser: { workshopAdminLevelEnum: AdminLevelEnum, ticketingAdminLevelEnum: AdminLevelEnum } | null, userInfoAdmin: { id: string, fullName: string, email: string, telephone: string, workshopPurchaseValue: number, ticketPurchaseValue: number, totalPurchaseValue: number, studentProfile: { specialNeeds: string | null, usedPronouns: string | null } | null, studentAvailability: { updatedAt: string, mondayDaytime: StudentAvailabilityEnum, mondayEvening: StudentAvailabilityEnum, tuesdayDaytime: StudentAvailabilityEnum, tuesdayEvening: StudentAvailabilityEnum, wednesdayDaytime: StudentAvailabilityEnum, wednesdayEvening: StudentAvailabilityEnum, thursdayDaytime: StudentAvailabilityEnum, thursdayEvening: StudentAvailabilityEnum, fridayDaytime: StudentAvailabilityEnum, fridayEvening: StudentAvailabilityEnum, saturdayDaytime: StudentAvailabilityEnum, saturdayEvening: StudentAvailabilityEnum, sundayDaytime: StudentAvailabilityEnum, sundayEvening: StudentAvailabilityEnum, startingFrom: string | null } | null, tickets: Array<{ id: string, email: string | null, refunded: boolean | null, bookingStatus: BookingStatusEnum, ticketQuantityFull: number, ticketQuantityConcession: number, ticketQuantityGroup: number, ticketQuantityCommunityMember: number, ticketQuantityPaidMember: number, ticketQuantityPatron: number, ticketQuantityTotal: number, paymentAmount: number, paymentAmountTickets: number, paymentAmountTip: number, paymentAmountDonation: number, paymentAmountFees: number, createdAt: string, paymentType: TicketPaymentTypeEnum, paymentDescription: string | null, paymentUid: string | null, redeemed: boolean, performance: { id: string, name: string, startDatetime: string, bookingWindowBufferMinutes: number | null, durationInMinutes: number, showType: { calendarThumbnailUrlWeb: string | null } }, ticketOrder: { paymentIntentId: string | null } | null }>, referredUsers: Array<{ id: string, fullName: string, email: string, workshopPurchaseValue: number, ticketPurchaseValue: number, totalPurchaseValue: number }> | null, vouchers: Array<{ id: string, code: string, voucherType: VoucherTypeEnum, expiryDate: string, memo: string, redeemed: boolean, maximumDollarValue: number, createdAt: string, restrictedToPurchasable: { __typename: 'Workshop' } | { __typename: 'WorkshopCategory', id: string, name: string } | { __typename: 'WorkshopLevel', id: string, name: string } | null }>, workshopRegistrations: Array<{ id: string, state: WorkshopRegistrationState, registrationType: WorkshopRegistrationTypeEnum, workshop: { id: string, name: string, startDate: string, workshopLevel: { name: string, levelType: WorkshopLevelTypeEnum, evaluationMode: EvaluationModeEnum }, teachers: Array<{ fullName: string }>, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, venue: { name: string } | null }> }, evaluationByTeacher: { instructorCommentsForStudent: string | null, instructorCommentsInternalUse: string | null, passRepeatStatusInternal: PassRepeatStatusInternalEnum | null, workshopTrackInvitations: Array<{ workshopTrack: { id: string, name: string } }> } | null }> } };

export type WorkshopAttendanceInfoQueryVariables = Exact<{
  workshopSessionId: Scalars['ID'];
}>;


export type WorkshopAttendanceInfoQuery = { workshopAttendanceQuery: { studentWorkshopAttendances: Array<{ workshopRegistrationId: string, state: StudentWorkshopAttendanceStateEnum, notes: string }>, calendarSessionable: { workshopRegistrations: Array<{ id: string, user: { fullName: string } }> } | {} } };

export type TeacherTakeAttendanceMutationVariables = Exact<{
  params: TeacherTakeAttendanceInput;
}>;


export type TeacherTakeAttendanceMutation = { teacherTakeAttendance: { success: boolean, errors: Array<{ message: string }> } };

export type TeacherLockAttendanceMutationVariables = Exact<{
  workshopSessionId: Scalars['ID'];
}>;


export type TeacherLockAttendanceMutation = { teacherLockAttendance: { success: boolean, errors: Array<{ message: string }> } };

export type WorkshopDetailsForInstructorQueryVariables = Exact<{
  workshopId: Scalars['ID'];
}>;


export type WorkshopDetailsForInstructorQuery = { currentUser: { name: string, workshopAdminLevelEnum: AdminLevelEnum } | null, workshopInstructorPermissions: { permissions: WorkshopInstructorPermissionsEnum }, workshopInfo: { id: string, name: string, capacity: number, evaluationsLocked: boolean, startOfTermDate: string, sentInstructorReminder: string | null, determinedStudentCompsOffered: boolean, determinedStudentCompsDuringTerm: number, determinedStudentJamsDuringTerm: number, internalComments: Array<{ comment: string, createdAt: string, user: { name: string } }>, workshopLevel: { workshopCategoryId: string, id: string, name: string, evaluationMode: EvaluationModeEnum, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, curriculumLink: string | null, levelType: WorkshopLevelTypeEnum, nextWorkshopLevel: { id: string } | null }, teachers: Array<{ name: string, pictureUrlWeb: string | null }>, assistants: Array<{ name: string, pictureUrlWeb: string | null }>, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, venue: { name: string } | null }>, workshopWaitingLists: Array<{ id: string, createdAt: string, user: { id: string, fullName: string, email: string, telephone: string } }>, workshopRegistrations: Array<{ id: string, createdAt: string, state: WorkshopRegistrationState, registrationType: WorkshopRegistrationTypeEnum, sentReminderEmails: string | null, upcomingPreregistration: { id: string } | null, workshopPaymentLedger: { amountPaidToDate: number, registrationFee: number, amountOutstanding: number } | null, evaluationByStudent: { id: string } | null, evaluationByTeacher: { instructorCommentsForStudent: string | null, instructorCommentsInternalUse: string | null, passRepeatStatusInternal: PassRepeatStatusInternalEnum | null, workshopTrackInvitations: Array<{ workshopTrack: { id: string, name: string } }> } | null, studentReservations: Array<{ redeemed: boolean, paymentType: TicketPaymentTypeEnum, performance: { name: string, startDatetime: string } }>, studentPerformanceAttendances: Array<{ performance: { name: string, startDatetime: string } }>, user: { id: string, fullName: string, email: string, telephone: string, studentProfile: { usedPronouns: string | null, specialNeeds: string | null } | null, workshopRegistrations: Array<{ workshop: { workshopLevelId: string }, evaluationByTeacher: { passRepeatStatusInternal: PassRepeatStatusInternalEnum | null, instructorCommentsInternalUse: string | null } | null }> }, studentWorkshopAttendances: Array<{ calendarSessionId: string, notes: string, state: StudentWorkshopAttendanceStateEnum, locked: boolean, calendarSession: { startDatetime: string } }> }> } };

export type InternalPassRepeatInformationFragment = { passRepeatStatusInternal: PassRepeatStatusInternalEnum | null, workshopTrackInvitations: Array<{ workshopTrack: { id: string, name: string } }> };

export type AdminWorkshopAddCommentMutationVariables = Exact<{
  input: AdminWorkshopAddCommentInput;
}>;


export type AdminWorkshopAddCommentMutation = { adminWorkshopAddComment: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type WorkshopRegistrationResendConfirmationEmailMutationVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
}>;


export type WorkshopRegistrationResendConfirmationEmailMutation = { workshopRegistrationResendConfirmationEmail: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type WorkshopSendManualCourseRemindersMutationVariables = Exact<{
  workshopId: Scalars['ID'];
}>;


export type WorkshopSendManualCourseRemindersMutation = { workshopSendManualCourseReminders: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type BatchCreatePerformancesMutationVariables = Exact<{
  attributes: Array<EditPerformanceAttributes> | EditPerformanceAttributes;
}>;


export type BatchCreatePerformancesMutation = { batchCreatePerformances: { errors: Array<{ message: string, path: Array<string> | null }>, performances: Array<{ id: string, name: string, status: PerformanceStatusEnum, description: string, calendarHeadline: string, startDatetime: string, onSaleDatetime: string | null, totalIncome: number, totalPaidTicketValue: number, totalTips: number, totalDonations: number, paidStandbyQuantity: number, paidStandbyValue: number, ticShareIncome: number, producerShareIncome: number, producerPayoutPercentage: number, expenses: number, soldOut: boolean, seatingCapacity: number, totalAttendance: number, totalPaidAttendance: number, totalFreeAttendance: number, studentCompsRemaining: number, drinkSaleQuantity: number, drinkSaleValue: number, showType: { id: string, name: string, showTags: Array<{ id: string, name: string, slug: string }> } }> | null } };

export type CreatePerformanceMutationVariables = Exact<{
  attributes: EditPerformanceAttributes;
}>;


export type CreatePerformanceMutation = { createPerformance: { errors: Array<{ message: string, path: Array<string> | null }>, performance: { id: string, name: string, status: PerformanceStatusEnum, description: string, calendarHeadline: string, startDatetime: string, onSaleDatetime: string | null, totalIncome: number, totalPaidTicketValue: number, totalTips: number, totalDonations: number, paidStandbyQuantity: number, paidStandbyValue: number, ticShareIncome: number, producerShareIncome: number, producerPayoutPercentage: number, expenses: number, soldOut: boolean, seatingCapacity: number, totalAttendance: number, totalPaidAttendance: number, totalFreeAttendance: number, studentCompsRemaining: number, drinkSaleQuantity: number, drinkSaleValue: number, showType: { id: string, name: string, showTags: Array<{ id: string, name: string, slug: string }> } } | null } };

export type EditPerformanceMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: EditPerformanceAttributes;
}>;


export type EditPerformanceMutation = { editPerformance: { errors: Array<{ message: string, path: Array<string> | null }>, performance: { id: string, name: string, status: PerformanceStatusEnum, description: string, calendarHeadline: string, startDatetime: string, onSaleDatetime: string | null, totalIncome: number, totalPaidTicketValue: number, totalTips: number, totalDonations: number, paidStandbyQuantity: number, paidStandbyValue: number, ticShareIncome: number, producerShareIncome: number, producerPayoutPercentage: number, expenses: number, soldOut: boolean, seatingCapacity: number, totalAttendance: number, totalPaidAttendance: number, totalFreeAttendance: number, studentCompsRemaining: number, drinkSaleQuantity: number, drinkSaleValue: number, showType: { id: string, name: string, showTags: Array<{ id: string, name: string, slug: string }> } } | null } };

export type PerformanceForEditFragment = { id: string, name: string, status: PerformanceStatusEnum, startDatetime: string, onSaleDatetime: string | null, seatingCapacityOverride: number | null, description: string, calendarHeadline: string, offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum, acceptStudentComps: ShowTypeSettingsOverrideEnum, studentQuotaCompAllotment: number | null, expenses: number, showType: { id: string, name: string, standardExpenses: number, standardDescription: string, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, studentQuotaCompAllotment: number, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum }, showTags: Array<{ id: string, name: string, slug: string }> }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum } | null, workshop: { id: string, name: string } | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, calendarSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null }> };

export type PerformanceLoadForEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PerformanceLoadForEditQuery = { performanceDetailsAdmin: Array<{ id: string, name: string, status: PerformanceStatusEnum, startDatetime: string, onSaleDatetime: string | null, seatingCapacityOverride: number | null, description: string, calendarHeadline: string, offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum, acceptStudentComps: ShowTypeSettingsOverrideEnum, studentQuotaCompAllotment: number | null, expenses: number, showType: { id: string, name: string, standardExpenses: number, standardDescription: string, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, studentQuotaCompAllotment: number, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum }, showTags: Array<{ id: string, name: string, slug: string }> }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum } | null, workshop: { id: string, name: string } | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, calendarSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null }> }> };

export type NfpStatsNodeFragment = { id: string, name: string, startDatetime: string, determinedSeatingCapacity: number, doorSaleValue: number, bracket2DoorSaleValue: number, paidStandbyValue: number, showType: { presentedByNfp: boolean }, ticketBookings: Array<{ redeemed: boolean, paymentType: TicketPaymentTypeEnum }> };

export type DonationToNfpQueryVariables = Exact<{
  params: AdminDonationToNfpInput;
}>;


export type DonationToNfpQuery = { adminDonationToNfpReport: Array<{ amount: number, transferStatus: DonationToNfpTransferStatusEnum }> };

export type DonationToNfpMarkPaidMutationVariables = Exact<{
  params: AdminDonationToNfpMarkPaidInput;
}>;


export type DonationToNfpMarkPaidMutation = { adminDonationToNfpMarkPaid: { success: boolean, errors: Array<{ message: string }> } };

export type NfpStatsQueryVariables = Exact<{
  params: PerformanceListAttributes;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type NfpStatsQuery = { performancesListAdmin: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ cursor: string, node: { id: string, name: string, startDatetime: string, determinedSeatingCapacity: number, doorSaleValue: number, bracket2DoorSaleValue: number, paidStandbyValue: number, showType: { presentedByNfp: boolean }, ticketBookings: Array<{ redeemed: boolean, paymentType: TicketPaymentTypeEnum }> } | null } | null> | null } };

export type PerformanceSetDoorSalesMutationVariables = Exact<{
  performanceId: Scalars['ID'];
  bracket: TicketBracketEnum;
  quantity: Scalars['Int'];
}>;


export type PerformanceSetDoorSalesMutation = { performanceSetDoorSales: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type TicketBookingsTableFieldsFragment = { id: string, name: string, startDatetime: string, determinedSeatingCapacity: number, determinedHasSecondBracket: boolean, onlinePaidSeatQuantity: number, onlineReservedSeatQuantity: number, onlineStudentSeatQuantity: number, onlineCompedSeatQuantity: number, onlineFreeRegistrationSeatQuantity: number, onlineTicketSalesValue: number, onlineTicketSalesValueAfterCreditCardFees: number, onlineCreditCardProcessingFees: number, venueNonPresaleAttendance: number, venuePaidSeatQuantity: number, venuePaidSeatQuantitySecondBracket: number, venueFreeEntryQuantity: number, venueTicketSalesValue: number, venueTicketSalesValueAfterCreditCardFees: number, venueCreditCardProcessingFees: number, venueDrinkSaleQuantity: number, venueDrinkSaleValue: number, paidStandbyQuantity: number, paidStandbyValue: number, totalIncome: number, totalPaidTicketValue: number, totalPaidTicketValueAfterCreditCardFees: number, totalCreditCardProcessingFees: number, totalTicketingFees: number, totalDonations: number, totalTips: number, totalAttendance: number, ticShareIncome: number, producerShareIncome: number, producerPayoutPercentage: number, expenses: number, determinedTicketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean } | null, showType: { id: string, name: string }, ticketBookings: Array<{ id: string, bracket: TicketBracketEnum, redeemed: boolean, confirmed: boolean, name: string, email: string | null, telephone: string | null, userId: string | null, paymentType: TicketPaymentTypeEnum, paymentAmount: number, paymentAmountTickets: number, paymentAmountFees: number, paymentAmountDonation: number, paymentAmountTip: number, paymentUid: string | null, paymentDescription: string | null, refunded: boolean | null, refundedAt: string | null, refundUid: string | null, refundAmount: number | null, ticketQuantityFull: number, ticketQuantityConcession: number, ticketQuantityGroup: number, ticketQuantityPatron: number, ticketQuantityTotal: number, user: { id: string, fullName: string, email: string, telephone: string } | null }>, studentPerformanceAttendances: Array<{ workshopRegistration: { user: { id: string, fullName: string, email: string, telephone: string } } }>, standbys: Array<{ id: string, bracket: string, name: string, admitted: boolean | null }> };

export type PerformanceLoadForTableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PerformanceLoadForTableQuery = { performanceDetailsAdmin: Array<{ id: string, name: string, startDatetime: string, determinedSeatingCapacity: number, determinedHasSecondBracket: boolean, onlinePaidSeatQuantity: number, onlineReservedSeatQuantity: number, onlineStudentSeatQuantity: number, onlineCompedSeatQuantity: number, onlineFreeRegistrationSeatQuantity: number, onlineTicketSalesValue: number, onlineTicketSalesValueAfterCreditCardFees: number, onlineCreditCardProcessingFees: number, venueNonPresaleAttendance: number, venuePaidSeatQuantity: number, venuePaidSeatQuantitySecondBracket: number, venueFreeEntryQuantity: number, venueTicketSalesValue: number, venueTicketSalesValueAfterCreditCardFees: number, venueCreditCardProcessingFees: number, venueDrinkSaleQuantity: number, venueDrinkSaleValue: number, paidStandbyQuantity: number, paidStandbyValue: number, totalIncome: number, totalPaidTicketValue: number, totalPaidTicketValueAfterCreditCardFees: number, totalCreditCardProcessingFees: number, totalTicketingFees: number, totalDonations: number, totalTips: number, totalAttendance: number, ticShareIncome: number, producerShareIncome: number, producerPayoutPercentage: number, expenses: number, determinedTicketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean } | null, showType: { id: string, name: string }, ticketBookings: Array<{ id: string, bracket: TicketBracketEnum, redeemed: boolean, confirmed: boolean, name: string, email: string | null, telephone: string | null, userId: string | null, paymentType: TicketPaymentTypeEnum, paymentAmount: number, paymentAmountTickets: number, paymentAmountFees: number, paymentAmountDonation: number, paymentAmountTip: number, paymentUid: string | null, paymentDescription: string | null, refunded: boolean | null, refundedAt: string | null, refundUid: string | null, refundAmount: number | null, ticketQuantityFull: number, ticketQuantityConcession: number, ticketQuantityGroup: number, ticketQuantityPatron: number, ticketQuantityTotal: number, user: { id: string, fullName: string, email: string, telephone: string } | null }>, studentPerformanceAttendances: Array<{ workshopRegistration: { user: { id: string, fullName: string, email: string, telephone: string } } }>, standbys: Array<{ id: string, bracket: string, name: string, admitted: boolean | null }> }> };

export type PerformanceUpdatedSubscriptionVariables = Exact<{
  performanceId: Scalars['ID'];
}>;


export type PerformanceUpdatedSubscription = { performanceUpdated: { id: string, name: string, startDatetime: string, determinedSeatingCapacity: number, determinedHasSecondBracket: boolean, onlinePaidSeatQuantity: number, onlineReservedSeatQuantity: number, onlineStudentSeatQuantity: number, onlineCompedSeatQuantity: number, onlineFreeRegistrationSeatQuantity: number, onlineTicketSalesValue: number, onlineTicketSalesValueAfterCreditCardFees: number, onlineCreditCardProcessingFees: number, venueNonPresaleAttendance: number, venuePaidSeatQuantity: number, venuePaidSeatQuantitySecondBracket: number, venueFreeEntryQuantity: number, venueTicketSalesValue: number, venueTicketSalesValueAfterCreditCardFees: number, venueCreditCardProcessingFees: number, venueDrinkSaleQuantity: number, venueDrinkSaleValue: number, paidStandbyQuantity: number, paidStandbyValue: number, totalIncome: number, totalPaidTicketValue: number, totalPaidTicketValueAfterCreditCardFees: number, totalCreditCardProcessingFees: number, totalTicketingFees: number, totalDonations: number, totalTips: number, totalAttendance: number, ticShareIncome: number, producerShareIncome: number, producerPayoutPercentage: number, expenses: number, determinedTicketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean } | null, showType: { id: string, name: string }, ticketBookings: Array<{ id: string, bracket: TicketBracketEnum, redeemed: boolean, confirmed: boolean, name: string, email: string | null, telephone: string | null, userId: string | null, paymentType: TicketPaymentTypeEnum, paymentAmount: number, paymentAmountTickets: number, paymentAmountFees: number, paymentAmountDonation: number, paymentAmountTip: number, paymentUid: string | null, paymentDescription: string | null, refunded: boolean | null, refundedAt: string | null, refundUid: string | null, refundAmount: number | null, ticketQuantityFull: number, ticketQuantityConcession: number, ticketQuantityGroup: number, ticketQuantityPatron: number, ticketQuantityTotal: number, user: { id: string, fullName: string, email: string, telephone: string } | null }>, studentPerformanceAttendances: Array<{ workshopRegistration: { user: { id: string, fullName: string, email: string, telephone: string } } }>, standbys: Array<{ id: string, bracket: string, name: string, admitted: boolean | null }> } };

export type MarkCollectedMutationVariables = Exact<{
  ticketId: Scalars['ID'];
  collected: Scalars['Boolean'];
}>;


export type MarkCollectedMutation = { ticketMarkCollected: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type TicketResendConfirmationEmailMutationVariables = Exact<{
  ticketId: Scalars['ID'];
}>;


export type TicketResendConfirmationEmailMutation = { ticketResendConfirmationEmail: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type TicketPricingFieldsFragment = { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean };

export type ShowTypeFragment = { showType: { id: string, name: string, showTags: Array<{ id: string, name: string, slug: string }> } };

export type BarSalesFragment = { drinkSaleQuantity: number, drinkSaleValue: number };

export type AttendanceFragment = { soldOut: boolean, seatingCapacity: number, totalAttendance: number, totalPaidAttendance: number, totalFreeAttendance: number, studentCompsRemaining: number };

export type PerformanceFinancesFragment = { totalIncome: number, totalPaidTicketValue: number, totalTips: number, totalDonations: number, paidStandbyQuantity: number, paidStandbyValue: number, ticShareIncome: number, producerShareIncome: number, producerPayoutPercentage: number, expenses: number };

export type CalendarSessionsFragment = { calendarSessions: Array<{ id: string, startDatetime: string, endDatetime: string, venue: { id: string, name: string } | null }> };

export type PerformanceAdminIndexFieldsFragment = { id: string, name: string, status: PerformanceStatusEnum, description: string, calendarHeadline: string, startDatetime: string, onSaleDatetime: string | null, totalIncome: number, totalPaidTicketValue: number, totalTips: number, totalDonations: number, paidStandbyQuantity: number, paidStandbyValue: number, ticShareIncome: number, producerShareIncome: number, producerPayoutPercentage: number, expenses: number, soldOut: boolean, seatingCapacity: number, totalAttendance: number, totalPaidAttendance: number, totalFreeAttendance: number, studentCompsRemaining: number, drinkSaleQuantity: number, drinkSaleValue: number, showType: { id: string, name: string, showTags: Array<{ id: string, name: string, slug: string }> } };

export type PerformancesListAdminQueryVariables = Exact<{
  params: PerformanceListAttributes;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type PerformancesListAdminQuery = { performancesListAdmin: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ cursor: string, node: { id: string, name: string, status: PerformanceStatusEnum, description: string, calendarHeadline: string, startDatetime: string, onSaleDatetime: string | null, totalIncome: number, totalPaidTicketValue: number, totalTips: number, totalDonations: number, paidStandbyQuantity: number, paidStandbyValue: number, ticShareIncome: number, producerShareIncome: number, producerPayoutPercentage: number, expenses: number, soldOut: boolean, seatingCapacity: number, totalAttendance: number, totalPaidAttendance: number, totalFreeAttendance: number, studentCompsRemaining: number, drinkSaleQuantity: number, drinkSaleValue: number, showType: { id: string, name: string, showTags: Array<{ id: string, name: string, slug: string }> } } | null } | null> | null } };

export type CheckVenueAvailabilityQueryVariables = Exact<{
  params: CheckVenueAvailabilityInput;
}>;


export type CheckVenueAvailabilityQuery = { checkVenueAvailability: Array<{ available: boolean, unavailableReason: string | null, otherVenuesAtSameTime: Array<{ available: boolean, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } }> }> };

export type VenueBlackoutsPublicQueryVariables = Exact<{
  blackoutSessionsBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
}>;


export type VenueBlackoutsPublicQuery = { venueBlackoutsPublic: Array<{ venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, venueAvailabilities: Array<{ scope: VenueAvailabilityScope, mondayAvailability: { secondsIntoDay: number, durationSeconds: number } | null, tuesdayAvailability: { secondsIntoDay: number, durationSeconds: number } | null, wednesdayAvailability: { secondsIntoDay: number, durationSeconds: number } | null, thursdayAvailability: { secondsIntoDay: number, durationSeconds: number } | null, fridayAvailability: { secondsIntoDay: number, durationSeconds: number } | null, saturdayAvailability: { secondsIntoDay: number, durationSeconds: number } | null, sundayAvailability: { secondsIntoDay: number, durationSeconds: number } | null }> }, upcomingBlackoutSessions: Array<{ startDatetime: string, endDatetime: string }> }> };

export type FullWorkshopTemplateFragment = { id: string, name: string, workshopNamePrefix: string, workshopNameSuffix: WorkshopNameSuffixEnum, capacity: number, meetingType: WorkshopMeetingTypeEnum, numberOfSessions: number, sessionDurationMinutes: number, zoomMeetingInvitation: string | null, description: string | null, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null };

export type StandaloneSeriesQueryVariables = Exact<{ [key: string]: never; }>;


export type StandaloneSeriesQuery = { adminWorkshopTemplates: Array<{ id: string, name: string, workshopNamePrefix: string, workshopNameSuffix: WorkshopNameSuffixEnum, capacity: number, meetingType: WorkshopMeetingTypeEnum, numberOfSessions: number, sessionDurationMinutes: number, zoomMeetingInvitation: string | null, description: string | null, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null }> };

export type BatchCreateWorkshopMutationVariables = Exact<{
  attributes: Array<EditWorkshopAttributes> | EditWorkshopAttributes;
}>;


export type BatchCreateWorkshopMutation = { batchCreateWorkshops: { errors: Array<{ message: string, path: Array<string> | null }>, workshops: Array<{ id: string, name: string, confirmed: boolean, visible: boolean, description: string, simplePassword: string | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, meetingType: WorkshopMeetingTypeEnum, zoomMeetingInvitation: string | null, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, grossIncome: number, workshopTerm: { id: string, name: string, startingMonday: string } | null, internalComments: Array<{ comment: string, user: { id: string, name: string } }>, workshopWaitingLists: Array<{ user: { id: string, name: string, email: string, telephone: string } }>, prerequisiteWorkshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } } | null, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, preferredWorkshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null }, studentShowcases: Array<{ id: string, name: string, status: PerformanceStatusEnum, startDatetime: string, onSaleDatetime: string | null, seatingCapacityOverride: number | null, description: string, calendarHeadline: string, offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum, acceptStudentComps: ShowTypeSettingsOverrideEnum, studentQuotaCompAllotment: number | null, expenses: number, showType: { id: string, name: string, standardExpenses: number, standardDescription: string, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, studentQuotaCompAllotment: number, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum }, showTags: Array<{ id: string, name: string, slug: string }> }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum } | null, workshop: { id: string, name: string } | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, calendarSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null }> }>, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, address: string | null, directions: string | null, recommendedWorkshopParticipantCapacity: number, seatingCapacity: number } | null }>, teachers: Array<{ id: string, name: string, workshopBio: string | null }>, assistants: Array<{ id: string, name: string, workshopBio: string | null }>, substituteTeachers: Array<{ id: string, name: string, workshopBio: string | null }> }> | null } };

export type BatchCreateWorkshopInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type BatchCreateWorkshopInfoQuery = { workshopLevelsList: Array<{ position: number, id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopTrack: { id: string, position: number, name: string }, workshopCategory: { id: string, name: string }, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null }> };

export type WorkshopLoadForEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WorkshopLoadForEditQuery = { workshopDetailsAdmin: Array<{ id: string, name: string, confirmed: boolean, visible: boolean, description: string, simplePassword: string | null, studentCompsOfferedOverride: boolean, studentCompsQuantityOverride: number | null, studentJamsQuantityOverride: number | null, studentShowcasesOfferedOverride: boolean, studentShowcasesQuantityOverride: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, meetingType: WorkshopMeetingTypeEnum, zoomMeetingInvitation: string | null, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, grossIncome: number, workshopTerm: { id: string, name: string, startingMonday: string } | null, prerequisiteWorkshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } } | null, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, preferredWorkshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null }, studentShowcases: Array<{ id: string, name: string, status: PerformanceStatusEnum, startDatetime: string, onSaleDatetime: string | null, seatingCapacityOverride: number | null, description: string, calendarHeadline: string, offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum, acceptStudentComps: ShowTypeSettingsOverrideEnum, studentQuotaCompAllotment: number | null, expenses: number, showType: { id: string, name: string, standardExpenses: number, standardDescription: string, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, studentQuotaCompAllotment: number, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum }, showTags: Array<{ id: string, name: string, slug: string }> }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum } | null, workshop: { id: string, name: string } | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, calendarSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null }> }>, internalComments: Array<{ comment: string, createdAt: string, user: { name: string } }>, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, address: string | null, directions: string | null, recommendedWorkshopParticipantCapacity: number, seatingCapacity: number } | null }>, teachers: Array<{ id: string, name: string, workshopBio: string | null }>, assistants: Array<{ id: string, name: string, workshopBio: string | null }>, substituteTeachers: Array<{ id: string, name: string, workshopBio: string | null }> }> };

export type StudentShowcaseInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentShowcaseInfoQuery = { showTypeStudentShowcase: { id: string, name: string, standardDescription: string, standardExpenses: number, studentQuotaCompAllotment: number, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number }, showTags: Array<{ id: string, name: string, slug: string }> } };

export type CreateWorkshopMutationVariables = Exact<{
  attributes: EditWorkshopAttributes;
}>;


export type CreateWorkshopMutation = { createWorkshop: { errors: Array<{ message: string, path: Array<string> | null }>, workshop: { id: string, name: string, confirmed: boolean, visible: boolean, description: string, simplePassword: string | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, meetingType: WorkshopMeetingTypeEnum, zoomMeetingInvitation: string | null, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, grossIncome: number, workshopTerm: { id: string, name: string, startingMonday: string } | null, internalComments: Array<{ comment: string, user: { id: string, name: string } }>, workshopWaitingLists: Array<{ user: { id: string, name: string, email: string, telephone: string } }>, prerequisiteWorkshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } } | null, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, preferredWorkshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null }, studentShowcases: Array<{ id: string, name: string, status: PerformanceStatusEnum, startDatetime: string, onSaleDatetime: string | null, seatingCapacityOverride: number | null, description: string, calendarHeadline: string, offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum, acceptStudentComps: ShowTypeSettingsOverrideEnum, studentQuotaCompAllotment: number | null, expenses: number, showType: { id: string, name: string, standardExpenses: number, standardDescription: string, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, studentQuotaCompAllotment: number, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum }, showTags: Array<{ id: string, name: string, slug: string }> }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum } | null, workshop: { id: string, name: string } | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, calendarSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null }> }>, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, address: string | null, directions: string | null, recommendedWorkshopParticipantCapacity: number, seatingCapacity: number } | null }>, teachers: Array<{ id: string, name: string, workshopBio: string | null }>, assistants: Array<{ id: string, name: string, workshopBio: string | null }>, substituteTeachers: Array<{ id: string, name: string, workshopBio: string | null }> } | null } };

export type EditWorkshopMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: EditWorkshopAttributes;
}>;


export type EditWorkshopMutation = { editWorkshop: { errors: Array<{ message: string, path: Array<string> | null }>, workshop: { id: string, name: string, confirmed: boolean, visible: boolean, description: string, simplePassword: string | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, meetingType: WorkshopMeetingTypeEnum, zoomMeetingInvitation: string | null, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, grossIncome: number, workshopTerm: { id: string, name: string, startingMonday: string } | null, internalComments: Array<{ comment: string, user: { id: string, name: string } }>, workshopWaitingLists: Array<{ user: { id: string, name: string, email: string, telephone: string } }>, prerequisiteWorkshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } } | null, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, preferredWorkshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null }, studentShowcases: Array<{ id: string, name: string, status: PerformanceStatusEnum, startDatetime: string, onSaleDatetime: string | null, seatingCapacityOverride: number | null, description: string, calendarHeadline: string, offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum, acceptStudentComps: ShowTypeSettingsOverrideEnum, studentQuotaCompAllotment: number | null, expenses: number, showType: { id: string, name: string, standardExpenses: number, standardDescription: string, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, studentQuotaCompAllotment: number, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum }, showTags: Array<{ id: string, name: string, slug: string }> }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum } | null, workshop: { id: string, name: string } | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, calendarSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null }> }>, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, address: string | null, directions: string | null, recommendedWorkshopParticipantCapacity: number, seatingCapacity: number } | null }>, teachers: Array<{ id: string, name: string, workshopBio: string | null }>, assistants: Array<{ id: string, name: string, workshopBio: string | null }>, substituteTeachers: Array<{ id: string, name: string, workshopBio: string | null }> } | null } };

export type EndOfTermWorkshopNodeFragment = { id: string, name: string, evaluationsLocked: boolean, endOfTermDate: string, workshopLevel: { evaluationMode: EvaluationModeEnum }, teachers: Array<{ name: string }>, confirmedWorkshopRegistrations: Array<{ id: string, sentCourseEvaluationEmails: string | null, sentCourseResultEmails: string | null, registrationType: WorkshopRegistrationTypeEnum, state: WorkshopRegistrationState, user: { fullName: string }, evaluationByTeacher: { instructorCommentsForStudent: string | null, instructorCommentsInternalUse: string | null, passRepeatStatusInternal: PassRepeatStatusInternalEnum | null, workshopTrackInvitations: Array<{ workshopTrack: { id: string, name: string } }> } | null }> };

export type EndOfTermInfoQueryVariables = Exact<{
  params: WorkshopsListAttributes;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type EndOfTermInfoQuery = { workshopsListAdmin: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ cursor: string, node: { id: string, name: string, evaluationsLocked: boolean, endOfTermDate: string, workshopLevel: { evaluationMode: EvaluationModeEnum }, teachers: Array<{ name: string }>, confirmedWorkshopRegistrations: Array<{ id: string, sentCourseEvaluationEmails: string | null, sentCourseResultEmails: string | null, registrationType: WorkshopRegistrationTypeEnum, state: WorkshopRegistrationState, user: { fullName: string }, evaluationByTeacher: { instructorCommentsForStudent: string | null, instructorCommentsInternalUse: string | null, passRepeatStatusInternal: PassRepeatStatusInternalEnum | null, workshopTrackInvitations: Array<{ workshopTrack: { id: string, name: string } }> } | null }> } | null } | null> | null } };

export type AdminSendCourseSurveysMutationVariables = Exact<{
  workshopRegistrationIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AdminSendCourseSurveysMutation = { adminSendCourseSurveys: { success: boolean, errors: Array<{ message: string }> } };

export type AdminSendCourseResultsMutationVariables = Exact<{
  workshopRegistrationIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AdminSendCourseResultsMutation = { adminSendCourseResults: { success: boolean, errors: Array<{ message: string }> } };

export type FreeTrialOfferWorkshopFragment = { id: string, name: string, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, venue: { id: string, name: string } | null }>, teachers: Array<{ name: string }>, assistants: Array<{ name: string }> };

export type FreeTrialOffersInfoQueryVariables = Exact<{
  workshopCategoryId: Scalars['ID'];
}>;


export type FreeTrialOffersInfoQuery = { freeTrialOffers: { nextTermWorkshops: Array<{ id: string, name: string, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, venue: { id: string, name: string } | null }>, teachers: Array<{ name: string }>, assistants: Array<{ name: string }> }>, otherUpcomingWorkshops: Array<{ id: string, name: string, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, venue: { id: string, name: string } | null }>, teachers: Array<{ name: string }>, assistants: Array<{ name: string }> }>, discountOffers: { inPersonNextTerm: number, inPersonAny: number, sameOrNextDay: number, thirtyDays: number, anytime: number } } };

export type FreeTrialStatsWorkshopNodeFragment = { id: string, name: string, workshopLevel: { workshopCategoryId: string }, teachers: Array<{ fullName: string }>, workshopSessions: Array<{ venue: { name: string } | null }>, workshopRegistrations: Array<{ state: WorkshopRegistrationState, user: { vouchers: Array<{ maximumDollarValue: number }>, workshopRegistrations: Array<{ workshop: { workshopLevel: { levelType: WorkshopLevelTypeEnum, workshopCategoryId: string } } }> } }> };

export type FreeTrialStatsWorkshopLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type FreeTrialStatsWorkshopLevelsQuery = { workshopLevelsList: Array<{ id: string, name: string, levelType: WorkshopLevelTypeEnum, workshopCategoryId: string, workshopCategory: { name: string } }> };

export type FreeTrialStatsQueryVariables = Exact<{
  params: WorkshopsListAttributes;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type FreeTrialStatsQuery = { workshopsListAdmin: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ cursor: string, node: { id: string, name: string, workshopLevel: { workshopCategoryId: string }, teachers: Array<{ fullName: string }>, workshopSessions: Array<{ venue: { name: string } | null }>, workshopRegistrations: Array<{ state: WorkshopRegistrationState, user: { vouchers: Array<{ maximumDollarValue: number }>, workshopRegistrations: Array<{ workshop: { workshopLevel: { levelType: WorkshopLevelTypeEnum, workshopCategoryId: string } } }> } }> } | null } | null> | null } };

export type CheckPostponeWorkshopsValidityQueryVariables = Exact<{
  workshopIds: Array<Scalars['ID']> | Scalars['ID'];
  checkValidityAttributes: PostponeWorkshopsAttributes;
}>;


export type CheckPostponeWorkshopsValidityQuery = { workshopDetailsAdmin: Array<{ id: string, name: string, confirmed: boolean, visible: boolean, description: string, simplePassword: string | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, meetingType: WorkshopMeetingTypeEnum, zoomMeetingInvitation: string | null, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, grossIncome: number, confirmedWorkshopRegistrations: Array<{ id: string, user: { id: string, fullName: string, email: string, telephone: string } }>, workshopTerm: { id: string, name: string, startingMonday: string } | null, internalComments: Array<{ comment: string, user: { id: string, name: string } }>, workshopWaitingLists: Array<{ user: { id: string, name: string, email: string, telephone: string } }>, prerequisiteWorkshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } } | null, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, preferredWorkshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null }, studentShowcases: Array<{ id: string, name: string, status: PerformanceStatusEnum, startDatetime: string, onSaleDatetime: string | null, seatingCapacityOverride: number | null, description: string, calendarHeadline: string, offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum, acceptStudentComps: ShowTypeSettingsOverrideEnum, studentQuotaCompAllotment: number | null, expenses: number, showType: { id: string, name: string, standardExpenses: number, standardDescription: string, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, studentQuotaCompAllotment: number, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum }, showTags: Array<{ id: string, name: string, slug: string }> }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum } | null, workshop: { id: string, name: string } | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, calendarSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null }> }>, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, address: string | null, directions: string | null, recommendedWorkshopParticipantCapacity: number, seatingCapacity: number } | null }>, teachers: Array<{ id: string, name: string, workshopBio: string | null }>, assistants: Array<{ id: string, name: string, workshopBio: string | null }>, substituteTeachers: Array<{ id: string, name: string, workshopBio: string | null }> }>, checkPostponeWorkshopsValidity: Array<{ workshopSessionId: string, valid: boolean, invalidReason: string | null, conflictingWorkshopId: string | null, newStartDatetime: string, newEndDatetime: string }> };

export type PostponeWorkshopsMutationVariables = Exact<{
  attributes: PostponeWorkshopsAttributes;
}>;


export type PostponeWorkshopsMutation = { postponeWorkshops: { errors: Array<{ message: string, path: Array<string> | null }>, workshops: Array<{ id: string, name: string, confirmed: boolean, visible: boolean, description: string, simplePassword: string | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, meetingType: WorkshopMeetingTypeEnum, zoomMeetingInvitation: string | null, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, grossIncome: number, workshopTerm: { id: string, name: string, startingMonday: string } | null, internalComments: Array<{ comment: string, user: { id: string, name: string } }>, workshopWaitingLists: Array<{ user: { id: string, name: string, email: string, telephone: string } }>, prerequisiteWorkshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } } | null, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, preferredWorkshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null }, studentShowcases: Array<{ id: string, name: string, status: PerformanceStatusEnum, startDatetime: string, onSaleDatetime: string | null, seatingCapacityOverride: number | null, description: string, calendarHeadline: string, offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum, acceptStudentComps: ShowTypeSettingsOverrideEnum, studentQuotaCompAllotment: number | null, expenses: number, showType: { id: string, name: string, standardExpenses: number, standardDescription: string, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, studentQuotaCompAllotment: number, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum }, showTags: Array<{ id: string, name: string, slug: string }> }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum } | null, workshop: { id: string, name: string } | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, calendarSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null }> }>, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, address: string | null, directions: string | null, recommendedWorkshopParticipantCapacity: number, seatingCapacity: number } | null }>, teachers: Array<{ id: string, name: string, workshopBio: string | null }>, assistants: Array<{ id: string, name: string, workshopBio: string | null }>, substituteTeachers: Array<{ id: string, name: string, workshopBio: string | null }> }> | null } };

export type ReferralBonusIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralBonusIndexQuery = { referralBonusPendingWorkshopRegistrations: Array<{ id: string, pendingReferral: boolean | null, referralDetail: string | null, user: { id: string, fullName: string, email: string, telephone: string }, workshop: { id: string, name: string, meetingType: WorkshopMeetingTypeEnum, zoomMeetingInvitation: string | null, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, address: string | null, directions: string | null, recommendedWorkshopParticipantCapacity: number, seatingCapacity: number } | null }> } }> };

export type ReferralBonusRejectMutationVariables = Exact<{
  workshopRegistrationId: Scalars['ID'];
}>;


export type ReferralBonusRejectMutation = { referralBonusReject: { success: boolean, errors: Array<{ message: string, path: Array<string> | null }> } };

export type SendEmailToCustomersInfoQueryVariables = Exact<{
  userIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SendEmailToCustomersInfoQuery = { currentUser: { id: string, firstName: string, fullName: string, email: string, outgoingEmailAlias: string | null } | null, batchUserInfoAdmin: Array<{ id: string, firstName: string, fullName: string, email: string }> };

export type SendEmailToCustomersMutationVariables = Exact<{
  params: SendMailMergeForCustomersInput;
}>;


export type SendEmailToCustomersMutation = { sendMailMergeForCustomers: { success: boolean, errors: Array<{ message: string }> } };

export type SendEmailToStudentsInfoQueryVariables = Exact<{
  workshopIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SendEmailToStudentsInfoQuery = { currentUser: { id: string, firstName: string, fullName: string, email: string, outgoingEmailAlias: string | null } | null, workshopDetailsAdmin: Array<{ name: string, teachers: Array<{ firstName: string, fullName: string, name: string, user: { id: string } | null }>, confirmedWorkshopRegistrations: Array<{ id: string, user: { id: string, firstName: string, fullName: string, email: string } }> }> };

export type SendEmailToStudentsMutationVariables = Exact<{
  params: SendMailMergeForWorkshopsInput;
}>;


export type SendEmailToStudentsMutation = { sendMailMergeForWorkshops: { success: boolean, errors: Array<{ message: string }> } };

export type StudentProgressGeneralQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentProgressGeneralQuery = { workshopCategoriesListAdmin: Array<{ id: string, name: string, workshopLevelsForCustomers: Array<{ id: string, name: string, userWorkshopLevelMaximumProgresses: Array<{ id: string }> }> }> };

export type StudentProgressDetailQueryVariables = Exact<{
  workshopLevelId: Scalars['ID'];
}>;


export type StudentProgressDetailQuery = { workshopLevelInfo: { id: string, name: string, userWorkshopLevelMaximumProgresses: Array<{ id: string, user: { id: string, fullName: string, email: string, studentAvailability: { updatedAt: string, mondayDaytime: StudentAvailabilityEnum, mondayEvening: StudentAvailabilityEnum, tuesdayDaytime: StudentAvailabilityEnum, tuesdayEvening: StudentAvailabilityEnum, wednesdayDaytime: StudentAvailabilityEnum, wednesdayEvening: StudentAvailabilityEnum, thursdayDaytime: StudentAvailabilityEnum, thursdayEvening: StudentAvailabilityEnum, fridayDaytime: StudentAvailabilityEnum, fridayEvening: StudentAvailabilityEnum, saturdayDaytime: StudentAvailabilityEnum, saturdayEvening: StudentAvailabilityEnum, sundayDaytime: StudentAvailabilityEnum, sundayEvening: StudentAvailabilityEnum, startingFrom: string | null } | null }, workshopRegistration: { evaluationByTeacher: { passRepeatStatusInternal: PassRepeatStatusInternalEnum | null } | null, evaluationByStudent: { programContinuationPlans: string | null, programContinuationPlansEnum: ProgramContinuationPlansEnum, programContinuationReasons: string | null } | null, workshop: { startOfTermDate: string } } }> } };

export type WorkshopPricingFieldsFragment = { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null };

export type WorkshopSessionsFragment = { meetingType: WorkshopMeetingTypeEnum, zoomMeetingInvitation: string | null, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, address: string | null, directions: string | null, recommendedWorkshopParticipantCapacity: number, seatingCapacity: number } | null }> };

export type InstructorFieldsFragment = { id: string, name: string, workshopBio: string | null };

export type InstructorsFragment = { teachers: Array<{ id: string, name: string, workshopBio: string | null }>, assistants: Array<{ id: string, name: string, workshopBio: string | null }>, substituteTeachers: Array<{ id: string, name: string, workshopBio: string | null }> };

export type CapacityFragment = { capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean };

export type WorkshopFinancesFragment = { grossIncome: number };

export type WorkshopAdminIndexFieldsFragment = { id: string, name: string, confirmed: boolean, visible: boolean, description: string, simplePassword: string | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, meetingType: WorkshopMeetingTypeEnum, zoomMeetingInvitation: string | null, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, grossIncome: number, workshopTerm: { id: string, name: string, startingMonday: string } | null, internalComments: Array<{ comment: string, user: { id: string, name: string } }>, workshopWaitingLists: Array<{ user: { id: string, name: string, email: string, telephone: string } }>, prerequisiteWorkshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } } | null, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, preferredWorkshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null }, studentShowcases: Array<{ id: string, name: string, status: PerformanceStatusEnum, startDatetime: string, onSaleDatetime: string | null, seatingCapacityOverride: number | null, description: string, calendarHeadline: string, offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum, acceptStudentComps: ShowTypeSettingsOverrideEnum, studentQuotaCompAllotment: number | null, expenses: number, showType: { id: string, name: string, standardExpenses: number, standardDescription: string, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, studentQuotaCompAllotment: number, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum }, showTags: Array<{ id: string, name: string, slug: string }> }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum } | null, workshop: { id: string, name: string } | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, calendarSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null }> }>, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, address: string | null, directions: string | null, recommendedWorkshopParticipantCapacity: number, seatingCapacity: number } | null }>, teachers: Array<{ id: string, name: string, workshopBio: string | null }>, assistants: Array<{ id: string, name: string, workshopBio: string | null }>, substituteTeachers: Array<{ id: string, name: string, workshopBio: string | null }> };

export type WorkshopsListAdminQueryVariables = Exact<{
  params: WorkshopsListAttributes;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type WorkshopsListAdminQuery = { workshopsListAdmin: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ cursor: string, node: { id: string, name: string, confirmed: boolean, visible: boolean, description: string, simplePassword: string | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, meetingType: WorkshopMeetingTypeEnum, zoomMeetingInvitation: string | null, capacity: number, absoluteMaximumCapacity: number, numStudentsEnrolled: number, soldOut: boolean, grossIncome: number, workshopTerm: { id: string, name: string, startingMonday: string } | null, internalComments: Array<{ comment: string, user: { id: string, name: string } }>, workshopWaitingLists: Array<{ user: { id: string, name: string, email: string, telephone: string } }>, prerequisiteWorkshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } } | null, workshopLevel: { id: string, name: string, levelType: WorkshopLevelTypeEnum, onlineClassesAvailable: boolean | null, studentCompsMode: StudentPerksModeEnum, studentCompsQuantity: number | null, studentJamsQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, sessionMode: SessionModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, description: string, visible: boolean, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { id: string, name: string } | null, workshopCategory: { id: string, name: string } }, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, preferredWorkshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null }, studentShowcases: Array<{ id: string, name: string, status: PerformanceStatusEnum, startDatetime: string, onSaleDatetime: string | null, seatingCapacityOverride: number | null, description: string, calendarHeadline: string, offerEarlyBirdDiscount: ShowTypeSettingsOverrideEnum, acceptStudentComps: ShowTypeSettingsOverrideEnum, studentQuotaCompAllotment: number | null, expenses: number, showType: { id: string, name: string, standardExpenses: number, standardDescription: string, studentViewingQuotaCreditGiven: boolean, acceptStudentComps: boolean, studentQuotaCompAllotment: number, offerEarlyBirdDiscount: boolean | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum }, showTags: Array<{ id: string, name: string, slug: string }> }, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number, blockOutOtherCalendarVenueId: string | null, blockOutOtherCalendarMode: CalendarBlockingModeEnum } | null, workshop: { id: string, name: string } | null, ticketPricingGroup: { id: string, name: string, fullPrice: number, concessionPrice: number, perUnitServiceFee: number, totalServiceFee: number, groupPrice: number | null, groupMinimumSize: number | null, archived: boolean, patronMarkupPercentage: number, paidMemberPrice: number | null, communityMemberPrice: number | null, communityMemberPriceDoorOnly: boolean, freeOnDoor: boolean } | null, calendarSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, seatingCapacity: number, recommendedWorkshopParticipantCapacity: number } | null }> }>, workshopSessions: Array<{ id: string, startDatetime: string, endDatetime: string, scope: VenueAvailabilityScope, venue: { id: string, name: string, address: string | null, directions: string | null, recommendedWorkshopParticipantCapacity: number, seatingCapacity: number } | null }>, teachers: Array<{ id: string, name: string, workshopBio: string | null }>, assistants: Array<{ id: string, name: string, workshopBio: string | null }>, substituteTeachers: Array<{ id: string, name: string, workshopBio: string | null }> } | null } | null> | null } };

export type JoinWaitingListQueryVariables = Exact<{
  workshopId: Scalars['ID'];
}>;


export type JoinWaitingListQuery = { currentUser: { id: string, fullName: string } | null, workshopInfo: { id: string, name: string }, workshopWaitingListStatus: { onWaitingList: boolean, canJoinWaitingList: boolean, numOtherStudentsOnList: number } | null };

export type JoinWorkshopWaitingListMutationVariables = Exact<{
  params: JoinWorkshopWaitingListInput;
}>;


export type JoinWorkshopWaitingListMutation = { joinWorkshopWaitingList: { success: boolean | null, errors: Array<{ message: string }> } };

export type WorkshopAlertSubscriptionsQueryVariables = Exact<{
  workshopLevelId: Scalars['ID'];
}>;


export type WorkshopAlertSubscriptionsQuery = { currentUser: { id: string, fullName: string, studentAvailability: { updatedAt: string, mondayDaytime: StudentAvailabilityEnum, mondayEvening: StudentAvailabilityEnum, tuesdayDaytime: StudentAvailabilityEnum, tuesdayEvening: StudentAvailabilityEnum, wednesdayDaytime: StudentAvailabilityEnum, wednesdayEvening: StudentAvailabilityEnum, thursdayDaytime: StudentAvailabilityEnum, thursdayEvening: StudentAvailabilityEnum, fridayDaytime: StudentAvailabilityEnum, fridayEvening: StudentAvailabilityEnum, saturdayDaytime: StudentAvailabilityEnum, saturdayEvening: StudentAvailabilityEnum, sundayDaytime: StudentAvailabilityEnum, sundayEvening: StudentAvailabilityEnum, startingFrom: string | null } | null, workshopAlertSubscriptions: Array<{ subscribed: boolean, workshopAlertable: { __typename: 'Workshop' } | { __typename: 'WorkshopLevel', id: string, name: string } }> } | null, workshopLevelInfo: { id: string, name: string } };

export type ManageWorkshopLevelAlertMutationVariables = Exact<{
  params: ManageWorkshopLevelAlertInput;
}>;


export type ManageWorkshopLevelAlertMutation = { manageWorkshopLevelAlert: { success: boolean, errors: Array<{ message: string }> } };

export type WorkshopTracksQueryVariables = Exact<{
  workshopCategoryId: Scalars['ID'];
}>;


export type WorkshopTracksQuery = { workshopCategory: { id: string, name: string, categoryType: ComedyDisciplineEnum, workshopTracksPublic: Array<{ id: string, name: string, description: string, headline: string, imageUrlWeb: string | null, workshopLevelsPublic: Array<{ id: string, name: string, summary: string, slug: string, evaluationMode: EvaluationModeEnum, sessionMode: SessionModeEnum, studentCompsMode: StudentPerksModeEnum, studentShowcaseMode: StudentPerksModeEnum, studentShowcaseQuantity: number | null, prerequisiteMode: WorkshopPrerequisiteModeEnum, workshopPricingGroup: { id: string, name: string | null, fullPrice: number, concessionPrice: number, totalServiceFee: number, flexibleFee: number | null, flexibleFeeName: string | null, earlyBirdDiscountAmount: number | null } | null, prerequisiteWorkshopLevel: { name: string } | null, upcomingWorkshops: Array<{ id: string, name: string }> }> }> } };

export const StudentAvailabilityEssentialsFragmentDoc = `
    fragment studentAvailabilityEssentials on StudentAvailability {
  updatedAt
  mondayDaytime
  mondayEvening
  tuesdayDaytime
  tuesdayEvening
  wednesdayDaytime
  wednesdayEvening
  thursdayDaytime
  thursdayEvening
  fridayDaytime
  fridayEvening
  saturdayDaytime
  saturdayEvening
  sundayDaytime
  sundayEvening
  startingFrom
}
    `;
export const AccountDetailsTicketFragmentDoc = `
    fragment accountDetailsTicket on PerformanceTicketRegistration {
  id
  email
  refunded
  performance {
    id
    name
    startDatetime
    bookingWindowBufferMinutes
    durationInMinutes
    showType {
      calendarThumbnailUrlWeb
    }
  }
  ticketOrder {
    paymentIntentId
  }
  bookingStatus
  ticketQuantityFull
  ticketQuantityConcession
  ticketQuantityGroup
  ticketQuantityCommunityMember
  ticketQuantityPaidMember
  ticketQuantityPatron
  ticketQuantityTotal
  paymentAmount
  paymentAmountTickets
  paymentAmountTip
  paymentAmountDonation
  paymentAmountFees
  createdAt
  paymentType
  paymentDescription
  paymentUid
  redeemed
}
    `;
export const AccountDetailsWorkshopPaymentLedgerFragmentDoc = `
    fragment accountDetailsWorkshopPaymentLedger on WorkshopPaymentLedger {
  id
  paymentLedgerType
  registrationFee
  amountPaidToDate
  amountOutstanding
  targetPaymentDateHalf
  targetPaymentDateFull
  paymentPlanStatus
  payments {
    paymentAmount
    paymentDescription
    paymentType
    paymentUid
    paymentIntentId
    createdAt
    paymentRefunds {
      refundUid
      refundAmount
      createdAt
    }
  }
}
    `;
export const AccountDetailsWorkshopRegistrationFragmentDoc = `
    fragment accountDetailsWorkshopRegistration on WorkshopRegistration {
  __typename
  id
  state
  createdAt
  registrationType
  workshopPaymentLedger {
    ...accountDetailsWorkshopPaymentLedger
  }
  evaluationByStudent {
    id
  }
  evaluationByTeacher {
    passRepeatStatusForUser
    instructorCommentsForStudent
    releasedByEducationDirector
    releaseStatus
  }
  studentReservations {
    id
    redeemed
    paymentType
    performance {
      name
      startDatetime
    }
  }
  workshop {
    id
    workshopLevel {
      levelType
      teacherEvaluationsRequired
      name
      nextWorkshopLevel {
        name
      }
    }
    preferredWorkshopPricingGroup {
      fullPrice
      concessionPrice
      flexibleFee
      totalServiceFee
    }
    name
    startDate
    endDate
    determinedStudentCompsOffered
    determinedStudentJamsDuringTerm
    determinedStudentCompsDuringTerm
    workshopSessions {
      startDatetime
      endDatetime
      venue {
        name
      }
    }
    teachers {
      fullName
    }
  }
}
    `;
export const NewsItemFragmentDoc = `
    fragment NewsItem on NewsItem {
  id
  title
  preview
  body
  slug
  category
  createdAt
  updatedAt
  authorId
}
    `;
export const PersonFragmentDoc = `
    fragment Person on Person {
  id
  firstName
  lastName
  bio
  twitterHandle
  picture
  createdAt
  updatedAt
  slug
  blogBio
  hidden
  workshopBio
  workshopsCount
  assistedWorkshopsCount
  userId
}
    `;
export const SingleUseVoucherFragmentDoc = `
    fragment SingleUseVoucher on SingleUseVoucher {
  id
  code
  createdAt
  updatedAt
  expiryDate
  redeemed
  memo
  maximumDollarValue
  hasVoucherId
  hasVoucherType
  restrictedToPurchasableId
  restrictedToPurchasableType
  voucherType
}
    `;
export const TicketPricingGroupFragmentDoc = `
    fragment TicketPricingGroup on TicketPricingGroup {
  id
  name
  fullPrice
  concessionPrice
  groupPrice
  groupMinimumSize
  communityMemberPrice
  communityMemberPriceDoorOnly
  archived
  paidMemberPrice
  perUnitServiceFee
  createdAt
  updatedAt
}
    `;
export const TicketBookingCustomerFieldsFragmentDoc = `
    fragment TicketBookingCustomerFields on PerformanceTicketRegistration {
  name
  email
  telephone
  userId
  user {
    id
    fullName
    email
    telephone
  }
}
    `;
export const TicketBookingPaymentFieldsFragmentDoc = `
    fragment TicketBookingPaymentFields on PerformanceTicketRegistration {
  paymentType
  paymentAmount
  paymentAmountTickets
  paymentAmountFees
  paymentAmountDonation
  paymentAmountTip
  paymentUid
  paymentDescription
  refunded
  refundedAt
  refundUid
  refundAmount
}
    `;
export const TicketBookingQuantityFieldsFragmentDoc = `
    fragment TicketBookingQuantityFields on PerformanceTicketRegistration {
  ticketQuantityFull
  ticketQuantityConcession
  ticketQuantityGroup
  ticketQuantityPatron
  ticketQuantityTotal
}
    `;
export const TicketPricingFieldsFragmentDoc = `
    fragment TicketPricingFields on TicketPricingGroup {
  id
  name
  fullPrice
  concessionPrice
  perUnitServiceFee
  totalServiceFee
  groupPrice
  groupMinimumSize
  archived
  patronMarkupPercentage
  paidMemberPrice
  communityMemberPrice
  communityMemberPriceDoorOnly
  freeOnDoor
}
    `;
export const ShowTypeBasicsFragmentDoc = `
    fragment ShowTypeBasics on ShowType {
  id
  name
  ticketPricingGroup {
    ...TicketPricingFields
  }
  standardDescription
  standardExpenses
  studentQuotaCompAllotment
  studentViewingQuotaCreditGiven
  acceptStudentComps
  offerEarlyBirdDiscount
  venue {
    id
    name
    seatingCapacity
    recommendedWorkshopParticipantCapacity
  }
  showTags {
    id
    name
    slug
  }
}
    `;
export const VenueAvailabilityBasicsFragmentDoc = `
    fragment VenueAvailabilityBasics on VenueAvailability {
  scope
  mondayAvailability {
    secondsIntoDay
    durationSeconds
  }
  tuesdayAvailability {
    secondsIntoDay
    durationSeconds
  }
  wednesdayAvailability {
    secondsIntoDay
    durationSeconds
  }
  thursdayAvailability {
    secondsIntoDay
    durationSeconds
  }
  fridayAvailability {
    secondsIntoDay
    durationSeconds
  }
  saturdayAvailability {
    secondsIntoDay
    durationSeconds
  }
  sundayAvailability {
    secondsIntoDay
    durationSeconds
  }
}
    `;
export const DefaultUserInfoFragmentDoc = `
    fragment DefaultUserInfo on User {
  id
  fullName
  email
  telephone
}
    `;
export const WorkshopRegistrationCommonFragmentDoc = `
    fragment WorkshopRegistrationCommon on WorkshopRegistration {
  id
  user {
    id
    fullName
    email
  }
  registrationType
  registrationDescription
  workshopPaymentLedger {
    registrationFee
    amountPaidToDate
    amountOutstanding
  }
  workshop {
    id
    name
    workshopSessions {
      startDatetime
      endDatetime
      venue {
        name
      }
    }
    teachers {
      name
    }
    assistants {
      name
    }
    capacity
    numStudentsEnrolled
    soldOut
  }
}
    `;
export const ReferredUserFragmentDoc = `
    fragment ReferredUser on User {
  id
  fullName
  email
  workshopPurchaseValue
  ticketPurchaseValue
  totalPurchaseValue
}
    `;
export const UserVoucherFragmentDoc = `
    fragment UserVoucher on SingleUseVoucher {
  id
  code
  restrictedToPurchasable {
    __typename
    ... on WorkshopLevel {
      id
      name
    }
    ... on WorkshopCategory {
      id
      name
    }
  }
  voucherType
  expiryDate
  memo
  redeemed
  maximumDollarValue
  createdAt
}
    `;
export const NfpStatsNodeFragmentDoc = `
    fragment NfpStatsNode on Performance {
  id
  name
  startDatetime
  determinedSeatingCapacity
  doorSaleValue
  bracket2DoorSaleValue
  paidStandbyValue
  showType {
    presentedByNfp
  }
  ticketBookings {
    redeemed
    paymentType
  }
}
    `;
export const TicketBookingsTableFieldsFragmentDoc = `
    fragment TicketBookingsTableFields on Performance {
  id
  name
  startDatetime
  determinedSeatingCapacity
  determinedHasSecondBracket
  determinedTicketPricingGroup {
    id
    name
    fullPrice
    concessionPrice
    perUnitServiceFee
    totalServiceFee
    groupPrice
    groupMinimumSize
    archived
    patronMarkupPercentage
    paidMemberPrice
    communityMemberPrice
    communityMemberPriceDoorOnly
  }
  onlinePaidSeatQuantity
  onlineReservedSeatQuantity
  onlineStudentSeatQuantity
  onlineCompedSeatQuantity
  onlineFreeRegistrationSeatQuantity
  onlineTicketSalesValue
  onlineTicketSalesValueAfterCreditCardFees
  onlineCreditCardProcessingFees
  venueNonPresaleAttendance
  venuePaidSeatQuantity
  venuePaidSeatQuantitySecondBracket
  venueFreeEntryQuantity
  venueTicketSalesValue
  venueTicketSalesValueAfterCreditCardFees
  venueCreditCardProcessingFees
  venueDrinkSaleQuantity
  venueDrinkSaleValue
  paidStandbyQuantity
  paidStandbyValue
  totalIncome
  totalPaidTicketValue
  totalPaidTicketValueAfterCreditCardFees
  totalCreditCardProcessingFees
  totalTicketingFees
  totalDonations
  totalTips
  totalAttendance
  ticShareIncome
  producerShareIncome
  producerPayoutPercentage
  expenses
  showType {
    id
    name
  }
  ticketBookings {
    id
    bracket
    redeemed
    confirmed
    name
    email
    telephone
    userId
    user {
      id
      fullName
      email
      telephone
    }
    paymentType
    paymentAmount
    paymentAmountTickets
    paymentAmountFees
    paymentAmountDonation
    paymentAmountTip
    paymentUid
    paymentDescription
    refunded
    refundedAt
    refundUid
    refundAmount
    ticketQuantityFull
    ticketQuantityConcession
    ticketQuantityGroup
    ticketQuantityPatron
    ticketQuantityTotal
  }
  studentPerformanceAttendances {
    workshopRegistration {
      user {
        id
        fullName
        email
        telephone
      }
    }
  }
  standbys {
    id
    bracket
    name
    admitted
  }
}
    `;
export const CalendarSessionsFragmentDoc = `
    fragment CalendarSessions on Performance {
  calendarSessions {
    id
    startDatetime
    endDatetime
    venue {
      id
      name
    }
  }
}
    `;
export const PerformanceFinancesFragmentDoc = `
    fragment PerformanceFinances on Performance {
  totalIncome
  totalPaidTicketValue
  totalTips
  totalDonations
  paidStandbyQuantity
  paidStandbyValue
  ticShareIncome
  producerShareIncome
  producerPayoutPercentage
  expenses
}
    `;
export const AttendanceFragmentDoc = `
    fragment Attendance on Performance {
  soldOut
  seatingCapacity
  totalAttendance
  totalPaidAttendance
  totalFreeAttendance
  studentCompsRemaining
}
    `;
export const BarSalesFragmentDoc = `
    fragment BarSales on Performance {
  drinkSaleQuantity
  drinkSaleValue
}
    `;
export const ShowTypeFragmentDoc = `
    fragment ShowType on Performance {
  showType {
    id
    name
    showTags {
      id
      name
      slug
    }
  }
}
    `;
export const PerformanceAdminIndexFieldsFragmentDoc = `
    fragment PerformanceAdminIndexFields on Performance {
  id
  name
  status
  description
  calendarHeadline
  startDatetime
  onSaleDatetime
  ...PerformanceFinances
  ...Attendance
  ...BarSales
  ...ShowType
}
    `;
export const WorkshopPricingFieldsFragmentDoc = `
    fragment WorkshopPricingFields on WorkshopPricingGroup {
  id
  name
  fullPrice
  concessionPrice
  totalServiceFee
  flexibleFee
  flexibleFeeName
  earlyBirdDiscountAmount
}
    `;
export const WorkshopLevelsListFragmentDoc = `
    fragment WorkshopLevelsList on WorkshopLevel {
  id
  name
  levelType
  workshopPricingGroup {
    ...WorkshopPricingFields
  }
  onlineClassesAvailable
  studentCompsMode
  studentCompsQuantity
  studentJamsQuantity
  prerequisiteMode
  prerequisiteWorkshopLevel {
    id
    name
  }
  sessionMode
  studentShowcaseMode
  studentShowcaseQuantity
  description
  workshopCategory {
    id
    name
  }
  visible
}
    `;
export const VenuesListAdminFragmentDoc = `
    fragment VenuesListAdmin on Venue {
  id
  name
  seatingCapacity
  recommendedWorkshopParticipantCapacity
}
    `;
export const FullWorkshopTemplateFragmentDoc = `
    fragment FullWorkshopTemplate on WorkshopTemplate {
  id
  name
  workshopLevel {
    ...WorkshopLevelsList
  }
  venue {
    ...VenuesListAdmin
  }
  workshopNamePrefix
  workshopNameSuffix
  capacity
  meetingType
  numberOfSessions
  sessionDurationMinutes
  zoomMeetingInvitation
  description
  workshopPricingGroup {
    ...WorkshopPricingFields
  }
}
    `;
export const InternalPassRepeatInformationFragmentDoc = `
    fragment InternalPassRepeatInformation on EvaluationByTeacher {
  passRepeatStatusInternal
  workshopTrackInvitations {
    workshopTrack {
      id
      name
    }
  }
}
    `;
export const EndOfTermWorkshopNodeFragmentDoc = `
    fragment EndOfTermWorkshopNode on Workshop {
  id
  name
  evaluationsLocked
  endOfTermDate
  workshopLevel {
    evaluationMode
  }
  teachers {
    name
  }
  confirmedWorkshopRegistrations {
    id
    sentCourseEvaluationEmails
    sentCourseResultEmails
    registrationType
    state
    user {
      fullName
    }
    evaluationByTeacher {
      ...InternalPassRepeatInformation
      instructorCommentsForStudent
      instructorCommentsInternalUse
    }
  }
}
    `;
export const FreeTrialOfferWorkshopFragmentDoc = `
    fragment FreeTrialOfferWorkshop on Workshop {
  id
  name
  workshopSessions {
    id
    startDatetime
    endDatetime
    venue {
      id
      name
    }
  }
  teachers {
    name
  }
  assistants {
    name
  }
  capacity
  absoluteMaximumCapacity
  numStudentsEnrolled
  soldOut
}
    `;
export const FreeTrialStatsWorkshopNodeFragmentDoc = `
    fragment FreeTrialStatsWorkshopNode on Workshop {
  id
  name
  workshopLevel {
    workshopCategoryId
  }
  teachers {
    fullName
  }
  workshopSessions {
    venue {
      name
    }
  }
  workshopRegistrations {
    state
    user {
      vouchers {
        maximumDollarValue
      }
      workshopRegistrations {
        workshop {
          workshopLevel {
            levelType
            workshopCategoryId
          }
        }
      }
    }
  }
}
    `;
export const WorkshopSessionsFragmentDoc = `
    fragment WorkshopSessions on Workshop {
  meetingType
  zoomMeetingInvitation
  workshopSessions {
    id
    startDatetime
    endDatetime
    scope
    venue {
      id
      name
      address
      directions
      recommendedWorkshopParticipantCapacity
      seatingCapacity
    }
  }
}
    `;
export const InstructorFieldsFragmentDoc = `
    fragment instructorFields on Person {
  id
  name
  workshopBio
}
    `;
export const InstructorsFragmentDoc = `
    fragment Instructors on Workshop {
  teachers {
    ...instructorFields
  }
  assistants {
    ...instructorFields
  }
  substituteTeachers {
    ...instructorFields
  }
}
    `;
export const CapacityFragmentDoc = `
    fragment Capacity on Workshop {
  capacity
  absoluteMaximumCapacity
  numStudentsEnrolled
  soldOut
}
    `;
export const WorkshopFinancesFragmentDoc = `
    fragment WorkshopFinances on Workshop {
  grossIncome
}
    `;
export const PerformanceForEditFragmentDoc = `
    fragment PerformanceForEdit on Performance {
  id
  showType {
    id
    name
    ticketPricingGroup {
      ...TicketPricingFields
    }
    venue {
      id
      name
      seatingCapacity
      recommendedWorkshopParticipantCapacity
      blockOutOtherCalendarVenueId
      blockOutOtherCalendarMode
    }
    standardExpenses
    standardDescription
    studentViewingQuotaCreditGiven
    acceptStudentComps
    studentQuotaCompAllotment
    offerEarlyBirdDiscount
    showTags {
      id
      name
      slug
    }
  }
  name
  status
  startDatetime
  onSaleDatetime
  venue {
    id
    name
    seatingCapacity
    recommendedWorkshopParticipantCapacity
    blockOutOtherCalendarVenueId
    blockOutOtherCalendarMode
  }
  workshop {
    id
    name
  }
  seatingCapacityOverride
  description
  calendarHeadline
  ticketPricingGroup {
    ...TicketPricingFields
  }
  offerEarlyBirdDiscount
  acceptStudentComps
  studentQuotaCompAllotment
  expenses
  calendarSessions {
    id
    startDatetime
    endDatetime
    scope
    venue {
      id
      name
      seatingCapacity
      recommendedWorkshopParticipantCapacity
    }
  }
}
    `;
export const WorkshopAdminIndexFieldsFragmentDoc = `
    fragment WorkshopAdminIndexFields on Workshop {
  id
  name
  confirmed
  visible
  description
  workshopTerm {
    id
    name
    startingMonday
  }
  simplePassword
  prerequisiteMode
  internalComments {
    comment
    user {
      id
      name
    }
  }
  workshopWaitingLists {
    user {
      id
      name
      email
      telephone
    }
  }
  prerequisiteWorkshopLevel {
    ...WorkshopLevelsList
  }
  workshopLevel {
    ...WorkshopLevelsList
  }
  workshopPricingGroup {
    ...WorkshopPricingFields
  }
  preferredWorkshopPricingGroup {
    ...WorkshopPricingFields
  }
  ...WorkshopSessions
  ...Instructors
  ...Capacity
  ...WorkshopFinances
  studentShowcases {
    ...PerformanceForEdit
  }
}
    `;
export const WorkshopCategoriesAndLevelsDocument = `
    query WorkshopCategoriesAndLevels {
  workshopCategoriesListAdmin {
    id
    name
    workshopLevelsForCustomers {
      id
      name
      summary
    }
  }
}
    `;
export const useWorkshopCategoriesAndLevelsQuery = <
      TData = WorkshopCategoriesAndLevelsQuery,
      TError = unknown
    >(
      variables?: WorkshopCategoriesAndLevelsQueryVariables,
      options?: UseQueryOptions<WorkshopCategoriesAndLevelsQuery, TError, TData>
    ) =>
    useQuery<WorkshopCategoriesAndLevelsQuery, TError, TData>(
      variables === undefined ? ['WorkshopCategoriesAndLevels'] : ['WorkshopCategoriesAndLevels', variables],
      fetchData<WorkshopCategoriesAndLevelsQuery, WorkshopCategoriesAndLevelsQueryVariables>(WorkshopCategoriesAndLevelsDocument, variables),
      options
    );
export const useInfiniteWorkshopCategoriesAndLevelsQuery = <
      TData = WorkshopCategoriesAndLevelsQuery,
      TError = unknown
    >(
      variables?: WorkshopCategoriesAndLevelsQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopCategoriesAndLevelsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopCategoriesAndLevelsQuery, TError, TData>(
      variables === undefined ? ['WorkshopCategoriesAndLevels.infinite'] : ['WorkshopCategoriesAndLevels.infinite', variables],
      (metaData) => fetchData<WorkshopCategoriesAndLevelsQuery, WorkshopCategoriesAndLevelsQueryVariables>(WorkshopCategoriesAndLevelsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const MyStudentAvailabilityDocument = `
    query MyStudentAvailability {
  currentUser {
    studentAvailability {
      ...studentAvailabilityEssentials
    }
  }
}
    ${StudentAvailabilityEssentialsFragmentDoc}`;
export const useMyStudentAvailabilityQuery = <
      TData = MyStudentAvailabilityQuery,
      TError = unknown
    >(
      variables?: MyStudentAvailabilityQueryVariables,
      options?: UseQueryOptions<MyStudentAvailabilityQuery, TError, TData>
    ) =>
    useQuery<MyStudentAvailabilityQuery, TError, TData>(
      variables === undefined ? ['MyStudentAvailability'] : ['MyStudentAvailability', variables],
      fetchData<MyStudentAvailabilityQuery, MyStudentAvailabilityQueryVariables>(MyStudentAvailabilityDocument, variables),
      options
    );
export const useInfiniteMyStudentAvailabilityQuery = <
      TData = MyStudentAvailabilityQuery,
      TError = unknown
    >(
      variables?: MyStudentAvailabilityQueryVariables,
      options?: UseInfiniteQueryOptions<MyStudentAvailabilityQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<MyStudentAvailabilityQuery, TError, TData>(
      variables === undefined ? ['MyStudentAvailability.infinite'] : ['MyStudentAvailability.infinite', variables],
      (metaData) => fetchData<MyStudentAvailabilityQuery, MyStudentAvailabilityQueryVariables>(MyStudentAvailabilityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const EditStudentAvailabilityDocument = `
    mutation EditStudentAvailability($params: EditStudentAvailabilityInput!) {
  editStudentAvailability(params: $params) {
    success
    errors {
      message
    }
  }
}
    `;
export const useEditStudentAvailabilityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditStudentAvailabilityMutation, TError, EditStudentAvailabilityMutationVariables, TContext>) =>
    useMutation<EditStudentAvailabilityMutation, TError, EditStudentAvailabilityMutationVariables, TContext>(
      ['EditStudentAvailability'],
      (variables?: EditStudentAvailabilityMutationVariables) => fetchData<EditStudentAvailabilityMutation, EditStudentAvailabilityMutationVariables>(EditStudentAvailabilityDocument, variables)(),
      options
    );
export const CourseEvaluationDocument = `
    query CourseEvaluation($workshopRegistrationId: ID!) {
  currentUser {
    studentAvailability {
      ...studentAvailabilityEssentials
    }
  }
  workshopRegistrationDetails(id: $workshopRegistrationId) {
    id
    upcomingPreregistration {
      nextWorkshopRegistration {
        workshop {
          name
        }
      }
    }
    workshop {
      name
      workshopLevel {
        name
        teacherEvaluationsRequired
        levelType
        nextWorkshopLevel {
          name
        }
      }
    }
  }
  courseEvaluationQuery(workshopRegistrationId: $workshopRegistrationId) {
    canEvaluate
  }
}
    ${StudentAvailabilityEssentialsFragmentDoc}`;
export const useCourseEvaluationQuery = <
      TData = CourseEvaluationQuery,
      TError = unknown
    >(
      variables: CourseEvaluationQueryVariables,
      options?: UseQueryOptions<CourseEvaluationQuery, TError, TData>
    ) =>
    useQuery<CourseEvaluationQuery, TError, TData>(
      ['CourseEvaluation', variables],
      fetchData<CourseEvaluationQuery, CourseEvaluationQueryVariables>(CourseEvaluationDocument, variables),
      options
    );
export const useInfiniteCourseEvaluationQuery = <
      TData = CourseEvaluationQuery,
      TError = unknown
    >(
      variables: CourseEvaluationQueryVariables,
      options?: UseInfiniteQueryOptions<CourseEvaluationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CourseEvaluationQuery, TError, TData>(
      ['CourseEvaluation.infinite', variables],
      (metaData) => fetchData<CourseEvaluationQuery, CourseEvaluationQueryVariables>(CourseEvaluationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const EvaluateCourseDocument = `
    mutation EvaluateCourse($params: CourseEvaluationInput!) {
  courseEvaluation(params: $params) {
    success
    errors {
      message
    }
  }
}
    `;
export const useEvaluateCourseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EvaluateCourseMutation, TError, EvaluateCourseMutationVariables, TContext>) =>
    useMutation<EvaluateCourseMutation, TError, EvaluateCourseMutationVariables, TContext>(
      ['EvaluateCourse'],
      (variables?: EvaluateCourseMutationVariables) => fetchData<EvaluateCourseMutation, EvaluateCourseMutationVariables>(EvaluateCourseDocument, variables)(),
      options
    );
export const AccountDetailsDocument = `
    query AccountDetails {
  siteConstants {
    coreWorkshopRequiredRepeatDiscountPercentage
    coreWorkshopVoluntaryRepeatDiscountPercentage
    freeTrialComplimentaryChangeWindowInHours
  }
  customerReferralOptions
  currentUser {
    id
    name
    firstName
    lastName
    fullName
    telephone
    email
    studentProfile {
      pronounsEnum
      pronounsOther
      specialNeeds
      referralDetail
      referralSource
    }
    activePaidMembership {
      tier
    }
    studentCompReport {
      showsUsed
      showsTotal
      jamsUsed
      jamsTotal
    }
    canPreregister
    tickets {
      ...accountDetailsTicket
    }
    workshopRegistrations {
      ...accountDetailsWorkshopRegistration
    }
    workshopPreregistrations {
      __typename
      id
      fulfillmentStatus
      workshopPreregistrationPeriod {
        currentTermTag
        preferencesDueAt
      }
      workshopPaymentLedger {
        ...accountDetailsWorkshopPaymentLedger
      }
    }
    studentAvailability {
      ...studentAvailabilityEssentials
    }
    workshopAlertSubscriptions {
      workshopAlertable {
        __typename
        ... on WorkshopLevel {
          id
        }
      }
      subscribed
    }
    subscribedSalesEmailCategories {
      internalName
      displayName
      displayDescription
      subscribed
    }
    referralCode
    referralLink
    referredUserNames
    vouchers {
      redeemed
      code
      memo
      maximumDollarValue
    }
  }
}
    ${AccountDetailsTicketFragmentDoc}
${AccountDetailsWorkshopRegistrationFragmentDoc}
${AccountDetailsWorkshopPaymentLedgerFragmentDoc}
${StudentAvailabilityEssentialsFragmentDoc}`;
export const useAccountDetailsQuery = <
      TData = AccountDetailsQuery,
      TError = unknown
    >(
      variables?: AccountDetailsQueryVariables,
      options?: UseQueryOptions<AccountDetailsQuery, TError, TData>
    ) =>
    useQuery<AccountDetailsQuery, TError, TData>(
      variables === undefined ? ['AccountDetails'] : ['AccountDetails', variables],
      fetchData<AccountDetailsQuery, AccountDetailsQueryVariables>(AccountDetailsDocument, variables),
      options
    );
export const useInfiniteAccountDetailsQuery = <
      TData = AccountDetailsQuery,
      TError = unknown
    >(
      variables?: AccountDetailsQueryVariables,
      options?: UseInfiniteQueryOptions<AccountDetailsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<AccountDetailsQuery, TError, TData>(
      variables === undefined ? ['AccountDetails.infinite'] : ['AccountDetails.infinite', variables],
      (metaData) => fetchData<AccountDetailsQuery, AccountDetailsQueryVariables>(AccountDetailsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const FindStudentTicketDocument = `
    query FindStudentTicket {
  performancesUpcoming {
    id
    slugifiedId
    startDatetime
    soldOut
    acceptStudentComps
    studentCompsRemaining
    name
    showType {
      calendarThumbnailUrlWeb
      category
    }
  }
}
    `;
export const useFindStudentTicketQuery = <
      TData = FindStudentTicketQuery,
      TError = unknown
    >(
      variables?: FindStudentTicketQueryVariables,
      options?: UseQueryOptions<FindStudentTicketQuery, TError, TData>
    ) =>
    useQuery<FindStudentTicketQuery, TError, TData>(
      variables === undefined ? ['FindStudentTicket'] : ['FindStudentTicket', variables],
      fetchData<FindStudentTicketQuery, FindStudentTicketQueryVariables>(FindStudentTicketDocument, variables),
      options
    );
export const useInfiniteFindStudentTicketQuery = <
      TData = FindStudentTicketQuery,
      TError = unknown
    >(
      variables?: FindStudentTicketQueryVariables,
      options?: UseInfiniteQueryOptions<FindStudentTicketQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<FindStudentTicketQuery, TError, TData>(
      variables === undefined ? ['FindStudentTicket.infinite'] : ['FindStudentTicket.infinite', variables],
      (metaData) => fetchData<FindStudentTicketQuery, FindStudentTicketQueryVariables>(FindStudentTicketDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const PaymentPlanCheckStatusDocument = `
    query PaymentPlanCheckStatus($workshopPaymentLedgerId: ID!) {
  paymentPlanCheckStatus(workshopPaymentLedgerId: $workshopPaymentLedgerId) {
    workshopPaymentLedger {
      registrationFeeCents
      amountPaidToDateCents
      amountOutstandingCents
      targetPaymentDateHalf
      targetPaymentDateFull
    }
    paymentOptions {
      paymentPercentage
      label
      paymentAmountCents
    }
  }
}
    `;
export const usePaymentPlanCheckStatusQuery = <
      TData = PaymentPlanCheckStatusQuery,
      TError = unknown
    >(
      variables: PaymentPlanCheckStatusQueryVariables,
      options?: UseQueryOptions<PaymentPlanCheckStatusQuery, TError, TData>
    ) =>
    useQuery<PaymentPlanCheckStatusQuery, TError, TData>(
      ['PaymentPlanCheckStatus', variables],
      fetchData<PaymentPlanCheckStatusQuery, PaymentPlanCheckStatusQueryVariables>(PaymentPlanCheckStatusDocument, variables),
      options
    );
export const useInfinitePaymentPlanCheckStatusQuery = <
      TData = PaymentPlanCheckStatusQuery,
      TError = unknown
    >(
      variables: PaymentPlanCheckStatusQueryVariables,
      options?: UseInfiniteQueryOptions<PaymentPlanCheckStatusQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<PaymentPlanCheckStatusQuery, TError, TData>(
      ['PaymentPlanCheckStatus.infinite', variables],
      (metaData) => fetchData<PaymentPlanCheckStatusQuery, PaymentPlanCheckStatusQueryVariables>(PaymentPlanCheckStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const PaymentPlanMakePaymentDocument = `
    mutation PaymentPlanMakePayment($params: PaymentPlanMakePaymentInput!) {
  paymentPlanMakePayment(params: $params) {
    workshopPaymentLedger {
      amountOutstandingCents
    }
    errors {
      message
      path
    }
  }
}
    `;
export const usePaymentPlanMakePaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PaymentPlanMakePaymentMutation, TError, PaymentPlanMakePaymentMutationVariables, TContext>) =>
    useMutation<PaymentPlanMakePaymentMutation, TError, PaymentPlanMakePaymentMutationVariables, TContext>(
      ['PaymentPlanMakePayment'],
      (variables?: PaymentPlanMakePaymentMutationVariables) => fetchData<PaymentPlanMakePaymentMutation, PaymentPlanMakePaymentMutationVariables>(PaymentPlanMakePaymentDocument, variables)(),
      options
    );
export const UpdateEmailSettingsDocument = `
    mutation UpdateEmailSettings($params: UpdateEmailSettingsInput!) {
  updateEmailSettings(params: $params) {
    success
    errors {
      message
    }
  }
}
    `;
export const useUpdateEmailSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateEmailSettingsMutation, TError, UpdateEmailSettingsMutationVariables, TContext>) =>
    useMutation<UpdateEmailSettingsMutation, TError, UpdateEmailSettingsMutationVariables, TContext>(
      ['UpdateEmailSettings'],
      (variables?: UpdateEmailSettingsMutationVariables) => fetchData<UpdateEmailSettingsMutation, UpdateEmailSettingsMutationVariables>(UpdateEmailSettingsDocument, variables)(),
      options
    );
export const WorkshopCheckoutInfoDocument = `
    query WorkshopCheckoutInfo($workshopId: ID!, $permissionCheckParams: WorkshopPermissionCheckParams!) {
  customerReferralOptions
  currentUser {
    id
    name
    email
  }
  customerReferralOptions
  workshopPaymentPlanAvailable(workshopId: $workshopId) {
    availableForWorkshop
    availableForUser
  }
  workshopPermissionCheck(params: $permissionCheckParams) {
    permission
    errorMessage
  }
  workshopInfo(id: $workshopId) {
    id
    name
    workshopLevel {
      collectReferralInformation
      allowDiscountsMode
      levelType
      name
      workshopCategory {
        categoryType
      }
    }
    preferredWorkshopPricingGroup {
      id
      name
      fullPrice
      concessionPrice
      totalServiceFee
      flexibleFee
      flexibleFeeName
    }
    meetingType
    workshopSessions {
      id
      startDatetime
      endDatetime
      venue {
        id
        name
        address
        directions
      }
    }
    teachers {
      id
      name
    }
  }
}
    `;
export const useWorkshopCheckoutInfoQuery = <
      TData = WorkshopCheckoutInfoQuery,
      TError = unknown
    >(
      variables: WorkshopCheckoutInfoQueryVariables,
      options?: UseQueryOptions<WorkshopCheckoutInfoQuery, TError, TData>
    ) =>
    useQuery<WorkshopCheckoutInfoQuery, TError, TData>(
      ['WorkshopCheckoutInfo', variables],
      fetchData<WorkshopCheckoutInfoQuery, WorkshopCheckoutInfoQueryVariables>(WorkshopCheckoutInfoDocument, variables),
      options
    );
export const useInfiniteWorkshopCheckoutInfoQuery = <
      TData = WorkshopCheckoutInfoQuery,
      TError = unknown
    >(
      variables: WorkshopCheckoutInfoQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopCheckoutInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopCheckoutInfoQuery, TError, TData>(
      ['WorkshopCheckoutInfo.infinite', variables],
      (metaData) => fetchData<WorkshopCheckoutInfoQuery, WorkshopCheckoutInfoQueryVariables>(WorkshopCheckoutInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CheckWorkshopPaymentsInfoDocument = `
    query CheckWorkshopPaymentsInfo($params: PaymentPlanCheckInitialPayments!) {
  paymentPlanCheckInitialPayments(params: $params) {
    name
    schedule {
      paymentAmountCents
      paymentDate
      headline
      description
    }
  }
}
    `;
export const useCheckWorkshopPaymentsInfoQuery = <
      TData = CheckWorkshopPaymentsInfoQuery,
      TError = unknown
    >(
      variables: CheckWorkshopPaymentsInfoQueryVariables,
      options?: UseQueryOptions<CheckWorkshopPaymentsInfoQuery, TError, TData>
    ) =>
    useQuery<CheckWorkshopPaymentsInfoQuery, TError, TData>(
      ['CheckWorkshopPaymentsInfo', variables],
      fetchData<CheckWorkshopPaymentsInfoQuery, CheckWorkshopPaymentsInfoQueryVariables>(CheckWorkshopPaymentsInfoDocument, variables),
      options
    );
export const useInfiniteCheckWorkshopPaymentsInfoQuery = <
      TData = CheckWorkshopPaymentsInfoQuery,
      TError = unknown
    >(
      variables: CheckWorkshopPaymentsInfoQueryVariables,
      options?: UseInfiniteQueryOptions<CheckWorkshopPaymentsInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CheckWorkshopPaymentsInfoQuery, TError, TData>(
      ['CheckWorkshopPaymentsInfo.infinite', variables],
      (metaData) => fetchData<CheckWorkshopPaymentsInfoQuery, CheckWorkshopPaymentsInfoQueryVariables>(CheckWorkshopPaymentsInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopCheckoutConfirmPendingDocument = `
    mutation WorkshopCheckoutConfirmPending($workshopRegistrationId: ID!) {
  workshopCheckoutConfirmPending(workshopRegistrationId: $workshopRegistrationId) {
    workshopRegistration {
      id
      aasmState
    }
    errors {
      message
      path
    }
  }
}
    `;
export const useWorkshopCheckoutConfirmPendingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WorkshopCheckoutConfirmPendingMutation, TError, WorkshopCheckoutConfirmPendingMutationVariables, TContext>) =>
    useMutation<WorkshopCheckoutConfirmPendingMutation, TError, WorkshopCheckoutConfirmPendingMutationVariables, TContext>(
      ['WorkshopCheckoutConfirmPending'],
      (variables?: WorkshopCheckoutConfirmPendingMutationVariables) => fetchData<WorkshopCheckoutConfirmPendingMutation, WorkshopCheckoutConfirmPendingMutationVariables>(WorkshopCheckoutConfirmPendingDocument, variables)(),
      options
    );
export const WorkshopDiscountInfoDocument = `
    query WorkshopDiscountInfo($params: WorkshopDiscountQueryAttributes!) {
  workshopDiscount(params: $params) {
    discounts {
      discountName
      discountType
      discountAmount
    }
    errorMessage
  }
}
    `;
export const useWorkshopDiscountInfoQuery = <
      TData = WorkshopDiscountInfoQuery,
      TError = unknown
    >(
      variables: WorkshopDiscountInfoQueryVariables,
      options?: UseQueryOptions<WorkshopDiscountInfoQuery, TError, TData>
    ) =>
    useQuery<WorkshopDiscountInfoQuery, TError, TData>(
      ['WorkshopDiscountInfo', variables],
      fetchData<WorkshopDiscountInfoQuery, WorkshopDiscountInfoQueryVariables>(WorkshopDiscountInfoDocument, variables),
      options
    );
export const useInfiniteWorkshopDiscountInfoQuery = <
      TData = WorkshopDiscountInfoQuery,
      TError = unknown
    >(
      variables: WorkshopDiscountInfoQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopDiscountInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopDiscountInfoQuery, TError, TData>(
      ['WorkshopDiscountInfo.infinite', variables],
      (metaData) => fetchData<WorkshopDiscountInfoQuery, WorkshopDiscountInfoQueryVariables>(WorkshopDiscountInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopPaymentIntentDocument = `
    query WorkshopPaymentIntent($params: WorkshopCheckoutParams!) {
  paymentIntentWorkshops(params: $params) {
    paymentIntent {
      id
      secret
      amount
    }
    isFree
    errorMessage
    workshopRegistration {
      id
      state
    }
  }
}
    `;
export const useWorkshopPaymentIntentQuery = <
      TData = WorkshopPaymentIntentQuery,
      TError = unknown
    >(
      variables: WorkshopPaymentIntentQueryVariables,
      options?: UseQueryOptions<WorkshopPaymentIntentQuery, TError, TData>
    ) =>
    useQuery<WorkshopPaymentIntentQuery, TError, TData>(
      ['WorkshopPaymentIntent', variables],
      fetchData<WorkshopPaymentIntentQuery, WorkshopPaymentIntentQueryVariables>(WorkshopPaymentIntentDocument, variables),
      options
    );
export const useInfiniteWorkshopPaymentIntentQuery = <
      TData = WorkshopPaymentIntentQuery,
      TError = unknown
    >(
      variables: WorkshopPaymentIntentQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopPaymentIntentQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopPaymentIntentQuery, TError, TData>(
      ['WorkshopPaymentIntent.infinite', variables],
      (metaData) => fetchData<WorkshopPaymentIntentQuery, WorkshopPaymentIntentQueryVariables>(WorkshopPaymentIntentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const StudentProfileDocument = `
    query StudentProfile {
  currentUser {
    studentProfile {
      referralSource
      referralDetail
      pronounsEnum
      pronounsOther
      specialNeeds
    }
  }
}
    `;
export const useStudentProfileQuery = <
      TData = StudentProfileQuery,
      TError = unknown
    >(
      variables?: StudentProfileQueryVariables,
      options?: UseQueryOptions<StudentProfileQuery, TError, TData>
    ) =>
    useQuery<StudentProfileQuery, TError, TData>(
      variables === undefined ? ['StudentProfile'] : ['StudentProfile', variables],
      fetchData<StudentProfileQuery, StudentProfileQueryVariables>(StudentProfileDocument, variables),
      options
    );
export const useInfiniteStudentProfileQuery = <
      TData = StudentProfileQuery,
      TError = unknown
    >(
      variables?: StudentProfileQueryVariables,
      options?: UseInfiniteQueryOptions<StudentProfileQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<StudentProfileQuery, TError, TData>(
      variables === undefined ? ['StudentProfile.infinite'] : ['StudentProfile.infinite', variables],
      (metaData) => fetchData<StudentProfileQuery, StudentProfileQueryVariables>(StudentProfileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopOrderStatusInfoDocument = `
    query WorkshopOrderStatusInfo($workshopRegistrationId: ID!) {
  workshopRegistrationDetails(id: $workshopRegistrationId) {
    id
    state
    donationPayment {
      paymentType
      paymentAmount
      paymentAmountDonation
      paymentIntentId
      status
    }
    workshopPaymentLedger {
      id
      paymentLedgerType
      registrationFee
      amountPaidToDate
      amountOutstanding
      payments {
        paymentType
        paymentAmount
        paymentAmountDonation
        paymentIntentId
        status
      }
    }
  }
}
    `;
export const useWorkshopOrderStatusInfoQuery = <
      TData = WorkshopOrderStatusInfoQuery,
      TError = unknown
    >(
      variables: WorkshopOrderStatusInfoQueryVariables,
      options?: UseQueryOptions<WorkshopOrderStatusInfoQuery, TError, TData>
    ) =>
    useQuery<WorkshopOrderStatusInfoQuery, TError, TData>(
      ['WorkshopOrderStatusInfo', variables],
      fetchData<WorkshopOrderStatusInfoQuery, WorkshopOrderStatusInfoQueryVariables>(WorkshopOrderStatusInfoDocument, variables),
      options
    );
export const useInfiniteWorkshopOrderStatusInfoQuery = <
      TData = WorkshopOrderStatusInfoQuery,
      TError = unknown
    >(
      variables: WorkshopOrderStatusInfoQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopOrderStatusInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopOrderStatusInfoQuery, TError, TData>(
      ['WorkshopOrderStatusInfo.infinite', variables],
      (metaData) => fetchData<WorkshopOrderStatusInfoQuery, WorkshopOrderStatusInfoQueryVariables>(WorkshopOrderStatusInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const EditStudentProfileDocument = `
    mutation EditStudentProfile($params: EditStudentProfileInput!) {
  editStudentProfile(params: $params) {
    success
    errors {
      message
    }
  }
}
    `;
export const useEditStudentProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditStudentProfileMutation, TError, EditStudentProfileMutationVariables, TContext>) =>
    useMutation<EditStudentProfileMutation, TError, EditStudentProfileMutationVariables, TContext>(
      ['EditStudentProfile'],
      (variables?: EditStudentProfileMutationVariables) => fetchData<EditStudentProfileMutation, EditStudentProfileMutationVariables>(EditStudentProfileDocument, variables)(),
      options
    );
export const WorkshopFeesLookupDocument = `
    query WorkshopFeesLookup($workshopId: ID!) {
  workshopInfo(id: $workshopId) {
    id
    workshopSessions {
      startDatetime
      endDatetime
    }
    workshopLevel {
      levelType
    }
    preferredWorkshopPricingGroup {
      fullPrice
      concessionPrice
      flexibleFee
      flexibleFeeName
      totalServiceFee
    }
  }
  workshopChangeFeesSchedule(id: $workshopId) {
    beforeDatetime
    percentageDeducted
    centsDeducted
    description
    reasonForFee
  }
  workshopChangeFeesScheduleFreeTrialPurchase(id: $workshopId) {
    beforeDatetime
    percentageDeducted
    centsDeducted
    description
    reasonForFee
  }
}
    `;
export const useWorkshopFeesLookupQuery = <
      TData = WorkshopFeesLookupQuery,
      TError = unknown
    >(
      variables: WorkshopFeesLookupQueryVariables,
      options?: UseQueryOptions<WorkshopFeesLookupQuery, TError, TData>
    ) =>
    useQuery<WorkshopFeesLookupQuery, TError, TData>(
      ['WorkshopFeesLookup', variables],
      fetchData<WorkshopFeesLookupQuery, WorkshopFeesLookupQueryVariables>(WorkshopFeesLookupDocument, variables),
      options
    );
export const useInfiniteWorkshopFeesLookupQuery = <
      TData = WorkshopFeesLookupQuery,
      TError = unknown
    >(
      variables: WorkshopFeesLookupQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopFeesLookupQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopFeesLookupQuery, TError, TData>(
      ['WorkshopFeesLookup.infinite', variables],
      (metaData) => fetchData<WorkshopFeesLookupQuery, WorkshopFeesLookupQueryVariables>(WorkshopFeesLookupDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const DonationStatusDocument = `
    query DonationStatus($orderUuid: String!) {
  standaloneDonation(uuid: $orderUuid) {
    id
    uuid
    paymentStatus
  }
}
    `;
export const useDonationStatusQuery = <
      TData = DonationStatusQuery,
      TError = unknown
    >(
      variables: DonationStatusQueryVariables,
      options?: UseQueryOptions<DonationStatusQuery, TError, TData>
    ) =>
    useQuery<DonationStatusQuery, TError, TData>(
      ['DonationStatus', variables],
      fetchData<DonationStatusQuery, DonationStatusQueryVariables>(DonationStatusDocument, variables),
      options
    );
export const useInfiniteDonationStatusQuery = <
      TData = DonationStatusQuery,
      TError = unknown
    >(
      variables: DonationStatusQueryVariables,
      options?: UseInfiniteQueryOptions<DonationStatusQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<DonationStatusQuery, TError, TData>(
      ['DonationStatus.infinite', variables],
      (metaData) => fetchData<DonationStatusQuery, DonationStatusQueryVariables>(DonationStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const DonationPaymentIntentDocument = `
    query DonationPaymentIntent($params: PaymentIntentDonationInput!) {
  paymentIntentDonation(params: $params) {
    paymentIntent {
      id
      secret
      amount
    }
    donation {
      id
    }
  }
}
    `;
export const useDonationPaymentIntentQuery = <
      TData = DonationPaymentIntentQuery,
      TError = unknown
    >(
      variables: DonationPaymentIntentQueryVariables,
      options?: UseQueryOptions<DonationPaymentIntentQuery, TError, TData>
    ) =>
    useQuery<DonationPaymentIntentQuery, TError, TData>(
      ['DonationPaymentIntent', variables],
      fetchData<DonationPaymentIntentQuery, DonationPaymentIntentQueryVariables>(DonationPaymentIntentDocument, variables),
      options
    );
export const useInfiniteDonationPaymentIntentQuery = <
      TData = DonationPaymentIntentQuery,
      TError = unknown
    >(
      variables: DonationPaymentIntentQueryVariables,
      options?: UseInfiniteQueryOptions<DonationPaymentIntentQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<DonationPaymentIntentQuery, TError, TData>(
      ['DonationPaymentIntent.infinite', variables],
      (metaData) => fetchData<DonationPaymentIntentQuery, DonationPaymentIntentQueryVariables>(DonationPaymentIntentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const PlainDonationDocument = `
    query PlainDonation {
  currentUser {
    name
    firstName
    lastName
    email
    telephone
  }
}
    `;
export const usePlainDonationQuery = <
      TData = PlainDonationQuery,
      TError = unknown
    >(
      variables?: PlainDonationQueryVariables,
      options?: UseQueryOptions<PlainDonationQuery, TError, TData>
    ) =>
    useQuery<PlainDonationQuery, TError, TData>(
      variables === undefined ? ['PlainDonation'] : ['PlainDonation', variables],
      fetchData<PlainDonationQuery, PlainDonationQueryVariables>(PlainDonationDocument, variables),
      options
    );
export const useInfinitePlainDonationQuery = <
      TData = PlainDonationQuery,
      TError = unknown
    >(
      variables?: PlainDonationQueryVariables,
      options?: UseInfiniteQueryOptions<PlainDonationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<PlainDonationQuery, TError, TData>(
      variables === undefined ? ['PlainDonation.infinite'] : ['PlainDonation.infinite', variables],
      (metaData) => fetchData<PlainDonationQuery, PlainDonationQueryVariables>(PlainDonationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const BecomeMemberDocument = `
    query BecomeMember {
  currentUser {
    name
    firstName
    lastName
    email
    telephone
    activePaidMembership {
      tier
      paymentStatus
      expirationDate
    }
  }
  theatreMembershipPricing
}
    `;
export const useBecomeMemberQuery = <
      TData = BecomeMemberQuery,
      TError = unknown
    >(
      variables?: BecomeMemberQueryVariables,
      options?: UseQueryOptions<BecomeMemberQuery, TError, TData>
    ) =>
    useQuery<BecomeMemberQuery, TError, TData>(
      variables === undefined ? ['BecomeMember'] : ['BecomeMember', variables],
      fetchData<BecomeMemberQuery, BecomeMemberQueryVariables>(BecomeMemberDocument, variables),
      options
    );
export const useInfiniteBecomeMemberQuery = <
      TData = BecomeMemberQuery,
      TError = unknown
    >(
      variables?: BecomeMemberQueryVariables,
      options?: UseInfiniteQueryOptions<BecomeMemberQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<BecomeMemberQuery, TError, TData>(
      variables === undefined ? ['BecomeMember.infinite'] : ['BecomeMember.infinite', variables],
      (metaData) => fetchData<BecomeMemberQuery, BecomeMemberQueryVariables>(BecomeMemberDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const BecomeMemberAwaitConfirmationDocument = `
    query BecomeMemberAwaitConfirmation {
  myTheatreMemberships {
    id
    tier
    paymentStatus
  }
}
    `;
export const useBecomeMemberAwaitConfirmationQuery = <
      TData = BecomeMemberAwaitConfirmationQuery,
      TError = unknown
    >(
      variables?: BecomeMemberAwaitConfirmationQueryVariables,
      options?: UseQueryOptions<BecomeMemberAwaitConfirmationQuery, TError, TData>
    ) =>
    useQuery<BecomeMemberAwaitConfirmationQuery, TError, TData>(
      variables === undefined ? ['BecomeMemberAwaitConfirmation'] : ['BecomeMemberAwaitConfirmation', variables],
      fetchData<BecomeMemberAwaitConfirmationQuery, BecomeMemberAwaitConfirmationQueryVariables>(BecomeMemberAwaitConfirmationDocument, variables),
      options
    );
export const useInfiniteBecomeMemberAwaitConfirmationQuery = <
      TData = BecomeMemberAwaitConfirmationQuery,
      TError = unknown
    >(
      variables?: BecomeMemberAwaitConfirmationQueryVariables,
      options?: UseInfiniteQueryOptions<BecomeMemberAwaitConfirmationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<BecomeMemberAwaitConfirmationQuery, TError, TData>(
      variables === undefined ? ['BecomeMemberAwaitConfirmation.infinite'] : ['BecomeMemberAwaitConfirmation.infinite', variables],
      (metaData) => fetchData<BecomeMemberAwaitConfirmationQuery, BecomeMemberAwaitConfirmationQueryVariables>(BecomeMemberAwaitConfirmationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const BecomeMemberPaymentIntentDocument = `
    query BecomeMemberPaymentIntent($params: PaymentIntentMembershipInput!) {
  paymentIntentMembership(params: $params) {
    paymentIntent {
      id
      secret
      amount
    }
    theatreMembership {
      id
    }
  }
}
    `;
export const useBecomeMemberPaymentIntentQuery = <
      TData = BecomeMemberPaymentIntentQuery,
      TError = unknown
    >(
      variables: BecomeMemberPaymentIntentQueryVariables,
      options?: UseQueryOptions<BecomeMemberPaymentIntentQuery, TError, TData>
    ) =>
    useQuery<BecomeMemberPaymentIntentQuery, TError, TData>(
      ['BecomeMemberPaymentIntent', variables],
      fetchData<BecomeMemberPaymentIntentQuery, BecomeMemberPaymentIntentQueryVariables>(BecomeMemberPaymentIntentDocument, variables),
      options
    );
export const useInfiniteBecomeMemberPaymentIntentQuery = <
      TData = BecomeMemberPaymentIntentQuery,
      TError = unknown
    >(
      variables: BecomeMemberPaymentIntentQueryVariables,
      options?: UseInfiniteQueryOptions<BecomeMemberPaymentIntentQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<BecomeMemberPaymentIntentQuery, TError, TData>(
      ['BecomeMemberPaymentIntent.infinite', variables],
      (metaData) => fetchData<BecomeMemberPaymentIntentQuery, BecomeMemberPaymentIntentQueryVariables>(BecomeMemberPaymentIntentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const NewsItemIndexDocument = `
    query NewsItemIndex {
  adminNewsItemList {
    ...NewsItem
  }
}
    ${NewsItemFragmentDoc}`;
export const useNewsItemIndexQuery = <
      TData = NewsItemIndexQuery,
      TError = unknown
    >(
      variables?: NewsItemIndexQueryVariables,
      options?: UseQueryOptions<NewsItemIndexQuery, TError, TData>
    ) =>
    useQuery<NewsItemIndexQuery, TError, TData>(
      variables === undefined ? ['NewsItemIndex'] : ['NewsItemIndex', variables],
      fetchData<NewsItemIndexQuery, NewsItemIndexQueryVariables>(NewsItemIndexDocument, variables),
      options
    );
export const useInfiniteNewsItemIndexQuery = <
      TData = NewsItemIndexQuery,
      TError = unknown
    >(
      variables?: NewsItemIndexQueryVariables,
      options?: UseInfiniteQueryOptions<NewsItemIndexQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<NewsItemIndexQuery, TError, TData>(
      variables === undefined ? ['NewsItemIndex.infinite'] : ['NewsItemIndex.infinite', variables],
      (metaData) => fetchData<NewsItemIndexQuery, NewsItemIndexQueryVariables>(NewsItemIndexDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const NewsItemDocument = `
    query NewsItem($id: ID!) {
  adminNewsItem(id: $id) {
    ...NewsItem
  }
}
    ${NewsItemFragmentDoc}`;
export const useNewsItemQuery = <
      TData = NewsItemQuery,
      TError = unknown
    >(
      variables: NewsItemQueryVariables,
      options?: UseQueryOptions<NewsItemQuery, TError, TData>
    ) =>
    useQuery<NewsItemQuery, TError, TData>(
      ['NewsItem', variables],
      fetchData<NewsItemQuery, NewsItemQueryVariables>(NewsItemDocument, variables),
      options
    );
export const useInfiniteNewsItemQuery = <
      TData = NewsItemQuery,
      TError = unknown
    >(
      variables: NewsItemQueryVariables,
      options?: UseInfiniteQueryOptions<NewsItemQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<NewsItemQuery, TError, TData>(
      ['NewsItem.infinite', variables],
      (metaData) => fetchData<NewsItemQuery, NewsItemQueryVariables>(NewsItemDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const NewsItemCreateDocument = `
    mutation NewsItemCreate($attributes: EditNewsItemInput!) {
  adminNewsItemCreate(attributes: $attributes) {
    newsItem {
      ...NewsItem
    }
    errors {
      message
    }
  }
}
    ${NewsItemFragmentDoc}`;
export const useNewsItemCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<NewsItemCreateMutation, TError, NewsItemCreateMutationVariables, TContext>) =>
    useMutation<NewsItemCreateMutation, TError, NewsItemCreateMutationVariables, TContext>(
      ['NewsItemCreate'],
      (variables?: NewsItemCreateMutationVariables) => fetchData<NewsItemCreateMutation, NewsItemCreateMutationVariables>(NewsItemCreateDocument, variables)(),
      options
    );
export const NewsItemEditDocument = `
    mutation NewsItemEdit($id: ID!, $attributes: EditNewsItemInput!) {
  adminNewsItemUpdate(id: $id, attributes: $attributes) {
    newsItem {
      ...NewsItem
    }
    errors {
      message
    }
  }
}
    ${NewsItemFragmentDoc}`;
export const useNewsItemEditMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<NewsItemEditMutation, TError, NewsItemEditMutationVariables, TContext>) =>
    useMutation<NewsItemEditMutation, TError, NewsItemEditMutationVariables, TContext>(
      ['NewsItemEdit'],
      (variables?: NewsItemEditMutationVariables) => fetchData<NewsItemEditMutation, NewsItemEditMutationVariables>(NewsItemEditDocument, variables)(),
      options
    );
export const NewsItemDestroyDocument = `
    mutation NewsItemDestroy($id: ID!) {
  adminNewsItemDestroy(id: $id) {
    success
    errors {
      message
    }
  }
}
    `;
export const useNewsItemDestroyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<NewsItemDestroyMutation, TError, NewsItemDestroyMutationVariables, TContext>) =>
    useMutation<NewsItemDestroyMutation, TError, NewsItemDestroyMutationVariables, TContext>(
      ['NewsItemDestroy'],
      (variables?: NewsItemDestroyMutationVariables) => fetchData<NewsItemDestroyMutation, NewsItemDestroyMutationVariables>(NewsItemDestroyDocument, variables)(),
      options
    );
export const PersonIndexDocument = `
    query PersonIndex {
  adminPersonList {
    ...Person
  }
}
    ${PersonFragmentDoc}`;
export const usePersonIndexQuery = <
      TData = PersonIndexQuery,
      TError = unknown
    >(
      variables?: PersonIndexQueryVariables,
      options?: UseQueryOptions<PersonIndexQuery, TError, TData>
    ) =>
    useQuery<PersonIndexQuery, TError, TData>(
      variables === undefined ? ['PersonIndex'] : ['PersonIndex', variables],
      fetchData<PersonIndexQuery, PersonIndexQueryVariables>(PersonIndexDocument, variables),
      options
    );
export const useInfinitePersonIndexQuery = <
      TData = PersonIndexQuery,
      TError = unknown
    >(
      variables?: PersonIndexQueryVariables,
      options?: UseInfiniteQueryOptions<PersonIndexQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<PersonIndexQuery, TError, TData>(
      variables === undefined ? ['PersonIndex.infinite'] : ['PersonIndex.infinite', variables],
      (metaData) => fetchData<PersonIndexQuery, PersonIndexQueryVariables>(PersonIndexDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const PersonDocument = `
    query Person($id: ID!) {
  adminPerson(id: $id) {
    ...Person
  }
}
    ${PersonFragmentDoc}`;
export const usePersonQuery = <
      TData = PersonQuery,
      TError = unknown
    >(
      variables: PersonQueryVariables,
      options?: UseQueryOptions<PersonQuery, TError, TData>
    ) =>
    useQuery<PersonQuery, TError, TData>(
      ['Person', variables],
      fetchData<PersonQuery, PersonQueryVariables>(PersonDocument, variables),
      options
    );
export const useInfinitePersonQuery = <
      TData = PersonQuery,
      TError = unknown
    >(
      variables: PersonQueryVariables,
      options?: UseInfiniteQueryOptions<PersonQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<PersonQuery, TError, TData>(
      ['Person.infinite', variables],
      (metaData) => fetchData<PersonQuery, PersonQueryVariables>(PersonDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const PersonCreateDocument = `
    mutation PersonCreate($attributes: EditPersonInput!) {
  adminPersonCreate(attributes: $attributes) {
    person {
      ...Person
    }
    errors {
      message
    }
  }
}
    ${PersonFragmentDoc}`;
export const usePersonCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PersonCreateMutation, TError, PersonCreateMutationVariables, TContext>) =>
    useMutation<PersonCreateMutation, TError, PersonCreateMutationVariables, TContext>(
      ['PersonCreate'],
      (variables?: PersonCreateMutationVariables) => fetchData<PersonCreateMutation, PersonCreateMutationVariables>(PersonCreateDocument, variables)(),
      options
    );
export const PersonEditDocument = `
    mutation PersonEdit($id: ID!, $attributes: EditPersonInput!) {
  adminPersonUpdate(id: $id, attributes: $attributes) {
    person {
      ...Person
    }
    errors {
      message
    }
  }
}
    ${PersonFragmentDoc}`;
export const usePersonEditMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PersonEditMutation, TError, PersonEditMutationVariables, TContext>) =>
    useMutation<PersonEditMutation, TError, PersonEditMutationVariables, TContext>(
      ['PersonEdit'],
      (variables?: PersonEditMutationVariables) => fetchData<PersonEditMutation, PersonEditMutationVariables>(PersonEditDocument, variables)(),
      options
    );
export const PersonDestroyDocument = `
    mutation PersonDestroy($id: ID!) {
  adminPersonDestroy(id: $id) {
    success
    errors {
      message
    }
  }
}
    `;
export const usePersonDestroyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PersonDestroyMutation, TError, PersonDestroyMutationVariables, TContext>) =>
    useMutation<PersonDestroyMutation, TError, PersonDestroyMutationVariables, TContext>(
      ['PersonDestroy'],
      (variables?: PersonDestroyMutationVariables) => fetchData<PersonDestroyMutation, PersonDestroyMutationVariables>(PersonDestroyDocument, variables)(),
      options
    );
export const SingleUseVoucherIndexDocument = `
    query SingleUseVoucherIndex {
  adminSingleUseVoucherList {
    ...SingleUseVoucher
  }
}
    ${SingleUseVoucherFragmentDoc}`;
export const useSingleUseVoucherIndexQuery = <
      TData = SingleUseVoucherIndexQuery,
      TError = unknown
    >(
      variables?: SingleUseVoucherIndexQueryVariables,
      options?: UseQueryOptions<SingleUseVoucherIndexQuery, TError, TData>
    ) =>
    useQuery<SingleUseVoucherIndexQuery, TError, TData>(
      variables === undefined ? ['SingleUseVoucherIndex'] : ['SingleUseVoucherIndex', variables],
      fetchData<SingleUseVoucherIndexQuery, SingleUseVoucherIndexQueryVariables>(SingleUseVoucherIndexDocument, variables),
      options
    );
export const useInfiniteSingleUseVoucherIndexQuery = <
      TData = SingleUseVoucherIndexQuery,
      TError = unknown
    >(
      variables?: SingleUseVoucherIndexQueryVariables,
      options?: UseInfiniteQueryOptions<SingleUseVoucherIndexQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<SingleUseVoucherIndexQuery, TError, TData>(
      variables === undefined ? ['SingleUseVoucherIndex.infinite'] : ['SingleUseVoucherIndex.infinite', variables],
      (metaData) => fetchData<SingleUseVoucherIndexQuery, SingleUseVoucherIndexQueryVariables>(SingleUseVoucherIndexDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const SingleUseVoucherDocument = `
    query SingleUseVoucher($id: ID!) {
  adminSingleUseVoucher(id: $id) {
    ...SingleUseVoucher
  }
}
    ${SingleUseVoucherFragmentDoc}`;
export const useSingleUseVoucherQuery = <
      TData = SingleUseVoucherQuery,
      TError = unknown
    >(
      variables: SingleUseVoucherQueryVariables,
      options?: UseQueryOptions<SingleUseVoucherQuery, TError, TData>
    ) =>
    useQuery<SingleUseVoucherQuery, TError, TData>(
      ['SingleUseVoucher', variables],
      fetchData<SingleUseVoucherQuery, SingleUseVoucherQueryVariables>(SingleUseVoucherDocument, variables),
      options
    );
export const useInfiniteSingleUseVoucherQuery = <
      TData = SingleUseVoucherQuery,
      TError = unknown
    >(
      variables: SingleUseVoucherQueryVariables,
      options?: UseInfiniteQueryOptions<SingleUseVoucherQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<SingleUseVoucherQuery, TError, TData>(
      ['SingleUseVoucher.infinite', variables],
      (metaData) => fetchData<SingleUseVoucherQuery, SingleUseVoucherQueryVariables>(SingleUseVoucherDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const SingleUseVoucherCreateDocument = `
    mutation SingleUseVoucherCreate($attributes: EditSingleUseVoucherInput!) {
  adminSingleUseVoucherCreate(attributes: $attributes) {
    singleUseVoucher {
      ...SingleUseVoucher
    }
    errors {
      message
    }
  }
}
    ${SingleUseVoucherFragmentDoc}`;
export const useSingleUseVoucherCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SingleUseVoucherCreateMutation, TError, SingleUseVoucherCreateMutationVariables, TContext>) =>
    useMutation<SingleUseVoucherCreateMutation, TError, SingleUseVoucherCreateMutationVariables, TContext>(
      ['SingleUseVoucherCreate'],
      (variables?: SingleUseVoucherCreateMutationVariables) => fetchData<SingleUseVoucherCreateMutation, SingleUseVoucherCreateMutationVariables>(SingleUseVoucherCreateDocument, variables)(),
      options
    );
export const SingleUseVoucherEditDocument = `
    mutation SingleUseVoucherEdit($id: ID!, $attributes: EditSingleUseVoucherInput!) {
  adminSingleUseVoucherUpdate(id: $id, attributes: $attributes) {
    singleUseVoucher {
      ...SingleUseVoucher
    }
    errors {
      message
    }
  }
}
    ${SingleUseVoucherFragmentDoc}`;
export const useSingleUseVoucherEditMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SingleUseVoucherEditMutation, TError, SingleUseVoucherEditMutationVariables, TContext>) =>
    useMutation<SingleUseVoucherEditMutation, TError, SingleUseVoucherEditMutationVariables, TContext>(
      ['SingleUseVoucherEdit'],
      (variables?: SingleUseVoucherEditMutationVariables) => fetchData<SingleUseVoucherEditMutation, SingleUseVoucherEditMutationVariables>(SingleUseVoucherEditDocument, variables)(),
      options
    );
export const SingleUseVoucherDestroyDocument = `
    mutation SingleUseVoucherDestroy($id: ID!) {
  adminSingleUseVoucherDestroy(id: $id) {
    success
    errors {
      message
    }
  }
}
    `;
export const useSingleUseVoucherDestroyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SingleUseVoucherDestroyMutation, TError, SingleUseVoucherDestroyMutationVariables, TContext>) =>
    useMutation<SingleUseVoucherDestroyMutation, TError, SingleUseVoucherDestroyMutationVariables, TContext>(
      ['SingleUseVoucherDestroy'],
      (variables?: SingleUseVoucherDestroyMutationVariables) => fetchData<SingleUseVoucherDestroyMutation, SingleUseVoucherDestroyMutationVariables>(SingleUseVoucherDestroyDocument, variables)(),
      options
    );
export const TicketPricingGroupIndexDocument = `
    query TicketPricingGroupIndex {
  adminTicketPricingGroupList {
    ...TicketPricingGroup
  }
}
    ${TicketPricingGroupFragmentDoc}`;
export const useTicketPricingGroupIndexQuery = <
      TData = TicketPricingGroupIndexQuery,
      TError = unknown
    >(
      variables?: TicketPricingGroupIndexQueryVariables,
      options?: UseQueryOptions<TicketPricingGroupIndexQuery, TError, TData>
    ) =>
    useQuery<TicketPricingGroupIndexQuery, TError, TData>(
      variables === undefined ? ['TicketPricingGroupIndex'] : ['TicketPricingGroupIndex', variables],
      fetchData<TicketPricingGroupIndexQuery, TicketPricingGroupIndexQueryVariables>(TicketPricingGroupIndexDocument, variables),
      options
    );
export const useInfiniteTicketPricingGroupIndexQuery = <
      TData = TicketPricingGroupIndexQuery,
      TError = unknown
    >(
      variables?: TicketPricingGroupIndexQueryVariables,
      options?: UseInfiniteQueryOptions<TicketPricingGroupIndexQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<TicketPricingGroupIndexQuery, TError, TData>(
      variables === undefined ? ['TicketPricingGroupIndex.infinite'] : ['TicketPricingGroupIndex.infinite', variables],
      (metaData) => fetchData<TicketPricingGroupIndexQuery, TicketPricingGroupIndexQueryVariables>(TicketPricingGroupIndexDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const TicketPricingGroupDocument = `
    query TicketPricingGroup($id: ID!) {
  adminTicketPricingGroup(id: $id) {
    ...TicketPricingGroup
  }
}
    ${TicketPricingGroupFragmentDoc}`;
export const useTicketPricingGroupQuery = <
      TData = TicketPricingGroupQuery,
      TError = unknown
    >(
      variables: TicketPricingGroupQueryVariables,
      options?: UseQueryOptions<TicketPricingGroupQuery, TError, TData>
    ) =>
    useQuery<TicketPricingGroupQuery, TError, TData>(
      ['TicketPricingGroup', variables],
      fetchData<TicketPricingGroupQuery, TicketPricingGroupQueryVariables>(TicketPricingGroupDocument, variables),
      options
    );
export const useInfiniteTicketPricingGroupQuery = <
      TData = TicketPricingGroupQuery,
      TError = unknown
    >(
      variables: TicketPricingGroupQueryVariables,
      options?: UseInfiniteQueryOptions<TicketPricingGroupQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<TicketPricingGroupQuery, TError, TData>(
      ['TicketPricingGroup.infinite', variables],
      (metaData) => fetchData<TicketPricingGroupQuery, TicketPricingGroupQueryVariables>(TicketPricingGroupDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const TicketPricingGroupCreateDocument = `
    mutation TicketPricingGroupCreate($attributes: EditTicketPricingGroupInput!) {
  adminTicketPricingGroupCreate(attributes: $attributes) {
    ticketPricingGroup {
      ...TicketPricingGroup
    }
    errors {
      message
    }
  }
}
    ${TicketPricingGroupFragmentDoc}`;
export const useTicketPricingGroupCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TicketPricingGroupCreateMutation, TError, TicketPricingGroupCreateMutationVariables, TContext>) =>
    useMutation<TicketPricingGroupCreateMutation, TError, TicketPricingGroupCreateMutationVariables, TContext>(
      ['TicketPricingGroupCreate'],
      (variables?: TicketPricingGroupCreateMutationVariables) => fetchData<TicketPricingGroupCreateMutation, TicketPricingGroupCreateMutationVariables>(TicketPricingGroupCreateDocument, variables)(),
      options
    );
export const TicketPricingGroupEditDocument = `
    mutation TicketPricingGroupEdit($id: ID!, $attributes: EditTicketPricingGroupInput!) {
  adminTicketPricingGroupUpdate(id: $id, attributes: $attributes) {
    ticketPricingGroup {
      ...TicketPricingGroup
    }
    errors {
      message
    }
  }
}
    ${TicketPricingGroupFragmentDoc}`;
export const useTicketPricingGroupEditMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TicketPricingGroupEditMutation, TError, TicketPricingGroupEditMutationVariables, TContext>) =>
    useMutation<TicketPricingGroupEditMutation, TError, TicketPricingGroupEditMutationVariables, TContext>(
      ['TicketPricingGroupEdit'],
      (variables?: TicketPricingGroupEditMutationVariables) => fetchData<TicketPricingGroupEditMutation, TicketPricingGroupEditMutationVariables>(TicketPricingGroupEditDocument, variables)(),
      options
    );
export const TicketPricingGroupDestroyDocument = `
    mutation TicketPricingGroupDestroy($id: ID!) {
  adminTicketPricingGroupDestroy(id: $id) {
    success
    errors {
      message
    }
  }
}
    `;
export const useTicketPricingGroupDestroyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TicketPricingGroupDestroyMutation, TError, TicketPricingGroupDestroyMutationVariables, TContext>) =>
    useMutation<TicketPricingGroupDestroyMutation, TError, TicketPricingGroupDestroyMutationVariables, TContext>(
      ['TicketPricingGroupDestroy'],
      (variables?: TicketPricingGroupDestroyMutationVariables) => fetchData<TicketPricingGroupDestroyMutation, TicketPricingGroupDestroyMutationVariables>(TicketPricingGroupDestroyDocument, variables)(),
      options
    );
export const TheatreMembershipListDocument = `
    query TheatreMembershipList {
  adminTheatreMembershipList {
    id
    user {
      id
      name
      email
    }
    tier
    paymentStatus
    expirationDate
  }
}
    `;
export const useTheatreMembershipListQuery = <
      TData = TheatreMembershipListQuery,
      TError = unknown
    >(
      variables?: TheatreMembershipListQueryVariables,
      options?: UseQueryOptions<TheatreMembershipListQuery, TError, TData>
    ) =>
    useQuery<TheatreMembershipListQuery, TError, TData>(
      variables === undefined ? ['TheatreMembershipList'] : ['TheatreMembershipList', variables],
      fetchData<TheatreMembershipListQuery, TheatreMembershipListQueryVariables>(TheatreMembershipListDocument, variables),
      options
    );
export const useInfiniteTheatreMembershipListQuery = <
      TData = TheatreMembershipListQuery,
      TError = unknown
    >(
      variables?: TheatreMembershipListQueryVariables,
      options?: UseInfiniteQueryOptions<TheatreMembershipListQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<TheatreMembershipListQuery, TError, TData>(
      variables === undefined ? ['TheatreMembershipList.infinite'] : ['TheatreMembershipList.infinite', variables],
      (metaData) => fetchData<TheatreMembershipListQuery, TheatreMembershipListQueryVariables>(TheatreMembershipListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const TheatreMembershipReadDocument = `
    query TheatreMembershipRead($id: ID!) {
  adminTheatreMembership(id: $id) {
    id
    user {
      id
      fullName
      telephone
      email
    }
    tier
    paymentStatus
    expirationDate
  }
}
    `;
export const useTheatreMembershipReadQuery = <
      TData = TheatreMembershipReadQuery,
      TError = unknown
    >(
      variables: TheatreMembershipReadQueryVariables,
      options?: UseQueryOptions<TheatreMembershipReadQuery, TError, TData>
    ) =>
    useQuery<TheatreMembershipReadQuery, TError, TData>(
      ['TheatreMembershipRead', variables],
      fetchData<TheatreMembershipReadQuery, TheatreMembershipReadQueryVariables>(TheatreMembershipReadDocument, variables),
      options
    );
export const useInfiniteTheatreMembershipReadQuery = <
      TData = TheatreMembershipReadQuery,
      TError = unknown
    >(
      variables: TheatreMembershipReadQueryVariables,
      options?: UseInfiniteQueryOptions<TheatreMembershipReadQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<TheatreMembershipReadQuery, TError, TData>(
      ['TheatreMembershipRead.infinite', variables],
      (metaData) => fetchData<TheatreMembershipReadQuery, TheatreMembershipReadQueryVariables>(TheatreMembershipReadDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const TheatreMembershipCreateDocument = `
    mutation TheatreMembershipCreate($attributes: EditTheatreMembershipInput!) {
  adminTheatreMembershipCreate(attributes: $attributes) {
    theatreMembership {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;
export const useTheatreMembershipCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TheatreMembershipCreateMutation, TError, TheatreMembershipCreateMutationVariables, TContext>) =>
    useMutation<TheatreMembershipCreateMutation, TError, TheatreMembershipCreateMutationVariables, TContext>(
      ['TheatreMembershipCreate'],
      (variables?: TheatreMembershipCreateMutationVariables) => fetchData<TheatreMembershipCreateMutation, TheatreMembershipCreateMutationVariables>(TheatreMembershipCreateDocument, variables)(),
      options
    );
export const TheatreMembershipUpdateMutationDocument = `
    mutation TheatreMembershipUpdateMutation($id: ID!, $attributes: EditTheatreMembershipInput!) {
  adminTheatreMembershipUpdate(id: $id, attributes: $attributes) {
    theatreMembership {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;
export const useTheatreMembershipUpdateMutationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TheatreMembershipUpdateMutationMutation, TError, TheatreMembershipUpdateMutationMutationVariables, TContext>) =>
    useMutation<TheatreMembershipUpdateMutationMutation, TError, TheatreMembershipUpdateMutationMutationVariables, TContext>(
      ['TheatreMembershipUpdateMutation'],
      (variables?: TheatreMembershipUpdateMutationMutationVariables) => fetchData<TheatreMembershipUpdateMutationMutation, TheatreMembershipUpdateMutationMutationVariables>(TheatreMembershipUpdateMutationDocument, variables)(),
      options
    );
export const TheatreMembershipDestroyDocument = `
    mutation TheatreMembershipDestroy($id: ID!) {
  adminTheatreMembershipDestroy(id: $id) {
    success
    errors {
      message
      path
    }
  }
}
    `;
export const useTheatreMembershipDestroyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TheatreMembershipDestroyMutation, TError, TheatreMembershipDestroyMutationVariables, TContext>) =>
    useMutation<TheatreMembershipDestroyMutation, TError, TheatreMembershipDestroyMutationVariables, TContext>(
      ['TheatreMembershipDestroy'],
      (variables?: TheatreMembershipDestroyMutationVariables) => fetchData<TheatreMembershipDestroyMutation, TheatreMembershipDestroyMutationVariables>(TheatreMembershipDestroyDocument, variables)(),
      options
    );
export const WorkshopLevelsListAdminDocument = `
    query WorkshopLevelsListAdmin {
  workshopLevelsList {
    ...WorkshopLevelsList
  }
}
    ${WorkshopLevelsListFragmentDoc}
${WorkshopPricingFieldsFragmentDoc}`;
export const useWorkshopLevelsListAdminQuery = <
      TData = WorkshopLevelsListAdminQuery,
      TError = unknown
    >(
      variables?: WorkshopLevelsListAdminQueryVariables,
      options?: UseQueryOptions<WorkshopLevelsListAdminQuery, TError, TData>
    ) =>
    useQuery<WorkshopLevelsListAdminQuery, TError, TData>(
      variables === undefined ? ['WorkshopLevelsListAdmin'] : ['WorkshopLevelsListAdmin', variables],
      fetchData<WorkshopLevelsListAdminQuery, WorkshopLevelsListAdminQueryVariables>(WorkshopLevelsListAdminDocument, variables),
      options
    );
export const useInfiniteWorkshopLevelsListAdminQuery = <
      TData = WorkshopLevelsListAdminQuery,
      TError = unknown
    >(
      variables?: WorkshopLevelsListAdminQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopLevelsListAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopLevelsListAdminQuery, TError, TData>(
      variables === undefined ? ['WorkshopLevelsListAdmin.infinite'] : ['WorkshopLevelsListAdmin.infinite', variables],
      (metaData) => fetchData<WorkshopLevelsListAdminQuery, WorkshopLevelsListAdminQueryVariables>(WorkshopLevelsListAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ShowTypesListAdminDocument = `
    query ShowTypesListAdmin {
  showTypesListAdmin {
    ...ShowTypeBasics
  }
}
    ${ShowTypeBasicsFragmentDoc}
${TicketPricingFieldsFragmentDoc}`;
export const useShowTypesListAdminQuery = <
      TData = ShowTypesListAdminQuery,
      TError = unknown
    >(
      variables?: ShowTypesListAdminQueryVariables,
      options?: UseQueryOptions<ShowTypesListAdminQuery, TError, TData>
    ) =>
    useQuery<ShowTypesListAdminQuery, TError, TData>(
      variables === undefined ? ['ShowTypesListAdmin'] : ['ShowTypesListAdmin', variables],
      fetchData<ShowTypesListAdminQuery, ShowTypesListAdminQueryVariables>(ShowTypesListAdminDocument, variables),
      options
    );
export const useInfiniteShowTypesListAdminQuery = <
      TData = ShowTypesListAdminQuery,
      TError = unknown
    >(
      variables?: ShowTypesListAdminQueryVariables,
      options?: UseInfiniteQueryOptions<ShowTypesListAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ShowTypesListAdminQuery, TError, TData>(
      variables === undefined ? ['ShowTypesListAdmin.infinite'] : ['ShowTypesListAdmin.infinite', variables],
      (metaData) => fetchData<ShowTypesListAdminQuery, ShowTypesListAdminQueryVariables>(ShowTypesListAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopPricingGroupsListAdminDocument = `
    query WorkshopPricingGroupsListAdmin {
  workshopPricingGroupsListAdmin {
    ...WorkshopPricingFields
  }
}
    ${WorkshopPricingFieldsFragmentDoc}`;
export const useWorkshopPricingGroupsListAdminQuery = <
      TData = WorkshopPricingGroupsListAdminQuery,
      TError = unknown
    >(
      variables?: WorkshopPricingGroupsListAdminQueryVariables,
      options?: UseQueryOptions<WorkshopPricingGroupsListAdminQuery, TError, TData>
    ) =>
    useQuery<WorkshopPricingGroupsListAdminQuery, TError, TData>(
      variables === undefined ? ['WorkshopPricingGroupsListAdmin'] : ['WorkshopPricingGroupsListAdmin', variables],
      fetchData<WorkshopPricingGroupsListAdminQuery, WorkshopPricingGroupsListAdminQueryVariables>(WorkshopPricingGroupsListAdminDocument, variables),
      options
    );
export const useInfiniteWorkshopPricingGroupsListAdminQuery = <
      TData = WorkshopPricingGroupsListAdminQuery,
      TError = unknown
    >(
      variables?: WorkshopPricingGroupsListAdminQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopPricingGroupsListAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopPricingGroupsListAdminQuery, TError, TData>(
      variables === undefined ? ['WorkshopPricingGroupsListAdmin.infinite'] : ['WorkshopPricingGroupsListAdmin.infinite', variables],
      (metaData) => fetchData<WorkshopPricingGroupsListAdminQuery, WorkshopPricingGroupsListAdminQueryVariables>(WorkshopPricingGroupsListAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopCategoriesListAdminDocument = `
    query WorkshopCategoriesListAdmin {
  workshopCategoriesListAdmin {
    id
    name
  }
}
    `;
export const useWorkshopCategoriesListAdminQuery = <
      TData = WorkshopCategoriesListAdminQuery,
      TError = unknown
    >(
      variables?: WorkshopCategoriesListAdminQueryVariables,
      options?: UseQueryOptions<WorkshopCategoriesListAdminQuery, TError, TData>
    ) =>
    useQuery<WorkshopCategoriesListAdminQuery, TError, TData>(
      variables === undefined ? ['WorkshopCategoriesListAdmin'] : ['WorkshopCategoriesListAdmin', variables],
      fetchData<WorkshopCategoriesListAdminQuery, WorkshopCategoriesListAdminQueryVariables>(WorkshopCategoriesListAdminDocument, variables),
      options
    );
export const useInfiniteWorkshopCategoriesListAdminQuery = <
      TData = WorkshopCategoriesListAdminQuery,
      TError = unknown
    >(
      variables?: WorkshopCategoriesListAdminQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopCategoriesListAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopCategoriesListAdminQuery, TError, TData>(
      variables === undefined ? ['WorkshopCategoriesListAdmin.infinite'] : ['WorkshopCategoriesListAdmin.infinite', variables],
      (metaData) => fetchData<WorkshopCategoriesListAdminQuery, WorkshopCategoriesListAdminQueryVariables>(WorkshopCategoriesListAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ShowTagsListAdminDocument = `
    query ShowTagsListAdmin {
  showTagsListAdmin {
    id
    name
    slug
  }
}
    `;
export const useShowTagsListAdminQuery = <
      TData = ShowTagsListAdminQuery,
      TError = unknown
    >(
      variables?: ShowTagsListAdminQueryVariables,
      options?: UseQueryOptions<ShowTagsListAdminQuery, TError, TData>
    ) =>
    useQuery<ShowTagsListAdminQuery, TError, TData>(
      variables === undefined ? ['ShowTagsListAdmin'] : ['ShowTagsListAdmin', variables],
      fetchData<ShowTagsListAdminQuery, ShowTagsListAdminQueryVariables>(ShowTagsListAdminDocument, variables),
      options
    );
export const useInfiniteShowTagsListAdminQuery = <
      TData = ShowTagsListAdminQuery,
      TError = unknown
    >(
      variables?: ShowTagsListAdminQueryVariables,
      options?: UseInfiniteQueryOptions<ShowTagsListAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ShowTagsListAdminQuery, TError, TData>(
      variables === undefined ? ['ShowTagsListAdmin.infinite'] : ['ShowTagsListAdmin.infinite', variables],
      (metaData) => fetchData<ShowTagsListAdminQuery, ShowTagsListAdminQueryVariables>(ShowTagsListAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const TicketPricingGroupsListAdminDocument = `
    query TicketPricingGroupsListAdmin {
  ticketPricingGroupsListAdmin {
    ...TicketPricingFields
  }
}
    ${TicketPricingFieldsFragmentDoc}`;
export const useTicketPricingGroupsListAdminQuery = <
      TData = TicketPricingGroupsListAdminQuery,
      TError = unknown
    >(
      variables?: TicketPricingGroupsListAdminQueryVariables,
      options?: UseQueryOptions<TicketPricingGroupsListAdminQuery, TError, TData>
    ) =>
    useQuery<TicketPricingGroupsListAdminQuery, TError, TData>(
      variables === undefined ? ['TicketPricingGroupsListAdmin'] : ['TicketPricingGroupsListAdmin', variables],
      fetchData<TicketPricingGroupsListAdminQuery, TicketPricingGroupsListAdminQueryVariables>(TicketPricingGroupsListAdminDocument, variables),
      options
    );
export const useInfiniteTicketPricingGroupsListAdminQuery = <
      TData = TicketPricingGroupsListAdminQuery,
      TError = unknown
    >(
      variables?: TicketPricingGroupsListAdminQueryVariables,
      options?: UseInfiniteQueryOptions<TicketPricingGroupsListAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<TicketPricingGroupsListAdminQuery, TError, TData>(
      variables === undefined ? ['TicketPricingGroupsListAdmin.infinite'] : ['TicketPricingGroupsListAdmin.infinite', variables],
      (metaData) => fetchData<TicketPricingGroupsListAdminQuery, TicketPricingGroupsListAdminQueryVariables>(TicketPricingGroupsListAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const VenuesListAdminDocument = `
    query VenuesListAdmin {
  venuesListAdmin {
    ...VenuesListAdmin
  }
}
    ${VenuesListAdminFragmentDoc}`;
export const useVenuesListAdminQuery = <
      TData = VenuesListAdminQuery,
      TError = unknown
    >(
      variables?: VenuesListAdminQueryVariables,
      options?: UseQueryOptions<VenuesListAdminQuery, TError, TData>
    ) =>
    useQuery<VenuesListAdminQuery, TError, TData>(
      variables === undefined ? ['VenuesListAdmin'] : ['VenuesListAdmin', variables],
      fetchData<VenuesListAdminQuery, VenuesListAdminQueryVariables>(VenuesListAdminDocument, variables),
      options
    );
export const useInfiniteVenuesListAdminQuery = <
      TData = VenuesListAdminQuery,
      TError = unknown
    >(
      variables?: VenuesListAdminQueryVariables,
      options?: UseInfiniteQueryOptions<VenuesListAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<VenuesListAdminQuery, TError, TData>(
      variables === undefined ? ['VenuesListAdmin.infinite'] : ['VenuesListAdmin.infinite', variables],
      (metaData) => fetchData<VenuesListAdminQuery, VenuesListAdminQueryVariables>(VenuesListAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const UserSearchAdminDocument = `
    query UserSearchAdmin($searchAttributes: UserSearchAttributes!) {
  userSearchAdmin(searchAttributes: $searchAttributes) {
    ...DefaultUserInfo
  }
}
    ${DefaultUserInfoFragmentDoc}`;
export const useUserSearchAdminQuery = <
      TData = UserSearchAdminQuery,
      TError = unknown
    >(
      variables: UserSearchAdminQueryVariables,
      options?: UseQueryOptions<UserSearchAdminQuery, TError, TData>
    ) =>
    useQuery<UserSearchAdminQuery, TError, TData>(
      ['UserSearchAdmin', variables],
      fetchData<UserSearchAdminQuery, UserSearchAdminQueryVariables>(UserSearchAdminDocument, variables),
      options
    );
export const useInfiniteUserSearchAdminQuery = <
      TData = UserSearchAdminQuery,
      TError = unknown
    >(
      variables: UserSearchAdminQueryVariables,
      options?: UseInfiniteQueryOptions<UserSearchAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<UserSearchAdminQuery, TError, TData>(
      ['UserSearchAdmin.infinite', variables],
      (metaData) => fetchData<UserSearchAdminQuery, UserSearchAdminQueryVariables>(UserSearchAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const InstructorSearchAdminDocument = `
    query InstructorSearchAdmin($searchAttributes: InstructorSearchAttributes!) {
  instructorSearchAdmin(searchAttributes: $searchAttributes) {
    ...instructorFields
  }
}
    ${InstructorFieldsFragmentDoc}`;
export const useInstructorSearchAdminQuery = <
      TData = InstructorSearchAdminQuery,
      TError = unknown
    >(
      variables: InstructorSearchAdminQueryVariables,
      options?: UseQueryOptions<InstructorSearchAdminQuery, TError, TData>
    ) =>
    useQuery<InstructorSearchAdminQuery, TError, TData>(
      ['InstructorSearchAdmin', variables],
      fetchData<InstructorSearchAdminQuery, InstructorSearchAdminQueryVariables>(InstructorSearchAdminDocument, variables),
      options
    );
export const useInfiniteInstructorSearchAdminQuery = <
      TData = InstructorSearchAdminQuery,
      TError = unknown
    >(
      variables: InstructorSearchAdminQueryVariables,
      options?: UseInfiniteQueryOptions<InstructorSearchAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<InstructorSearchAdminQuery, TError, TData>(
      ['InstructorSearchAdmin.infinite', variables],
      (metaData) => fetchData<InstructorSearchAdminQuery, InstructorSearchAdminQueryVariables>(InstructorSearchAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopDetailsAdminDocument = `
    query WorkshopDetailsAdmin($ids: [ID!]!) {
  workshopDetailsAdmin(ids: $ids) {
    ...WorkshopAdminIndexFields
    confirmedWorkshopRegistrations {
      id
      user {
        ...DefaultUserInfo
      }
    }
  }
}
    ${WorkshopAdminIndexFieldsFragmentDoc}
${WorkshopLevelsListFragmentDoc}
${WorkshopPricingFieldsFragmentDoc}
${WorkshopSessionsFragmentDoc}
${InstructorsFragmentDoc}
${InstructorFieldsFragmentDoc}
${CapacityFragmentDoc}
${WorkshopFinancesFragmentDoc}
${PerformanceForEditFragmentDoc}
${TicketPricingFieldsFragmentDoc}
${DefaultUserInfoFragmentDoc}`;
export const useWorkshopDetailsAdminQuery = <
      TData = WorkshopDetailsAdminQuery,
      TError = unknown
    >(
      variables: WorkshopDetailsAdminQueryVariables,
      options?: UseQueryOptions<WorkshopDetailsAdminQuery, TError, TData>
    ) =>
    useQuery<WorkshopDetailsAdminQuery, TError, TData>(
      ['WorkshopDetailsAdmin', variables],
      fetchData<WorkshopDetailsAdminQuery, WorkshopDetailsAdminQueryVariables>(WorkshopDetailsAdminDocument, variables),
      options
    );
export const useInfiniteWorkshopDetailsAdminQuery = <
      TData = WorkshopDetailsAdminQuery,
      TError = unknown
    >(
      variables: WorkshopDetailsAdminQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopDetailsAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopDetailsAdminQuery, TError, TData>(
      ['WorkshopDetailsAdmin.infinite', variables],
      (metaData) => fetchData<WorkshopDetailsAdminQuery, WorkshopDetailsAdminQueryVariables>(WorkshopDetailsAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopSearchAdminDocument = `
    query WorkshopSearchAdmin($searchAttributes: WorkshopSearchAttributes!) {
  workshopSearchAdmin(searchAttributes: $searchAttributes) {
    id
    name
    ...WorkshopSessions
    ...Instructors
    ...Capacity
    workshopLevel {
      ...WorkshopLevelsList
    }
  }
}
    ${WorkshopSessionsFragmentDoc}
${InstructorsFragmentDoc}
${InstructorFieldsFragmentDoc}
${CapacityFragmentDoc}
${WorkshopLevelsListFragmentDoc}
${WorkshopPricingFieldsFragmentDoc}`;
export const useWorkshopSearchAdminQuery = <
      TData = WorkshopSearchAdminQuery,
      TError = unknown
    >(
      variables: WorkshopSearchAdminQueryVariables,
      options?: UseQueryOptions<WorkshopSearchAdminQuery, TError, TData>
    ) =>
    useQuery<WorkshopSearchAdminQuery, TError, TData>(
      ['WorkshopSearchAdmin', variables],
      fetchData<WorkshopSearchAdminQuery, WorkshopSearchAdminQueryVariables>(WorkshopSearchAdminDocument, variables),
      options
    );
export const useInfiniteWorkshopSearchAdminQuery = <
      TData = WorkshopSearchAdminQuery,
      TError = unknown
    >(
      variables: WorkshopSearchAdminQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopSearchAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopSearchAdminQuery, TError, TData>(
      ['WorkshopSearchAdmin.infinite', variables],
      (metaData) => fetchData<WorkshopSearchAdminQuery, WorkshopSearchAdminQueryVariables>(WorkshopSearchAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopTermsListAdminDocument = `
    query WorkshopTermsListAdmin {
  workshopTermsList(params: {scope: ALL}) {
    id
    name
    startingMonday
  }
}
    `;
export const useWorkshopTermsListAdminQuery = <
      TData = WorkshopTermsListAdminQuery,
      TError = unknown
    >(
      variables?: WorkshopTermsListAdminQueryVariables,
      options?: UseQueryOptions<WorkshopTermsListAdminQuery, TError, TData>
    ) =>
    useQuery<WorkshopTermsListAdminQuery, TError, TData>(
      variables === undefined ? ['WorkshopTermsListAdmin'] : ['WorkshopTermsListAdmin', variables],
      fetchData<WorkshopTermsListAdminQuery, WorkshopTermsListAdminQueryVariables>(WorkshopTermsListAdminDocument, variables),
      options
    );
export const useInfiniteWorkshopTermsListAdminQuery = <
      TData = WorkshopTermsListAdminQuery,
      TError = unknown
    >(
      variables?: WorkshopTermsListAdminQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopTermsListAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopTermsListAdminQuery, TError, TData>(
      variables === undefined ? ['WorkshopTermsListAdmin.infinite'] : ['WorkshopTermsListAdmin.infinite', variables],
      (metaData) => fetchData<WorkshopTermsListAdminQuery, WorkshopTermsListAdminQueryVariables>(WorkshopTermsListAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const AddStudentToIntroCourseDocument = `
    query AddStudentToIntroCourse($userId: ID!, $workshopCategoryId: ID!) {
  userInfoAdmin(userId: $userId) {
    id
    fullName
    email
    telephone
  }
  workshopsFreeTrialSellClassOptions(
    workshopCategoryId: $workshopCategoryId
    userId: $userId
  ) {
    discounts {
      discountAmount
      discountName
    }
    workshop {
      id
      name
      meetingType
      workshopSessions {
        id
        startDatetime
        endDatetime
        venue {
          id
          name
          address
          directions
        }
      }
      teachers {
        name
      }
      assistants {
        name
      }
      capacity
      absoluteMaximumCapacity
      numStudentsEnrolled
      soldOut
      workshopLevel {
        id
        name
        levelType
        onlineClassesAvailable
        description
        workshopPricingGroup {
          id
          name
          fullPrice
          concessionPrice
          totalServiceFee
          flexibleFee
          flexibleFeeName
        }
        workshopCategory {
          id
          name
        }
      }
      preferredWorkshopPricingGroup {
        id
        name
        fullPrice
        concessionPrice
        totalServiceFee
        flexibleFee
        flexibleFeeName
      }
    }
  }
}
    `;
export const useAddStudentToIntroCourseQuery = <
      TData = AddStudentToIntroCourseQuery,
      TError = unknown
    >(
      variables: AddStudentToIntroCourseQueryVariables,
      options?: UseQueryOptions<AddStudentToIntroCourseQuery, TError, TData>
    ) =>
    useQuery<AddStudentToIntroCourseQuery, TError, TData>(
      ['AddStudentToIntroCourse', variables],
      fetchData<AddStudentToIntroCourseQuery, AddStudentToIntroCourseQueryVariables>(AddStudentToIntroCourseDocument, variables),
      options
    );
export const useInfiniteAddStudentToIntroCourseQuery = <
      TData = AddStudentToIntroCourseQuery,
      TError = unknown
    >(
      variables: AddStudentToIntroCourseQueryVariables,
      options?: UseInfiniteQueryOptions<AddStudentToIntroCourseQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<AddStudentToIntroCourseQuery, TError, TData>(
      ['AddStudentToIntroCourse.infinite', variables],
      (metaData) => fetchData<AddStudentToIntroCourseQuery, AddStudentToIntroCourseQueryVariables>(AddStudentToIntroCourseDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const AddStudentToIntroCourseStripeDocument = `
    mutation AddStudentToIntroCourseStripe($params: WorkshopAddStudentStripe!) {
  workshopAddStudentStripe(params: $params) {
    workshopRegistration {
      id
      workshopPaymentLedger {
        amountPaidToDate
      }
    }
    errors {
      message
      path
    }
  }
}
    `;
export const useAddStudentToIntroCourseStripeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddStudentToIntroCourseStripeMutation, TError, AddStudentToIntroCourseStripeMutationVariables, TContext>) =>
    useMutation<AddStudentToIntroCourseStripeMutation, TError, AddStudentToIntroCourseStripeMutationVariables, TContext>(
      ['AddStudentToIntroCourseStripe'],
      (variables?: AddStudentToIntroCourseStripeMutationVariables) => fetchData<AddStudentToIntroCourseStripeMutation, AddStudentToIntroCourseStripeMutationVariables>(AddStudentToIntroCourseStripeDocument, variables)(),
      options
    );
export const AddStudentToIntroCourseManualDocument = `
    mutation AddStudentToIntroCourseManual($params: WorkshopAddStudentManualInput!) {
  workshopAddStudentManual(params: $params) {
    errors {
      message
      path
    }
    workshopRegistration {
      id
    }
  }
}
    `;
export const useAddStudentToIntroCourseManualMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddStudentToIntroCourseManualMutation, TError, AddStudentToIntroCourseManualMutationVariables, TContext>) =>
    useMutation<AddStudentToIntroCourseManualMutation, TError, AddStudentToIntroCourseManualMutationVariables, TContext>(
      ['AddStudentToIntroCourseManual'],
      (variables?: AddStudentToIntroCourseManualMutationVariables) => fetchData<AddStudentToIntroCourseManualMutation, AddStudentToIntroCourseManualMutationVariables>(AddStudentToIntroCourseManualDocument, variables)(),
      options
    );
export const ReferralBonusAwardMutationDocument = `
    mutation ReferralBonusAwardMutation($workshopRegistrationId: ID!, $userId: ID!) {
  referralBonusAward(
    workshopRegistrationId: $workshopRegistrationId
    userId: $userId
  ) {
    success
    errors {
      message
      path
    }
  }
}
    `;
export const useReferralBonusAwardMutationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReferralBonusAwardMutationMutation, TError, ReferralBonusAwardMutationMutationVariables, TContext>) =>
    useMutation<ReferralBonusAwardMutationMutation, TError, ReferralBonusAwardMutationMutationVariables, TContext>(
      ['ReferralBonusAwardMutation'],
      (variables?: ReferralBonusAwardMutationMutationVariables) => fetchData<ReferralBonusAwardMutationMutation, ReferralBonusAwardMutationMutationVariables>(ReferralBonusAwardMutationDocument, variables)(),
      options
    );
export const DeleteCompInfoDocument = `
    query DeleteCompInfo($ticketId: ID!) {
  ticketInfo(ticketId: $ticketId) {
    id
    name
    ticketQuantityTotal
    paymentType
  }
}
    `;
export const useDeleteCompInfoQuery = <
      TData = DeleteCompInfoQuery,
      TError = unknown
    >(
      variables: DeleteCompInfoQueryVariables,
      options?: UseQueryOptions<DeleteCompInfoQuery, TError, TData>
    ) =>
    useQuery<DeleteCompInfoQuery, TError, TData>(
      ['DeleteCompInfo', variables],
      fetchData<DeleteCompInfoQuery, DeleteCompInfoQueryVariables>(DeleteCompInfoDocument, variables),
      options
    );
export const useInfiniteDeleteCompInfoQuery = <
      TData = DeleteCompInfoQuery,
      TError = unknown
    >(
      variables: DeleteCompInfoQueryVariables,
      options?: UseInfiniteQueryOptions<DeleteCompInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<DeleteCompInfoQuery, TError, TData>(
      ['DeleteCompInfo.infinite', variables],
      (metaData) => fetchData<DeleteCompInfoQuery, DeleteCompInfoQueryVariables>(DeleteCompInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const DeleteCompDocument = `
    mutation DeleteComp($ticketId: ID!) {
  ticketDeleteComp(ticketId: $ticketId) {
    errors {
      message
      path
    }
    success
  }
}
    `;
export const useDeleteCompMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCompMutation, TError, DeleteCompMutationVariables, TContext>) =>
    useMutation<DeleteCompMutation, TError, DeleteCompMutationVariables, TContext>(
      ['DeleteComp'],
      (variables?: DeleteCompMutationVariables) => fetchData<DeleteCompMutation, DeleteCompMutationVariables>(DeleteCompDocument, variables)(),
      options
    );
export const WorkshopStudentsInTermDocument = `
    query WorkshopStudentsInTerm {
  workshopStudentsInTerm {
    user {
      id
      fullName
      email
      telephone
    }
  }
}
    `;
export const useWorkshopStudentsInTermQuery = <
      TData = WorkshopStudentsInTermQuery,
      TError = unknown
    >(
      variables?: WorkshopStudentsInTermQueryVariables,
      options?: UseQueryOptions<WorkshopStudentsInTermQuery, TError, TData>
    ) =>
    useQuery<WorkshopStudentsInTermQuery, TError, TData>(
      variables === undefined ? ['WorkshopStudentsInTerm'] : ['WorkshopStudentsInTerm', variables],
      fetchData<WorkshopStudentsInTermQuery, WorkshopStudentsInTermQueryVariables>(WorkshopStudentsInTermDocument, variables),
      options
    );
export const useInfiniteWorkshopStudentsInTermQuery = <
      TData = WorkshopStudentsInTermQuery,
      TError = unknown
    >(
      variables?: WorkshopStudentsInTermQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopStudentsInTermQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopStudentsInTermQuery, TError, TData>(
      variables === undefined ? ['WorkshopStudentsInTerm.infinite'] : ['WorkshopStudentsInTerm.infinite', variables],
      (metaData) => fetchData<WorkshopStudentsInTermQuery, WorkshopStudentsInTermQueryVariables>(WorkshopStudentsInTermDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const LogStudentAttendanceDocument = `
    mutation LogStudentAttendance($userId: ID!, $performanceId: ID!) {
  performanceLogStudentAttendance(userId: $userId, performanceId: $performanceId) {
    errors {
      message
      path
    }
    success
  }
}
    `;
export const useLogStudentAttendanceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LogStudentAttendanceMutation, TError, LogStudentAttendanceMutationVariables, TContext>) =>
    useMutation<LogStudentAttendanceMutation, TError, LogStudentAttendanceMutationVariables, TContext>(
      ['LogStudentAttendance'],
      (variables?: LogStudentAttendanceMutationVariables) => fetchData<LogStudentAttendanceMutation, LogStudentAttendanceMutationVariables>(LogStudentAttendanceDocument, variables)(),
      options
    );
export const MoveTicketsOptionsDocument = `
    query MoveTicketsOptions($ticketId: ID!) {
  ticketInfo(ticketId: $ticketId) {
    id
    name
    bracket
    ticketQuantityTotal
    performance {
      name
      startDatetime
      showType {
        id
        name
      }
    }
  }
  performancesUpcoming {
    id
    startDatetime
    name
    showType {
      id
      name
      calendarThumbnailUrlWeb
    }
    seatsRemainingReport {
      firstBracket
      secondBracket
      bothBrackets
    }
    determinedHasSecondBracket
  }
}
    `;
export const useMoveTicketsOptionsQuery = <
      TData = MoveTicketsOptionsQuery,
      TError = unknown
    >(
      variables: MoveTicketsOptionsQueryVariables,
      options?: UseQueryOptions<MoveTicketsOptionsQuery, TError, TData>
    ) =>
    useQuery<MoveTicketsOptionsQuery, TError, TData>(
      ['MoveTicketsOptions', variables],
      fetchData<MoveTicketsOptionsQuery, MoveTicketsOptionsQueryVariables>(MoveTicketsOptionsDocument, variables),
      options
    );
export const useInfiniteMoveTicketsOptionsQuery = <
      TData = MoveTicketsOptionsQuery,
      TError = unknown
    >(
      variables: MoveTicketsOptionsQueryVariables,
      options?: UseInfiniteQueryOptions<MoveTicketsOptionsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<MoveTicketsOptionsQuery, TError, TData>(
      ['MoveTicketsOptions.infinite', variables],
      (metaData) => fetchData<MoveTicketsOptionsQuery, MoveTicketsOptionsQueryVariables>(MoveTicketsOptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const MoveTicketsAdminDocument = `
    mutation MoveTicketsAdmin($params: AdminMoveTicketsInput!) {
  adminMoveTicketsToDifferentPerformance(params: $params) {
    success
    errors {
      message
    }
  }
}
    `;
export const useMoveTicketsAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveTicketsAdminMutation, TError, MoveTicketsAdminMutationVariables, TContext>) =>
    useMutation<MoveTicketsAdminMutation, TError, MoveTicketsAdminMutationVariables, TContext>(
      ['MoveTicketsAdmin'],
      (variables?: MoveTicketsAdminMutationVariables) => fetchData<MoveTicketsAdminMutation, MoveTicketsAdminMutationVariables>(MoveTicketsAdminDocument, variables)(),
      options
    );
export const PerformanceAddCompsDocument = `
    mutation PerformanceAddComps($params: PerformanceAddCompsParams!) {
  performanceAddComps(params: $params) {
    errors {
      message
      path
    }
    success
  }
}
    `;
export const usePerformanceAddCompsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PerformanceAddCompsMutation, TError, PerformanceAddCompsMutationVariables, TContext>) =>
    useMutation<PerformanceAddCompsMutation, TError, PerformanceAddCompsMutationVariables, TContext>(
      ['PerformanceAddComps'],
      (variables?: PerformanceAddCompsMutationVariables) => fetchData<PerformanceAddCompsMutation, PerformanceAddCompsMutationVariables>(PerformanceAddCompsDocument, variables)(),
      options
    );
export const TicketRefundStripeInfoDocument = `
    query TicketRefundStripeInfo($ticketId: ID!) {
  ticketInfo(ticketId: $ticketId) {
    id
    name
    paymentAmount
    paymentAmountTickets
    paymentAmountFees
    paymentAmountTip
    paymentAmountDonation
    paymentType
  }
}
    `;
export const useTicketRefundStripeInfoQuery = <
      TData = TicketRefundStripeInfoQuery,
      TError = unknown
    >(
      variables: TicketRefundStripeInfoQueryVariables,
      options?: UseQueryOptions<TicketRefundStripeInfoQuery, TError, TData>
    ) =>
    useQuery<TicketRefundStripeInfoQuery, TError, TData>(
      ['TicketRefundStripeInfo', variables],
      fetchData<TicketRefundStripeInfoQuery, TicketRefundStripeInfoQueryVariables>(TicketRefundStripeInfoDocument, variables),
      options
    );
export const useInfiniteTicketRefundStripeInfoQuery = <
      TData = TicketRefundStripeInfoQuery,
      TError = unknown
    >(
      variables: TicketRefundStripeInfoQueryVariables,
      options?: UseInfiniteQueryOptions<TicketRefundStripeInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<TicketRefundStripeInfoQuery, TError, TData>(
      ['TicketRefundStripeInfo.infinite', variables],
      (metaData) => fetchData<TicketRefundStripeInfoQuery, TicketRefundStripeInfoQueryVariables>(TicketRefundStripeInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const TicketRefundStripeDocument = `
    mutation TicketRefundStripe($ticketId: ID!) {
  ticketRefundStripe(ticketId: $ticketId) {
    errors {
      message
      path
    }
    success
  }
}
    `;
export const useTicketRefundStripeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TicketRefundStripeMutation, TError, TicketRefundStripeMutationVariables, TContext>) =>
    useMutation<TicketRefundStripeMutation, TError, TicketRefundStripeMutationVariables, TContext>(
      ['TicketRefundStripe'],
      (variables?: TicketRefundStripeMutationVariables) => fetchData<TicketRefundStripeMutation, TicketRefundStripeMutationVariables>(TicketRefundStripeDocument, variables)(),
      options
    );
export const WorkshopVoucherPriceDocument = `
    query WorkshopVoucherPrice($checkPriceParams: WorkshopVoucherCheckPriceInput!, $userId: ID!) {
  userInfoAdmin(userId: $userId) {
    id
    fullName
    email
    telephone
  }
  workshopVoucherCheckPrice(params: $checkPriceParams) {
    discounts {
      discountAmount
      discountName
    }
    workshopPricingGroup {
      id
      name
      fullPrice
      concessionPrice
      totalServiceFee
      flexibleFee
      flexibleFeeName
    }
  }
}
    `;
export const useWorkshopVoucherPriceQuery = <
      TData = WorkshopVoucherPriceQuery,
      TError = unknown
    >(
      variables: WorkshopVoucherPriceQueryVariables,
      options?: UseQueryOptions<WorkshopVoucherPriceQuery, TError, TData>
    ) =>
    useQuery<WorkshopVoucherPriceQuery, TError, TData>(
      ['WorkshopVoucherPrice', variables],
      fetchData<WorkshopVoucherPriceQuery, WorkshopVoucherPriceQueryVariables>(WorkshopVoucherPriceDocument, variables),
      options
    );
export const useInfiniteWorkshopVoucherPriceQuery = <
      TData = WorkshopVoucherPriceQuery,
      TError = unknown
    >(
      variables: WorkshopVoucherPriceQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopVoucherPriceQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopVoucherPriceQuery, TError, TData>(
      ['WorkshopVoucherPrice.infinite', variables],
      (metaData) => fetchData<WorkshopVoucherPriceQuery, WorkshopVoucherPriceQueryVariables>(WorkshopVoucherPriceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopVoucherSellStripeDocument = `
    mutation WorkshopVoucherSellStripe($params: WorkshopVoucherSellStripeInput!) {
  workshopVoucherSellStripe(params: $params) {
    workshopVoucher {
      id
      code
      maximumDollarValue
      expiryDate
      payment {
        id
        paymentType
        paymentAmount
        paymentDescription
        paymentUid
      }
    }
    errors {
      message
      path
    }
  }
}
    `;
export const useWorkshopVoucherSellStripeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WorkshopVoucherSellStripeMutation, TError, WorkshopVoucherSellStripeMutationVariables, TContext>) =>
    useMutation<WorkshopVoucherSellStripeMutation, TError, WorkshopVoucherSellStripeMutationVariables, TContext>(
      ['WorkshopVoucherSellStripe'],
      (variables?: WorkshopVoucherSellStripeMutationVariables) => fetchData<WorkshopVoucherSellStripeMutation, WorkshopVoucherSellStripeMutationVariables>(WorkshopVoucherSellStripeDocument, variables)(),
      options
    );
export const WorkshopVoucherSellManualDocument = `
    mutation WorkshopVoucherSellManual($params: WorkshopVoucherSellManualInput!) {
  workshopVoucherSellManual(params: $params) {
    workshopVoucher {
      id
      code
      maximumDollarValue
      expiryDate
    }
    errors {
      message
      path
    }
  }
}
    `;
export const useWorkshopVoucherSellManualMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WorkshopVoucherSellManualMutation, TError, WorkshopVoucherSellManualMutationVariables, TContext>) =>
    useMutation<WorkshopVoucherSellManualMutation, TError, WorkshopVoucherSellManualMutationVariables, TContext>(
      ['WorkshopVoucherSellManual'],
      (variables?: WorkshopVoucherSellManualMutationVariables) => fetchData<WorkshopVoucherSellManualMutation, WorkshopVoucherSellManualMutationVariables>(WorkshopVoucherSellManualDocument, variables)(),
      options
    );
export const WorkshopAddStudentManualDocument = `
    mutation WorkshopAddStudentManual($params: WorkshopAddStudentManualInput!) {
  workshopAddStudentManual(params: $params) {
    errors {
      message
      path
    }
    workshopRegistration {
      id
    }
  }
}
    `;
export const useWorkshopAddStudentManualMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WorkshopAddStudentManualMutation, TError, WorkshopAddStudentManualMutationVariables, TContext>) =>
    useMutation<WorkshopAddStudentManualMutation, TError, WorkshopAddStudentManualMutationVariables, TContext>(
      ['WorkshopAddStudentManual'],
      (variables?: WorkshopAddStudentManualMutationVariables) => fetchData<WorkshopAddStudentManualMutation, WorkshopAddStudentManualMutationVariables>(WorkshopAddStudentManualDocument, variables)(),
      options
    );
export const PerformanceAddStandbyDocument = `
    mutation PerformanceAddStandby($performanceId: ID!, $bracket: String!, $name: String!) {
  performanceAddStandby(
    performanceId: $performanceId
    bracket: $bracket
    name: $name
  ) {
    errors {
      message
      path
    }
    success
  }
}
    `;
export const usePerformanceAddStandbyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PerformanceAddStandbyMutation, TError, PerformanceAddStandbyMutationVariables, TContext>) =>
    useMutation<PerformanceAddStandbyMutation, TError, PerformanceAddStandbyMutationVariables, TContext>(
      ['PerformanceAddStandby'],
      (variables?: PerformanceAddStandbyMutationVariables) => fetchData<PerformanceAddStandbyMutation, PerformanceAddStandbyMutationVariables>(PerformanceAddStandbyDocument, variables)(),
      options
    );
export const WorkshopRegistrationDeferInfoDocument = `
    query WorkshopRegistrationDeferInfo($workshopRegistrationId: ID!) {
  workshopRegistrationDetailsAdmin(ids: [$workshopRegistrationId]) {
    id
    workshopPaymentLedger {
      netPaymentAmount
    }
    changeFeesSchedule {
      beforeDatetime
      reasonForFee
      centsDeducted
      percentageDeducted
      description
    }
    ...WorkshopRegistrationCommon
  }
}
    ${WorkshopRegistrationCommonFragmentDoc}`;
export const useWorkshopRegistrationDeferInfoQuery = <
      TData = WorkshopRegistrationDeferInfoQuery,
      TError = unknown
    >(
      variables: WorkshopRegistrationDeferInfoQueryVariables,
      options?: UseQueryOptions<WorkshopRegistrationDeferInfoQuery, TError, TData>
    ) =>
    useQuery<WorkshopRegistrationDeferInfoQuery, TError, TData>(
      ['WorkshopRegistrationDeferInfo', variables],
      fetchData<WorkshopRegistrationDeferInfoQuery, WorkshopRegistrationDeferInfoQueryVariables>(WorkshopRegistrationDeferInfoDocument, variables),
      options
    );
export const useInfiniteWorkshopRegistrationDeferInfoQuery = <
      TData = WorkshopRegistrationDeferInfoQuery,
      TError = unknown
    >(
      variables: WorkshopRegistrationDeferInfoQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopRegistrationDeferInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopRegistrationDeferInfoQuery, TError, TData>(
      ['WorkshopRegistrationDeferInfo.infinite', variables],
      (metaData) => fetchData<WorkshopRegistrationDeferInfoQuery, WorkshopRegistrationDeferInfoQueryVariables>(WorkshopRegistrationDeferInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopRegistrationDeferDocument = `
    mutation WorkshopRegistrationDefer($params: WorkshopRegistrationDeferInput!) {
  workshopRegistrationDefer(params: $params) {
    errors {
      message
      path
    }
    workshopRegistration {
      id
    }
  }
}
    `;
export const useWorkshopRegistrationDeferMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WorkshopRegistrationDeferMutation, TError, WorkshopRegistrationDeferMutationVariables, TContext>) =>
    useMutation<WorkshopRegistrationDeferMutation, TError, WorkshopRegistrationDeferMutationVariables, TContext>(
      ['WorkshopRegistrationDefer'],
      (variables?: WorkshopRegistrationDeferMutationVariables) => fetchData<WorkshopRegistrationDeferMutation, WorkshopRegistrationDeferMutationVariables>(WorkshopRegistrationDeferDocument, variables)(),
      options
    );
export const WorkshopRegistrationDropInfoDocument = `
    query WorkshopRegistrationDropInfo($workshopRegistrationId: ID!) {
  workshopRegistrationDetailsAdmin(ids: [$workshopRegistrationId]) {
    id
    registrationType
    workshopPaymentLedger {
      netPaymentAmount
      exclusivelyStripePayments
    }
    ...WorkshopRegistrationCommon
  }
}
    ${WorkshopRegistrationCommonFragmentDoc}`;
export const useWorkshopRegistrationDropInfoQuery = <
      TData = WorkshopRegistrationDropInfoQuery,
      TError = unknown
    >(
      variables: WorkshopRegistrationDropInfoQueryVariables,
      options?: UseQueryOptions<WorkshopRegistrationDropInfoQuery, TError, TData>
    ) =>
    useQuery<WorkshopRegistrationDropInfoQuery, TError, TData>(
      ['WorkshopRegistrationDropInfo', variables],
      fetchData<WorkshopRegistrationDropInfoQuery, WorkshopRegistrationDropInfoQueryVariables>(WorkshopRegistrationDropInfoDocument, variables),
      options
    );
export const useInfiniteWorkshopRegistrationDropInfoQuery = <
      TData = WorkshopRegistrationDropInfoQuery,
      TError = unknown
    >(
      variables: WorkshopRegistrationDropInfoQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopRegistrationDropInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopRegistrationDropInfoQuery, TError, TData>(
      ['WorkshopRegistrationDropInfo.infinite', variables],
      (metaData) => fetchData<WorkshopRegistrationDropInfoQuery, WorkshopRegistrationDropInfoQueryVariables>(WorkshopRegistrationDropInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopRegistrationDropDocument = `
    mutation WorkshopRegistrationDrop($workshopRegistrationId: ID!, $issueRefund: Boolean!, $emailStudent: Boolean!, $messageForStudent: String) {
  workshopRegistrationDrop(
    workshopRegistrationId: $workshopRegistrationId
    issueRefund: $issueRefund
    emailStudent: $emailStudent
    messageForStudent: $messageForStudent
  ) {
    errors {
      message
      path
    }
    workshopRegistration {
      id
    }
  }
}
    `;
export const useWorkshopRegistrationDropMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WorkshopRegistrationDropMutation, TError, WorkshopRegistrationDropMutationVariables, TContext>) =>
    useMutation<WorkshopRegistrationDropMutation, TError, WorkshopRegistrationDropMutationVariables, TContext>(
      ['WorkshopRegistrationDrop'],
      (variables?: WorkshopRegistrationDropMutationVariables) => fetchData<WorkshopRegistrationDropMutation, WorkshopRegistrationDropMutationVariables>(WorkshopRegistrationDropDocument, variables)(),
      options
    );
export const WorkshopRegistrationMoveToDifferentUserInfoDocument = `
    query WorkshopRegistrationMoveToDifferentUserInfo($workshopRegistrationId: ID!) {
  workshopRegistrationDetailsAdmin(ids: [$workshopRegistrationId]) {
    ...WorkshopRegistrationCommon
  }
}
    ${WorkshopRegistrationCommonFragmentDoc}`;
export const useWorkshopRegistrationMoveToDifferentUserInfoQuery = <
      TData = WorkshopRegistrationMoveToDifferentUserInfoQuery,
      TError = unknown
    >(
      variables: WorkshopRegistrationMoveToDifferentUserInfoQueryVariables,
      options?: UseQueryOptions<WorkshopRegistrationMoveToDifferentUserInfoQuery, TError, TData>
    ) =>
    useQuery<WorkshopRegistrationMoveToDifferentUserInfoQuery, TError, TData>(
      ['WorkshopRegistrationMoveToDifferentUserInfo', variables],
      fetchData<WorkshopRegistrationMoveToDifferentUserInfoQuery, WorkshopRegistrationMoveToDifferentUserInfoQueryVariables>(WorkshopRegistrationMoveToDifferentUserInfoDocument, variables),
      options
    );
export const useInfiniteWorkshopRegistrationMoveToDifferentUserInfoQuery = <
      TData = WorkshopRegistrationMoveToDifferentUserInfoQuery,
      TError = unknown
    >(
      variables: WorkshopRegistrationMoveToDifferentUserInfoQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopRegistrationMoveToDifferentUserInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopRegistrationMoveToDifferentUserInfoQuery, TError, TData>(
      ['WorkshopRegistrationMoveToDifferentUserInfo.infinite', variables],
      (metaData) => fetchData<WorkshopRegistrationMoveToDifferentUserInfoQuery, WorkshopRegistrationMoveToDifferentUserInfoQueryVariables>(WorkshopRegistrationMoveToDifferentUserInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopRegistrationMoveToDifferentUserDocument = `
    mutation WorkshopRegistrationMoveToDifferentUser($workshopRegistrationId: ID!, $userId: ID!) {
  workshopRegistrationMoveToDifferentUser(
    workshopRegistrationId: $workshopRegistrationId
    userId: $userId
  ) {
    errors {
      message
      path
    }
    workshopRegistration {
      id
    }
  }
}
    `;
export const useWorkshopRegistrationMoveToDifferentUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WorkshopRegistrationMoveToDifferentUserMutation, TError, WorkshopRegistrationMoveToDifferentUserMutationVariables, TContext>) =>
    useMutation<WorkshopRegistrationMoveToDifferentUserMutation, TError, WorkshopRegistrationMoveToDifferentUserMutationVariables, TContext>(
      ['WorkshopRegistrationMoveToDifferentUser'],
      (variables?: WorkshopRegistrationMoveToDifferentUserMutationVariables) => fetchData<WorkshopRegistrationMoveToDifferentUserMutation, WorkshopRegistrationMoveToDifferentUserMutationVariables>(WorkshopRegistrationMoveToDifferentUserDocument, variables)(),
      options
    );
export const WorkshopRegistrationMoveToDifferentWorkshopInfoDocument = `
    query WorkshopRegistrationMoveToDifferentWorkshopInfo($workshopRegistrationId: ID!) {
  workshopRegistrationDetailsAdmin(ids: [$workshopRegistrationId]) {
    workshop {
      workshopLevel {
        id
      }
    }
    ...WorkshopRegistrationCommon
  }
}
    ${WorkshopRegistrationCommonFragmentDoc}`;
export const useWorkshopRegistrationMoveToDifferentWorkshopInfoQuery = <
      TData = WorkshopRegistrationMoveToDifferentWorkshopInfoQuery,
      TError = unknown
    >(
      variables: WorkshopRegistrationMoveToDifferentWorkshopInfoQueryVariables,
      options?: UseQueryOptions<WorkshopRegistrationMoveToDifferentWorkshopInfoQuery, TError, TData>
    ) =>
    useQuery<WorkshopRegistrationMoveToDifferentWorkshopInfoQuery, TError, TData>(
      ['WorkshopRegistrationMoveToDifferentWorkshopInfo', variables],
      fetchData<WorkshopRegistrationMoveToDifferentWorkshopInfoQuery, WorkshopRegistrationMoveToDifferentWorkshopInfoQueryVariables>(WorkshopRegistrationMoveToDifferentWorkshopInfoDocument, variables),
      options
    );
export const useInfiniteWorkshopRegistrationMoveToDifferentWorkshopInfoQuery = <
      TData = WorkshopRegistrationMoveToDifferentWorkshopInfoQuery,
      TError = unknown
    >(
      variables: WorkshopRegistrationMoveToDifferentWorkshopInfoQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopRegistrationMoveToDifferentWorkshopInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopRegistrationMoveToDifferentWorkshopInfoQuery, TError, TData>(
      ['WorkshopRegistrationMoveToDifferentWorkshopInfo.infinite', variables],
      (metaData) => fetchData<WorkshopRegistrationMoveToDifferentWorkshopInfoQuery, WorkshopRegistrationMoveToDifferentWorkshopInfoQueryVariables>(WorkshopRegistrationMoveToDifferentWorkshopInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopRegistrationMoveToDifferentWorkshopDocument = `
    mutation WorkshopRegistrationMoveToDifferentWorkshop($workshopRegistrationId: ID!, $workshopId: ID!) {
  workshopRegistrationMoveToDifferentWorkshop(
    workshopRegistrationId: $workshopRegistrationId
    workshopId: $workshopId
  ) {
    errors {
      message
      path
    }
    workshopRegistration {
      id
    }
  }
}
    `;
export const useWorkshopRegistrationMoveToDifferentWorkshopMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WorkshopRegistrationMoveToDifferentWorkshopMutation, TError, WorkshopRegistrationMoveToDifferentWorkshopMutationVariables, TContext>) =>
    useMutation<WorkshopRegistrationMoveToDifferentWorkshopMutation, TError, WorkshopRegistrationMoveToDifferentWorkshopMutationVariables, TContext>(
      ['WorkshopRegistrationMoveToDifferentWorkshop'],
      (variables?: WorkshopRegistrationMoveToDifferentWorkshopMutationVariables) => fetchData<WorkshopRegistrationMoveToDifferentWorkshopMutation, WorkshopRegistrationMoveToDifferentWorkshopMutationVariables>(WorkshopRegistrationMoveToDifferentWorkshopDocument, variables)(),
      options
    );
export const SessionReferralCodeDocument = `
    query SessionReferralCode {
  sessionReferralCode
}
    `;
export const useSessionReferralCodeQuery = <
      TData = SessionReferralCodeQuery,
      TError = unknown
    >(
      variables?: SessionReferralCodeQueryVariables,
      options?: UseQueryOptions<SessionReferralCodeQuery, TError, TData>
    ) =>
    useQuery<SessionReferralCodeQuery, TError, TData>(
      variables === undefined ? ['SessionReferralCode'] : ['SessionReferralCode', variables],
      fetchData<SessionReferralCodeQuery, SessionReferralCodeQueryVariables>(SessionReferralCodeDocument, variables),
      options
    );
export const useInfiniteSessionReferralCodeQuery = <
      TData = SessionReferralCodeQuery,
      TError = unknown
    >(
      variables?: SessionReferralCodeQueryVariables,
      options?: UseInfiniteQueryOptions<SessionReferralCodeQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<SessionReferralCodeQuery, TError, TData>(
      variables === undefined ? ['SessionReferralCode.infinite'] : ['SessionReferralCode.infinite', variables],
      (metaData) => fetchData<SessionReferralCodeQuery, SessionReferralCodeQueryVariables>(SessionReferralCodeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ClassFinancesInfoDocument = `
    query ClassFinancesInfo($workshopId: ID!) {
  workshopInfo(id: $workshopId) {
    id
    workshopRegistrations {
      id
      state
      registrationType
      registrationDescription
      user {
        fullName
      }
      workshopPaymentLedger {
        paymentLedgerType
        paymentPlanStatus
        amountOutstanding
        amountPaidToDate
        registrationFee
        targetPaymentDateHalf
        targetPaymentDateFull
        refundedAmount
        paymentPlanStatus
        payments {
          paymentAmount
          paymentType
          paymentIntentId
          paymentUid
          paymentDescription
          createdAt
          paymentRefunds {
            refundAmount
            refundUid
            createdAt
          }
        }
      }
    }
  }
}
    `;
export const useClassFinancesInfoQuery = <
      TData = ClassFinancesInfoQuery,
      TError = unknown
    >(
      variables: ClassFinancesInfoQueryVariables,
      options?: UseQueryOptions<ClassFinancesInfoQuery, TError, TData>
    ) =>
    useQuery<ClassFinancesInfoQuery, TError, TData>(
      ['ClassFinancesInfo', variables],
      fetchData<ClassFinancesInfoQuery, ClassFinancesInfoQueryVariables>(ClassFinancesInfoDocument, variables),
      options
    );
export const useInfiniteClassFinancesInfoQuery = <
      TData = ClassFinancesInfoQuery,
      TError = unknown
    >(
      variables: ClassFinancesInfoQueryVariables,
      options?: UseInfiniteQueryOptions<ClassFinancesInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ClassFinancesInfoQuery, TError, TData>(
      ['ClassFinancesInfo.infinite', variables],
      (metaData) => fetchData<ClassFinancesInfoQuery, ClassFinancesInfoQueryVariables>(ClassFinancesInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const EvaluateStudentsInfoDocument = `
    query EvaluateStudentsInfo($workshopId: ID!) {
  workshopInfo(id: $workshopId) {
    evaluationsLocked
    determinedStudentCompsOffered
    determinedStudentCompsDuringTerm
    workshopLevel {
      evaluationMode
      advancingWorkshopLevels {
        workshopTrack {
          id
          name
          requiresExplicitInvitation
          allAdvancingStudentsReceiveInvitation
        }
      }
    }
    workshopRegistrations {
      workshopId
      id
      state
      user {
        fullName
      }
      evaluationByTeacher {
        instructorCommentsForStudent
        instructorCommentsInternalUse
        passRepeatStatusInternal
        workshopRegistrationId
        workshopTrackInvitations {
          status
          workshopTrack {
            id
            name
          }
        }
      }
      studentPerformanceAttendances {
        performance {
          name
          startDatetime
        }
      }
      studentReservations {
        redeemed
        paymentType
        performance {
          name
          startDatetime
        }
      }
      studentWorkshopAttendances {
        calendarSessionId
        notes
        state
        calendarSession {
          startDatetime
        }
      }
    }
  }
}
    `;
export const useEvaluateStudentsInfoQuery = <
      TData = EvaluateStudentsInfoQuery,
      TError = unknown
    >(
      variables: EvaluateStudentsInfoQueryVariables,
      options?: UseQueryOptions<EvaluateStudentsInfoQuery, TError, TData>
    ) =>
    useQuery<EvaluateStudentsInfoQuery, TError, TData>(
      ['EvaluateStudentsInfo', variables],
      fetchData<EvaluateStudentsInfoQuery, EvaluateStudentsInfoQueryVariables>(EvaluateStudentsInfoDocument, variables),
      options
    );
export const useInfiniteEvaluateStudentsInfoQuery = <
      TData = EvaluateStudentsInfoQuery,
      TError = unknown
    >(
      variables: EvaluateStudentsInfoQueryVariables,
      options?: UseInfiniteQueryOptions<EvaluateStudentsInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<EvaluateStudentsInfoQuery, TError, TData>(
      ['EvaluateStudentsInfo.infinite', variables],
      (metaData) => fetchData<EvaluateStudentsInfoQuery, EvaluateStudentsInfoQueryVariables>(EvaluateStudentsInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const TeacherEvaluateStudentDocument = `
    mutation TeacherEvaluateStudent($params: TeacherEvaluateStudentInput!) {
  teacherEvaluateStudent(params: $params) {
    success
    errors {
      message
    }
  }
}
    `;
export const useTeacherEvaluateStudentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TeacherEvaluateStudentMutation, TError, TeacherEvaluateStudentMutationVariables, TContext>) =>
    useMutation<TeacherEvaluateStudentMutation, TError, TeacherEvaluateStudentMutationVariables, TContext>(
      ['TeacherEvaluateStudent'],
      (variables?: TeacherEvaluateStudentMutationVariables) => fetchData<TeacherEvaluateStudentMutation, TeacherEvaluateStudentMutationVariables>(TeacherEvaluateStudentDocument, variables)(),
      options
    );
export const TeacherLockEvaluationsDocument = `
    mutation TeacherLockEvaluations($workshopId: ID!) {
  teacherLockEvaluations(workshopId: $workshopId) {
    success
    errors {
      message
    }
  }
}
    `;
export const useTeacherLockEvaluationsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TeacherLockEvaluationsMutation, TError, TeacherLockEvaluationsMutationVariables, TContext>) =>
    useMutation<TeacherLockEvaluationsMutation, TError, TeacherLockEvaluationsMutationVariables, TContext>(
      ['TeacherLockEvaluations'],
      (variables?: TeacherLockEvaluationsMutationVariables) => fetchData<TeacherLockEvaluationsMutation, TeacherLockEvaluationsMutationVariables>(TeacherLockEvaluationsDocument, variables)(),
      options
    );
export const SellClassesAndVouchersInfoDocument = `
    query SellClassesAndVouchersInfo($workshopId: ID!) {
  workshopInfo(id: $workshopId) {
    workshopLevel {
      workshopCategoryId
      levelType
    }
    workshopRegistrations {
      state
      id
      user {
        id
        fullName
        vouchers {
          restrictedToPurchasable {
            __typename
            ... on WorkshopLevel {
              workshopCategoryId
            }
          }
        }
        workshopRegistrations {
          state
          workshop {
            workshopLevel {
              workshopCategoryId
              id
              levelType
            }
          }
        }
      }
    }
  }
}
    `;
export const useSellClassesAndVouchersInfoQuery = <
      TData = SellClassesAndVouchersInfoQuery,
      TError = unknown
    >(
      variables: SellClassesAndVouchersInfoQueryVariables,
      options?: UseQueryOptions<SellClassesAndVouchersInfoQuery, TError, TData>
    ) =>
    useQuery<SellClassesAndVouchersInfoQuery, TError, TData>(
      ['SellClassesAndVouchersInfo', variables],
      fetchData<SellClassesAndVouchersInfoQuery, SellClassesAndVouchersInfoQueryVariables>(SellClassesAndVouchersInfoDocument, variables),
      options
    );
export const useInfiniteSellClassesAndVouchersInfoQuery = <
      TData = SellClassesAndVouchersInfoQuery,
      TError = unknown
    >(
      variables: SellClassesAndVouchersInfoQueryVariables,
      options?: UseInfiniteQueryOptions<SellClassesAndVouchersInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<SellClassesAndVouchersInfoQuery, TError, TData>(
      ['SellClassesAndVouchersInfo.infinite', variables],
      (metaData) => fetchData<SellClassesAndVouchersInfoQuery, SellClassesAndVouchersInfoQueryVariables>(SellClassesAndVouchersInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const StudentProfileForInstructorInfoDocument = `
    query StudentProfileForInstructorInfo($userId: ID!) {
  currentUser {
    workshopAdminLevelEnum
    ticketingAdminLevelEnum
  }
  userInfoAdmin(userId: $userId) {
    id
    fullName
    email
    telephone
    studentProfile {
      specialNeeds
      usedPronouns
    }
    workshopPurchaseValue
    ticketPurchaseValue
    totalPurchaseValue
    studentAvailability {
      ...studentAvailabilityEssentials
    }
    tickets {
      ...accountDetailsTicket
    }
    referredUsers {
      ...ReferredUser
    }
    vouchers {
      ...UserVoucher
    }
    workshopRegistrations {
      id
      state
      registrationType
      workshop {
        id
        name
        workshopLevel {
          name
          levelType
          evaluationMode
        }
        startDate
        teachers {
          fullName
        }
        workshopSessions {
          id
          startDatetime
          endDatetime
          venue {
            name
          }
        }
      }
      evaluationByTeacher {
        ...InternalPassRepeatInformation
        instructorCommentsForStudent
        instructorCommentsInternalUse
      }
    }
  }
}
    ${StudentAvailabilityEssentialsFragmentDoc}
${AccountDetailsTicketFragmentDoc}
${ReferredUserFragmentDoc}
${UserVoucherFragmentDoc}
${InternalPassRepeatInformationFragmentDoc}`;
export const useStudentProfileForInstructorInfoQuery = <
      TData = StudentProfileForInstructorInfoQuery,
      TError = unknown
    >(
      variables: StudentProfileForInstructorInfoQueryVariables,
      options?: UseQueryOptions<StudentProfileForInstructorInfoQuery, TError, TData>
    ) =>
    useQuery<StudentProfileForInstructorInfoQuery, TError, TData>(
      ['StudentProfileForInstructorInfo', variables],
      fetchData<StudentProfileForInstructorInfoQuery, StudentProfileForInstructorInfoQueryVariables>(StudentProfileForInstructorInfoDocument, variables),
      options
    );
export const useInfiniteStudentProfileForInstructorInfoQuery = <
      TData = StudentProfileForInstructorInfoQuery,
      TError = unknown
    >(
      variables: StudentProfileForInstructorInfoQueryVariables,
      options?: UseInfiniteQueryOptions<StudentProfileForInstructorInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<StudentProfileForInstructorInfoQuery, TError, TData>(
      ['StudentProfileForInstructorInfo.infinite', variables],
      (metaData) => fetchData<StudentProfileForInstructorInfoQuery, StudentProfileForInstructorInfoQueryVariables>(StudentProfileForInstructorInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopAttendanceInfoDocument = `
    query WorkshopAttendanceInfo($workshopSessionId: ID!) {
  workshopAttendanceQuery(workshopSessionId: $workshopSessionId) {
    studentWorkshopAttendances {
      workshopRegistrationId
      state
      notes
    }
    calendarSessionable {
      ... on Workshop {
        workshopRegistrations {
          id
          user {
            fullName
          }
        }
      }
    }
  }
}
    `;
export const useWorkshopAttendanceInfoQuery = <
      TData = WorkshopAttendanceInfoQuery,
      TError = unknown
    >(
      variables: WorkshopAttendanceInfoQueryVariables,
      options?: UseQueryOptions<WorkshopAttendanceInfoQuery, TError, TData>
    ) =>
    useQuery<WorkshopAttendanceInfoQuery, TError, TData>(
      ['WorkshopAttendanceInfo', variables],
      fetchData<WorkshopAttendanceInfoQuery, WorkshopAttendanceInfoQueryVariables>(WorkshopAttendanceInfoDocument, variables),
      options
    );
export const useInfiniteWorkshopAttendanceInfoQuery = <
      TData = WorkshopAttendanceInfoQuery,
      TError = unknown
    >(
      variables: WorkshopAttendanceInfoQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopAttendanceInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopAttendanceInfoQuery, TError, TData>(
      ['WorkshopAttendanceInfo.infinite', variables],
      (metaData) => fetchData<WorkshopAttendanceInfoQuery, WorkshopAttendanceInfoQueryVariables>(WorkshopAttendanceInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const TeacherTakeAttendanceDocument = `
    mutation TeacherTakeAttendance($params: TeacherTakeAttendanceInput!) {
  teacherTakeAttendance(params: $params) {
    success
    errors {
      message
    }
  }
}
    `;
export const useTeacherTakeAttendanceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TeacherTakeAttendanceMutation, TError, TeacherTakeAttendanceMutationVariables, TContext>) =>
    useMutation<TeacherTakeAttendanceMutation, TError, TeacherTakeAttendanceMutationVariables, TContext>(
      ['TeacherTakeAttendance'],
      (variables?: TeacherTakeAttendanceMutationVariables) => fetchData<TeacherTakeAttendanceMutation, TeacherTakeAttendanceMutationVariables>(TeacherTakeAttendanceDocument, variables)(),
      options
    );
export const TeacherLockAttendanceDocument = `
    mutation TeacherLockAttendance($workshopSessionId: ID!) {
  teacherLockAttendance(workshopSessionId: $workshopSessionId) {
    success
    errors {
      message
    }
  }
}
    `;
export const useTeacherLockAttendanceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TeacherLockAttendanceMutation, TError, TeacherLockAttendanceMutationVariables, TContext>) =>
    useMutation<TeacherLockAttendanceMutation, TError, TeacherLockAttendanceMutationVariables, TContext>(
      ['TeacherLockAttendance'],
      (variables?: TeacherLockAttendanceMutationVariables) => fetchData<TeacherLockAttendanceMutation, TeacherLockAttendanceMutationVariables>(TeacherLockAttendanceDocument, variables)(),
      options
    );
export const WorkshopDetailsForInstructorDocument = `
    query WorkshopDetailsForInstructor($workshopId: ID!) {
  currentUser {
    name
    workshopAdminLevelEnum
  }
  workshopInstructorPermissions(workshopId: $workshopId) {
    permissions
  }
  workshopInfo(id: $workshopId) {
    id
    name
    capacity
    evaluationsLocked
    startOfTermDate
    sentInstructorReminder
    determinedStudentCompsOffered
    determinedStudentCompsDuringTerm
    determinedStudentJamsDuringTerm
    internalComments {
      comment
      createdAt
      user {
        name
      }
    }
    workshopLevel {
      workshopCategoryId
      id
      name
      evaluationMode
      studentCompsMode
      studentCompsQuantity
      curriculumLink
      levelType
      nextWorkshopLevel {
        id
      }
    }
    teachers {
      name
      pictureUrlWeb
    }
    assistants {
      name
      pictureUrlWeb
    }
    workshopSessions {
      id
      startDatetime
      endDatetime
      venue {
        name
      }
    }
    workshopWaitingLists {
      id
      createdAt
      user {
        id
        fullName
        email
        telephone
      }
    }
    workshopRegistrations {
      id
      createdAt
      state
      registrationType
      sentReminderEmails
      upcomingPreregistration {
        id
      }
      workshopPaymentLedger {
        amountPaidToDate
        registrationFee
        amountOutstanding
      }
      evaluationByStudent {
        id
      }
      evaluationByTeacher {
        ...InternalPassRepeatInformation
        instructorCommentsForStudent
        instructorCommentsInternalUse
      }
      studentReservations {
        redeemed
        paymentType
        performance {
          name
          startDatetime
        }
      }
      studentPerformanceAttendances {
        performance {
          name
          startDatetime
        }
      }
      user {
        id
        fullName
        email
        telephone
        studentProfile {
          usedPronouns
          specialNeeds
        }
        workshopRegistrations {
          workshop {
            workshopLevelId
          }
          evaluationByTeacher {
            passRepeatStatusInternal
            instructorCommentsInternalUse
          }
        }
      }
      studentWorkshopAttendances {
        calendarSessionId
        notes
        state
        locked
        calendarSession {
          startDatetime
        }
      }
    }
  }
}
    ${InternalPassRepeatInformationFragmentDoc}`;
export const useWorkshopDetailsForInstructorQuery = <
      TData = WorkshopDetailsForInstructorQuery,
      TError = unknown
    >(
      variables: WorkshopDetailsForInstructorQueryVariables,
      options?: UseQueryOptions<WorkshopDetailsForInstructorQuery, TError, TData>
    ) =>
    useQuery<WorkshopDetailsForInstructorQuery, TError, TData>(
      ['WorkshopDetailsForInstructor', variables],
      fetchData<WorkshopDetailsForInstructorQuery, WorkshopDetailsForInstructorQueryVariables>(WorkshopDetailsForInstructorDocument, variables),
      options
    );
export const useInfiniteWorkshopDetailsForInstructorQuery = <
      TData = WorkshopDetailsForInstructorQuery,
      TError = unknown
    >(
      variables: WorkshopDetailsForInstructorQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopDetailsForInstructorQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopDetailsForInstructorQuery, TError, TData>(
      ['WorkshopDetailsForInstructor.infinite', variables],
      (metaData) => fetchData<WorkshopDetailsForInstructorQuery, WorkshopDetailsForInstructorQueryVariables>(WorkshopDetailsForInstructorDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const AdminWorkshopAddCommentDocument = `
    mutation AdminWorkshopAddComment($input: AdminWorkshopAddCommentInput!) {
  adminWorkshopAddComment(input: $input) {
    success
    errors {
      message
      path
    }
  }
}
    `;
export const useAdminWorkshopAddCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AdminWorkshopAddCommentMutation, TError, AdminWorkshopAddCommentMutationVariables, TContext>) =>
    useMutation<AdminWorkshopAddCommentMutation, TError, AdminWorkshopAddCommentMutationVariables, TContext>(
      ['AdminWorkshopAddComment'],
      (variables?: AdminWorkshopAddCommentMutationVariables) => fetchData<AdminWorkshopAddCommentMutation, AdminWorkshopAddCommentMutationVariables>(AdminWorkshopAddCommentDocument, variables)(),
      options
    );
export const WorkshopRegistrationResendConfirmationEmailDocument = `
    mutation WorkshopRegistrationResendConfirmationEmail($workshopRegistrationId: ID!) {
  workshopRegistrationResendConfirmationEmail(
    workshopRegistrationId: $workshopRegistrationId
  ) {
    success
    errors {
      message
      path
    }
  }
}
    `;
export const useWorkshopRegistrationResendConfirmationEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WorkshopRegistrationResendConfirmationEmailMutation, TError, WorkshopRegistrationResendConfirmationEmailMutationVariables, TContext>) =>
    useMutation<WorkshopRegistrationResendConfirmationEmailMutation, TError, WorkshopRegistrationResendConfirmationEmailMutationVariables, TContext>(
      ['WorkshopRegistrationResendConfirmationEmail'],
      (variables?: WorkshopRegistrationResendConfirmationEmailMutationVariables) => fetchData<WorkshopRegistrationResendConfirmationEmailMutation, WorkshopRegistrationResendConfirmationEmailMutationVariables>(WorkshopRegistrationResendConfirmationEmailDocument, variables)(),
      options
    );
export const WorkshopSendManualCourseRemindersDocument = `
    mutation WorkshopSendManualCourseReminders($workshopId: ID!) {
  workshopSendManualCourseReminders(workshopId: $workshopId) {
    success
    errors {
      message
      path
    }
  }
}
    `;
export const useWorkshopSendManualCourseRemindersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WorkshopSendManualCourseRemindersMutation, TError, WorkshopSendManualCourseRemindersMutationVariables, TContext>) =>
    useMutation<WorkshopSendManualCourseRemindersMutation, TError, WorkshopSendManualCourseRemindersMutationVariables, TContext>(
      ['WorkshopSendManualCourseReminders'],
      (variables?: WorkshopSendManualCourseRemindersMutationVariables) => fetchData<WorkshopSendManualCourseRemindersMutation, WorkshopSendManualCourseRemindersMutationVariables>(WorkshopSendManualCourseRemindersDocument, variables)(),
      options
    );
export const BatchCreatePerformancesDocument = `
    mutation BatchCreatePerformances($attributes: [EditPerformanceAttributes!]!) {
  batchCreatePerformances(attributes: $attributes) {
    errors {
      message
      path
    }
    performances {
      ...PerformanceAdminIndexFields
    }
  }
}
    ${PerformanceAdminIndexFieldsFragmentDoc}
${PerformanceFinancesFragmentDoc}
${AttendanceFragmentDoc}
${BarSalesFragmentDoc}
${ShowTypeFragmentDoc}`;
export const useBatchCreatePerformancesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BatchCreatePerformancesMutation, TError, BatchCreatePerformancesMutationVariables, TContext>) =>
    useMutation<BatchCreatePerformancesMutation, TError, BatchCreatePerformancesMutationVariables, TContext>(
      ['BatchCreatePerformances'],
      (variables?: BatchCreatePerformancesMutationVariables) => fetchData<BatchCreatePerformancesMutation, BatchCreatePerformancesMutationVariables>(BatchCreatePerformancesDocument, variables)(),
      options
    );
export const CreatePerformanceDocument = `
    mutation CreatePerformance($attributes: EditPerformanceAttributes!) {
  createPerformance(attributes: $attributes) {
    errors {
      message
      path
    }
    performance {
      ...PerformanceAdminIndexFields
    }
  }
}
    ${PerformanceAdminIndexFieldsFragmentDoc}
${PerformanceFinancesFragmentDoc}
${AttendanceFragmentDoc}
${BarSalesFragmentDoc}
${ShowTypeFragmentDoc}`;
export const useCreatePerformanceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePerformanceMutation, TError, CreatePerformanceMutationVariables, TContext>) =>
    useMutation<CreatePerformanceMutation, TError, CreatePerformanceMutationVariables, TContext>(
      ['CreatePerformance'],
      (variables?: CreatePerformanceMutationVariables) => fetchData<CreatePerformanceMutation, CreatePerformanceMutationVariables>(CreatePerformanceDocument, variables)(),
      options
    );
export const EditPerformanceDocument = `
    mutation EditPerformance($id: ID!, $attributes: EditPerformanceAttributes!) {
  editPerformance(id: $id, attributes: $attributes) {
    errors {
      message
      path
    }
    performance {
      ...PerformanceAdminIndexFields
    }
  }
}
    ${PerformanceAdminIndexFieldsFragmentDoc}
${PerformanceFinancesFragmentDoc}
${AttendanceFragmentDoc}
${BarSalesFragmentDoc}
${ShowTypeFragmentDoc}`;
export const useEditPerformanceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditPerformanceMutation, TError, EditPerformanceMutationVariables, TContext>) =>
    useMutation<EditPerformanceMutation, TError, EditPerformanceMutationVariables, TContext>(
      ['EditPerformance'],
      (variables?: EditPerformanceMutationVariables) => fetchData<EditPerformanceMutation, EditPerformanceMutationVariables>(EditPerformanceDocument, variables)(),
      options
    );
export const PerformanceLoadForEditDocument = `
    query PerformanceLoadForEdit($id: ID!) {
  performanceDetailsAdmin(ids: [$id]) {
    ...PerformanceForEdit
  }
}
    ${PerformanceForEditFragmentDoc}
${TicketPricingFieldsFragmentDoc}`;
export const usePerformanceLoadForEditQuery = <
      TData = PerformanceLoadForEditQuery,
      TError = unknown
    >(
      variables: PerformanceLoadForEditQueryVariables,
      options?: UseQueryOptions<PerformanceLoadForEditQuery, TError, TData>
    ) =>
    useQuery<PerformanceLoadForEditQuery, TError, TData>(
      ['PerformanceLoadForEdit', variables],
      fetchData<PerformanceLoadForEditQuery, PerformanceLoadForEditQueryVariables>(PerformanceLoadForEditDocument, variables),
      options
    );
export const useInfinitePerformanceLoadForEditQuery = <
      TData = PerformanceLoadForEditQuery,
      TError = unknown
    >(
      variables: PerformanceLoadForEditQueryVariables,
      options?: UseInfiniteQueryOptions<PerformanceLoadForEditQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<PerformanceLoadForEditQuery, TError, TData>(
      ['PerformanceLoadForEdit.infinite', variables],
      (metaData) => fetchData<PerformanceLoadForEditQuery, PerformanceLoadForEditQueryVariables>(PerformanceLoadForEditDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const DonationToNfpDocument = `
    query DonationToNfp($params: AdminDonationToNfpInput!) {
  adminDonationToNfpReport(params: $params) {
    amount
    transferStatus
  }
}
    `;
export const useDonationToNfpQuery = <
      TData = DonationToNfpQuery,
      TError = unknown
    >(
      variables: DonationToNfpQueryVariables,
      options?: UseQueryOptions<DonationToNfpQuery, TError, TData>
    ) =>
    useQuery<DonationToNfpQuery, TError, TData>(
      ['DonationToNfp', variables],
      fetchData<DonationToNfpQuery, DonationToNfpQueryVariables>(DonationToNfpDocument, variables),
      options
    );
export const useInfiniteDonationToNfpQuery = <
      TData = DonationToNfpQuery,
      TError = unknown
    >(
      variables: DonationToNfpQueryVariables,
      options?: UseInfiniteQueryOptions<DonationToNfpQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<DonationToNfpQuery, TError, TData>(
      ['DonationToNfp.infinite', variables],
      (metaData) => fetchData<DonationToNfpQuery, DonationToNfpQueryVariables>(DonationToNfpDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const DonationToNfpMarkPaidDocument = `
    mutation DonationToNfpMarkPaid($params: AdminDonationToNfpMarkPaidInput!) {
  adminDonationToNfpMarkPaid(params: $params) {
    success
    errors {
      message
    }
  }
}
    `;
export const useDonationToNfpMarkPaidMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DonationToNfpMarkPaidMutation, TError, DonationToNfpMarkPaidMutationVariables, TContext>) =>
    useMutation<DonationToNfpMarkPaidMutation, TError, DonationToNfpMarkPaidMutationVariables, TContext>(
      ['DonationToNfpMarkPaid'],
      (variables?: DonationToNfpMarkPaidMutationVariables) => fetchData<DonationToNfpMarkPaidMutation, DonationToNfpMarkPaidMutationVariables>(DonationToNfpMarkPaidDocument, variables)(),
      options
    );
export const NfpStatsDocument = `
    query NfpStats($params: PerformanceListAttributes!, $first: Int, $after: String) {
  performancesListAdmin(params: $params, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...NfpStatsNode
      }
    }
  }
}
    ${NfpStatsNodeFragmentDoc}`;
export const useNfpStatsQuery = <
      TData = NfpStatsQuery,
      TError = unknown
    >(
      variables: NfpStatsQueryVariables,
      options?: UseQueryOptions<NfpStatsQuery, TError, TData>
    ) =>
    useQuery<NfpStatsQuery, TError, TData>(
      ['NfpStats', variables],
      fetchData<NfpStatsQuery, NfpStatsQueryVariables>(NfpStatsDocument, variables),
      options
    );
export const useInfiniteNfpStatsQuery = <
      TData = NfpStatsQuery,
      TError = unknown
    >(
      variables: NfpStatsQueryVariables,
      options?: UseInfiniteQueryOptions<NfpStatsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<NfpStatsQuery, TError, TData>(
      ['NfpStats.infinite', variables],
      (metaData) => fetchData<NfpStatsQuery, NfpStatsQueryVariables>(NfpStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const PerformanceSetDoorSalesDocument = `
    mutation PerformanceSetDoorSales($performanceId: ID!, $bracket: TicketBracketEnum!, $quantity: Int!) {
  performanceSetDoorSales(
    performanceId: $performanceId
    bracket: $bracket
    quantity: $quantity
  ) {
    errors {
      message
      path
    }
    success
  }
}
    `;
export const usePerformanceSetDoorSalesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PerformanceSetDoorSalesMutation, TError, PerformanceSetDoorSalesMutationVariables, TContext>) =>
    useMutation<PerformanceSetDoorSalesMutation, TError, PerformanceSetDoorSalesMutationVariables, TContext>(
      ['PerformanceSetDoorSales'],
      (variables?: PerformanceSetDoorSalesMutationVariables) => fetchData<PerformanceSetDoorSalesMutation, PerformanceSetDoorSalesMutationVariables>(PerformanceSetDoorSalesDocument, variables)(),
      options
    );
export const PerformanceLoadForTableDocument = `
    query PerformanceLoadForTable($id: ID!) {
  performanceDetailsAdmin(ids: [$id]) {
    ...TicketBookingsTableFields
  }
}
    ${TicketBookingsTableFieldsFragmentDoc}`;
export const usePerformanceLoadForTableQuery = <
      TData = PerformanceLoadForTableQuery,
      TError = unknown
    >(
      variables: PerformanceLoadForTableQueryVariables,
      options?: UseQueryOptions<PerformanceLoadForTableQuery, TError, TData>
    ) =>
    useQuery<PerformanceLoadForTableQuery, TError, TData>(
      ['PerformanceLoadForTable', variables],
      fetchData<PerformanceLoadForTableQuery, PerformanceLoadForTableQueryVariables>(PerformanceLoadForTableDocument, variables),
      options
    );
export const useInfinitePerformanceLoadForTableQuery = <
      TData = PerformanceLoadForTableQuery,
      TError = unknown
    >(
      variables: PerformanceLoadForTableQueryVariables,
      options?: UseInfiniteQueryOptions<PerformanceLoadForTableQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<PerformanceLoadForTableQuery, TError, TData>(
      ['PerformanceLoadForTable.infinite', variables],
      (metaData) => fetchData<PerformanceLoadForTableQuery, PerformanceLoadForTableQueryVariables>(PerformanceLoadForTableDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const PerformanceUpdatedDocument = `
    subscription PerformanceUpdated($performanceId: ID!) {
  performanceUpdated(performanceId: $performanceId) {
    ...TicketBookingsTableFields
  }
}
    ${TicketBookingsTableFieldsFragmentDoc}`;
export const MarkCollectedDocument = `
    mutation MarkCollected($ticketId: ID!, $collected: Boolean!) {
  ticketMarkCollected(ticketId: $ticketId, collected: $collected) {
    errors {
      message
      path
    }
    success
  }
}
    `;
export const useMarkCollectedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MarkCollectedMutation, TError, MarkCollectedMutationVariables, TContext>) =>
    useMutation<MarkCollectedMutation, TError, MarkCollectedMutationVariables, TContext>(
      ['MarkCollected'],
      (variables?: MarkCollectedMutationVariables) => fetchData<MarkCollectedMutation, MarkCollectedMutationVariables>(MarkCollectedDocument, variables)(),
      options
    );
export const TicketResendConfirmationEmailDocument = `
    mutation TicketResendConfirmationEmail($ticketId: ID!) {
  ticketResendConfirmationEmail(ticketId: $ticketId) {
    success
    errors {
      message
      path
    }
  }
}
    `;
export const useTicketResendConfirmationEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TicketResendConfirmationEmailMutation, TError, TicketResendConfirmationEmailMutationVariables, TContext>) =>
    useMutation<TicketResendConfirmationEmailMutation, TError, TicketResendConfirmationEmailMutationVariables, TContext>(
      ['TicketResendConfirmationEmail'],
      (variables?: TicketResendConfirmationEmailMutationVariables) => fetchData<TicketResendConfirmationEmailMutation, TicketResendConfirmationEmailMutationVariables>(TicketResendConfirmationEmailDocument, variables)(),
      options
    );
export const PerformancesListAdminDocument = `
    query PerformancesListAdmin($params: PerformanceListAttributes!, $first: Int, $after: String) {
  performancesListAdmin(params: $params, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...PerformanceAdminIndexFields
      }
    }
  }
}
    ${PerformanceAdminIndexFieldsFragmentDoc}
${PerformanceFinancesFragmentDoc}
${AttendanceFragmentDoc}
${BarSalesFragmentDoc}
${ShowTypeFragmentDoc}`;
export const usePerformancesListAdminQuery = <
      TData = PerformancesListAdminQuery,
      TError = unknown
    >(
      variables: PerformancesListAdminQueryVariables,
      options?: UseQueryOptions<PerformancesListAdminQuery, TError, TData>
    ) =>
    useQuery<PerformancesListAdminQuery, TError, TData>(
      ['PerformancesListAdmin', variables],
      fetchData<PerformancesListAdminQuery, PerformancesListAdminQueryVariables>(PerformancesListAdminDocument, variables),
      options
    );
export const useInfinitePerformancesListAdminQuery = <
      TData = PerformancesListAdminQuery,
      TError = unknown
    >(
      variables: PerformancesListAdminQueryVariables,
      options?: UseInfiniteQueryOptions<PerformancesListAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<PerformancesListAdminQuery, TError, TData>(
      ['PerformancesListAdmin.infinite', variables],
      (metaData) => fetchData<PerformancesListAdminQuery, PerformancesListAdminQueryVariables>(PerformancesListAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CheckVenueAvailabilityDocument = `
    query CheckVenueAvailability($params: CheckVenueAvailabilityInput!) {
  checkVenueAvailability(params: $params) {
    available
    unavailableReason
    otherVenuesAtSameTime {
      venue {
        id
        name
        seatingCapacity
        recommendedWorkshopParticipantCapacity
      }
      available
    }
  }
}
    `;
export const useCheckVenueAvailabilityQuery = <
      TData = CheckVenueAvailabilityQuery,
      TError = unknown
    >(
      variables: CheckVenueAvailabilityQueryVariables,
      options?: UseQueryOptions<CheckVenueAvailabilityQuery, TError, TData>
    ) =>
    useQuery<CheckVenueAvailabilityQuery, TError, TData>(
      ['CheckVenueAvailability', variables],
      fetchData<CheckVenueAvailabilityQuery, CheckVenueAvailabilityQueryVariables>(CheckVenueAvailabilityDocument, variables),
      options
    );
export const useInfiniteCheckVenueAvailabilityQuery = <
      TData = CheckVenueAvailabilityQuery,
      TError = unknown
    >(
      variables: CheckVenueAvailabilityQueryVariables,
      options?: UseInfiniteQueryOptions<CheckVenueAvailabilityQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CheckVenueAvailabilityQuery, TError, TData>(
      ['CheckVenueAvailability.infinite', variables],
      (metaData) => fetchData<CheckVenueAvailabilityQuery, CheckVenueAvailabilityQueryVariables>(CheckVenueAvailabilityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const VenueBlackoutsPublicDocument = `
    query VenueBlackoutsPublic($blackoutSessionsBefore: ISO8601DateTime) {
  venueBlackoutsPublic(blackoutSessionsBefore: $blackoutSessionsBefore) {
    venue {
      id
      name
      seatingCapacity
      recommendedWorkshopParticipantCapacity
      venueAvailabilities {
        ...VenueAvailabilityBasics
      }
    }
    upcomingBlackoutSessions {
      startDatetime
      endDatetime
    }
  }
}
    ${VenueAvailabilityBasicsFragmentDoc}`;
export const useVenueBlackoutsPublicQuery = <
      TData = VenueBlackoutsPublicQuery,
      TError = unknown
    >(
      variables?: VenueBlackoutsPublicQueryVariables,
      options?: UseQueryOptions<VenueBlackoutsPublicQuery, TError, TData>
    ) =>
    useQuery<VenueBlackoutsPublicQuery, TError, TData>(
      variables === undefined ? ['VenueBlackoutsPublic'] : ['VenueBlackoutsPublic', variables],
      fetchData<VenueBlackoutsPublicQuery, VenueBlackoutsPublicQueryVariables>(VenueBlackoutsPublicDocument, variables),
      options
    );
export const useInfiniteVenueBlackoutsPublicQuery = <
      TData = VenueBlackoutsPublicQuery,
      TError = unknown
    >(
      variables?: VenueBlackoutsPublicQueryVariables,
      options?: UseInfiniteQueryOptions<VenueBlackoutsPublicQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<VenueBlackoutsPublicQuery, TError, TData>(
      variables === undefined ? ['VenueBlackoutsPublic.infinite'] : ['VenueBlackoutsPublic.infinite', variables],
      (metaData) => fetchData<VenueBlackoutsPublicQuery, VenueBlackoutsPublicQueryVariables>(VenueBlackoutsPublicDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const StandaloneSeriesDocument = `
    query StandaloneSeries {
  adminWorkshopTemplates {
    ...FullWorkshopTemplate
  }
}
    ${FullWorkshopTemplateFragmentDoc}
${WorkshopLevelsListFragmentDoc}
${WorkshopPricingFieldsFragmentDoc}
${VenuesListAdminFragmentDoc}`;
export const useStandaloneSeriesQuery = <
      TData = StandaloneSeriesQuery,
      TError = unknown
    >(
      variables?: StandaloneSeriesQueryVariables,
      options?: UseQueryOptions<StandaloneSeriesQuery, TError, TData>
    ) =>
    useQuery<StandaloneSeriesQuery, TError, TData>(
      variables === undefined ? ['StandaloneSeries'] : ['StandaloneSeries', variables],
      fetchData<StandaloneSeriesQuery, StandaloneSeriesQueryVariables>(StandaloneSeriesDocument, variables),
      options
    );
export const useInfiniteStandaloneSeriesQuery = <
      TData = StandaloneSeriesQuery,
      TError = unknown
    >(
      variables?: StandaloneSeriesQueryVariables,
      options?: UseInfiniteQueryOptions<StandaloneSeriesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<StandaloneSeriesQuery, TError, TData>(
      variables === undefined ? ['StandaloneSeries.infinite'] : ['StandaloneSeries.infinite', variables],
      (metaData) => fetchData<StandaloneSeriesQuery, StandaloneSeriesQueryVariables>(StandaloneSeriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const BatchCreateWorkshopDocument = `
    mutation BatchCreateWorkshop($attributes: [EditWorkshopAttributes!]!) {
  batchCreateWorkshops(attributes: $attributes) {
    errors {
      message
      path
    }
    workshops {
      ...WorkshopAdminIndexFields
    }
  }
}
    ${WorkshopAdminIndexFieldsFragmentDoc}
${WorkshopLevelsListFragmentDoc}
${WorkshopPricingFieldsFragmentDoc}
${WorkshopSessionsFragmentDoc}
${InstructorsFragmentDoc}
${InstructorFieldsFragmentDoc}
${CapacityFragmentDoc}
${WorkshopFinancesFragmentDoc}
${PerformanceForEditFragmentDoc}
${TicketPricingFieldsFragmentDoc}`;
export const useBatchCreateWorkshopMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BatchCreateWorkshopMutation, TError, BatchCreateWorkshopMutationVariables, TContext>) =>
    useMutation<BatchCreateWorkshopMutation, TError, BatchCreateWorkshopMutationVariables, TContext>(
      ['BatchCreateWorkshop'],
      (variables?: BatchCreateWorkshopMutationVariables) => fetchData<BatchCreateWorkshopMutation, BatchCreateWorkshopMutationVariables>(BatchCreateWorkshopDocument, variables)(),
      options
    );
export const BatchCreateWorkshopInfoDocument = `
    query BatchCreateWorkshopInfo {
  workshopLevelsList {
    ...WorkshopLevelsList
    position
    workshopTrack {
      id
      position
      name
    }
    workshopCategory {
      id
      name
    }
  }
}
    ${WorkshopLevelsListFragmentDoc}
${WorkshopPricingFieldsFragmentDoc}`;
export const useBatchCreateWorkshopInfoQuery = <
      TData = BatchCreateWorkshopInfoQuery,
      TError = unknown
    >(
      variables?: BatchCreateWorkshopInfoQueryVariables,
      options?: UseQueryOptions<BatchCreateWorkshopInfoQuery, TError, TData>
    ) =>
    useQuery<BatchCreateWorkshopInfoQuery, TError, TData>(
      variables === undefined ? ['BatchCreateWorkshopInfo'] : ['BatchCreateWorkshopInfo', variables],
      fetchData<BatchCreateWorkshopInfoQuery, BatchCreateWorkshopInfoQueryVariables>(BatchCreateWorkshopInfoDocument, variables),
      options
    );
export const useInfiniteBatchCreateWorkshopInfoQuery = <
      TData = BatchCreateWorkshopInfoQuery,
      TError = unknown
    >(
      variables?: BatchCreateWorkshopInfoQueryVariables,
      options?: UseInfiniteQueryOptions<BatchCreateWorkshopInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<BatchCreateWorkshopInfoQuery, TError, TData>(
      variables === undefined ? ['BatchCreateWorkshopInfo.infinite'] : ['BatchCreateWorkshopInfo.infinite', variables],
      (metaData) => fetchData<BatchCreateWorkshopInfoQuery, BatchCreateWorkshopInfoQueryVariables>(BatchCreateWorkshopInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopLoadForEditDocument = `
    query WorkshopLoadForEdit($id: ID!) {
  workshopDetailsAdmin(ids: [$id]) {
    id
    name
    confirmed
    visible
    description
    workshopTerm {
      id
      name
      startingMonday
    }
    simplePassword
    studentCompsOfferedOverride
    studentCompsQuantityOverride
    studentJamsQuantityOverride
    studentShowcasesOfferedOverride
    studentShowcasesQuantityOverride
    prerequisiteMode
    prerequisiteWorkshopLevel {
      ...WorkshopLevelsList
    }
    workshopLevel {
      ...WorkshopLevelsList
    }
    workshopPricingGroup {
      ...WorkshopPricingFields
    }
    preferredWorkshopPricingGroup {
      ...WorkshopPricingFields
    }
    ...WorkshopSessions
    ...Instructors
    ...Capacity
    ...WorkshopFinances
    studentShowcases {
      ...PerformanceForEdit
    }
    internalComments {
      comment
      createdAt
      user {
        name
      }
    }
  }
}
    ${WorkshopLevelsListFragmentDoc}
${WorkshopPricingFieldsFragmentDoc}
${WorkshopSessionsFragmentDoc}
${InstructorsFragmentDoc}
${InstructorFieldsFragmentDoc}
${CapacityFragmentDoc}
${WorkshopFinancesFragmentDoc}
${PerformanceForEditFragmentDoc}
${TicketPricingFieldsFragmentDoc}`;
export const useWorkshopLoadForEditQuery = <
      TData = WorkshopLoadForEditQuery,
      TError = unknown
    >(
      variables: WorkshopLoadForEditQueryVariables,
      options?: UseQueryOptions<WorkshopLoadForEditQuery, TError, TData>
    ) =>
    useQuery<WorkshopLoadForEditQuery, TError, TData>(
      ['WorkshopLoadForEdit', variables],
      fetchData<WorkshopLoadForEditQuery, WorkshopLoadForEditQueryVariables>(WorkshopLoadForEditDocument, variables),
      options
    );
export const useInfiniteWorkshopLoadForEditQuery = <
      TData = WorkshopLoadForEditQuery,
      TError = unknown
    >(
      variables: WorkshopLoadForEditQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopLoadForEditQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopLoadForEditQuery, TError, TData>(
      ['WorkshopLoadForEdit.infinite', variables],
      (metaData) => fetchData<WorkshopLoadForEditQuery, WorkshopLoadForEditQueryVariables>(WorkshopLoadForEditDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const StudentShowcaseInfoDocument = `
    query StudentShowcaseInfo {
  showTypeStudentShowcase {
    ...ShowTypeBasics
  }
}
    ${ShowTypeBasicsFragmentDoc}
${TicketPricingFieldsFragmentDoc}`;
export const useStudentShowcaseInfoQuery = <
      TData = StudentShowcaseInfoQuery,
      TError = unknown
    >(
      variables?: StudentShowcaseInfoQueryVariables,
      options?: UseQueryOptions<StudentShowcaseInfoQuery, TError, TData>
    ) =>
    useQuery<StudentShowcaseInfoQuery, TError, TData>(
      variables === undefined ? ['StudentShowcaseInfo'] : ['StudentShowcaseInfo', variables],
      fetchData<StudentShowcaseInfoQuery, StudentShowcaseInfoQueryVariables>(StudentShowcaseInfoDocument, variables),
      options
    );
export const useInfiniteStudentShowcaseInfoQuery = <
      TData = StudentShowcaseInfoQuery,
      TError = unknown
    >(
      variables?: StudentShowcaseInfoQueryVariables,
      options?: UseInfiniteQueryOptions<StudentShowcaseInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<StudentShowcaseInfoQuery, TError, TData>(
      variables === undefined ? ['StudentShowcaseInfo.infinite'] : ['StudentShowcaseInfo.infinite', variables],
      (metaData) => fetchData<StudentShowcaseInfoQuery, StudentShowcaseInfoQueryVariables>(StudentShowcaseInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CreateWorkshopDocument = `
    mutation CreateWorkshop($attributes: EditWorkshopAttributes!) {
  createWorkshop(attributes: $attributes) {
    errors {
      message
      path
    }
    workshop {
      ...WorkshopAdminIndexFields
    }
  }
}
    ${WorkshopAdminIndexFieldsFragmentDoc}
${WorkshopLevelsListFragmentDoc}
${WorkshopPricingFieldsFragmentDoc}
${WorkshopSessionsFragmentDoc}
${InstructorsFragmentDoc}
${InstructorFieldsFragmentDoc}
${CapacityFragmentDoc}
${WorkshopFinancesFragmentDoc}
${PerformanceForEditFragmentDoc}
${TicketPricingFieldsFragmentDoc}`;
export const useCreateWorkshopMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateWorkshopMutation, TError, CreateWorkshopMutationVariables, TContext>) =>
    useMutation<CreateWorkshopMutation, TError, CreateWorkshopMutationVariables, TContext>(
      ['CreateWorkshop'],
      (variables?: CreateWorkshopMutationVariables) => fetchData<CreateWorkshopMutation, CreateWorkshopMutationVariables>(CreateWorkshopDocument, variables)(),
      options
    );
export const EditWorkshopDocument = `
    mutation EditWorkshop($id: ID!, $attributes: EditWorkshopAttributes!) {
  editWorkshop(id: $id, attributes: $attributes) {
    errors {
      message
      path
    }
    workshop {
      ...WorkshopAdminIndexFields
    }
  }
}
    ${WorkshopAdminIndexFieldsFragmentDoc}
${WorkshopLevelsListFragmentDoc}
${WorkshopPricingFieldsFragmentDoc}
${WorkshopSessionsFragmentDoc}
${InstructorsFragmentDoc}
${InstructorFieldsFragmentDoc}
${CapacityFragmentDoc}
${WorkshopFinancesFragmentDoc}
${PerformanceForEditFragmentDoc}
${TicketPricingFieldsFragmentDoc}`;
export const useEditWorkshopMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditWorkshopMutation, TError, EditWorkshopMutationVariables, TContext>) =>
    useMutation<EditWorkshopMutation, TError, EditWorkshopMutationVariables, TContext>(
      ['EditWorkshop'],
      (variables?: EditWorkshopMutationVariables) => fetchData<EditWorkshopMutation, EditWorkshopMutationVariables>(EditWorkshopDocument, variables)(),
      options
    );
export const EndOfTermInfoDocument = `
    query EndOfTermInfo($params: WorkshopsListAttributes!, $first: Int, $after: String) {
  workshopsListAdmin(params: $params, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...EndOfTermWorkshopNode
      }
    }
  }
}
    ${EndOfTermWorkshopNodeFragmentDoc}
${InternalPassRepeatInformationFragmentDoc}`;
export const useEndOfTermInfoQuery = <
      TData = EndOfTermInfoQuery,
      TError = unknown
    >(
      variables: EndOfTermInfoQueryVariables,
      options?: UseQueryOptions<EndOfTermInfoQuery, TError, TData>
    ) =>
    useQuery<EndOfTermInfoQuery, TError, TData>(
      ['EndOfTermInfo', variables],
      fetchData<EndOfTermInfoQuery, EndOfTermInfoQueryVariables>(EndOfTermInfoDocument, variables),
      options
    );
export const useInfiniteEndOfTermInfoQuery = <
      TData = EndOfTermInfoQuery,
      TError = unknown
    >(
      variables: EndOfTermInfoQueryVariables,
      options?: UseInfiniteQueryOptions<EndOfTermInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<EndOfTermInfoQuery, TError, TData>(
      ['EndOfTermInfo.infinite', variables],
      (metaData) => fetchData<EndOfTermInfoQuery, EndOfTermInfoQueryVariables>(EndOfTermInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const AdminSendCourseSurveysDocument = `
    mutation AdminSendCourseSurveys($workshopRegistrationIds: [ID!]!) {
  adminSendCourseSurveys(workshopRegistrationIds: $workshopRegistrationIds) {
    success
    errors {
      message
    }
  }
}
    `;
export const useAdminSendCourseSurveysMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AdminSendCourseSurveysMutation, TError, AdminSendCourseSurveysMutationVariables, TContext>) =>
    useMutation<AdminSendCourseSurveysMutation, TError, AdminSendCourseSurveysMutationVariables, TContext>(
      ['AdminSendCourseSurveys'],
      (variables?: AdminSendCourseSurveysMutationVariables) => fetchData<AdminSendCourseSurveysMutation, AdminSendCourseSurveysMutationVariables>(AdminSendCourseSurveysDocument, variables)(),
      options
    );
export const AdminSendCourseResultsDocument = `
    mutation AdminSendCourseResults($workshopRegistrationIds: [ID!]!) {
  adminSendCourseResults(workshopRegistrationIds: $workshopRegistrationIds) {
    success
    errors {
      message
    }
  }
}
    `;
export const useAdminSendCourseResultsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AdminSendCourseResultsMutation, TError, AdminSendCourseResultsMutationVariables, TContext>) =>
    useMutation<AdminSendCourseResultsMutation, TError, AdminSendCourseResultsMutationVariables, TContext>(
      ['AdminSendCourseResults'],
      (variables?: AdminSendCourseResultsMutationVariables) => fetchData<AdminSendCourseResultsMutation, AdminSendCourseResultsMutationVariables>(AdminSendCourseResultsDocument, variables)(),
      options
    );
export const FreeTrialOffersInfoDocument = `
    query FreeTrialOffersInfo($workshopCategoryId: ID!) {
  freeTrialOffers(workshopCategoryId: $workshopCategoryId) {
    nextTermWorkshops {
      ...FreeTrialOfferWorkshop
    }
    otherUpcomingWorkshops {
      ...FreeTrialOfferWorkshop
    }
    discountOffers {
      inPersonNextTerm
      inPersonAny
      sameOrNextDay
      thirtyDays
      anytime
    }
  }
}
    ${FreeTrialOfferWorkshopFragmentDoc}`;
export const useFreeTrialOffersInfoQuery = <
      TData = FreeTrialOffersInfoQuery,
      TError = unknown
    >(
      variables: FreeTrialOffersInfoQueryVariables,
      options?: UseQueryOptions<FreeTrialOffersInfoQuery, TError, TData>
    ) =>
    useQuery<FreeTrialOffersInfoQuery, TError, TData>(
      ['FreeTrialOffersInfo', variables],
      fetchData<FreeTrialOffersInfoQuery, FreeTrialOffersInfoQueryVariables>(FreeTrialOffersInfoDocument, variables),
      options
    );
export const useInfiniteFreeTrialOffersInfoQuery = <
      TData = FreeTrialOffersInfoQuery,
      TError = unknown
    >(
      variables: FreeTrialOffersInfoQueryVariables,
      options?: UseInfiniteQueryOptions<FreeTrialOffersInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<FreeTrialOffersInfoQuery, TError, TData>(
      ['FreeTrialOffersInfo.infinite', variables],
      (metaData) => fetchData<FreeTrialOffersInfoQuery, FreeTrialOffersInfoQueryVariables>(FreeTrialOffersInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const FreeTrialStatsWorkshopLevelsDocument = `
    query FreeTrialStatsWorkshopLevels {
  workshopLevelsList {
    id
    name
    levelType
    workshopCategoryId
    workshopCategory {
      name
    }
  }
}
    `;
export const useFreeTrialStatsWorkshopLevelsQuery = <
      TData = FreeTrialStatsWorkshopLevelsQuery,
      TError = unknown
    >(
      variables?: FreeTrialStatsWorkshopLevelsQueryVariables,
      options?: UseQueryOptions<FreeTrialStatsWorkshopLevelsQuery, TError, TData>
    ) =>
    useQuery<FreeTrialStatsWorkshopLevelsQuery, TError, TData>(
      variables === undefined ? ['FreeTrialStatsWorkshopLevels'] : ['FreeTrialStatsWorkshopLevels', variables],
      fetchData<FreeTrialStatsWorkshopLevelsQuery, FreeTrialStatsWorkshopLevelsQueryVariables>(FreeTrialStatsWorkshopLevelsDocument, variables),
      options
    );
export const useInfiniteFreeTrialStatsWorkshopLevelsQuery = <
      TData = FreeTrialStatsWorkshopLevelsQuery,
      TError = unknown
    >(
      variables?: FreeTrialStatsWorkshopLevelsQueryVariables,
      options?: UseInfiniteQueryOptions<FreeTrialStatsWorkshopLevelsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<FreeTrialStatsWorkshopLevelsQuery, TError, TData>(
      variables === undefined ? ['FreeTrialStatsWorkshopLevels.infinite'] : ['FreeTrialStatsWorkshopLevels.infinite', variables],
      (metaData) => fetchData<FreeTrialStatsWorkshopLevelsQuery, FreeTrialStatsWorkshopLevelsQueryVariables>(FreeTrialStatsWorkshopLevelsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const FreeTrialStatsDocument = `
    query FreeTrialStats($params: WorkshopsListAttributes!, $first: Int, $after: String) {
  workshopsListAdmin(params: $params, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...FreeTrialStatsWorkshopNode
      }
    }
  }
}
    ${FreeTrialStatsWorkshopNodeFragmentDoc}`;
export const useFreeTrialStatsQuery = <
      TData = FreeTrialStatsQuery,
      TError = unknown
    >(
      variables: FreeTrialStatsQueryVariables,
      options?: UseQueryOptions<FreeTrialStatsQuery, TError, TData>
    ) =>
    useQuery<FreeTrialStatsQuery, TError, TData>(
      ['FreeTrialStats', variables],
      fetchData<FreeTrialStatsQuery, FreeTrialStatsQueryVariables>(FreeTrialStatsDocument, variables),
      options
    );
export const useInfiniteFreeTrialStatsQuery = <
      TData = FreeTrialStatsQuery,
      TError = unknown
    >(
      variables: FreeTrialStatsQueryVariables,
      options?: UseInfiniteQueryOptions<FreeTrialStatsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<FreeTrialStatsQuery, TError, TData>(
      ['FreeTrialStats.infinite', variables],
      (metaData) => fetchData<FreeTrialStatsQuery, FreeTrialStatsQueryVariables>(FreeTrialStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CheckPostponeWorkshopsValidityDocument = `
    query CheckPostponeWorkshopsValidity($workshopIds: [ID!]!, $checkValidityAttributes: PostponeWorkshopsAttributes!) {
  workshopDetailsAdmin(ids: $workshopIds) {
    ...WorkshopAdminIndexFields
    confirmedWorkshopRegistrations {
      id
      user {
        ...DefaultUserInfo
      }
    }
  }
  checkPostponeWorkshopsValidity(attributes: $checkValidityAttributes) {
    workshopSessionId
    valid
    invalidReason
    conflictingWorkshopId
    newStartDatetime
    newEndDatetime
  }
}
    ${WorkshopAdminIndexFieldsFragmentDoc}
${WorkshopLevelsListFragmentDoc}
${WorkshopPricingFieldsFragmentDoc}
${WorkshopSessionsFragmentDoc}
${InstructorsFragmentDoc}
${InstructorFieldsFragmentDoc}
${CapacityFragmentDoc}
${WorkshopFinancesFragmentDoc}
${PerformanceForEditFragmentDoc}
${TicketPricingFieldsFragmentDoc}
${DefaultUserInfoFragmentDoc}`;
export const useCheckPostponeWorkshopsValidityQuery = <
      TData = CheckPostponeWorkshopsValidityQuery,
      TError = unknown
    >(
      variables: CheckPostponeWorkshopsValidityQueryVariables,
      options?: UseQueryOptions<CheckPostponeWorkshopsValidityQuery, TError, TData>
    ) =>
    useQuery<CheckPostponeWorkshopsValidityQuery, TError, TData>(
      ['CheckPostponeWorkshopsValidity', variables],
      fetchData<CheckPostponeWorkshopsValidityQuery, CheckPostponeWorkshopsValidityQueryVariables>(CheckPostponeWorkshopsValidityDocument, variables),
      options
    );
export const useInfiniteCheckPostponeWorkshopsValidityQuery = <
      TData = CheckPostponeWorkshopsValidityQuery,
      TError = unknown
    >(
      variables: CheckPostponeWorkshopsValidityQueryVariables,
      options?: UseInfiniteQueryOptions<CheckPostponeWorkshopsValidityQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CheckPostponeWorkshopsValidityQuery, TError, TData>(
      ['CheckPostponeWorkshopsValidity.infinite', variables],
      (metaData) => fetchData<CheckPostponeWorkshopsValidityQuery, CheckPostponeWorkshopsValidityQueryVariables>(CheckPostponeWorkshopsValidityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const PostponeWorkshopsDocument = `
    mutation PostponeWorkshops($attributes: PostponeWorkshopsAttributes!) {
  postponeWorkshops(attributes: $attributes) {
    errors {
      message
      path
    }
    workshops {
      ...WorkshopAdminIndexFields
    }
  }
}
    ${WorkshopAdminIndexFieldsFragmentDoc}
${WorkshopLevelsListFragmentDoc}
${WorkshopPricingFieldsFragmentDoc}
${WorkshopSessionsFragmentDoc}
${InstructorsFragmentDoc}
${InstructorFieldsFragmentDoc}
${CapacityFragmentDoc}
${WorkshopFinancesFragmentDoc}
${PerformanceForEditFragmentDoc}
${TicketPricingFieldsFragmentDoc}`;
export const usePostponeWorkshopsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PostponeWorkshopsMutation, TError, PostponeWorkshopsMutationVariables, TContext>) =>
    useMutation<PostponeWorkshopsMutation, TError, PostponeWorkshopsMutationVariables, TContext>(
      ['PostponeWorkshops'],
      (variables?: PostponeWorkshopsMutationVariables) => fetchData<PostponeWorkshopsMutation, PostponeWorkshopsMutationVariables>(PostponeWorkshopsDocument, variables)(),
      options
    );
export const ReferralBonusIndexDocument = `
    query ReferralBonusIndex {
  referralBonusPendingWorkshopRegistrations {
    id
    pendingReferral
    referralDetail
    user {
      ...DefaultUserInfo
    }
    workshop {
      id
      name
      ...WorkshopSessions
    }
  }
}
    ${DefaultUserInfoFragmentDoc}
${WorkshopSessionsFragmentDoc}`;
export const useReferralBonusIndexQuery = <
      TData = ReferralBonusIndexQuery,
      TError = unknown
    >(
      variables?: ReferralBonusIndexQueryVariables,
      options?: UseQueryOptions<ReferralBonusIndexQuery, TError, TData>
    ) =>
    useQuery<ReferralBonusIndexQuery, TError, TData>(
      variables === undefined ? ['ReferralBonusIndex'] : ['ReferralBonusIndex', variables],
      fetchData<ReferralBonusIndexQuery, ReferralBonusIndexQueryVariables>(ReferralBonusIndexDocument, variables),
      options
    );
export const useInfiniteReferralBonusIndexQuery = <
      TData = ReferralBonusIndexQuery,
      TError = unknown
    >(
      variables?: ReferralBonusIndexQueryVariables,
      options?: UseInfiniteQueryOptions<ReferralBonusIndexQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ReferralBonusIndexQuery, TError, TData>(
      variables === undefined ? ['ReferralBonusIndex.infinite'] : ['ReferralBonusIndex.infinite', variables],
      (metaData) => fetchData<ReferralBonusIndexQuery, ReferralBonusIndexQueryVariables>(ReferralBonusIndexDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ReferralBonusRejectDocument = `
    mutation ReferralBonusReject($workshopRegistrationId: ID!) {
  referralBonusReject(workshopRegistrationId: $workshopRegistrationId) {
    success
    errors {
      message
      path
    }
  }
}
    `;
export const useReferralBonusRejectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReferralBonusRejectMutation, TError, ReferralBonusRejectMutationVariables, TContext>) =>
    useMutation<ReferralBonusRejectMutation, TError, ReferralBonusRejectMutationVariables, TContext>(
      ['ReferralBonusReject'],
      (variables?: ReferralBonusRejectMutationVariables) => fetchData<ReferralBonusRejectMutation, ReferralBonusRejectMutationVariables>(ReferralBonusRejectDocument, variables)(),
      options
    );
export const SendEmailToCustomersInfoDocument = `
    query SendEmailToCustomersInfo($userIds: [ID!]!) {
  currentUser {
    id
    firstName
    fullName
    email
    outgoingEmailAlias
  }
  batchUserInfoAdmin(userIds: $userIds) {
    id
    firstName
    fullName
    email
  }
}
    `;
export const useSendEmailToCustomersInfoQuery = <
      TData = SendEmailToCustomersInfoQuery,
      TError = unknown
    >(
      variables: SendEmailToCustomersInfoQueryVariables,
      options?: UseQueryOptions<SendEmailToCustomersInfoQuery, TError, TData>
    ) =>
    useQuery<SendEmailToCustomersInfoQuery, TError, TData>(
      ['SendEmailToCustomersInfo', variables],
      fetchData<SendEmailToCustomersInfoQuery, SendEmailToCustomersInfoQueryVariables>(SendEmailToCustomersInfoDocument, variables),
      options
    );
export const useInfiniteSendEmailToCustomersInfoQuery = <
      TData = SendEmailToCustomersInfoQuery,
      TError = unknown
    >(
      variables: SendEmailToCustomersInfoQueryVariables,
      options?: UseInfiniteQueryOptions<SendEmailToCustomersInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<SendEmailToCustomersInfoQuery, TError, TData>(
      ['SendEmailToCustomersInfo.infinite', variables],
      (metaData) => fetchData<SendEmailToCustomersInfoQuery, SendEmailToCustomersInfoQueryVariables>(SendEmailToCustomersInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const SendEmailToCustomersDocument = `
    mutation SendEmailToCustomers($params: SendMailMergeForCustomersInput!) {
  sendMailMergeForCustomers(params: $params) {
    success
    errors {
      message
    }
  }
}
    `;
export const useSendEmailToCustomersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendEmailToCustomersMutation, TError, SendEmailToCustomersMutationVariables, TContext>) =>
    useMutation<SendEmailToCustomersMutation, TError, SendEmailToCustomersMutationVariables, TContext>(
      ['SendEmailToCustomers'],
      (variables?: SendEmailToCustomersMutationVariables) => fetchData<SendEmailToCustomersMutation, SendEmailToCustomersMutationVariables>(SendEmailToCustomersDocument, variables)(),
      options
    );
export const SendEmailToStudentsInfoDocument = `
    query SendEmailToStudentsInfo($workshopIds: [ID!]!) {
  currentUser {
    id
    firstName
    fullName
    email
    outgoingEmailAlias
  }
  workshopDetailsAdmin(ids: $workshopIds) {
    name
    teachers {
      firstName
      fullName
      name
      user {
        id
      }
    }
    confirmedWorkshopRegistrations {
      id
      user {
        id
        firstName
        fullName
        email
      }
    }
  }
}
    `;
export const useSendEmailToStudentsInfoQuery = <
      TData = SendEmailToStudentsInfoQuery,
      TError = unknown
    >(
      variables: SendEmailToStudentsInfoQueryVariables,
      options?: UseQueryOptions<SendEmailToStudentsInfoQuery, TError, TData>
    ) =>
    useQuery<SendEmailToStudentsInfoQuery, TError, TData>(
      ['SendEmailToStudentsInfo', variables],
      fetchData<SendEmailToStudentsInfoQuery, SendEmailToStudentsInfoQueryVariables>(SendEmailToStudentsInfoDocument, variables),
      options
    );
export const useInfiniteSendEmailToStudentsInfoQuery = <
      TData = SendEmailToStudentsInfoQuery,
      TError = unknown
    >(
      variables: SendEmailToStudentsInfoQueryVariables,
      options?: UseInfiniteQueryOptions<SendEmailToStudentsInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<SendEmailToStudentsInfoQuery, TError, TData>(
      ['SendEmailToStudentsInfo.infinite', variables],
      (metaData) => fetchData<SendEmailToStudentsInfoQuery, SendEmailToStudentsInfoQueryVariables>(SendEmailToStudentsInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const SendEmailToStudentsDocument = `
    mutation SendEmailToStudents($params: SendMailMergeForWorkshopsInput!) {
  sendMailMergeForWorkshops(params: $params) {
    success
    errors {
      message
    }
  }
}
    `;
export const useSendEmailToStudentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendEmailToStudentsMutation, TError, SendEmailToStudentsMutationVariables, TContext>) =>
    useMutation<SendEmailToStudentsMutation, TError, SendEmailToStudentsMutationVariables, TContext>(
      ['SendEmailToStudents'],
      (variables?: SendEmailToStudentsMutationVariables) => fetchData<SendEmailToStudentsMutation, SendEmailToStudentsMutationVariables>(SendEmailToStudentsDocument, variables)(),
      options
    );
export const StudentProgressGeneralDocument = `
    query StudentProgressGeneral {
  workshopCategoriesListAdmin {
    id
    name
    workshopLevelsForCustomers {
      id
      name
      userWorkshopLevelMaximumProgresses {
        id
      }
    }
  }
}
    `;
export const useStudentProgressGeneralQuery = <
      TData = StudentProgressGeneralQuery,
      TError = unknown
    >(
      variables?: StudentProgressGeneralQueryVariables,
      options?: UseQueryOptions<StudentProgressGeneralQuery, TError, TData>
    ) =>
    useQuery<StudentProgressGeneralQuery, TError, TData>(
      variables === undefined ? ['StudentProgressGeneral'] : ['StudentProgressGeneral', variables],
      fetchData<StudentProgressGeneralQuery, StudentProgressGeneralQueryVariables>(StudentProgressGeneralDocument, variables),
      options
    );
export const useInfiniteStudentProgressGeneralQuery = <
      TData = StudentProgressGeneralQuery,
      TError = unknown
    >(
      variables?: StudentProgressGeneralQueryVariables,
      options?: UseInfiniteQueryOptions<StudentProgressGeneralQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<StudentProgressGeneralQuery, TError, TData>(
      variables === undefined ? ['StudentProgressGeneral.infinite'] : ['StudentProgressGeneral.infinite', variables],
      (metaData) => fetchData<StudentProgressGeneralQuery, StudentProgressGeneralQueryVariables>(StudentProgressGeneralDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const StudentProgressDetailDocument = `
    query StudentProgressDetail($workshopLevelId: ID!) {
  workshopLevelInfo(id: $workshopLevelId) {
    id
    name
    userWorkshopLevelMaximumProgresses {
      id
      user {
        id
        fullName
        email
        studentAvailability {
          ...studentAvailabilityEssentials
        }
      }
      workshopRegistration {
        evaluationByTeacher {
          passRepeatStatusInternal
        }
        evaluationByStudent {
          programContinuationPlans
          programContinuationPlansEnum
          programContinuationReasons
        }
        workshop {
          startOfTermDate
        }
      }
    }
  }
}
    ${StudentAvailabilityEssentialsFragmentDoc}`;
export const useStudentProgressDetailQuery = <
      TData = StudentProgressDetailQuery,
      TError = unknown
    >(
      variables: StudentProgressDetailQueryVariables,
      options?: UseQueryOptions<StudentProgressDetailQuery, TError, TData>
    ) =>
    useQuery<StudentProgressDetailQuery, TError, TData>(
      ['StudentProgressDetail', variables],
      fetchData<StudentProgressDetailQuery, StudentProgressDetailQueryVariables>(StudentProgressDetailDocument, variables),
      options
    );
export const useInfiniteStudentProgressDetailQuery = <
      TData = StudentProgressDetailQuery,
      TError = unknown
    >(
      variables: StudentProgressDetailQueryVariables,
      options?: UseInfiniteQueryOptions<StudentProgressDetailQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<StudentProgressDetailQuery, TError, TData>(
      ['StudentProgressDetail.infinite', variables],
      (metaData) => fetchData<StudentProgressDetailQuery, StudentProgressDetailQueryVariables>(StudentProgressDetailDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const WorkshopsListAdminDocument = `
    query WorkshopsListAdmin($params: WorkshopsListAttributes!, $first: Int, $after: String) {
  workshopsListAdmin(params: $params, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...WorkshopAdminIndexFields
      }
    }
  }
}
    ${WorkshopAdminIndexFieldsFragmentDoc}
${WorkshopLevelsListFragmentDoc}
${WorkshopPricingFieldsFragmentDoc}
${WorkshopSessionsFragmentDoc}
${InstructorsFragmentDoc}
${InstructorFieldsFragmentDoc}
${CapacityFragmentDoc}
${WorkshopFinancesFragmentDoc}
${PerformanceForEditFragmentDoc}
${TicketPricingFieldsFragmentDoc}`;
export const useWorkshopsListAdminQuery = <
      TData = WorkshopsListAdminQuery,
      TError = unknown
    >(
      variables: WorkshopsListAdminQueryVariables,
      options?: UseQueryOptions<WorkshopsListAdminQuery, TError, TData>
    ) =>
    useQuery<WorkshopsListAdminQuery, TError, TData>(
      ['WorkshopsListAdmin', variables],
      fetchData<WorkshopsListAdminQuery, WorkshopsListAdminQueryVariables>(WorkshopsListAdminDocument, variables),
      options
    );
export const useInfiniteWorkshopsListAdminQuery = <
      TData = WorkshopsListAdminQuery,
      TError = unknown
    >(
      variables: WorkshopsListAdminQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopsListAdminQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopsListAdminQuery, TError, TData>(
      ['WorkshopsListAdmin.infinite', variables],
      (metaData) => fetchData<WorkshopsListAdminQuery, WorkshopsListAdminQueryVariables>(WorkshopsListAdminDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const JoinWaitingListDocument = `
    query JoinWaitingList($workshopId: ID!) {
  currentUser {
    id
    fullName
  }
  workshopInfo(id: $workshopId) {
    id
    name
  }
  workshopWaitingListStatus(workshopId: $workshopId) {
    onWaitingList
    canJoinWaitingList
    numOtherStudentsOnList
  }
}
    `;
export const useJoinWaitingListQuery = <
      TData = JoinWaitingListQuery,
      TError = unknown
    >(
      variables: JoinWaitingListQueryVariables,
      options?: UseQueryOptions<JoinWaitingListQuery, TError, TData>
    ) =>
    useQuery<JoinWaitingListQuery, TError, TData>(
      ['JoinWaitingList', variables],
      fetchData<JoinWaitingListQuery, JoinWaitingListQueryVariables>(JoinWaitingListDocument, variables),
      options
    );
export const useInfiniteJoinWaitingListQuery = <
      TData = JoinWaitingListQuery,
      TError = unknown
    >(
      variables: JoinWaitingListQueryVariables,
      options?: UseInfiniteQueryOptions<JoinWaitingListQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<JoinWaitingListQuery, TError, TData>(
      ['JoinWaitingList.infinite', variables],
      (metaData) => fetchData<JoinWaitingListQuery, JoinWaitingListQueryVariables>(JoinWaitingListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const JoinWorkshopWaitingListDocument = `
    mutation JoinWorkshopWaitingList($params: JoinWorkshopWaitingListInput!) {
  joinWorkshopWaitingList(params: $params) {
    success
    errors {
      message
    }
  }
}
    `;
export const useJoinWorkshopWaitingListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<JoinWorkshopWaitingListMutation, TError, JoinWorkshopWaitingListMutationVariables, TContext>) =>
    useMutation<JoinWorkshopWaitingListMutation, TError, JoinWorkshopWaitingListMutationVariables, TContext>(
      ['JoinWorkshopWaitingList'],
      (variables?: JoinWorkshopWaitingListMutationVariables) => fetchData<JoinWorkshopWaitingListMutation, JoinWorkshopWaitingListMutationVariables>(JoinWorkshopWaitingListDocument, variables)(),
      options
    );
export const WorkshopAlertSubscriptionsDocument = `
    query WorkshopAlertSubscriptions($workshopLevelId: ID!) {
  currentUser {
    id
    fullName
    studentAvailability {
      ...studentAvailabilityEssentials
    }
    workshopAlertSubscriptions {
      subscribed
      workshopAlertable {
        __typename
        ... on WorkshopLevel {
          id
          name
        }
      }
    }
  }
  workshopLevelInfo(id: $workshopLevelId) {
    id
    name
  }
}
    ${StudentAvailabilityEssentialsFragmentDoc}`;
export const useWorkshopAlertSubscriptionsQuery = <
      TData = WorkshopAlertSubscriptionsQuery,
      TError = unknown
    >(
      variables: WorkshopAlertSubscriptionsQueryVariables,
      options?: UseQueryOptions<WorkshopAlertSubscriptionsQuery, TError, TData>
    ) =>
    useQuery<WorkshopAlertSubscriptionsQuery, TError, TData>(
      ['WorkshopAlertSubscriptions', variables],
      fetchData<WorkshopAlertSubscriptionsQuery, WorkshopAlertSubscriptionsQueryVariables>(WorkshopAlertSubscriptionsDocument, variables),
      options
    );
export const useInfiniteWorkshopAlertSubscriptionsQuery = <
      TData = WorkshopAlertSubscriptionsQuery,
      TError = unknown
    >(
      variables: WorkshopAlertSubscriptionsQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopAlertSubscriptionsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopAlertSubscriptionsQuery, TError, TData>(
      ['WorkshopAlertSubscriptions.infinite', variables],
      (metaData) => fetchData<WorkshopAlertSubscriptionsQuery, WorkshopAlertSubscriptionsQueryVariables>(WorkshopAlertSubscriptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ManageWorkshopLevelAlertDocument = `
    mutation ManageWorkshopLevelAlert($params: ManageWorkshopLevelAlertInput!) {
  manageWorkshopLevelAlert(params: $params) {
    success
    errors {
      message
    }
  }
}
    `;
export const useManageWorkshopLevelAlertMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ManageWorkshopLevelAlertMutation, TError, ManageWorkshopLevelAlertMutationVariables, TContext>) =>
    useMutation<ManageWorkshopLevelAlertMutation, TError, ManageWorkshopLevelAlertMutationVariables, TContext>(
      ['ManageWorkshopLevelAlert'],
      (variables?: ManageWorkshopLevelAlertMutationVariables) => fetchData<ManageWorkshopLevelAlertMutation, ManageWorkshopLevelAlertMutationVariables>(ManageWorkshopLevelAlertDocument, variables)(),
      options
    );
export const WorkshopTracksDocument = `
    query WorkshopTracks($workshopCategoryId: ID!) {
  workshopCategory(id: $workshopCategoryId) {
    id
    name
    categoryType
    workshopTracksPublic {
      id
      name
      description
      headline
      imageUrlWeb
      workshopLevelsPublic {
        id
        name
        summary
        slug
        evaluationMode
        sessionMode
        studentCompsMode
        studentShowcaseMode
        studentShowcaseQuantity
        workshopPricingGroup {
          ...WorkshopPricingFields
        }
        prerequisiteMode
        prerequisiteWorkshopLevel {
          name
        }
        upcomingWorkshops {
          id
          name
        }
      }
    }
  }
}
    ${WorkshopPricingFieldsFragmentDoc}`;
export const useWorkshopTracksQuery = <
      TData = WorkshopTracksQuery,
      TError = unknown
    >(
      variables: WorkshopTracksQueryVariables,
      options?: UseQueryOptions<WorkshopTracksQuery, TError, TData>
    ) =>
    useQuery<WorkshopTracksQuery, TError, TData>(
      ['WorkshopTracks', variables],
      fetchData<WorkshopTracksQuery, WorkshopTracksQueryVariables>(WorkshopTracksDocument, variables),
      options
    );
export const useInfiniteWorkshopTracksQuery = <
      TData = WorkshopTracksQuery,
      TError = unknown
    >(
      variables: WorkshopTracksQueryVariables,
      options?: UseInfiniteQueryOptions<WorkshopTracksQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<WorkshopTracksQuery, TError, TData>(
      ['WorkshopTracks.infinite', variables],
      (metaData) => fetchData<WorkshopTracksQuery, WorkshopTracksQueryVariables>(WorkshopTracksDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};
